/*! For license information please see scripts.js.LICENSE.txt */
(() => {
  var e = {
    755: function (e, t) {
      var n;
      !(function (t, n) {
        "use strict";
        "object" == typeof e.exports
          ? (e.exports = t.document
            ? n(t, !0)
            : function (e) {
              if (!e.document) throw new Error("jQuery requires a window with a document");
              return n(e);
            })
          : n(t);
      })("undefined" != typeof window ? window : this, function (r, i) {
        "use strict";
        var a = [],
          s = Object.getPrototypeOf,
          o = a.slice,
          l = a.flat
            ? function (e) {
              return a.flat.call(e);
            }
            : function (e) {
              return a.concat.apply([], e);
            },
          c = a.push,
          d = a.indexOf,
          u = {},
          p = u.toString,
          f = u.hasOwnProperty,
          h = f.toString,
          m = h.call(Object),
          g = {},
          v = function (e) {
            return "function" == typeof e && "number" != typeof e.nodeType && "function" != typeof e.item;
          },
          y = function (e) {
            return null != e && e === e.window;
          },
          b = r.document,
          w = { type: !0, src: !0, nonce: !0, noModule: !0 };
        function x(e, t, n) {
          var r,
            i,
            a = (n = n || b).createElement("script");
          if (((a.text = e), t))
            for (r in w) (i = t[r] || (t.getAttribute && t.getAttribute(r))) && a.setAttribute(r, i);
          n.head.appendChild(a).parentNode.removeChild(a);
        }
        function C(e) {
          return null == e
            ? e + ""
            : "object" == typeof e || "function" == typeof e
              ? u[p.call(e)] || "object"
              : typeof e;
        }
        var E = "3.6.3",
          T = function (e, t) {
            return new T.fn.init(e, t);
          };
        function S(e) {
          var t = !!e && "length" in e && e.length,
            n = C(e);
          return !v(e) && !y(e) && ("array" === n || 0 === t || ("number" == typeof t && t > 0 && t - 1 in e));
        }
        (T.fn = T.prototype =
        {
          jquery: E,
          constructor: T,
          length: 0,
          toArray: function () {
            return o.call(this);
          },
          get: function (e) {
            return null == e ? o.call(this) : e < 0 ? this[e + this.length] : this[e];
          },
          pushStack: function (e) {
            var t = T.merge(this.constructor(), e);
            return (t.prevObject = this), t;
          },
          each: function (e) {
            return T.each(this, e);
          },
          map: function (e) {
            return this.pushStack(
              T.map(this, function (t, n) {
                return e.call(t, n, t);
              })
            );
          },
          slice: function () {
            return this.pushStack(o.apply(this, arguments));
          },
          first: function () {
            return this.eq(0);
          },
          last: function () {
            return this.eq(-1);
          },
          even: function () {
            return this.pushStack(
              T.grep(this, function (e, t) {
                return (t + 1) % 2;
              })
            );
          },
          odd: function () {
            return this.pushStack(
              T.grep(this, function (e, t) {
                return t % 2;
              })
            );
          },
          eq: function (e) {
            var t = this.length,
              n = +e + (e < 0 ? t : 0);
            return this.pushStack(n >= 0 && n < t ? [this[n]] : []);
          },
          end: function () {
            return this.prevObject || this.constructor();
          },
          push: c,
          sort: a.sort,
          splice: a.splice,
        }),
          (T.extend = T.fn.extend =
            function () {
              var e,
                t,
                n,
                r,
                i,
                a,
                s = arguments[0] || {},
                o = 1,
                l = arguments.length,
                c = !1;
              for (
                "boolean" == typeof s && ((c = s), (s = arguments[o] || {}), o++),
                "object" == typeof s || v(s) || (s = {}),
                o === l && ((s = this), o--);
                o < l;
                o++
              )
                if (null != (e = arguments[o]))
                  for (t in e)
                    (r = e[t]),
                      "__proto__" !== t &&
                      s !== r &&
                      (c && r && (T.isPlainObject(r) || (i = Array.isArray(r)))
                        ? ((n = s[t]),
                          (a = i && !Array.isArray(n) ? [] : i || T.isPlainObject(n) ? n : {}),
                          (i = !1),
                          (s[t] = T.extend(c, a, r)))
                        : void 0 !== r && (s[t] = r));
              return s;
            }),
          T.extend({
            expando: "jQuery" + (E + Math.random()).replace(/\D/g, ""),
            isReady: !0,
            error: function (e) {
              throw new Error(e);
            },
            noop: function () { },
            isPlainObject: function (e) {
              var t, n;
              return !(
                !e ||
                "[object Object]" !== p.call(e) ||
                ((t = s(e)) &&
                  ("function" != typeof (n = f.call(t, "constructor") && t.constructor) || h.call(n) !== m))
              );
            },
            isEmptyObject: function (e) {
              var t;
              for (t in e) return !1;
              return !0;
            },
            globalEval: function (e, t, n) {
              x(e, { nonce: t && t.nonce }, n);
            },
            each: function (e, t) {
              var n,
                r = 0;
              if (S(e)) for (n = e.length; r < n && !1 !== t.call(e[r], r, e[r]); r++);
              else for (r in e) if (!1 === t.call(e[r], r, e[r])) break;
              return e;
            },
            makeArray: function (e, t) {
              var n = t || [];
              return null != e && (S(Object(e)) ? T.merge(n, "string" == typeof e ? [e] : e) : c.call(n, e)), n;
            },
            inArray: function (e, t, n) {
              return null == t ? -1 : d.call(t, e, n);
            },
            merge: function (e, t) {
              for (var n = +t.length, r = 0, i = e.length; r < n; r++) e[i++] = t[r];
              return (e.length = i), e;
            },
            grep: function (e, t, n) {
              for (var r = [], i = 0, a = e.length, s = !n; i < a; i++) !t(e[i], i) !== s && r.push(e[i]);
              return r;
            },
            map: function (e, t, n) {
              var r,
                i,
                a = 0,
                s = [];
              if (S(e)) for (r = e.length; a < r; a++) null != (i = t(e[a], a, n)) && s.push(i);
              else for (a in e) null != (i = t(e[a], a, n)) && s.push(i);
              return l(s);
            },
            guid: 1,
            support: g,
          }),
          "function" == typeof Symbol && (T.fn[Symbol.iterator] = a[Symbol.iterator]),
          T.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function (e, t) {
            u["[object " + t + "]"] = t.toLowerCase();
          });
        var $ = (function (e) {
          var t,
            n,
            r,
            i,
            a,
            s,
            o,
            l,
            c,
            d,
            u,
            p,
            f,
            h,
            m,
            g,
            v,
            y,
            b,
            w = "sizzle" + 1 * new Date(),
            x = e.document,
            C = 0,
            E = 0,
            T = le(),
            S = le(),
            $ = le(),
            k = le(),
            M = function (e, t) {
              return e === t && (u = !0), 0;
            },
            P = {}.hasOwnProperty,
            L = [],
            O = L.pop,
            A = L.push,
            D = L.push,
            N = L.slice,
            I = function (e, t) {
              for (var n = 0, r = e.length; n < r; n++) if (e[n] === t) return n;
              return -1;
            },
            j =
              "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
            z = "[\\x20\\t\\r\\n\\f]",
            q = "(?:\\\\[\\da-fA-F]{1,6}" + z + "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",
            _ =
              "\\[" +
              z +
              "*(" +
              q +
              ")(?:" +
              z +
              "*([*^$|!~]?=)" +
              z +
              "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" +
              q +
              "))|)" +
              z +
              "*\\]",
            H =
              ":(" +
              q +
              ")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|" +
              _ +
              ")*)|.*)\\)|)",
            B = new RegExp(z + "+", "g"),
            R = new RegExp("^" + z + "+|((?:^|[^\\\\])(?:\\\\.)*)" + z + "+$", "g"),
            G = new RegExp("^" + z + "*," + z + "*"),
            W = new RegExp("^" + z + "*([>+~]|" + z + ")" + z + "*"),
            F = new RegExp(z + "|>"),
            X = new RegExp(H),
            Y = new RegExp("^" + q + "$"),
            V = {
              ID: new RegExp("^#(" + q + ")"),
              CLASS: new RegExp("^\\.(" + q + ")"),
              TAG: new RegExp("^(" + q + "|[*])"),
              ATTR: new RegExp("^" + _),
              PSEUDO: new RegExp("^" + H),
              CHILD: new RegExp(
                "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" +
                z +
                "*(even|odd|(([+-]|)(\\d*)n|)" +
                z +
                "*(?:([+-]|)" +
                z +
                "*(\\d+)|))" +
                z +
                "*\\)|)",
                "i"
              ),
              bool: new RegExp("^(?:" + j + ")$", "i"),
              needsContext: new RegExp(
                "^" +
                z +
                "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
                z +
                "*((?:-\\d)?\\d*)" +
                z +
                "*\\)|)(?=[^-]|$)",
                "i"
              ),
            },
            U = /HTML$/i,
            K = /^(?:input|select|textarea|button)$/i,
            J = /^h\d$/i,
            Q = /^[^{]+\{\s*\[native \w/,
            Z = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
            ee = /[+~]/,
            te = new RegExp("\\\\[\\da-fA-F]{1,6}" + z + "?|\\\\([^\\r\\n\\f])", "g"),
            ne = function (e, t) {
              var n = "0x" + e.slice(1) - 65536;
              return (
                t ||
                (n < 0 ? String.fromCharCode(n + 65536) : String.fromCharCode((n >> 10) | 55296, (1023 & n) | 56320))
              );
            },
            re = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
            ie = function (e, t) {
              return t
                ? "\0" === e
                  ? "�"
                  : e.slice(0, -1) + "\\" + e.charCodeAt(e.length - 1).toString(16) + " "
                : "\\" + e;
            },
            ae = function () {
              p();
            },
            se = we(
              function (e) {
                return !0 === e.disabled && "fieldset" === e.nodeName.toLowerCase();
              },
              { dir: "parentNode", next: "legend" }
            );
          try {
            D.apply((L = N.call(x.childNodes)), x.childNodes), L[x.childNodes.length].nodeType;
          } catch (e) {
            D = {
              apply: L.length
                ? function (e, t) {
                  A.apply(e, N.call(t));
                }
                : function (e, t) {
                  for (var n = e.length, r = 0; (e[n++] = t[r++]););
                  e.length = n - 1;
                },
            };
          }
          function oe(e, t, r, i) {
            var a,
              o,
              c,
              d,
              u,
              h,
              v,
              y = t && t.ownerDocument,
              x = t ? t.nodeType : 9;
            if (((r = r || []), "string" != typeof e || !e || (1 !== x && 9 !== x && 11 !== x))) return r;
            if (!i && (p(t), (t = t || f), m)) {
              if (11 !== x && (u = Z.exec(e)))
                if ((a = u[1])) {
                  if (9 === x) {
                    if (!(c = t.getElementById(a))) return r;
                    if (c.id === a) return r.push(c), r;
                  } else if (y && (c = y.getElementById(a)) && b(t, c) && c.id === a) return r.push(c), r;
                } else {
                  if (u[2]) return D.apply(r, t.getElementsByTagName(e)), r;
                  if ((a = u[3]) && n.getElementsByClassName && t.getElementsByClassName)
                    return D.apply(r, t.getElementsByClassName(a)), r;
                }
              if (n.qsa && !k[e + " "] && (!g || !g.test(e)) && (1 !== x || "object" !== t.nodeName.toLowerCase())) {
                if (((v = e), (y = t), 1 === x && (F.test(e) || W.test(e)))) {
                  for (
                    ((y = (ee.test(e) && ve(t.parentNode)) || t) === t && n.scope) ||
                    ((d = t.getAttribute("id")) ? (d = d.replace(re, ie)) : t.setAttribute("id", (d = w))),
                    o = (h = s(e)).length;
                    o--;

                  )
                    h[o] = (d ? "#" + d : ":scope") + " " + be(h[o]);
                  v = h.join(",");
                }
                try {
                  if (n.cssSupportsSelector && !CSS.supports("selector(:is(" + v + "))")) throw new Error();
                  return D.apply(r, y.querySelectorAll(v)), r;
                } catch (t) {
                  k(e, !0);
                } finally {
                  d === w && t.removeAttribute("id");
                }
              }
            }
            return l(e.replace(R, "$1"), t, r, i);
          }
          function le() {
            var e = [];
            return function t(n, i) {
              return e.push(n + " ") > r.cacheLength && delete t[e.shift()], (t[n + " "] = i);
            };
          }
          function ce(e) {
            return (e[w] = !0), e;
          }
          function de(e) {
            var t = f.createElement("fieldset");
            try {
              return !!e(t);
            } catch (e) {
              return !1;
            } finally {
              t.parentNode && t.parentNode.removeChild(t), (t = null);
            }
          }
          function ue(e, t) {
            for (var n = e.split("|"), i = n.length; i--;) r.attrHandle[n[i]] = t;
          }
          function pe(e, t) {
            var n = t && e,
              r = n && 1 === e.nodeType && 1 === t.nodeType && e.sourceIndex - t.sourceIndex;
            if (r) return r;
            if (n) for (; (n = n.nextSibling);) if (n === t) return -1;
            return e ? 1 : -1;
          }
          function fe(e) {
            return function (t) {
              return "input" === t.nodeName.toLowerCase() && t.type === e;
            };
          }
          function he(e) {
            return function (t) {
              var n = t.nodeName.toLowerCase();
              return ("input" === n || "button" === n) && t.type === e;
            };
          }
          function me(e) {
            return function (t) {
              return "form" in t
                ? t.parentNode && !1 === t.disabled
                  ? "label" in t
                    ? "label" in t.parentNode
                      ? t.parentNode.disabled === e
                      : t.disabled === e
                    : t.isDisabled === e || (t.isDisabled !== !e && se(t) === e)
                  : t.disabled === e
                : "label" in t && t.disabled === e;
            };
          }
          function ge(e) {
            return ce(function (t) {
              return (
                (t = +t),
                ce(function (n, r) {
                  for (var i, a = e([], n.length, t), s = a.length; s--;) n[(i = a[s])] && (n[i] = !(r[i] = n[i]));
                })
              );
            });
          }
          function ve(e) {
            return e && void 0 !== e.getElementsByTagName && e;
          }
          for (t in ((n = oe.support = {}),
            (a = oe.isXML =
              function (e) {
                var t = e && e.namespaceURI,
                  n = e && (e.ownerDocument || e).documentElement;
                return !U.test(t || (n && n.nodeName) || "HTML");
              }),
            (p = oe.setDocument =
              function (e) {
                var t,
                  i,
                  s = e ? e.ownerDocument || e : x;
                return s != f && 9 === s.nodeType && s.documentElement
                  ? ((h = (f = s).documentElement),
                    (m = !a(f)),
                    x != f &&
                    (i = f.defaultView) &&
                    i.top !== i &&
                    (i.addEventListener
                      ? i.addEventListener("unload", ae, !1)
                      : i.attachEvent && i.attachEvent("onunload", ae)),
                    (n.scope = de(function (e) {
                      return (
                        h.appendChild(e).appendChild(f.createElement("div")),
                        void 0 !== e.querySelectorAll && !e.querySelectorAll(":scope fieldset div").length
                      );
                    })),
                    (n.cssSupportsSelector = de(function () {
                      return (
                        CSS.supports("selector(*)") &&
                        f.querySelectorAll(":is(:jqfake)") &&
                        !CSS.supports("selector(:is(*,:jqfake))")
                      );
                    })),
                    (n.attributes = de(function (e) {
                      return (e.className = "i"), !e.getAttribute("className");
                    })),
                    (n.getElementsByTagName = de(function (e) {
                      return e.appendChild(f.createComment("")), !e.getElementsByTagName("*").length;
                    })),
                    (n.getElementsByClassName = Q.test(f.getElementsByClassName)),
                    (n.getById = de(function (e) {
                      return (h.appendChild(e).id = w), !f.getElementsByName || !f.getElementsByName(w).length;
                    })),
                    n.getById
                      ? ((r.filter.ID = function (e) {
                        var t = e.replace(te, ne);
                        return function (e) {
                          return e.getAttribute("id") === t;
                        };
                      }),
                        (r.find.ID = function (e, t) {
                          if (void 0 !== t.getElementById && m) {
                            var n = t.getElementById(e);
                            return n ? [n] : [];
                          }
                        }))
                      : ((r.filter.ID = function (e) {
                        var t = e.replace(te, ne);
                        return function (e) {
                          var n = void 0 !== e.getAttributeNode && e.getAttributeNode("id");
                          return n && n.value === t;
                        };
                      }),
                        (r.find.ID = function (e, t) {
                          if (void 0 !== t.getElementById && m) {
                            var n,
                              r,
                              i,
                              a = t.getElementById(e);
                            if (a) {
                              if ((n = a.getAttributeNode("id")) && n.value === e) return [a];
                              for (i = t.getElementsByName(e), r = 0; (a = i[r++]);)
                                if ((n = a.getAttributeNode("id")) && n.value === e) return [a];
                            }
                            return [];
                          }
                        })),
                    (r.find.TAG = n.getElementsByTagName
                      ? function (e, t) {
                        return void 0 !== t.getElementsByTagName
                          ? t.getElementsByTagName(e)
                          : n.qsa
                            ? t.querySelectorAll(e)
                            : void 0;
                      }
                      : function (e, t) {
                        var n,
                          r = [],
                          i = 0,
                          a = t.getElementsByTagName(e);
                        if ("*" === e) {
                          for (; (n = a[i++]);) 1 === n.nodeType && r.push(n);
                          return r;
                        }
                        return a;
                      }),
                    (r.find.CLASS =
                      n.getElementsByClassName &&
                      function (e, t) {
                        if (void 0 !== t.getElementsByClassName && m) return t.getElementsByClassName(e);
                      }),
                    (v = []),
                    (g = []),
                    (n.qsa = Q.test(f.querySelectorAll)) &&
                    (de(function (e) {
                      var t;
                      (h.appendChild(e).innerHTML =
                        "<a id='" +
                        w +
                        "'></a><select id='" +
                        w +
                        "-\r\\' msallowcapture=''><option selected=''></option></select>"),
                        e.querySelectorAll("[msallowcapture^='']").length && g.push("[*^$]=" + z + "*(?:''|\"\")"),
                        e.querySelectorAll("[selected]").length || g.push("\\[" + z + "*(?:value|" + j + ")"),
                        e.querySelectorAll("[id~=" + w + "-]").length || g.push("~="),
                        (t = f.createElement("input")).setAttribute("name", ""),
                        e.appendChild(t),
                        e.querySelectorAll("[name='']").length ||
                        g.push("\\[" + z + "*name" + z + "*=" + z + "*(?:''|\"\")"),
                        e.querySelectorAll(":checked").length || g.push(":checked"),
                        e.querySelectorAll("a#" + w + "+*").length || g.push(".#.+[+~]"),
                        e.querySelectorAll("\\\f"),
                        g.push("[\\r\\n\\f]");
                    }),
                      de(function (e) {
                        e.innerHTML =
                          "<a href='' disabled='disabled'></a><select disabled='disabled'><option/></select>";
                        var t = f.createElement("input");
                        t.setAttribute("type", "hidden"),
                          e.appendChild(t).setAttribute("name", "D"),
                          e.querySelectorAll("[name=d]").length && g.push("name" + z + "*[*^$|!~]?="),
                          2 !== e.querySelectorAll(":enabled").length && g.push(":enabled", ":disabled"),
                          (h.appendChild(e).disabled = !0),
                          2 !== e.querySelectorAll(":disabled").length && g.push(":enabled", ":disabled"),
                          e.querySelectorAll("*,:x"),
                          g.push(",.*:");
                      })),
                    (n.matchesSelector = Q.test(
                      (y =
                        h.matches ||
                        h.webkitMatchesSelector ||
                        h.mozMatchesSelector ||
                        h.oMatchesSelector ||
                        h.msMatchesSelector)
                    )) &&
                    de(function (e) {
                      (n.disconnectedMatch = y.call(e, "*")), y.call(e, "[s!='']:x"), v.push("!=", H);
                    }),
                    n.cssSupportsSelector || g.push(":has"),
                    (g = g.length && new RegExp(g.join("|"))),
                    (v = v.length && new RegExp(v.join("|"))),
                    (t = Q.test(h.compareDocumentPosition)),
                    (b =
                      t || Q.test(h.contains)
                        ? function (e, t) {
                          var n = (9 === e.nodeType && e.documentElement) || e,
                            r = t && t.parentNode;
                          return (
                            e === r ||
                            !(
                              !r ||
                              1 !== r.nodeType ||
                              !(n.contains
                                ? n.contains(r)
                                : e.compareDocumentPosition && 16 & e.compareDocumentPosition(r))
                            )
                          );
                        }
                        : function (e, t) {
                          if (t) for (; (t = t.parentNode);) if (t === e) return !0;
                          return !1;
                        }),
                    (M = t
                      ? function (e, t) {
                        if (e === t) return (u = !0), 0;
                        var r = !e.compareDocumentPosition - !t.compareDocumentPosition;
                        return (
                          r ||
                          (1 &
                            (r =
                              (e.ownerDocument || e) == (t.ownerDocument || t) ? e.compareDocumentPosition(t) : 1) ||
                            (!n.sortDetached && t.compareDocumentPosition(e) === r)
                            ? e == f || (e.ownerDocument == x && b(x, e))
                              ? -1
                              : t == f || (t.ownerDocument == x && b(x, t))
                                ? 1
                                : d
                                  ? I(d, e) - I(d, t)
                                  : 0
                            : 4 & r
                              ? -1
                              : 1)
                        );
                      }
                      : function (e, t) {
                        if (e === t) return (u = !0), 0;
                        var n,
                          r = 0,
                          i = e.parentNode,
                          a = t.parentNode,
                          s = [e],
                          o = [t];
                        if (!i || !a) return e == f ? -1 : t == f ? 1 : i ? -1 : a ? 1 : d ? I(d, e) - I(d, t) : 0;
                        if (i === a) return pe(e, t);
                        for (n = e; (n = n.parentNode);) s.unshift(n);
                        for (n = t; (n = n.parentNode);) o.unshift(n);
                        for (; s[r] === o[r];) r++;
                        return r ? pe(s[r], o[r]) : s[r] == x ? -1 : o[r] == x ? 1 : 0;
                      }),
                    f)
                  : f;
              }),
            (oe.matches = function (e, t) {
              return oe(e, null, null, t);
            }),
            (oe.matchesSelector = function (e, t) {
              if ((p(e), n.matchesSelector && m && !k[t + " "] && (!v || !v.test(t)) && (!g || !g.test(t))))
                try {
                  var r = y.call(e, t);
                  if (r || n.disconnectedMatch || (e.document && 11 !== e.document.nodeType)) return r;
                } catch (e) {
                  k(t, !0);
                }
              return oe(t, f, null, [e]).length > 0;
            }),
            (oe.contains = function (e, t) {
              return (e.ownerDocument || e) != f && p(e), b(e, t);
            }),
            (oe.attr = function (e, t) {
              (e.ownerDocument || e) != f && p(e);
              var i = r.attrHandle[t.toLowerCase()],
                a = i && P.call(r.attrHandle, t.toLowerCase()) ? i(e, t, !m) : void 0;
              return void 0 !== a
                ? a
                : n.attributes || !m
                  ? e.getAttribute(t)
                  : (a = e.getAttributeNode(t)) && a.specified
                    ? a.value
                    : null;
            }),
            (oe.escape = function (e) {
              return (e + "").replace(re, ie);
            }),
            (oe.error = function (e) {
              throw new Error("Syntax error, unrecognized expression: " + e);
            }),
            (oe.uniqueSort = function (e) {
              var t,
                r = [],
                i = 0,
                a = 0;
              if (((u = !n.detectDuplicates), (d = !n.sortStable && e.slice(0)), e.sort(M), u)) {
                for (; (t = e[a++]);) t === e[a] && (i = r.push(a));
                for (; i--;) e.splice(r[i], 1);
              }
              return (d = null), e;
            }),
            (i = oe.getText =
              function (e) {
                var t,
                  n = "",
                  r = 0,
                  a = e.nodeType;
                if (a) {
                  if (1 === a || 9 === a || 11 === a) {
                    if ("string" == typeof e.textContent) return e.textContent;
                    for (e = e.firstChild; e; e = e.nextSibling) n += i(e);
                  } else if (3 === a || 4 === a) return e.nodeValue;
                } else for (; (t = e[r++]);) n += i(t);
                return n;
              }),
            (r = oe.selectors =
            {
              cacheLength: 50,
              createPseudo: ce,
              match: V,
              attrHandle: {},
              find: {},
              relative: {
                ">": { dir: "parentNode", first: !0 },
                " ": { dir: "parentNode" },
                "+": { dir: "previousSibling", first: !0 },
                "~": { dir: "previousSibling" },
              },
              preFilter: {
                ATTR: function (e) {
                  return (
                    (e[1] = e[1].replace(te, ne)),
                    (e[3] = (e[3] || e[4] || e[5] || "").replace(te, ne)),
                    "~=" === e[2] && (e[3] = " " + e[3] + " "),
                    e.slice(0, 4)
                  );
                },
                CHILD: function (e) {
                  return (
                    (e[1] = e[1].toLowerCase()),
                    "nth" === e[1].slice(0, 3)
                      ? (e[3] || oe.error(e[0]),
                        (e[4] = +(e[4] ? e[5] + (e[6] || 1) : 2 * ("even" === e[3] || "odd" === e[3]))),
                        (e[5] = +(e[7] + e[8] || "odd" === e[3])))
                      : e[3] && oe.error(e[0]),
                    e
                  );
                },
                PSEUDO: function (e) {
                  var t,
                    n = !e[6] && e[2];
                  return V.CHILD.test(e[0])
                    ? null
                    : (e[3]
                      ? (e[2] = e[4] || e[5] || "")
                      : n &&
                      X.test(n) &&
                      (t = s(n, !0)) &&
                      (t = n.indexOf(")", n.length - t) - n.length) &&
                      ((e[0] = e[0].slice(0, t)), (e[2] = n.slice(0, t))),
                      e.slice(0, 3));
                },
              },
              filter: {
                TAG: function (e) {
                  var t = e.replace(te, ne).toLowerCase();
                  return "*" === e
                    ? function () {
                      return !0;
                    }
                    : function (e) {
                      return e.nodeName && e.nodeName.toLowerCase() === t;
                    };
                },
                CLASS: function (e) {
                  var t = T[e + " "];
                  return (
                    t ||
                    ((t = new RegExp("(^|" + z + ")" + e + "(" + z + "|$)")) &&
                      T(e, function (e) {
                        return t.test(
                          ("string" == typeof e.className && e.className) ||
                          (void 0 !== e.getAttribute && e.getAttribute("class")) ||
                          ""
                        );
                      }))
                  );
                },
                ATTR: function (e, t, n) {
                  return function (r) {
                    var i = oe.attr(r, e);
                    return null == i
                      ? "!=" === t
                      : !t ||
                      ((i += ""),
                        "=" === t
                          ? i === n
                          : "!=" === t
                            ? i !== n
                            : "^=" === t
                              ? n && 0 === i.indexOf(n)
                              : "*=" === t
                                ? n && i.indexOf(n) > -1
                                : "$=" === t
                                  ? n && i.slice(-n.length) === n
                                  : "~=" === t
                                    ? (" " + i.replace(B, " ") + " ").indexOf(n) > -1
                                    : "|=" === t && (i === n || i.slice(0, n.length + 1) === n + "-"));
                  };
                },
                CHILD: function (e, t, n, r, i) {
                  var a = "nth" !== e.slice(0, 3),
                    s = "last" !== e.slice(-4),
                    o = "of-type" === t;
                  return 1 === r && 0 === i
                    ? function (e) {
                      return !!e.parentNode;
                    }
                    : function (t, n, l) {
                      var c,
                        d,
                        u,
                        p,
                        f,
                        h,
                        m = a !== s ? "nextSibling" : "previousSibling",
                        g = t.parentNode,
                        v = o && t.nodeName.toLowerCase(),
                        y = !l && !o,
                        b = !1;
                      if (g) {
                        if (a) {
                          for (; m;) {
                            for (p = t; (p = p[m]);)
                              if (o ? p.nodeName.toLowerCase() === v : 1 === p.nodeType) return !1;
                            h = m = "only" === e && !h && "nextSibling";
                          }
                          return !0;
                        }
                        if (((h = [s ? g.firstChild : g.lastChild]), s && y)) {
                          for (
                            b =
                            (f =
                              (c =
                                (d = (u = (p = g)[w] || (p[w] = {}))[p.uniqueID] || (u[p.uniqueID] = {}))[e] ||
                                [])[0] === C && c[1]) && c[2],
                            p = f && g.childNodes[f];
                            (p = (++f && p && p[m]) || (b = f = 0) || h.pop());

                          )
                            if (1 === p.nodeType && ++b && p === t) {
                              d[e] = [C, f, b];
                              break;
                            }
                        } else if (
                          (y &&
                            (b = f =
                              (c =
                                (d = (u = (p = t)[w] || (p[w] = {}))[p.uniqueID] || (u[p.uniqueID] = {}))[e] ||
                                [])[0] === C && c[1]),
                            !1 === b)
                        )
                          for (
                            ;
                            (p = (++f && p && p[m]) || (b = f = 0) || h.pop()) &&
                            ((o ? p.nodeName.toLowerCase() !== v : 1 !== p.nodeType) ||
                              !++b ||
                              (y &&
                                ((d = (u = p[w] || (p[w] = {}))[p.uniqueID] || (u[p.uniqueID] = {}))[e] = [C, b]),
                                p !== t));

                          );
                        return (b -= i) === r || (b % r == 0 && b / r >= 0);
                      }
                    };
                },
                PSEUDO: function (e, t) {
                  var n,
                    i = r.pseudos[e] || r.setFilters[e.toLowerCase()] || oe.error("unsupported pseudo: " + e);
                  return i[w]
                    ? i(t)
                    : i.length > 1
                      ? ((n = [e, e, "", t]),
                        r.setFilters.hasOwnProperty(e.toLowerCase())
                          ? ce(function (e, n) {
                            for (var r, a = i(e, t), s = a.length; s--;) e[(r = I(e, a[s]))] = !(n[r] = a[s]);
                          })
                          : function (e) {
                            return i(e, 0, n);
                          })
                      : i;
                },
              },
              pseudos: {
                not: ce(function (e) {
                  var t = [],
                    n = [],
                    r = o(e.replace(R, "$1"));
                  return r[w]
                    ? ce(function (e, t, n, i) {
                      for (var a, s = r(e, null, i, []), o = e.length; o--;) (a = s[o]) && (e[o] = !(t[o] = a));
                    })
                    : function (e, i, a) {
                      return (t[0] = e), r(t, null, a, n), (t[0] = null), !n.pop();
                    };
                }),
                has: ce(function (e) {
                  return function (t) {
                    return oe(e, t).length > 0;
                  };
                }),
                contains: ce(function (e) {
                  return (
                    (e = e.replace(te, ne)),
                    function (t) {
                      return (t.textContent || i(t)).indexOf(e) > -1;
                    }
                  );
                }),
                lang: ce(function (e) {
                  return (
                    Y.test(e || "") || oe.error("unsupported lang: " + e),
                    (e = e.replace(te, ne).toLowerCase()),
                    function (t) {
                      var n;
                      do {
                        if ((n = m ? t.lang : t.getAttribute("xml:lang") || t.getAttribute("lang")))
                          return (n = n.toLowerCase()) === e || 0 === n.indexOf(e + "-");
                      } while ((t = t.parentNode) && 1 === t.nodeType);
                      return !1;
                    }
                  );
                }),
                target: function (t) {
                  var n = e.location && e.location.hash;
                  return n && n.slice(1) === t.id;
                },
                root: function (e) {
                  return e === h;
                },
                focus: function (e) {
                  return (
                    e === f.activeElement && (!f.hasFocus || f.hasFocus()) && !!(e.type || e.href || ~e.tabIndex)
                  );
                },
                enabled: me(!1),
                disabled: me(!0),
                checked: function (e) {
                  var t = e.nodeName.toLowerCase();
                  return ("input" === t && !!e.checked) || ("option" === t && !!e.selected);
                },
                selected: function (e) {
                  return e.parentNode && e.parentNode.selectedIndex, !0 === e.selected;
                },
                empty: function (e) {
                  for (e = e.firstChild; e; e = e.nextSibling) if (e.nodeType < 6) return !1;
                  return !0;
                },
                parent: function (e) {
                  return !r.pseudos.empty(e);
                },
                header: function (e) {
                  return J.test(e.nodeName);
                },
                input: function (e) {
                  return K.test(e.nodeName);
                },
                button: function (e) {
                  var t = e.nodeName.toLowerCase();
                  return ("input" === t && "button" === e.type) || "button" === t;
                },
                text: function (e) {
                  var t;
                  return (
                    "input" === e.nodeName.toLowerCase() &&
                    "text" === e.type &&
                    (null == (t = e.getAttribute("type")) || "text" === t.toLowerCase())
                  );
                },
                first: ge(function () {
                  return [0];
                }),
                last: ge(function (e, t) {
                  return [t - 1];
                }),
                eq: ge(function (e, t, n) {
                  return [n < 0 ? n + t : n];
                }),
                even: ge(function (e, t) {
                  for (var n = 0; n < t; n += 2) e.push(n);
                  return e;
                }),
                odd: ge(function (e, t) {
                  for (var n = 1; n < t; n += 2) e.push(n);
                  return e;
                }),
                lt: ge(function (e, t, n) {
                  for (var r = n < 0 ? n + t : n > t ? t : n; --r >= 0;) e.push(r);
                  return e;
                }),
                gt: ge(function (e, t, n) {
                  for (var r = n < 0 ? n + t : n; ++r < t;) e.push(r);
                  return e;
                }),
              },
            }),
            (r.pseudos.nth = r.pseudos.eq),
            { radio: !0, checkbox: !0, file: !0, password: !0, image: !0 }))
            r.pseudos[t] = fe(t);
          for (t in { submit: !0, reset: !0 }) r.pseudos[t] = he(t);
          function ye() { }
          function be(e) {
            for (var t = 0, n = e.length, r = ""; t < n; t++) r += e[t].value;
            return r;
          }
          function we(e, t, n) {
            var r = t.dir,
              i = t.next,
              a = i || r,
              s = n && "parentNode" === a,
              o = E++;
            return t.first
              ? function (t, n, i) {
                for (; (t = t[r]);) if (1 === t.nodeType || s) return e(t, n, i);
                return !1;
              }
              : function (t, n, l) {
                var c,
                  d,
                  u,
                  p = [C, o];
                if (l) {
                  for (; (t = t[r]);) if ((1 === t.nodeType || s) && e(t, n, l)) return !0;
                } else
                  for (; (t = t[r]);)
                    if (1 === t.nodeType || s)
                      if (
                        ((d = (u = t[w] || (t[w] = {}))[t.uniqueID] || (u[t.uniqueID] = {})),
                          i && i === t.nodeName.toLowerCase())
                      )
                        t = t[r] || t;
                      else {
                        if ((c = d[a]) && c[0] === C && c[1] === o) return (p[2] = c[2]);
                        if (((d[a] = p), (p[2] = e(t, n, l)))) return !0;
                      }
                return !1;
              };
          }
          function xe(e) {
            return e.length > 1
              ? function (t, n, r) {
                for (var i = e.length; i--;) if (!e[i](t, n, r)) return !1;
                return !0;
              }
              : e[0];
          }
          function Ce(e, t, n, r, i) {
            for (var a, s = [], o = 0, l = e.length, c = null != t; o < l; o++)
              (a = e[o]) && ((n && !n(a, r, i)) || (s.push(a), c && t.push(o)));
            return s;
          }
          function Ee(e, t, n, r, i, a) {
            return (
              r && !r[w] && (r = Ee(r)),
              i && !i[w] && (i = Ee(i, a)),
              ce(function (a, s, o, l) {
                var c,
                  d,
                  u,
                  p = [],
                  f = [],
                  h = s.length,
                  m =
                    a ||
                    (function (e, t, n) {
                      for (var r = 0, i = t.length; r < i; r++) oe(e, t[r], n);
                      return n;
                    })(t || "*", o.nodeType ? [o] : o, []),
                  g = !e || (!a && t) ? m : Ce(m, p, e, o, l),
                  v = n ? (i || (a ? e : h || r) ? [] : s) : g;
                if ((n && n(g, v, o, l), r))
                  for (c = Ce(v, f), r(c, [], o, l), d = c.length; d--;) (u = c[d]) && (v[f[d]] = !(g[f[d]] = u));
                if (a) {
                  if (i || e) {
                    if (i) {
                      for (c = [], d = v.length; d--;) (u = v[d]) && c.push((g[d] = u));
                      i(null, (v = []), c, l);
                    }
                    for (d = v.length; d--;) (u = v[d]) && (c = i ? I(a, u) : p[d]) > -1 && (a[c] = !(s[c] = u));
                  }
                } else (v = Ce(v === s ? v.splice(h, v.length) : v)), i ? i(null, s, v, l) : D.apply(s, v);
              })
            );
          }
          function Te(e) {
            for (
              var t,
              n,
              i,
              a = e.length,
              s = r.relative[e[0].type],
              o = s || r.relative[" "],
              l = s ? 1 : 0,
              d = we(
                function (e) {
                  return e === t;
                },
                o,
                !0
              ),
              u = we(
                function (e) {
                  return I(t, e) > -1;
                },
                o,
                !0
              ),
              p = [
                function (e, n, r) {
                  var i = (!s && (r || n !== c)) || ((t = n).nodeType ? d(e, n, r) : u(e, n, r));
                  return (t = null), i;
                },
              ];
              l < a;
              l++
            )
              if ((n = r.relative[e[l].type])) p = [we(xe(p), n)];
              else {
                if ((n = r.filter[e[l].type].apply(null, e[l].matches))[w]) {
                  for (i = ++l; i < a && !r.relative[e[i].type]; i++);
                  return Ee(
                    l > 1 && xe(p),
                    l > 1 &&
                    be(e.slice(0, l - 1).concat({ value: " " === e[l - 2].type ? "*" : "" })).replace(R, "$1"),
                    n,
                    l < i && Te(e.slice(l, i)),
                    i < a && Te((e = e.slice(i))),
                    i < a && be(e)
                  );
                }
                p.push(n);
              }
            return xe(p);
          }
          return (
            (ye.prototype = r.filters = r.pseudos),
            (r.setFilters = new ye()),
            (s = oe.tokenize =
              function (e, t) {
                var n,
                  i,
                  a,
                  s,
                  o,
                  l,
                  c,
                  d = S[e + " "];
                if (d) return t ? 0 : d.slice(0);
                for (o = e, l = [], c = r.preFilter; o;) {
                  for (s in ((n && !(i = G.exec(o))) || (i && (o = o.slice(i[0].length) || o), l.push((a = []))),
                    (n = !1),
                    (i = W.exec(o)) &&
                    ((n = i.shift()), a.push({ value: n, type: i[0].replace(R, " ") }), (o = o.slice(n.length))),
                    r.filter))
                    !(i = V[s].exec(o)) ||
                      (c[s] && !(i = c[s](i))) ||
                      ((n = i.shift()), a.push({ value: n, type: s, matches: i }), (o = o.slice(n.length)));
                  if (!n) break;
                }
                return t ? o.length : o ? oe.error(e) : S(e, l).slice(0);
              }),
            (o = oe.compile =
              function (e, t) {
                var n,
                  i = [],
                  a = [],
                  o = $[e + " "];
                if (!o) {
                  for (t || (t = s(e)), n = t.length; n--;) (o = Te(t[n]))[w] ? i.push(o) : a.push(o);
                  (o = $(
                    e,
                    (function (e, t) {
                      var n = t.length > 0,
                        i = e.length > 0,
                        a = function (a, s, o, l, d) {
                          var u,
                            h,
                            g,
                            v = 0,
                            y = "0",
                            b = a && [],
                            w = [],
                            x = c,
                            E = a || (i && r.find.TAG("*", d)),
                            T = (C += null == x ? 1 : Math.random() || 0.1),
                            S = E.length;
                          for (d && (c = s == f || s || d); y !== S && null != (u = E[y]); y++) {
                            if (i && u) {
                              for (h = 0, s || u.ownerDocument == f || (p(u), (o = !m)); (g = e[h++]);)
                                if (g(u, s || f, o)) {
                                  l.push(u);
                                  break;
                                }
                              d && (C = T);
                            }
                            n && ((u = !g && u) && v--, a && b.push(u));
                          }
                          if (((v += y), n && y !== v)) {
                            for (h = 0; (g = t[h++]);) g(b, w, s, o);
                            if (a) {
                              if (v > 0) for (; y--;) b[y] || w[y] || (w[y] = O.call(l));
                              w = Ce(w);
                            }
                            D.apply(l, w), d && !a && w.length > 0 && v + t.length > 1 && oe.uniqueSort(l);
                          }
                          return d && ((C = T), (c = x)), b;
                        };
                      return n ? ce(a) : a;
                    })(a, i)
                  )),
                    (o.selector = e);
                }
                return o;
              }),
            (l = oe.select =
              function (e, t, n, i) {
                var a,
                  l,
                  c,
                  d,
                  u,
                  p = "function" == typeof e && e,
                  f = !i && s((e = p.selector || e));
                if (((n = n || []), 1 === f.length)) {
                  if (
                    (l = f[0] = f[0].slice(0)).length > 2 &&
                    "ID" === (c = l[0]).type &&
                    9 === t.nodeType &&
                    m &&
                    r.relative[l[1].type]
                  ) {
                    if (!(t = (r.find.ID(c.matches[0].replace(te, ne), t) || [])[0])) return n;
                    p && (t = t.parentNode), (e = e.slice(l.shift().value.length));
                  }
                  for (a = V.needsContext.test(e) ? 0 : l.length; a-- && ((c = l[a]), !r.relative[(d = c.type)]);)
                    if (
                      (u = r.find[d]) &&
                      (i = u(c.matches[0].replace(te, ne), (ee.test(l[0].type) && ve(t.parentNode)) || t))
                    ) {
                      if ((l.splice(a, 1), !(e = i.length && be(l)))) return D.apply(n, i), n;
                      break;
                    }
                }
                return (p || o(e, f))(i, t, !m, n, !t || (ee.test(e) && ve(t.parentNode)) || t), n;
              }),
            (n.sortStable = w.split("").sort(M).join("") === w),
            (n.detectDuplicates = !!u),
            p(),
            (n.sortDetached = de(function (e) {
              return 1 & e.compareDocumentPosition(f.createElement("fieldset"));
            })),
            de(function (e) {
              return (e.innerHTML = "<a href='#'></a>"), "#" === e.firstChild.getAttribute("href");
            }) ||
            ue("type|href|height|width", function (e, t, n) {
              if (!n) return e.getAttribute(t, "type" === t.toLowerCase() ? 1 : 2);
            }),
            (n.attributes &&
              de(function (e) {
                return (
                  (e.innerHTML = "<input/>"),
                  e.firstChild.setAttribute("value", ""),
                  "" === e.firstChild.getAttribute("value")
                );
              })) ||
            ue("value", function (e, t, n) {
              if (!n && "input" === e.nodeName.toLowerCase()) return e.defaultValue;
            }),
            de(function (e) {
              return null == e.getAttribute("disabled");
            }) ||
            ue(j, function (e, t, n) {
              var r;
              if (!n)
                return !0 === e[t] ? t.toLowerCase() : (r = e.getAttributeNode(t)) && r.specified ? r.value : null;
            }),
            oe
          );
        })(r);
        (T.find = $),
          (T.expr = $.selectors),
          (T.expr[":"] = T.expr.pseudos),
          (T.uniqueSort = T.unique = $.uniqueSort),
          (T.text = $.getText),
          (T.isXMLDoc = $.isXML),
          (T.contains = $.contains),
          (T.escapeSelector = $.escape);
        var k = function (e, t, n) {
          for (var r = [], i = void 0 !== n; (e = e[t]) && 9 !== e.nodeType;)
            if (1 === e.nodeType) {
              if (i && T(e).is(n)) break;
              r.push(e);
            }
          return r;
        },
          M = function (e, t) {
            for (var n = []; e; e = e.nextSibling) 1 === e.nodeType && e !== t && n.push(e);
            return n;
          },
          P = T.expr.match.needsContext;
        function L(e, t) {
          return e.nodeName && e.nodeName.toLowerCase() === t.toLowerCase();
        }
        var O = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
        function A(e, t, n) {
          return v(t)
            ? T.grep(e, function (e, r) {
              return !!t.call(e, r, e) !== n;
            })
            : t.nodeType
              ? T.grep(e, function (e) {
                return (e === t) !== n;
              })
              : "string" != typeof t
                ? T.grep(e, function (e) {
                  return d.call(t, e) > -1 !== n;
                })
                : T.filter(t, e, n);
        }
        (T.filter = function (e, t, n) {
          var r = t[0];
          return (
            n && (e = ":not(" + e + ")"),
            1 === t.length && 1 === r.nodeType
              ? T.find.matchesSelector(r, e)
                ? [r]
                : []
              : T.find.matches(
                e,
                T.grep(t, function (e) {
                  return 1 === e.nodeType;
                })
              )
          );
        }),
          T.fn.extend({
            find: function (e) {
              var t,
                n,
                r = this.length,
                i = this;
              if ("string" != typeof e)
                return this.pushStack(
                  T(e).filter(function () {
                    for (t = 0; t < r; t++) if (T.contains(i[t], this)) return !0;
                  })
                );
              for (n = this.pushStack([]), t = 0; t < r; t++) T.find(e, i[t], n);
              return r > 1 ? T.uniqueSort(n) : n;
            },
            filter: function (e) {
              return this.pushStack(A(this, e || [], !1));
            },
            not: function (e) {
              return this.pushStack(A(this, e || [], !0));
            },
            is: function (e) {
              return !!A(this, "string" == typeof e && P.test(e) ? T(e) : e || [], !1).length;
            },
          });
        var D,
          N = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/;
        ((T.fn.init = function (e, t, n) {
          var r, i;
          if (!e) return this;
          if (((n = n || D), "string" == typeof e)) {
            if (
              !(r = "<" === e[0] && ">" === e[e.length - 1] && e.length >= 3 ? [null, e, null] : N.exec(e)) ||
              (!r[1] && t)
            )
              return !t || t.jquery ? (t || n).find(e) : this.constructor(t).find(e);
            if (r[1]) {
              if (
                ((t = t instanceof T ? t[0] : t),
                  T.merge(this, T.parseHTML(r[1], t && t.nodeType ? t.ownerDocument || t : b, !0)),
                  O.test(r[1]) && T.isPlainObject(t))
              )
                for (r in t) v(this[r]) ? this[r](t[r]) : this.attr(r, t[r]);
              return this;
            }
            return (i = b.getElementById(r[2])) && ((this[0] = i), (this.length = 1)), this;
          }
          return e.nodeType
            ? ((this[0] = e), (this.length = 1), this)
            : v(e)
              ? void 0 !== n.ready
                ? n.ready(e)
                : e(T)
              : T.makeArray(e, this);
        }).prototype = T.fn),
          (D = T(b));
        var I = /^(?:parents|prev(?:Until|All))/,
          j = { children: !0, contents: !0, next: !0, prev: !0 };
        function z(e, t) {
          for (; (e = e[t]) && 1 !== e.nodeType;);
          return e;
        }
        T.fn.extend({
          has: function (e) {
            var t = T(e, this),
              n = t.length;
            return this.filter(function () {
              for (var e = 0; e < n; e++) if (T.contains(this, t[e])) return !0;
            });
          },
          closest: function (e, t) {
            var n,
              r = 0,
              i = this.length,
              a = [],
              s = "string" != typeof e && T(e);
            if (!P.test(e))
              for (; r < i; r++)
                for (n = this[r]; n && n !== t; n = n.parentNode)
                  if (n.nodeType < 11 && (s ? s.index(n) > -1 : 1 === n.nodeType && T.find.matchesSelector(n, e))) {
                    a.push(n);
                    break;
                  }
            return this.pushStack(a.length > 1 ? T.uniqueSort(a) : a);
          },
          index: function (e) {
            return e
              ? "string" == typeof e
                ? d.call(T(e), this[0])
                : d.call(this, e.jquery ? e[0] : e)
              : this[0] && this[0].parentNode
                ? this.first().prevAll().length
                : -1;
          },
          add: function (e, t) {
            return this.pushStack(T.uniqueSort(T.merge(this.get(), T(e, t))));
          },
          addBack: function (e) {
            return this.add(null == e ? this.prevObject : this.prevObject.filter(e));
          },
        }),
          T.each(
            {
              parent: function (e) {
                var t = e.parentNode;
                return t && 11 !== t.nodeType ? t : null;
              },
              parents: function (e) {
                return k(e, "parentNode");
              },
              parentsUntil: function (e, t, n) {
                return k(e, "parentNode", n);
              },
              next: function (e) {
                return z(e, "nextSibling");
              },
              prev: function (e) {
                return z(e, "previousSibling");
              },
              nextAll: function (e) {
                return k(e, "nextSibling");
              },
              prevAll: function (e) {
                return k(e, "previousSibling");
              },
              nextUntil: function (e, t, n) {
                return k(e, "nextSibling", n);
              },
              prevUntil: function (e, t, n) {
                return k(e, "previousSibling", n);
              },
              siblings: function (e) {
                return M((e.parentNode || {}).firstChild, e);
              },
              children: function (e) {
                return M(e.firstChild);
              },
              contents: function (e) {
                return null != e.contentDocument && s(e.contentDocument)
                  ? e.contentDocument
                  : (L(e, "template") && (e = e.content || e), T.merge([], e.childNodes));
              },
            },
            function (e, t) {
              T.fn[e] = function (n, r) {
                var i = T.map(this, t, n);
                return (
                  "Until" !== e.slice(-5) && (r = n),
                  r && "string" == typeof r && (i = T.filter(r, i)),
                  this.length > 1 && (j[e] || T.uniqueSort(i), I.test(e) && i.reverse()),
                  this.pushStack(i)
                );
              };
            }
          );
        var q = /[^\x20\t\r\n\f]+/g;
        function _(e) {
          return e;
        }
        function H(e) {
          throw e;
        }
        function B(e, t, n, r) {
          var i;
          try {
            e && v((i = e.promise))
              ? i.call(e).done(t).fail(n)
              : e && v((i = e.then))
                ? i.call(e, t, n)
                : t.apply(void 0, [e].slice(r));
          } catch (e) {
            n.apply(void 0, [e]);
          }
        }
        (T.Callbacks = function (e) {
          e =
            "string" == typeof e
              ? (function (e) {
                var t = {};
                return (
                  T.each(e.match(q) || [], function (e, n) {
                    t[n] = !0;
                  }),
                  t
                );
              })(e)
              : T.extend({}, e);
          var t,
            n,
            r,
            i,
            a = [],
            s = [],
            o = -1,
            l = function () {
              for (i = i || e.once, r = t = !0; s.length; o = -1)
                for (n = s.shift(); ++o < a.length;)
                  !1 === a[o].apply(n[0], n[1]) && e.stopOnFalse && ((o = a.length), (n = !1));
              e.memory || (n = !1), (t = !1), i && (a = n ? [] : "");
            },
            c = {
              add: function () {
                return (
                  a &&
                  (n && !t && ((o = a.length - 1), s.push(n)),
                    (function t(n) {
                      T.each(n, function (n, r) {
                        v(r) ? (e.unique && c.has(r)) || a.push(r) : r && r.length && "string" !== C(r) && t(r);
                      });
                    })(arguments),
                    n && !t && l()),
                  this
                );
              },
              remove: function () {
                return (
                  T.each(arguments, function (e, t) {
                    for (var n; (n = T.inArray(t, a, n)) > -1;) a.splice(n, 1), n <= o && o--;
                  }),
                  this
                );
              },
              has: function (e) {
                return e ? T.inArray(e, a) > -1 : a.length > 0;
              },
              empty: function () {
                return a && (a = []), this;
              },
              disable: function () {
                return (i = s = []), (a = n = ""), this;
              },
              disabled: function () {
                return !a;
              },
              lock: function () {
                return (i = s = []), n || t || (a = n = ""), this;
              },
              locked: function () {
                return !!i;
              },
              fireWith: function (e, n) {
                return i || ((n = [e, (n = n || []).slice ? n.slice() : n]), s.push(n), t || l()), this;
              },
              fire: function () {
                return c.fireWith(this, arguments), this;
              },
              fired: function () {
                return !!r;
              },
            };
          return c;
        }),
          T.extend({
            Deferred: function (e) {
              var t = [
                ["notify", "progress", T.Callbacks("memory"), T.Callbacks("memory"), 2],
                ["resolve", "done", T.Callbacks("once memory"), T.Callbacks("once memory"), 0, "resolved"],
                ["reject", "fail", T.Callbacks("once memory"), T.Callbacks("once memory"), 1, "rejected"],
              ],
                n = "pending",
                i = {
                  state: function () {
                    return n;
                  },
                  always: function () {
                    return a.done(arguments).fail(arguments), this;
                  },
                  catch: function (e) {
                    return i.then(null, e);
                  },
                  pipe: function () {
                    var e = arguments;
                    return T.Deferred(function (n) {
                      T.each(t, function (t, r) {
                        var i = v(e[r[4]]) && e[r[4]];
                        a[r[1]](function () {
                          var e = i && i.apply(this, arguments);
                          e && v(e.promise)
                            ? e.promise().progress(n.notify).done(n.resolve).fail(n.reject)
                            : n[r[0] + "With"](this, i ? [e] : arguments);
                        });
                      }),
                        (e = null);
                    }).promise();
                  },
                  then: function (e, n, i) {
                    var a = 0;
                    function s(e, t, n, i) {
                      return function () {
                        var o = this,
                          l = arguments,
                          c = function () {
                            var r, c;
                            if (!(e < a)) {
                              if ((r = n.apply(o, l)) === t.promise())
                                throw new TypeError("Thenable self-resolution");
                              (c = r && ("object" == typeof r || "function" == typeof r) && r.then),
                                v(c)
                                  ? i
                                    ? c.call(r, s(a, t, _, i), s(a, t, H, i))
                                    : (a++, c.call(r, s(a, t, _, i), s(a, t, H, i), s(a, t, _, t.notifyWith)))
                                  : (n !== _ && ((o = void 0), (l = [r])), (i || t.resolveWith)(o, l));
                            }
                          },
                          d = i
                            ? c
                            : function () {
                              try {
                                c();
                              } catch (r) {
                                T.Deferred.exceptionHook && T.Deferred.exceptionHook(r, d.stackTrace),
                                  e + 1 >= a && (n !== H && ((o = void 0), (l = [r])), t.rejectWith(o, l));
                              }
                            };
                        e
                          ? d()
                          : (T.Deferred.getStackHook && (d.stackTrace = T.Deferred.getStackHook()), r.setTimeout(d));
                      };
                    }
                    return T.Deferred(function (r) {
                      t[0][3].add(s(0, r, v(i) ? i : _, r.notifyWith)),
                        t[1][3].add(s(0, r, v(e) ? e : _)),
                        t[2][3].add(s(0, r, v(n) ? n : H));
                    }).promise();
                  },
                  promise: function (e) {
                    return null != e ? T.extend(e, i) : i;
                  },
                },
                a = {};
              return (
                T.each(t, function (e, r) {
                  var s = r[2],
                    o = r[5];
                  (i[r[1]] = s.add),
                    o &&
                    s.add(
                      function () {
                        n = o;
                      },
                      t[3 - e][2].disable,
                      t[3 - e][3].disable,
                      t[0][2].lock,
                      t[0][3].lock
                    ),
                    s.add(r[3].fire),
                    (a[r[0]] = function () {
                      return a[r[0] + "With"](this === a ? void 0 : this, arguments), this;
                    }),
                    (a[r[0] + "With"] = s.fireWith);
                }),
                i.promise(a),
                e && e.call(a, a),
                a
              );
            },
            when: function (e) {
              var t = arguments.length,
                n = t,
                r = Array(n),
                i = o.call(arguments),
                a = T.Deferred(),
                s = function (e) {
                  return function (n) {
                    (r[e] = this), (i[e] = arguments.length > 1 ? o.call(arguments) : n), --t || a.resolveWith(r, i);
                  };
                };
              if (
                t <= 1 &&
                (B(e, a.done(s(n)).resolve, a.reject, !t), "pending" === a.state() || v(i[n] && i[n].then))
              )
                return a.then();
              for (; n--;) B(i[n], s(n), a.reject);
              return a.promise();
            },
          });
        var R = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
        (T.Deferred.exceptionHook = function (e, t) {
          r.console &&
            r.console.warn &&
            e &&
            R.test(e.name) &&
            r.console.warn("jQuery.Deferred exception: " + e.message, e.stack, t);
        }),
          (T.readyException = function (e) {
            r.setTimeout(function () {
              throw e;
            });
          });
        var G = T.Deferred();
        function W() {
          b.removeEventListener("DOMContentLoaded", W), r.removeEventListener("load", W), T.ready();
        }
        (T.fn.ready = function (e) {
          return (
            G.then(e).catch(function (e) {
              T.readyException(e);
            }),
            this
          );
        }),
          T.extend({
            isReady: !1,
            readyWait: 1,
            ready: function (e) {
              (!0 === e ? --T.readyWait : T.isReady) ||
                ((T.isReady = !0), (!0 !== e && --T.readyWait > 0) || G.resolveWith(b, [T]));
            },
          }),
          (T.ready.then = G.then),
          "complete" === b.readyState || ("loading" !== b.readyState && !b.documentElement.doScroll)
            ? r.setTimeout(T.ready)
            : (b.addEventListener("DOMContentLoaded", W), r.addEventListener("load", W));
        var F = function (e, t, n, r, i, a, s) {
          var o = 0,
            l = e.length,
            c = null == n;
          if ("object" === C(n)) for (o in ((i = !0), n)) F(e, t, o, n[o], !0, a, s);
          else if (
            void 0 !== r &&
            ((i = !0),
              v(r) || (s = !0),
              c &&
              (s
                ? (t.call(e, r), (t = null))
                : ((c = t),
                  (t = function (e, t, n) {
                    return c.call(T(e), n);
                  }))),
              t)
          )
            for (; o < l; o++) t(e[o], n, s ? r : r.call(e[o], o, t(e[o], n)));
          return i ? e : c ? t.call(e) : l ? t(e[0], n) : a;
        },
          X = /^-ms-/,
          Y = /-([a-z])/g;
        function V(e, t) {
          return t.toUpperCase();
        }
        function U(e) {
          return e.replace(X, "ms-").replace(Y, V);
        }
        var K = function (e) {
          return 1 === e.nodeType || 9 === e.nodeType || !+e.nodeType;
        };
        function J() {
          this.expando = T.expando + J.uid++;
        }
        (J.uid = 1),
          (J.prototype = {
            cache: function (e) {
              var t = e[this.expando];
              return (
                t ||
                ((t = {}),
                  K(e) &&
                  (e.nodeType
                    ? (e[this.expando] = t)
                    : Object.defineProperty(e, this.expando, { value: t, configurable: !0 }))),
                t
              );
            },
            set: function (e, t, n) {
              var r,
                i = this.cache(e);
              if ("string" == typeof t) i[U(t)] = n;
              else for (r in t) i[U(r)] = t[r];
              return i;
            },
            get: function (e, t) {
              return void 0 === t ? this.cache(e) : e[this.expando] && e[this.expando][U(t)];
            },
            access: function (e, t, n) {
              return void 0 === t || (t && "string" == typeof t && void 0 === n)
                ? this.get(e, t)
                : (this.set(e, t, n), void 0 !== n ? n : t);
            },
            remove: function (e, t) {
              var n,
                r = e[this.expando];
              if (void 0 !== r) {
                if (void 0 !== t) {
                  n = (t = Array.isArray(t) ? t.map(U) : (t = U(t)) in r ? [t] : t.match(q) || []).length;
                  for (; n--;) delete r[t[n]];
                }
                (void 0 === t || T.isEmptyObject(r)) &&
                  (e.nodeType ? (e[this.expando] = void 0) : delete e[this.expando]);
              }
            },
            hasData: function (e) {
              var t = e[this.expando];
              return void 0 !== t && !T.isEmptyObject(t);
            },
          });
        var Q = new J(),
          Z = new J(),
          ee = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
          te = /[A-Z]/g;
        function ne(e, t, n) {
          var r;
          if (void 0 === n && 1 === e.nodeType)
            if (((r = "data-" + t.replace(te, "-$&").toLowerCase()), "string" == typeof (n = e.getAttribute(r)))) {
              try {
                n = (function (e) {
                  return (
                    "true" === e ||
                    ("false" !== e && ("null" === e ? null : e === +e + "" ? +e : ee.test(e) ? JSON.parse(e) : e))
                  );
                })(n);
              } catch (e) { }
              Z.set(e, t, n);
            } else n = void 0;
          return n;
        }
        T.extend({
          hasData: function (e) {
            return Z.hasData(e) || Q.hasData(e);
          },
          data: function (e, t, n) {
            return Z.access(e, t, n);
          },
          removeData: function (e, t) {
            Z.remove(e, t);
          },
          _data: function (e, t, n) {
            return Q.access(e, t, n);
          },
          _removeData: function (e, t) {
            Q.remove(e, t);
          },
        }),
          T.fn.extend({
            data: function (e, t) {
              var n,
                r,
                i,
                a = this[0],
                s = a && a.attributes;
              if (void 0 === e) {
                if (this.length && ((i = Z.get(a)), 1 === a.nodeType && !Q.get(a, "hasDataAttrs"))) {
                  for (n = s.length; n--;)
                    s[n] && 0 === (r = s[n].name).indexOf("data-") && ((r = U(r.slice(5))), ne(a, r, i[r]));
                  Q.set(a, "hasDataAttrs", !0);
                }
                return i;
              }
              return "object" == typeof e
                ? this.each(function () {
                  Z.set(this, e);
                })
                : F(
                  this,
                  function (t) {
                    var n;
                    if (a && void 0 === t)
                      return void 0 !== (n = Z.get(a, e)) || void 0 !== (n = ne(a, e)) ? n : void 0;
                    this.each(function () {
                      Z.set(this, e, t);
                    });
                  },
                  null,
                  t,
                  arguments.length > 1,
                  null,
                  !0
                );
            },
            removeData: function (e) {
              return this.each(function () {
                Z.remove(this, e);
              });
            },
          }),
          T.extend({
            queue: function (e, t, n) {
              var r;
              if (e)
                return (
                  (t = (t || "fx") + "queue"),
                  (r = Q.get(e, t)),
                  n && (!r || Array.isArray(n) ? (r = Q.access(e, t, T.makeArray(n))) : r.push(n)),
                  r || []
                );
            },
            dequeue: function (e, t) {
              t = t || "fx";
              var n = T.queue(e, t),
                r = n.length,
                i = n.shift(),
                a = T._queueHooks(e, t);
              "inprogress" === i && ((i = n.shift()), r--),
                i &&
                ("fx" === t && n.unshift("inprogress"),
                  delete a.stop,
                  i.call(
                    e,
                    function () {
                      T.dequeue(e, t);
                    },
                    a
                  )),
                !r && a && a.empty.fire();
            },
            _queueHooks: function (e, t) {
              var n = t + "queueHooks";
              return (
                Q.get(e, n) ||
                Q.access(e, n, {
                  empty: T.Callbacks("once memory").add(function () {
                    Q.remove(e, [t + "queue", n]);
                  }),
                })
              );
            },
          }),
          T.fn.extend({
            queue: function (e, t) {
              var n = 2;
              return (
                "string" != typeof e && ((t = e), (e = "fx"), n--),
                arguments.length < n
                  ? T.queue(this[0], e)
                  : void 0 === t
                    ? this
                    : this.each(function () {
                      var n = T.queue(this, e, t);
                      T._queueHooks(this, e), "fx" === e && "inprogress" !== n[0] && T.dequeue(this, e);
                    })
              );
            },
            dequeue: function (e) {
              return this.each(function () {
                T.dequeue(this, e);
              });
            },
            clearQueue: function (e) {
              return this.queue(e || "fx", []);
            },
            promise: function (e, t) {
              var n,
                r = 1,
                i = T.Deferred(),
                a = this,
                s = this.length,
                o = function () {
                  --r || i.resolveWith(a, [a]);
                };
              for ("string" != typeof e && ((t = e), (e = void 0)), e = e || "fx"; s--;)
                (n = Q.get(a[s], e + "queueHooks")) && n.empty && (r++, n.empty.add(o));
              return o(), i.promise(t);
            },
          });
        var re = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,
          ie = new RegExp("^(?:([+-])=|)(" + re + ")([a-z%]*)$", "i"),
          ae = ["Top", "Right", "Bottom", "Left"],
          se = b.documentElement,
          oe = function (e) {
            return T.contains(e.ownerDocument, e);
          },
          le = { composed: !0 };
        se.getRootNode &&
          (oe = function (e) {
            return T.contains(e.ownerDocument, e) || e.getRootNode(le) === e.ownerDocument;
          });
        var ce = function (e, t) {
          return (
            "none" === (e = t || e).style.display ||
            ("" === e.style.display && oe(e) && "none" === T.css(e, "display"))
          );
        };
        function de(e, t, n, r) {
          var i,
            a,
            s = 20,
            o = r
              ? function () {
                return r.cur();
              }
              : function () {
                return T.css(e, t, "");
              },
            l = o(),
            c = (n && n[3]) || (T.cssNumber[t] ? "" : "px"),
            d = e.nodeType && (T.cssNumber[t] || ("px" !== c && +l)) && ie.exec(T.css(e, t));
          if (d && d[3] !== c) {
            for (l /= 2, c = c || d[3], d = +l || 1; s--;)
              T.style(e, t, d + c), (1 - a) * (1 - (a = o() / l || 0.5)) <= 0 && (s = 0), (d /= a);
            (d *= 2), T.style(e, t, d + c), (n = n || []);
          }
          return (
            n &&
            ((d = +d || +l || 0),
              (i = n[1] ? d + (n[1] + 1) * n[2] : +n[2]),
              r && ((r.unit = c), (r.start = d), (r.end = i))),
            i
          );
        }
        var ue = {};
        function pe(e) {
          var t,
            n = e.ownerDocument,
            r = e.nodeName,
            i = ue[r];
          return (
            i ||
            ((t = n.body.appendChild(n.createElement(r))),
              (i = T.css(t, "display")),
              t.parentNode.removeChild(t),
              "none" === i && (i = "block"),
              (ue[r] = i),
              i)
          );
        }
        function fe(e, t) {
          for (var n, r, i = [], a = 0, s = e.length; a < s; a++)
            (r = e[a]).style &&
              ((n = r.style.display),
                t
                  ? ("none" === n && ((i[a] = Q.get(r, "display") || null), i[a] || (r.style.display = "")),
                    "" === r.style.display && ce(r) && (i[a] = pe(r)))
                  : "none" !== n && ((i[a] = "none"), Q.set(r, "display", n)));
          for (a = 0; a < s; a++) null != i[a] && (e[a].style.display = i[a]);
          return e;
        }
        T.fn.extend({
          show: function () {
            return fe(this, !0);
          },
          hide: function () {
            return fe(this);
          },
          toggle: function (e) {
            return "boolean" == typeof e
              ? e
                ? this.show()
                : this.hide()
              : this.each(function () {
                ce(this) ? T(this).show() : T(this).hide();
              });
          },
        });
        var he,
          me,
          ge = /^(?:checkbox|radio)$/i,
          ve = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i,
          ye = /^$|^module$|\/(?:java|ecma)script/i;
        (he = b.createDocumentFragment().appendChild(b.createElement("div"))),
          (me = b.createElement("input")).setAttribute("type", "radio"),
          me.setAttribute("checked", "checked"),
          me.setAttribute("name", "t"),
          he.appendChild(me),
          (g.checkClone = he.cloneNode(!0).cloneNode(!0).lastChild.checked),
          (he.innerHTML = "<textarea>x</textarea>"),
          (g.noCloneChecked = !!he.cloneNode(!0).lastChild.defaultValue),
          (he.innerHTML = "<option></option>"),
          (g.option = !!he.lastChild);
        var be = {
          thead: [1, "<table>", "</table>"],
          col: [2, "<table><colgroup>", "</colgroup></table>"],
          tr: [2, "<table><tbody>", "</tbody></table>"],
          td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
          _default: [0, "", ""],
        };
        function we(e, t) {
          var n;
          return (
            (n =
              void 0 !== e.getElementsByTagName
                ? e.getElementsByTagName(t || "*")
                : void 0 !== e.querySelectorAll
                  ? e.querySelectorAll(t || "*")
                  : []),
            void 0 === t || (t && L(e, t)) ? T.merge([e], n) : n
          );
        }
        function xe(e, t) {
          for (var n = 0, r = e.length; n < r; n++) Q.set(e[n], "globalEval", !t || Q.get(t[n], "globalEval"));
        }
        (be.tbody = be.tfoot = be.colgroup = be.caption = be.thead),
          (be.th = be.td),
          g.option || (be.optgroup = be.option = [1, "<select multiple='multiple'>", "</select>"]);
        var Ce = /<|&#?\w+;/;
        function Ee(e, t, n, r, i) {
          for (var a, s, o, l, c, d, u = t.createDocumentFragment(), p = [], f = 0, h = e.length; f < h; f++)
            if ((a = e[f]) || 0 === a)
              if ("object" === C(a)) T.merge(p, a.nodeType ? [a] : a);
              else if (Ce.test(a)) {
                for (
                  s = s || u.appendChild(t.createElement("div")),
                  o = (ve.exec(a) || ["", ""])[1].toLowerCase(),
                  l = be[o] || be._default,
                  s.innerHTML = l[1] + T.htmlPrefilter(a) + l[2],
                  d = l[0];
                  d--;

                )
                  s = s.lastChild;
                T.merge(p, s.childNodes), ((s = u.firstChild).textContent = "");
              } else p.push(t.createTextNode(a));
          for (u.textContent = "", f = 0; (a = p[f++]);)
            if (r && T.inArray(a, r) > -1) i && i.push(a);
            else if (((c = oe(a)), (s = we(u.appendChild(a), "script")), c && xe(s), n))
              for (d = 0; (a = s[d++]);) ye.test(a.type || "") && n.push(a);
          return u;
        }
        var Te = /^([^.]*)(?:\.(.+)|)/;
        function Se() {
          return !0;
        }
        function $e() {
          return !1;
        }
        function ke(e, t) {
          return (
            (e ===
              (function () {
                try {
                  return b.activeElement;
                } catch (e) { }
              })()) ==
            ("focus" === t)
          );
        }
        function Me(e, t, n, r, i, a) {
          var s, o;
          if ("object" == typeof t) {
            for (o in ("string" != typeof n && ((r = r || n), (n = void 0)), t)) Me(e, o, n, r, t[o], a);
            return e;
          }
          if (
            (null == r && null == i
              ? ((i = n), (r = n = void 0))
              : null == i && ("string" == typeof n ? ((i = r), (r = void 0)) : ((i = r), (r = n), (n = void 0))),
              !1 === i)
          )
            i = $e;
          else if (!i) return e;
          return (
            1 === a &&
            ((s = i),
              (i = function (e) {
                return T().off(e), s.apply(this, arguments);
              }),
              (i.guid = s.guid || (s.guid = T.guid++))),
            e.each(function () {
              T.event.add(this, t, i, r, n);
            })
          );
        }
        function Pe(e, t, n) {
          n
            ? (Q.set(e, t, !1),
              T.event.add(e, t, {
                namespace: !1,
                handler: function (e) {
                  var r,
                    i,
                    a = Q.get(this, t);
                  if (1 & e.isTrigger && this[t]) {
                    if (a.length) (T.event.special[t] || {}).delegateType && e.stopPropagation();
                    else if (
                      ((a = o.call(arguments)),
                        Q.set(this, t, a),
                        (r = n(this, t)),
                        this[t](),
                        a !== (i = Q.get(this, t)) || r ? Q.set(this, t, !1) : (i = {}),
                        a !== i)
                    )
                      return e.stopImmediatePropagation(), e.preventDefault(), i && i.value;
                  } else
                    a.length &&
                      (Q.set(this, t, {
                        value: T.event.trigger(T.extend(a[0], T.Event.prototype), a.slice(1), this),
                      }),
                        e.stopImmediatePropagation());
                },
              }))
            : void 0 === Q.get(e, t) && T.event.add(e, t, Se);
        }
        (T.event = {
          global: {},
          add: function (e, t, n, r, i) {
            var a,
              s,
              o,
              l,
              c,
              d,
              u,
              p,
              f,
              h,
              m,
              g = Q.get(e);
            if (K(e))
              for (
                n.handler && ((n = (a = n).handler), (i = a.selector)),
                i && T.find.matchesSelector(se, i),
                n.guid || (n.guid = T.guid++),
                (l = g.events) || (l = g.events = Object.create(null)),
                (s = g.handle) ||
                (s = g.handle =
                  function (t) {
                    return void 0 !== T && T.event.triggered !== t.type
                      ? T.event.dispatch.apply(e, arguments)
                      : void 0;
                  }),
                c = (t = (t || "").match(q) || [""]).length;
                c--;

              )
                (f = m = (o = Te.exec(t[c]) || [])[1]),
                  (h = (o[2] || "").split(".").sort()),
                  f &&
                  ((u = T.event.special[f] || {}),
                    (f = (i ? u.delegateType : u.bindType) || f),
                    (u = T.event.special[f] || {}),
                    (d = T.extend(
                      {
                        type: f,
                        origType: m,
                        data: r,
                        handler: n,
                        guid: n.guid,
                        selector: i,
                        needsContext: i && T.expr.match.needsContext.test(i),
                        namespace: h.join("."),
                      },
                      a
                    )),
                    (p = l[f]) ||
                    (((p = l[f] = []).delegateCount = 0),
                      (u.setup && !1 !== u.setup.call(e, r, h, s)) ||
                      (e.addEventListener && e.addEventListener(f, s))),
                    u.add && (u.add.call(e, d), d.handler.guid || (d.handler.guid = n.guid)),
                    i ? p.splice(p.delegateCount++, 0, d) : p.push(d),
                    (T.event.global[f] = !0));
          },
          remove: function (e, t, n, r, i) {
            var a,
              s,
              o,
              l,
              c,
              d,
              u,
              p,
              f,
              h,
              m,
              g = Q.hasData(e) && Q.get(e);
            if (g && (l = g.events)) {
              for (c = (t = (t || "").match(q) || [""]).length; c--;)
                if (((f = m = (o = Te.exec(t[c]) || [])[1]), (h = (o[2] || "").split(".").sort()), f)) {
                  for (
                    u = T.event.special[f] || {},
                    p = l[(f = (r ? u.delegateType : u.bindType) || f)] || [],
                    o = o[2] && new RegExp("(^|\\.)" + h.join("\\.(?:.*\\.|)") + "(\\.|$)"),
                    s = a = p.length;
                    a--;

                  )
                    (d = p[a]),
                      (!i && m !== d.origType) ||
                      (n && n.guid !== d.guid) ||
                      (o && !o.test(d.namespace)) ||
                      (r && r !== d.selector && ("**" !== r || !d.selector)) ||
                      (p.splice(a, 1), d.selector && p.delegateCount--, u.remove && u.remove.call(e, d));
                  s &&
                    !p.length &&
                    ((u.teardown && !1 !== u.teardown.call(e, h, g.handle)) || T.removeEvent(e, f, g.handle),
                      delete l[f]);
                } else for (f in l) T.event.remove(e, f + t[c], n, r, !0);
              T.isEmptyObject(l) && Q.remove(e, "handle events");
            }
          },
          dispatch: function (e) {
            var t,
              n,
              r,
              i,
              a,
              s,
              o = new Array(arguments.length),
              l = T.event.fix(e),
              c = (Q.get(this, "events") || Object.create(null))[l.type] || [],
              d = T.event.special[l.type] || {};
            for (o[0] = l, t = 1; t < arguments.length; t++) o[t] = arguments[t];
            if (((l.delegateTarget = this), !d.preDispatch || !1 !== d.preDispatch.call(this, l))) {
              for (s = T.event.handlers.call(this, l, c), t = 0; (i = s[t++]) && !l.isPropagationStopped();)
                for (l.currentTarget = i.elem, n = 0; (a = i.handlers[n++]) && !l.isImmediatePropagationStopped();)
                  (l.rnamespace && !1 !== a.namespace && !l.rnamespace.test(a.namespace)) ||
                    ((l.handleObj = a),
                      (l.data = a.data),
                      void 0 !== (r = ((T.event.special[a.origType] || {}).handle || a.handler).apply(i.elem, o)) &&
                      !1 === (l.result = r) &&
                      (l.preventDefault(), l.stopPropagation()));
              return d.postDispatch && d.postDispatch.call(this, l), l.result;
            }
          },
          handlers: function (e, t) {
            var n,
              r,
              i,
              a,
              s,
              o = [],
              l = t.delegateCount,
              c = e.target;
            if (l && c.nodeType && !("click" === e.type && e.button >= 1))
              for (; c !== this; c = c.parentNode || this)
                if (1 === c.nodeType && ("click" !== e.type || !0 !== c.disabled)) {
                  for (a = [], s = {}, n = 0; n < l; n++)
                    void 0 === s[(i = (r = t[n]).selector + " ")] &&
                      (s[i] = r.needsContext ? T(i, this).index(c) > -1 : T.find(i, this, null, [c]).length),
                      s[i] && a.push(r);
                  a.length && o.push({ elem: c, handlers: a });
                }
            return (c = this), l < t.length && o.push({ elem: c, handlers: t.slice(l) }), o;
          },
          addProp: function (e, t) {
            Object.defineProperty(T.Event.prototype, e, {
              enumerable: !0,
              configurable: !0,
              get: v(t)
                ? function () {
                  if (this.originalEvent) return t(this.originalEvent);
                }
                : function () {
                  if (this.originalEvent) return this.originalEvent[e];
                },
              set: function (t) {
                Object.defineProperty(this, e, { enumerable: !0, configurable: !0, writable: !0, value: t });
              },
            });
          },
          fix: function (e) {
            return e[T.expando] ? e : new T.Event(e);
          },
          special: {
            load: { noBubble: !0 },
            click: {
              setup: function (e) {
                var t = this || e;
                return ge.test(t.type) && t.click && L(t, "input") && Pe(t, "click", Se), !1;
              },
              trigger: function (e) {
                var t = this || e;
                return ge.test(t.type) && t.click && L(t, "input") && Pe(t, "click"), !0;
              },
              _default: function (e) {
                var t = e.target;
                return (ge.test(t.type) && t.click && L(t, "input") && Q.get(t, "click")) || L(t, "a");
              },
            },
            beforeunload: {
              postDispatch: function (e) {
                void 0 !== e.result && e.originalEvent && (e.originalEvent.returnValue = e.result);
              },
            },
          },
        }),
          (T.removeEvent = function (e, t, n) {
            e.removeEventListener && e.removeEventListener(t, n);
          }),
          (T.Event = function (e, t) {
            if (!(this instanceof T.Event)) return new T.Event(e, t);
            e && e.type
              ? ((this.originalEvent = e),
                (this.type = e.type),
                (this.isDefaultPrevented =
                  e.defaultPrevented || (void 0 === e.defaultPrevented && !1 === e.returnValue) ? Se : $e),
                (this.target = e.target && 3 === e.target.nodeType ? e.target.parentNode : e.target),
                (this.currentTarget = e.currentTarget),
                (this.relatedTarget = e.relatedTarget))
              : (this.type = e),
              t && T.extend(this, t),
              (this.timeStamp = (e && e.timeStamp) || Date.now()),
              (this[T.expando] = !0);
          }),
          (T.Event.prototype = {
            constructor: T.Event,
            isDefaultPrevented: $e,
            isPropagationStopped: $e,
            isImmediatePropagationStopped: $e,
            isSimulated: !1,
            preventDefault: function () {
              var e = this.originalEvent;
              (this.isDefaultPrevented = Se), e && !this.isSimulated && e.preventDefault();
            },
            stopPropagation: function () {
              var e = this.originalEvent;
              (this.isPropagationStopped = Se), e && !this.isSimulated && e.stopPropagation();
            },
            stopImmediatePropagation: function () {
              var e = this.originalEvent;
              (this.isImmediatePropagationStopped = Se),
                e && !this.isSimulated && e.stopImmediatePropagation(),
                this.stopPropagation();
            },
          }),
          T.each(
            {
              altKey: !0,
              bubbles: !0,
              cancelable: !0,
              changedTouches: !0,
              ctrlKey: !0,
              detail: !0,
              eventPhase: !0,
              metaKey: !0,
              pageX: !0,
              pageY: !0,
              shiftKey: !0,
              view: !0,
              char: !0,
              code: !0,
              charCode: !0,
              key: !0,
              keyCode: !0,
              button: !0,
              buttons: !0,
              clientX: !0,
              clientY: !0,
              offsetX: !0,
              offsetY: !0,
              pointerId: !0,
              pointerType: !0,
              screenX: !0,
              screenY: !0,
              targetTouches: !0,
              toElement: !0,
              touches: !0,
              which: !0,
            },
            T.event.addProp
          ),
          T.each({ focus: "focusin", blur: "focusout" }, function (e, t) {
            T.event.special[e] = {
              setup: function () {
                return Pe(this, e, ke), !1;
              },
              trigger: function () {
                return Pe(this, e), !0;
              },
              _default: function (t) {
                return Q.get(t.target, e);
              },
              delegateType: t,
            };
          }),
          T.each(
            {
              mouseenter: "mouseover",
              mouseleave: "mouseout",
              pointerenter: "pointerover",
              pointerleave: "pointerout",
            },
            function (e, t) {
              T.event.special[e] = {
                delegateType: t,
                bindType: t,
                handle: function (e) {
                  var n,
                    r = this,
                    i = e.relatedTarget,
                    a = e.handleObj;
                  return (
                    (i && (i === r || T.contains(r, i))) ||
                    ((e.type = a.origType), (n = a.handler.apply(this, arguments)), (e.type = t)),
                    n
                  );
                },
              };
            }
          ),
          T.fn.extend({
            on: function (e, t, n, r) {
              return Me(this, e, t, n, r);
            },
            one: function (e, t, n, r) {
              return Me(this, e, t, n, r, 1);
            },
            off: function (e, t, n) {
              var r, i;
              if (e && e.preventDefault && e.handleObj)
                return (
                  (r = e.handleObj),
                  T(e.delegateTarget).off(
                    r.namespace ? r.origType + "." + r.namespace : r.origType,
                    r.selector,
                    r.handler
                  ),
                  this
                );
              if ("object" == typeof e) {
                for (i in e) this.off(i, t, e[i]);
                return this;
              }
              return (
                (!1 !== t && "function" != typeof t) || ((n = t), (t = void 0)),
                !1 === n && (n = $e),
                this.each(function () {
                  T.event.remove(this, e, n, t);
                })
              );
            },
          });
        var Le = /<script|<style|<link/i,
          Oe = /checked\s*(?:[^=]|=\s*.checked.)/i,
          Ae = /^\s*<!\[CDATA\[|\]\]>\s*$/g;
        function De(e, t) {
          return (L(e, "table") && L(11 !== t.nodeType ? t : t.firstChild, "tr") && T(e).children("tbody")[0]) || e;
        }
        function Ne(e) {
          return (e.type = (null !== e.getAttribute("type")) + "/" + e.type), e;
        }
        function Ie(e) {
          return "true/" === (e.type || "").slice(0, 5) ? (e.type = e.type.slice(5)) : e.removeAttribute("type"), e;
        }
        function je(e, t) {
          var n, r, i, a, s, o;
          if (1 === t.nodeType) {
            if (Q.hasData(e) && (o = Q.get(e).events))
              for (i in (Q.remove(t, "handle events"), o))
                for (n = 0, r = o[i].length; n < r; n++) T.event.add(t, i, o[i][n]);
            Z.hasData(e) && ((a = Z.access(e)), (s = T.extend({}, a)), Z.set(t, s));
          }
        }
        function ze(e, t) {
          var n = t.nodeName.toLowerCase();
          "input" === n && ge.test(e.type)
            ? (t.checked = e.checked)
            : ("input" !== n && "textarea" !== n) || (t.defaultValue = e.defaultValue);
        }
        function qe(e, t, n, r) {
          t = l(t);
          var i,
            a,
            s,
            o,
            c,
            d,
            u = 0,
            p = e.length,
            f = p - 1,
            h = t[0],
            m = v(h);
          if (m || (p > 1 && "string" == typeof h && !g.checkClone && Oe.test(h)))
            return e.each(function (i) {
              var a = e.eq(i);
              m && (t[0] = h.call(this, i, a.html())), qe(a, t, n, r);
            });
          if (
            p &&
            ((a = (i = Ee(t, e[0].ownerDocument, !1, e, r)).firstChild), 1 === i.childNodes.length && (i = a), a || r)
          ) {
            for (o = (s = T.map(we(i, "script"), Ne)).length; u < p; u++)
              (c = i), u !== f && ((c = T.clone(c, !0, !0)), o && T.merge(s, we(c, "script"))), n.call(e[u], c, u);
            if (o)
              for (d = s[s.length - 1].ownerDocument, T.map(s, Ie), u = 0; u < o; u++)
                (c = s[u]),
                  ye.test(c.type || "") &&
                  !Q.access(c, "globalEval") &&
                  T.contains(d, c) &&
                  (c.src && "module" !== (c.type || "").toLowerCase()
                    ? T._evalUrl &&
                    !c.noModule &&
                    T._evalUrl(c.src, { nonce: c.nonce || c.getAttribute("nonce") }, d)
                    : x(c.textContent.replace(Ae, ""), c, d));
          }
          return e;
        }
        function _e(e, t, n) {
          for (var r, i = t ? T.filter(t, e) : e, a = 0; null != (r = i[a]); a++)
            n || 1 !== r.nodeType || T.cleanData(we(r)),
              r.parentNode && (n && oe(r) && xe(we(r, "script")), r.parentNode.removeChild(r));
          return e;
        }
        T.extend({
          htmlPrefilter: function (e) {
            return e;
          },
          clone: function (e, t, n) {
            var r,
              i,
              a,
              s,
              o = e.cloneNode(!0),
              l = oe(e);
            if (!(g.noCloneChecked || (1 !== e.nodeType && 11 !== e.nodeType) || T.isXMLDoc(e)))
              for (s = we(o), r = 0, i = (a = we(e)).length; r < i; r++) ze(a[r], s[r]);
            if (t)
              if (n) for (a = a || we(e), s = s || we(o), r = 0, i = a.length; r < i; r++) je(a[r], s[r]);
              else je(e, o);
            return (s = we(o, "script")).length > 0 && xe(s, !l && we(e, "script")), o;
          },
          cleanData: function (e) {
            for (var t, n, r, i = T.event.special, a = 0; void 0 !== (n = e[a]); a++)
              if (K(n)) {
                if ((t = n[Q.expando])) {
                  if (t.events) for (r in t.events) i[r] ? T.event.remove(n, r) : T.removeEvent(n, r, t.handle);
                  n[Q.expando] = void 0;
                }
                n[Z.expando] && (n[Z.expando] = void 0);
              }
          },
        }),
          T.fn.extend({
            detach: function (e) {
              return _e(this, e, !0);
            },
            remove: function (e) {
              return _e(this, e);
            },
            text: function (e) {
              return F(
                this,
                function (e) {
                  return void 0 === e
                    ? T.text(this)
                    : this.empty().each(function () {
                      (1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType) ||
                        (this.textContent = e);
                    });
                },
                null,
                e,
                arguments.length
              );
            },
            append: function () {
              return qe(this, arguments, function (e) {
                (1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType) || De(this, e).appendChild(e);
              });
            },
            prepend: function () {
              return qe(this, arguments, function (e) {
                if (1 === this.nodeType || 11 === this.nodeType || 9 === this.nodeType) {
                  var t = De(this, e);
                  t.insertBefore(e, t.firstChild);
                }
              });
            },
            before: function () {
              return qe(this, arguments, function (e) {
                this.parentNode && this.parentNode.insertBefore(e, this);
              });
            },
            after: function () {
              return qe(this, arguments, function (e) {
                this.parentNode && this.parentNode.insertBefore(e, this.nextSibling);
              });
            },
            empty: function () {
              for (var e, t = 0; null != (e = this[t]); t++)
                1 === e.nodeType && (T.cleanData(we(e, !1)), (e.textContent = ""));
              return this;
            },
            clone: function (e, t) {
              return (
                (e = null != e && e),
                (t = null == t ? e : t),
                this.map(function () {
                  return T.clone(this, e, t);
                })
              );
            },
            html: function (e) {
              return F(
                this,
                function (e) {
                  var t = this[0] || {},
                    n = 0,
                    r = this.length;
                  if (void 0 === e && 1 === t.nodeType) return t.innerHTML;
                  if ("string" == typeof e && !Le.test(e) && !be[(ve.exec(e) || ["", ""])[1].toLowerCase()]) {
                    e = T.htmlPrefilter(e);
                    try {
                      for (; n < r; n++)
                        1 === (t = this[n] || {}).nodeType && (T.cleanData(we(t, !1)), (t.innerHTML = e));
                      t = 0;
                    } catch (e) { }
                  }
                  t && this.empty().append(e);
                },
                null,
                e,
                arguments.length
              );
            },
            replaceWith: function () {
              var e = [];
              return qe(
                this,
                arguments,
                function (t) {
                  var n = this.parentNode;
                  T.inArray(this, e) < 0 && (T.cleanData(we(this)), n && n.replaceChild(t, this));
                },
                e
              );
            },
          }),
          T.each(
            {
              appendTo: "append",
              prependTo: "prepend",
              insertBefore: "before",
              insertAfter: "after",
              replaceAll: "replaceWith",
            },
            function (e, t) {
              T.fn[e] = function (e) {
                for (var n, r = [], i = T(e), a = i.length - 1, s = 0; s <= a; s++)
                  (n = s === a ? this : this.clone(!0)), T(i[s])[t](n), c.apply(r, n.get());
                return this.pushStack(r);
              };
            }
          );
        var He = new RegExp("^(" + re + ")(?!px)[a-z%]+$", "i"),
          Be = /^--/,
          Re = function (e) {
            var t = e.ownerDocument.defaultView;
            return (t && t.opener) || (t = r), t.getComputedStyle(e);
          },
          Ge = function (e, t, n) {
            var r,
              i,
              a = {};
            for (i in t) (a[i] = e.style[i]), (e.style[i] = t[i]);
            for (i in ((r = n.call(e)), t)) e.style[i] = a[i];
            return r;
          },
          We = new RegExp(ae.join("|"), "i"),
          Fe = "[\\x20\\t\\r\\n\\f]",
          Xe = new RegExp("^" + Fe + "+|((?:^|[^\\\\])(?:\\\\.)*)" + Fe + "+$", "g");
        function Ye(e, t, n) {
          var r,
            i,
            a,
            s,
            o = Be.test(t),
            l = e.style;
          return (
            (n = n || Re(e)) &&
            ((s = n.getPropertyValue(t) || n[t]),
              o && s && (s = s.replace(Xe, "$1") || void 0),
              "" !== s || oe(e) || (s = T.style(e, t)),
              !g.pixelBoxStyles() &&
              He.test(s) &&
              We.test(t) &&
              ((r = l.width),
                (i = l.minWidth),
                (a = l.maxWidth),
                (l.minWidth = l.maxWidth = l.width = s),
                (s = n.width),
                (l.width = r),
                (l.minWidth = i),
                (l.maxWidth = a))),
            void 0 !== s ? s + "" : s
          );
        }
        function Ve(e, t) {
          return {
            get: function () {
              if (!e()) return (this.get = t).apply(this, arguments);
              delete this.get;
            },
          };
        }
        !(function () {
          function e() {
            if (d) {
              (c.style.cssText = "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0"),
                (d.style.cssText =
                  "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%"),
                se.appendChild(c).appendChild(d);
              var e = r.getComputedStyle(d);
              (n = "1%" !== e.top),
                (l = 12 === t(e.marginLeft)),
                (d.style.right = "60%"),
                (s = 36 === t(e.right)),
                (i = 36 === t(e.width)),
                (d.style.position = "absolute"),
                (a = 12 === t(d.offsetWidth / 3)),
                se.removeChild(c),
                (d = null);
            }
          }
          function t(e) {
            return Math.round(parseFloat(e));
          }
          var n,
            i,
            a,
            s,
            o,
            l,
            c = b.createElement("div"),
            d = b.createElement("div");
          d.style &&
            ((d.style.backgroundClip = "content-box"),
              (d.cloneNode(!0).style.backgroundClip = ""),
              (g.clearCloneStyle = "content-box" === d.style.backgroundClip),
              T.extend(g, {
                boxSizingReliable: function () {
                  return e(), i;
                },
                pixelBoxStyles: function () {
                  return e(), s;
                },
                pixelPosition: function () {
                  return e(), n;
                },
                reliableMarginLeft: function () {
                  return e(), l;
                },
                scrollboxSize: function () {
                  return e(), a;
                },
                reliableTrDimensions: function () {
                  var e, t, n, i;
                  return (
                    null == o &&
                    ((e = b.createElement("table")),
                      (t = b.createElement("tr")),
                      (n = b.createElement("div")),
                      (e.style.cssText = "position:absolute;left:-11111px;border-collapse:separate"),
                      (t.style.cssText = "border:1px solid"),
                      (t.style.height = "1px"),
                      (n.style.height = "9px"),
                      (n.style.display = "block"),
                      se.appendChild(e).appendChild(t).appendChild(n),
                      (i = r.getComputedStyle(t)),
                      (o =
                        parseInt(i.height, 10) + parseInt(i.borderTopWidth, 10) + parseInt(i.borderBottomWidth, 10) ===
                        t.offsetHeight),
                      se.removeChild(e)),
                    o
                  );
                },
              }));
        })();
        var Ue = ["Webkit", "Moz", "ms"],
          Ke = b.createElement("div").style,
          Je = {};
        function Qe(e) {
          return (
            T.cssProps[e] ||
            Je[e] ||
            (e in Ke
              ? e
              : (Je[e] =
                (function (e) {
                  for (var t = e[0].toUpperCase() + e.slice(1), n = Ue.length; n--;)
                    if ((e = Ue[n] + t) in Ke) return e;
                })(e) || e))
          );
        }
        var Ze = /^(none|table(?!-c[ea]).+)/,
          et = { position: "absolute", visibility: "hidden", display: "block" },
          tt = { letterSpacing: "0", fontWeight: "400" };
        function nt(e, t, n) {
          var r = ie.exec(t);
          return r ? Math.max(0, r[2] - (n || 0)) + (r[3] || "px") : t;
        }
        function rt(e, t, n, r, i, a) {
          var s = "width" === t ? 1 : 0,
            o = 0,
            l = 0;
          if (n === (r ? "border" : "content")) return 0;
          for (; s < 4; s += 2)
            "margin" === n && (l += T.css(e, n + ae[s], !0, i)),
              r
                ? ("content" === n && (l -= T.css(e, "padding" + ae[s], !0, i)),
                  "margin" !== n && (l -= T.css(e, "border" + ae[s] + "Width", !0, i)))
                : ((l += T.css(e, "padding" + ae[s], !0, i)),
                  "padding" !== n
                    ? (l += T.css(e, "border" + ae[s] + "Width", !0, i))
                    : (o += T.css(e, "border" + ae[s] + "Width", !0, i)));
          return (
            !r &&
            a >= 0 &&
            (l += Math.max(0, Math.ceil(e["offset" + t[0].toUpperCase() + t.slice(1)] - a - l - o - 0.5)) || 0),
            l
          );
        }
        function it(e, t, n) {
          var r = Re(e),
            i = (!g.boxSizingReliable() || n) && "border-box" === T.css(e, "boxSizing", !1, r),
            a = i,
            s = Ye(e, t, r),
            o = "offset" + t[0].toUpperCase() + t.slice(1);
          if (He.test(s)) {
            if (!n) return s;
            s = "auto";
          }
          return (
            ((!g.boxSizingReliable() && i) ||
              (!g.reliableTrDimensions() && L(e, "tr")) ||
              "auto" === s ||
              (!parseFloat(s) && "inline" === T.css(e, "display", !1, r))) &&
            e.getClientRects().length &&
            ((i = "border-box" === T.css(e, "boxSizing", !1, r)), (a = o in e) && (s = e[o])),
            (s = parseFloat(s) || 0) + rt(e, t, n || (i ? "border" : "content"), a, r, s) + "px"
          );
        }
        function at(e, t, n, r, i) {
          return new at.prototype.init(e, t, n, r, i);
        }
        T.extend({
          cssHooks: {
            opacity: {
              get: function (e, t) {
                if (t) {
                  var n = Ye(e, "opacity");
                  return "" === n ? "1" : n;
                }
              },
            },
          },
          cssNumber: {
            animationIterationCount: !0,
            columnCount: !0,
            fillOpacity: !0,
            flexGrow: !0,
            flexShrink: !0,
            fontWeight: !0,
            gridArea: !0,
            gridColumn: !0,
            gridColumnEnd: !0,
            gridColumnStart: !0,
            gridRow: !0,
            gridRowEnd: !0,
            gridRowStart: !0,
            lineHeight: !0,
            opacity: !0,
            order: !0,
            orphans: !0,
            widows: !0,
            zIndex: !0,
            zoom: !0,
          },
          cssProps: {},
          style: function (e, t, n, r) {
            if (e && 3 !== e.nodeType && 8 !== e.nodeType && e.style) {
              var i,
                a,
                s,
                o = U(t),
                l = Be.test(t),
                c = e.style;
              if ((l || (t = Qe(o)), (s = T.cssHooks[t] || T.cssHooks[o]), void 0 === n))
                return s && "get" in s && void 0 !== (i = s.get(e, !1, r)) ? i : c[t];
              "string" == (a = typeof n) && (i = ie.exec(n)) && i[1] && ((n = de(e, t, i)), (a = "number")),
                null != n &&
                n == n &&
                ("number" !== a || l || (n += (i && i[3]) || (T.cssNumber[o] ? "" : "px")),
                  g.clearCloneStyle || "" !== n || 0 !== t.indexOf("background") || (c[t] = "inherit"),
                  (s && "set" in s && void 0 === (n = s.set(e, n, r))) || (l ? c.setProperty(t, n) : (c[t] = n)));
            }
          },
          css: function (e, t, n, r) {
            var i,
              a,
              s,
              o = U(t);
            return (
              Be.test(t) || (t = Qe(o)),
              (s = T.cssHooks[t] || T.cssHooks[o]) && "get" in s && (i = s.get(e, !0, n)),
              void 0 === i && (i = Ye(e, t, r)),
              "normal" === i && t in tt && (i = tt[t]),
              "" === n || n ? ((a = parseFloat(i)), !0 === n || isFinite(a) ? a || 0 : i) : i
            );
          },
        }),
          T.each(["height", "width"], function (e, t) {
            T.cssHooks[t] = {
              get: function (e, n, r) {
                if (n)
                  return !Ze.test(T.css(e, "display")) ||
                    (e.getClientRects().length && e.getBoundingClientRect().width)
                    ? it(e, t, r)
                    : Ge(e, et, function () {
                      return it(e, t, r);
                    });
              },
              set: function (e, n, r) {
                var i,
                  a = Re(e),
                  s = !g.scrollboxSize() && "absolute" === a.position,
                  o = (s || r) && "border-box" === T.css(e, "boxSizing", !1, a),
                  l = r ? rt(e, t, r, o, a) : 0;
                return (
                  o &&
                  s &&
                  (l -= Math.ceil(
                    e["offset" + t[0].toUpperCase() + t.slice(1)] -
                    parseFloat(a[t]) -
                    rt(e, t, "border", !1, a) -
                    0.5
                  )),
                  l && (i = ie.exec(n)) && "px" !== (i[3] || "px") && ((e.style[t] = n), (n = T.css(e, t))),
                  nt(0, n, l)
                );
              },
            };
          }),
          (T.cssHooks.marginLeft = Ve(g.reliableMarginLeft, function (e, t) {
            if (t)
              return (
                (parseFloat(Ye(e, "marginLeft")) ||
                  e.getBoundingClientRect().left -
                  Ge(e, { marginLeft: 0 }, function () {
                    return e.getBoundingClientRect().left;
                  })) + "px"
              );
          })),
          T.each({ margin: "", padding: "", border: "Width" }, function (e, t) {
            (T.cssHooks[e + t] = {
              expand: function (n) {
                for (var r = 0, i = {}, a = "string" == typeof n ? n.split(" ") : [n]; r < 4; r++)
                  i[e + ae[r] + t] = a[r] || a[r - 2] || a[0];
                return i;
              },
            }),
              "margin" !== e && (T.cssHooks[e + t].set = nt);
          }),
          T.fn.extend({
            css: function (e, t) {
              return F(
                this,
                function (e, t, n) {
                  var r,
                    i,
                    a = {},
                    s = 0;
                  if (Array.isArray(t)) {
                    for (r = Re(e), i = t.length; s < i; s++) a[t[s]] = T.css(e, t[s], !1, r);
                    return a;
                  }
                  return void 0 !== n ? T.style(e, t, n) : T.css(e, t);
                },
                e,
                t,
                arguments.length > 1
              );
            },
          }),
          (T.Tween = at),
          (at.prototype = {
            constructor: at,
            init: function (e, t, n, r, i, a) {
              (this.elem = e),
                (this.prop = n),
                (this.easing = i || T.easing._default),
                (this.options = t),
                (this.start = this.now = this.cur()),
                (this.end = r),
                (this.unit = a || (T.cssNumber[n] ? "" : "px"));
            },
            cur: function () {
              var e = at.propHooks[this.prop];
              return e && e.get ? e.get(this) : at.propHooks._default.get(this);
            },
            run: function (e) {
              var t,
                n = at.propHooks[this.prop];
              return (
                this.options.duration
                  ? (this.pos = t = T.easing[this.easing](e, this.options.duration * e, 0, 1, this.options.duration))
                  : (this.pos = t = e),
                (this.now = (this.end - this.start) * t + this.start),
                this.options.step && this.options.step.call(this.elem, this.now, this),
                n && n.set ? n.set(this) : at.propHooks._default.set(this),
                this
              );
            },
          }),
          (at.prototype.init.prototype = at.prototype),
          (at.propHooks = {
            _default: {
              get: function (e) {
                var t;
                return 1 !== e.elem.nodeType || (null != e.elem[e.prop] && null == e.elem.style[e.prop])
                  ? e.elem[e.prop]
                  : (t = T.css(e.elem, e.prop, "")) && "auto" !== t
                    ? t
                    : 0;
              },
              set: function (e) {
                T.fx.step[e.prop]
                  ? T.fx.step[e.prop](e)
                  : 1 !== e.elem.nodeType || (!T.cssHooks[e.prop] && null == e.elem.style[Qe(e.prop)])
                    ? (e.elem[e.prop] = e.now)
                    : T.style(e.elem, e.prop, e.now + e.unit);
              },
            },
          }),
          (at.propHooks.scrollTop = at.propHooks.scrollLeft =
          {
            set: function (e) {
              e.elem.nodeType && e.elem.parentNode && (e.elem[e.prop] = e.now);
            },
          }),
          (T.easing = {
            linear: function (e) {
              return e;
            },
            swing: function (e) {
              return 0.5 - Math.cos(e * Math.PI) / 2;
            },
            _default: "swing",
          }),
          (T.fx = at.prototype.init),
          (T.fx.step = {});
        var st,
          ot,
          lt = /^(?:toggle|show|hide)$/,
          ct = /queueHooks$/;
        function dt() {
          ot &&
            (!1 === b.hidden && r.requestAnimationFrame
              ? r.requestAnimationFrame(dt)
              : r.setTimeout(dt, T.fx.interval),
              T.fx.tick());
        }
        function ut() {
          return (
            r.setTimeout(function () {
              st = void 0;
            }),
            (st = Date.now())
          );
        }
        function pt(e, t) {
          var n,
            r = 0,
            i = { height: e };
          for (t = t ? 1 : 0; r < 4; r += 2 - t) i["margin" + (n = ae[r])] = i["padding" + n] = e;
          return t && (i.opacity = i.width = e), i;
        }
        function ft(e, t, n) {
          for (var r, i = (ht.tweeners[t] || []).concat(ht.tweeners["*"]), a = 0, s = i.length; a < s; a++)
            if ((r = i[a].call(n, t, e))) return r;
        }
        function ht(e, t, n) {
          var r,
            i,
            a = 0,
            s = ht.prefilters.length,
            o = T.Deferred().always(function () {
              delete l.elem;
            }),
            l = function () {
              if (i) return !1;
              for (
                var t = st || ut(),
                n = Math.max(0, c.startTime + c.duration - t),
                r = 1 - (n / c.duration || 0),
                a = 0,
                s = c.tweens.length;
                a < s;
                a++
              )
                c.tweens[a].run(r);
              return (
                o.notifyWith(e, [c, r, n]),
                r < 1 && s ? n : (s || o.notifyWith(e, [c, 1, 0]), o.resolveWith(e, [c]), !1)
              );
            },
            c = o.promise({
              elem: e,
              props: T.extend({}, t),
              opts: T.extend(!0, { specialEasing: {}, easing: T.easing._default }, n),
              originalProperties: t,
              originalOptions: n,
              startTime: st || ut(),
              duration: n.duration,
              tweens: [],
              createTween: function (t, n) {
                var r = T.Tween(e, c.opts, t, n, c.opts.specialEasing[t] || c.opts.easing);
                return c.tweens.push(r), r;
              },
              stop: function (t) {
                var n = 0,
                  r = t ? c.tweens.length : 0;
                if (i) return this;
                for (i = !0; n < r; n++) c.tweens[n].run(1);
                return t ? (o.notifyWith(e, [c, 1, 0]), o.resolveWith(e, [c, t])) : o.rejectWith(e, [c, t]), this;
              },
            }),
            d = c.props;
          for (
            (function (e, t) {
              var n, r, i, a, s;
              for (n in e)
                if (
                  ((i = t[(r = U(n))]),
                    (a = e[n]),
                    Array.isArray(a) && ((i = a[1]), (a = e[n] = a[0])),
                    n !== r && ((e[r] = a), delete e[n]),
                    (s = T.cssHooks[r]) && ("expand" in s))
                )
                  for (n in ((a = s.expand(a)), delete e[r], a)) (n in e) || ((e[n] = a[n]), (t[n] = i));
                else t[r] = i;
            })(d, c.opts.specialEasing);
            a < s;
            a++
          )
            if ((r = ht.prefilters[a].call(c, e, d, c.opts)))
              return v(r.stop) && (T._queueHooks(c.elem, c.opts.queue).stop = r.stop.bind(r)), r;
          return (
            T.map(d, ft, c),
            v(c.opts.start) && c.opts.start.call(e, c),
            c.progress(c.opts.progress).done(c.opts.done, c.opts.complete).fail(c.opts.fail).always(c.opts.always),
            T.fx.timer(T.extend(l, { elem: e, anim: c, queue: c.opts.queue })),
            c
          );
        }
        (T.Animation = T.extend(ht, {
          tweeners: {
            "*": [
              function (e, t) {
                var n = this.createTween(e, t);
                return de(n.elem, e, ie.exec(t), n), n;
              },
            ],
          },
          tweener: function (e, t) {
            v(e) ? ((t = e), (e = ["*"])) : (e = e.match(q));
            for (var n, r = 0, i = e.length; r < i; r++)
              (n = e[r]), (ht.tweeners[n] = ht.tweeners[n] || []), ht.tweeners[n].unshift(t);
          },
          prefilters: [
            function (e, t, n) {
              var r,
                i,
                a,
                s,
                o,
                l,
                c,
                d,
                u = "width" in t || "height" in t,
                p = this,
                f = {},
                h = e.style,
                m = e.nodeType && ce(e),
                g = Q.get(e, "fxshow");
              for (r in (n.queue ||
                (null == (s = T._queueHooks(e, "fx")).unqueued &&
                  ((s.unqueued = 0),
                    (o = s.empty.fire),
                    (s.empty.fire = function () {
                      s.unqueued || o();
                    })),
                  s.unqueued++,
                  p.always(function () {
                    p.always(function () {
                      s.unqueued--, T.queue(e, "fx").length || s.empty.fire();
                    });
                  })),
                t))
                if (((i = t[r]), lt.test(i))) {
                  if ((delete t[r], (a = a || "toggle" === i), i === (m ? "hide" : "show"))) {
                    if ("show" !== i || !g || void 0 === g[r]) continue;
                    m = !0;
                  }
                  f[r] = (g && g[r]) || T.style(e, r);
                }
              if ((l = !T.isEmptyObject(t)) || !T.isEmptyObject(f))
                for (r in (u &&
                  1 === e.nodeType &&
                  ((n.overflow = [h.overflow, h.overflowX, h.overflowY]),
                    null == (c = g && g.display) && (c = Q.get(e, "display")),
                    "none" === (d = T.css(e, "display")) &&
                    (c ? (d = c) : (fe([e], !0), (c = e.style.display || c), (d = T.css(e, "display")), fe([e]))),
                    ("inline" === d || ("inline-block" === d && null != c)) &&
                    "none" === T.css(e, "float") &&
                    (l ||
                      (p.done(function () {
                        h.display = c;
                      }),
                        null == c && ((d = h.display), (c = "none" === d ? "" : d))),
                      (h.display = "inline-block"))),
                  n.overflow &&
                  ((h.overflow = "hidden"),
                    p.always(function () {
                      (h.overflow = n.overflow[0]), (h.overflowX = n.overflow[1]), (h.overflowY = n.overflow[2]);
                    })),
                  (l = !1),
                  f))
                  l ||
                    (g ? "hidden" in g && (m = g.hidden) : (g = Q.access(e, "fxshow", { display: c })),
                      a && (g.hidden = !m),
                      m && fe([e], !0),
                      p.done(function () {
                        for (r in (m || fe([e]), Q.remove(e, "fxshow"), f)) T.style(e, r, f[r]);
                      })),
                    (l = ft(m ? g[r] : 0, r, p)),
                    r in g || ((g[r] = l.start), m && ((l.end = l.start), (l.start = 0)));
            },
          ],
          prefilter: function (e, t) {
            t ? ht.prefilters.unshift(e) : ht.prefilters.push(e);
          },
        })),
          (T.speed = function (e, t, n) {
            var r =
              e && "object" == typeof e
                ? T.extend({}, e)
                : { complete: n || (!n && t) || (v(e) && e), duration: e, easing: (n && t) || (t && !v(t) && t) };
            return (
              T.fx.off
                ? (r.duration = 0)
                : "number" != typeof r.duration &&
                (r.duration in T.fx.speeds
                  ? (r.duration = T.fx.speeds[r.duration])
                  : (r.duration = T.fx.speeds._default)),
              (null != r.queue && !0 !== r.queue) || (r.queue = "fx"),
              (r.old = r.complete),
              (r.complete = function () {
                v(r.old) && r.old.call(this), r.queue && T.dequeue(this, r.queue);
              }),
              r
            );
          }),
          T.fn.extend({
            fadeTo: function (e, t, n, r) {
              return this.filter(ce).css("opacity", 0).show().end().animate({ opacity: t }, e, n, r);
            },
            animate: function (e, t, n, r) {
              var i = T.isEmptyObject(e),
                a = T.speed(t, n, r),
                s = function () {
                  var t = ht(this, T.extend({}, e), a);
                  (i || Q.get(this, "finish")) && t.stop(!0);
                };
              return (s.finish = s), i || !1 === a.queue ? this.each(s) : this.queue(a.queue, s);
            },
            stop: function (e, t, n) {
              var r = function (e) {
                var t = e.stop;
                delete e.stop, t(n);
              };
              return (
                "string" != typeof e && ((n = t), (t = e), (e = void 0)),
                t && this.queue(e || "fx", []),
                this.each(function () {
                  var t = !0,
                    i = null != e && e + "queueHooks",
                    a = T.timers,
                    s = Q.get(this);
                  if (i) s[i] && s[i].stop && r(s[i]);
                  else for (i in s) s[i] && s[i].stop && ct.test(i) && r(s[i]);
                  for (i = a.length; i--;)
                    a[i].elem !== this ||
                      (null != e && a[i].queue !== e) ||
                      (a[i].anim.stop(n), (t = !1), a.splice(i, 1));
                  (!t && n) || T.dequeue(this, e);
                })
              );
            },
            finish: function (e) {
              return (
                !1 !== e && (e = e || "fx"),
                this.each(function () {
                  var t,
                    n = Q.get(this),
                    r = n[e + "queue"],
                    i = n[e + "queueHooks"],
                    a = T.timers,
                    s = r ? r.length : 0;
                  for (n.finish = !0, T.queue(this, e, []), i && i.stop && i.stop.call(this, !0), t = a.length; t--;)
                    a[t].elem === this && a[t].queue === e && (a[t].anim.stop(!0), a.splice(t, 1));
                  for (t = 0; t < s; t++) r[t] && r[t].finish && r[t].finish.call(this);
                  delete n.finish;
                })
              );
            },
          }),
          T.each(["toggle", "show", "hide"], function (e, t) {
            var n = T.fn[t];
            T.fn[t] = function (e, r, i) {
              return null == e || "boolean" == typeof e ? n.apply(this, arguments) : this.animate(pt(t, !0), e, r, i);
            };
          }),
          T.each(
            {
              slideDown: pt("show"),
              slideUp: pt("hide"),
              slideToggle: pt("toggle"),
              fadeIn: { opacity: "show" },
              fadeOut: { opacity: "hide" },
              fadeToggle: { opacity: "toggle" },
            },
            function (e, t) {
              T.fn[e] = function (e, n, r) {
                return this.animate(t, e, n, r);
              };
            }
          ),
          (T.timers = []),
          (T.fx.tick = function () {
            var e,
              t = 0,
              n = T.timers;
            for (st = Date.now(); t < n.length; t++) (e = n[t])() || n[t] !== e || n.splice(t--, 1);
            n.length || T.fx.stop(), (st = void 0);
          }),
          (T.fx.timer = function (e) {
            T.timers.push(e), T.fx.start();
          }),
          (T.fx.interval = 13),
          (T.fx.start = function () {
            ot || ((ot = !0), dt());
          }),
          (T.fx.stop = function () {
            ot = null;
          }),
          (T.fx.speeds = { slow: 600, fast: 200, _default: 400 }),
          (T.fn.delay = function (e, t) {
            return (
              (e = (T.fx && T.fx.speeds[e]) || e),
              (t = t || "fx"),
              this.queue(t, function (t, n) {
                var i = r.setTimeout(t, e);
                n.stop = function () {
                  r.clearTimeout(i);
                };
              })
            );
          }),
          (function () {
            var e = b.createElement("input"),
              t = b.createElement("select").appendChild(b.createElement("option"));
            (e.type = "checkbox"),
              (g.checkOn = "" !== e.value),
              (g.optSelected = t.selected),
              ((e = b.createElement("input")).value = "t"),
              (e.type = "radio"),
              (g.radioValue = "t" === e.value);
          })();
        var mt,
          gt = T.expr.attrHandle;
        T.fn.extend({
          attr: function (e, t) {
            return F(this, T.attr, e, t, arguments.length > 1);
          },
          removeAttr: function (e) {
            return this.each(function () {
              T.removeAttr(this, e);
            });
          },
        }),
          T.extend({
            attr: function (e, t, n) {
              var r,
                i,
                a = e.nodeType;
              if (3 !== a && 8 !== a && 2 !== a)
                return void 0 === e.getAttribute
                  ? T.prop(e, t, n)
                  : ((1 === a && T.isXMLDoc(e)) ||
                    (i = T.attrHooks[t.toLowerCase()] || (T.expr.match.bool.test(t) ? mt : void 0)),
                    void 0 !== n
                      ? null === n
                        ? void T.removeAttr(e, t)
                        : i && "set" in i && void 0 !== (r = i.set(e, n, t))
                          ? r
                          : (e.setAttribute(t, n + ""), n)
                      : i && "get" in i && null !== (r = i.get(e, t))
                        ? r
                        : null == (r = T.find.attr(e, t))
                          ? void 0
                          : r);
            },
            attrHooks: {
              type: {
                set: function (e, t) {
                  if (!g.radioValue && "radio" === t && L(e, "input")) {
                    var n = e.value;
                    return e.setAttribute("type", t), n && (e.value = n), t;
                  }
                },
              },
            },
            removeAttr: function (e, t) {
              var n,
                r = 0,
                i = t && t.match(q);
              if (i && 1 === e.nodeType) for (; (n = i[r++]);) e.removeAttribute(n);
            },
          }),
          (mt = {
            set: function (e, t, n) {
              return !1 === t ? T.removeAttr(e, n) : e.setAttribute(n, n), n;
            },
          }),
          T.each(T.expr.match.bool.source.match(/\w+/g), function (e, t) {
            var n = gt[t] || T.find.attr;
            gt[t] = function (e, t, r) {
              var i,
                a,
                s = t.toLowerCase();
              return r || ((a = gt[s]), (gt[s] = i), (i = null != n(e, t, r) ? s : null), (gt[s] = a)), i;
            };
          });
        var vt = /^(?:input|select|textarea|button)$/i,
          yt = /^(?:a|area)$/i;
        function bt(e) {
          return (e.match(q) || []).join(" ");
        }
        function wt(e) {
          return (e.getAttribute && e.getAttribute("class")) || "";
        }
        function xt(e) {
          return Array.isArray(e) ? e : ("string" == typeof e && e.match(q)) || [];
        }
        T.fn.extend({
          prop: function (e, t) {
            return F(this, T.prop, e, t, arguments.length > 1);
          },
          removeProp: function (e) {
            return this.each(function () {
              delete this[T.propFix[e] || e];
            });
          },
        }),
          T.extend({
            prop: function (e, t, n) {
              var r,
                i,
                a = e.nodeType;
              if (3 !== a && 8 !== a && 2 !== a)
                return (
                  (1 === a && T.isXMLDoc(e)) || ((t = T.propFix[t] || t), (i = T.propHooks[t])),
                  void 0 !== n
                    ? i && "set" in i && void 0 !== (r = i.set(e, n, t))
                      ? r
                      : (e[t] = n)
                    : i && "get" in i && null !== (r = i.get(e, t))
                      ? r
                      : e[t]
                );
            },
            propHooks: {
              tabIndex: {
                get: function (e) {
                  var t = T.find.attr(e, "tabindex");
                  return t ? parseInt(t, 10) : vt.test(e.nodeName) || (yt.test(e.nodeName) && e.href) ? 0 : -1;
                },
              },
            },
            propFix: { for: "htmlFor", class: "className" },
          }),
          g.optSelected ||
          (T.propHooks.selected = {
            get: function (e) {
              var t = e.parentNode;
              return t && t.parentNode && t.parentNode.selectedIndex, null;
            },
            set: function (e) {
              var t = e.parentNode;
              t && (t.selectedIndex, t.parentNode && t.parentNode.selectedIndex);
            },
          }),
          T.each(
            [
              "tabIndex",
              "readOnly",
              "maxLength",
              "cellSpacing",
              "cellPadding",
              "rowSpan",
              "colSpan",
              "useMap",
              "frameBorder",
              "contentEditable",
            ],
            function () {
              T.propFix[this.toLowerCase()] = this;
            }
          ),
          T.fn.extend({
            addClass: function (e) {
              var t, n, r, i, a, s;
              return v(e)
                ? this.each(function (t) {
                  T(this).addClass(e.call(this, t, wt(this)));
                })
                : (t = xt(e)).length
                  ? this.each(function () {
                    if (((r = wt(this)), (n = 1 === this.nodeType && " " + bt(r) + " "))) {
                      for (a = 0; a < t.length; a++) (i = t[a]), n.indexOf(" " + i + " ") < 0 && (n += i + " ");
                      (s = bt(n)), r !== s && this.setAttribute("class", s);
                    }
                  })
                  : this;
            },
            removeClass: function (e) {
              var t, n, r, i, a, s;
              return v(e)
                ? this.each(function (t) {
                  T(this).removeClass(e.call(this, t, wt(this)));
                })
                : arguments.length
                  ? (t = xt(e)).length
                    ? this.each(function () {
                      if (((r = wt(this)), (n = 1 === this.nodeType && " " + bt(r) + " "))) {
                        for (a = 0; a < t.length; a++)
                          for (i = t[a]; n.indexOf(" " + i + " ") > -1;) n = n.replace(" " + i + " ", " ");
                        (s = bt(n)), r !== s && this.setAttribute("class", s);
                      }
                    })
                    : this
                  : this.attr("class", "");
            },
            toggleClass: function (e, t) {
              var n,
                r,
                i,
                a,
                s = typeof e,
                o = "string" === s || Array.isArray(e);
              return v(e)
                ? this.each(function (n) {
                  T(this).toggleClass(e.call(this, n, wt(this), t), t);
                })
                : "boolean" == typeof t && o
                  ? t
                    ? this.addClass(e)
                    : this.removeClass(e)
                  : ((n = xt(e)),
                    this.each(function () {
                      if (o)
                        for (a = T(this), i = 0; i < n.length; i++)
                          (r = n[i]), a.hasClass(r) ? a.removeClass(r) : a.addClass(r);
                      else
                        (void 0 !== e && "boolean" !== s) ||
                          ((r = wt(this)) && Q.set(this, "__className__", r),
                            this.setAttribute &&
                            this.setAttribute("class", r || !1 === e ? "" : Q.get(this, "__className__") || ""));
                    }));
            },
            hasClass: function (e) {
              var t,
                n,
                r = 0;
              for (t = " " + e + " "; (n = this[r++]);)
                if (1 === n.nodeType && (" " + bt(wt(n)) + " ").indexOf(t) > -1) return !0;
              return !1;
            },
          });
        var Ct = /\r/g;
        T.fn.extend({
          val: function (e) {
            var t,
              n,
              r,
              i = this[0];
            return arguments.length
              ? ((r = v(e)),
                this.each(function (n) {
                  var i;
                  1 === this.nodeType &&
                    (null == (i = r ? e.call(this, n, T(this).val()) : e)
                      ? (i = "")
                      : "number" == typeof i
                        ? (i += "")
                        : Array.isArray(i) &&
                        (i = T.map(i, function (e) {
                          return null == e ? "" : e + "";
                        })),
                      ((t = T.valHooks[this.type] || T.valHooks[this.nodeName.toLowerCase()]) &&
                        "set" in t &&
                        void 0 !== t.set(this, i, "value")) ||
                      (this.value = i));
                }))
              : i
                ? (t = T.valHooks[i.type] || T.valHooks[i.nodeName.toLowerCase()]) &&
                  "get" in t &&
                  void 0 !== (n = t.get(i, "value"))
                  ? n
                  : "string" == typeof (n = i.value)
                    ? n.replace(Ct, "")
                    : null == n
                      ? ""
                      : n
                : void 0;
          },
        }),
          T.extend({
            valHooks: {
              option: {
                get: function (e) {
                  var t = T.find.attr(e, "value");
                  return null != t ? t : bt(T.text(e));
                },
              },
              select: {
                get: function (e) {
                  var t,
                    n,
                    r,
                    i = e.options,
                    a = e.selectedIndex,
                    s = "select-one" === e.type,
                    o = s ? null : [],
                    l = s ? a + 1 : i.length;
                  for (r = a < 0 ? l : s ? a : 0; r < l; r++)
                    if (
                      ((n = i[r]).selected || r === a) &&
                      !n.disabled &&
                      (!n.parentNode.disabled || !L(n.parentNode, "optgroup"))
                    ) {
                      if (((t = T(n).val()), s)) return t;
                      o.push(t);
                    }
                  return o;
                },
                set: function (e, t) {
                  for (var n, r, i = e.options, a = T.makeArray(t), s = i.length; s--;)
                    ((r = i[s]).selected = T.inArray(T.valHooks.option.get(r), a) > -1) && (n = !0);
                  return n || (e.selectedIndex = -1), a;
                },
              },
            },
          }),
          T.each(["radio", "checkbox"], function () {
            (T.valHooks[this] = {
              set: function (e, t) {
                if (Array.isArray(t)) return (e.checked = T.inArray(T(e).val(), t) > -1);
              },
            }),
              g.checkOn ||
              (T.valHooks[this].get = function (e) {
                return null === e.getAttribute("value") ? "on" : e.value;
              });
          }),
          (g.focusin = "onfocusin" in r);
        var Et = /^(?:focusinfocus|focusoutblur)$/,
          Tt = function (e) {
            e.stopPropagation();
          };
        T.extend(T.event, {
          trigger: function (e, t, n, i) {
            var a,
              s,
              o,
              l,
              c,
              d,
              u,
              p,
              h = [n || b],
              m = f.call(e, "type") ? e.type : e,
              g = f.call(e, "namespace") ? e.namespace.split(".") : [];
            if (
              ((s = p = o = n = n || b),
                3 !== n.nodeType &&
                8 !== n.nodeType &&
                !Et.test(m + T.event.triggered) &&
                (m.indexOf(".") > -1 && ((g = m.split(".")), (m = g.shift()), g.sort()),
                  (c = m.indexOf(":") < 0 && "on" + m),
                  ((e = e[T.expando] ? e : new T.Event(m, "object" == typeof e && e)).isTrigger = i ? 2 : 3),
                  (e.namespace = g.join(".")),
                  (e.rnamespace = e.namespace ? new RegExp("(^|\\.)" + g.join("\\.(?:.*\\.|)") + "(\\.|$)") : null),
                  (e.result = void 0),
                  e.target || (e.target = n),
                  (t = null == t ? [e] : T.makeArray(t, [e])),
                  (u = T.event.special[m] || {}),
                  i || !u.trigger || !1 !== u.trigger.apply(n, t)))
            ) {
              if (!i && !u.noBubble && !y(n)) {
                for (l = u.delegateType || m, Et.test(l + m) || (s = s.parentNode); s; s = s.parentNode)
                  h.push(s), (o = s);
                o === (n.ownerDocument || b) && h.push(o.defaultView || o.parentWindow || r);
              }
              for (a = 0; (s = h[a++]) && !e.isPropagationStopped();)
                (p = s),
                  (e.type = a > 1 ? l : u.bindType || m),
                  (d = (Q.get(s, "events") || Object.create(null))[e.type] && Q.get(s, "handle")) && d.apply(s, t),
                  (d = c && s[c]) &&
                  d.apply &&
                  K(s) &&
                  ((e.result = d.apply(s, t)), !1 === e.result && e.preventDefault());
              return (
                (e.type = m),
                i ||
                e.isDefaultPrevented() ||
                (u._default && !1 !== u._default.apply(h.pop(), t)) ||
                !K(n) ||
                (c &&
                  v(n[m]) &&
                  !y(n) &&
                  ((o = n[c]) && (n[c] = null),
                    (T.event.triggered = m),
                    e.isPropagationStopped() && p.addEventListener(m, Tt),
                    n[m](),
                    e.isPropagationStopped() && p.removeEventListener(m, Tt),
                    (T.event.triggered = void 0),
                    o && (n[c] = o))),
                e.result
              );
            }
          },
          simulate: function (e, t, n) {
            var r = T.extend(new T.Event(), n, { type: e, isSimulated: !0 });
            T.event.trigger(r, null, t);
          },
        }),
          T.fn.extend({
            trigger: function (e, t) {
              return this.each(function () {
                T.event.trigger(e, t, this);
              });
            },
            triggerHandler: function (e, t) {
              var n = this[0];
              if (n) return T.event.trigger(e, t, n, !0);
            },
          }),
          g.focusin ||
          T.each({ focus: "focusin", blur: "focusout" }, function (e, t) {
            var n = function (e) {
              T.event.simulate(t, e.target, T.event.fix(e));
            };
            T.event.special[t] = {
              setup: function () {
                var r = this.ownerDocument || this.document || this,
                  i = Q.access(r, t);
                i || r.addEventListener(e, n, !0), Q.access(r, t, (i || 0) + 1);
              },
              teardown: function () {
                var r = this.ownerDocument || this.document || this,
                  i = Q.access(r, t) - 1;
                i ? Q.access(r, t, i) : (r.removeEventListener(e, n, !0), Q.remove(r, t));
              },
            };
          });
        var St = r.location,
          $t = { guid: Date.now() },
          kt = /\?/;
        T.parseXML = function (e) {
          var t, n;
          if (!e || "string" != typeof e) return null;
          try {
            t = new r.DOMParser().parseFromString(e, "text/xml");
          } catch (e) { }
          return (
            (n = t && t.getElementsByTagName("parsererror")[0]),
            (t && !n) ||
            T.error(
              "Invalid XML: " +
              (n
                ? T.map(n.childNodes, function (e) {
                  return e.textContent;
                }).join("\n")
                : e)
            ),
            t
          );
        };
        var Mt = /\[\]$/,
          Pt = /\r?\n/g,
          Lt = /^(?:submit|button|image|reset|file)$/i,
          Ot = /^(?:input|select|textarea|keygen)/i;
        function At(e, t, n, r) {
          var i;
          if (Array.isArray(t))
            T.each(t, function (t, i) {
              n || Mt.test(e) ? r(e, i) : At(e + "[" + ("object" == typeof i && null != i ? t : "") + "]", i, n, r);
            });
          else if (n || "object" !== C(t)) r(e, t);
          else for (i in t) At(e + "[" + i + "]", t[i], n, r);
        }
        (T.param = function (e, t) {
          var n,
            r = [],
            i = function (e, t) {
              var n = v(t) ? t() : t;
              r[r.length] = encodeURIComponent(e) + "=" + encodeURIComponent(null == n ? "" : n);
            };
          if (null == e) return "";
          if (Array.isArray(e) || (e.jquery && !T.isPlainObject(e)))
            T.each(e, function () {
              i(this.name, this.value);
            });
          else for (n in e) At(n, e[n], t, i);
          return r.join("&");
        }),
          T.fn.extend({
            serialize: function () {
              return T.param(this.serializeArray());
            },
            serializeArray: function () {
              return this.map(function () {
                var e = T.prop(this, "elements");
                return e ? T.makeArray(e) : this;
              })
                .filter(function () {
                  var e = this.type;
                  return (
                    this.name &&
                    !T(this).is(":disabled") &&
                    Ot.test(this.nodeName) &&
                    !Lt.test(e) &&
                    (this.checked || !ge.test(e))
                  );
                })
                .map(function (e, t) {
                  var n = T(this).val();
                  return null == n
                    ? null
                    : Array.isArray(n)
                      ? T.map(n, function (e) {
                        return { name: t.name, value: e.replace(Pt, "\r\n") };
                      })
                      : { name: t.name, value: n.replace(Pt, "\r\n") };
                })
                .get();
            },
          });
        var Dt = /%20/g,
          Nt = /#.*$/,
          It = /([?&])_=[^&]*/,
          jt = /^(.*?):[ \t]*([^\r\n]*)$/gm,
          zt = /^(?:GET|HEAD)$/,
          qt = /^\/\//,
          _t = {},
          Ht = {},
          Bt = "*/".concat("*"),
          Rt = b.createElement("a");
        function Gt(e) {
          return function (t, n) {
            "string" != typeof t && ((n = t), (t = "*"));
            var r,
              i = 0,
              a = t.toLowerCase().match(q) || [];
            if (v(n))
              for (; (r = a[i++]);)
                "+" === r[0]
                  ? ((r = r.slice(1) || "*"), (e[r] = e[r] || []).unshift(n))
                  : (e[r] = e[r] || []).push(n);
          };
        }
        function Wt(e, t, n, r) {
          var i = {},
            a = e === Ht;
          function s(o) {
            var l;
            return (
              (i[o] = !0),
              T.each(e[o] || [], function (e, o) {
                var c = o(t, n, r);
                return "string" != typeof c || a || i[c]
                  ? a
                    ? !(l = c)
                    : void 0
                  : (t.dataTypes.unshift(c), s(c), !1);
              }),
              l
            );
          }
          return s(t.dataTypes[0]) || (!i["*"] && s("*"));
        }
        function Ft(e, t) {
          var n,
            r,
            i = T.ajaxSettings.flatOptions || {};
          for (n in t) void 0 !== t[n] && ((i[n] ? e : r || (r = {}))[n] = t[n]);
          return r && T.extend(!0, e, r), e;
        }
        (Rt.href = St.href),
          T.extend({
            active: 0,
            lastModified: {},
            etag: {},
            ajaxSettings: {
              url: St.href,
              type: "GET",
              isLocal: /^(?:about|app|app-storage|.+-extension|file|res|widget):$/.test(St.protocol),
              global: !0,
              processData: !0,
              async: !0,
              contentType: "application/x-www-form-urlencoded; charset=UTF-8",
              accepts: {
                "*": Bt,
                text: "text/plain",
                html: "text/html",
                xml: "application/xml, text/xml",
                json: "application/json, text/javascript",
              },
              contents: { xml: /\bxml\b/, html: /\bhtml/, json: /\bjson\b/ },
              responseFields: { xml: "responseXML", text: "responseText", json: "responseJSON" },
              converters: { "* text": String, "text html": !0, "text json": JSON.parse, "text xml": T.parseXML },
              flatOptions: { url: !0, context: !0 },
            },
            ajaxSetup: function (e, t) {
              return t ? Ft(Ft(e, T.ajaxSettings), t) : Ft(T.ajaxSettings, e);
            },
            ajaxPrefilter: Gt(_t),
            ajaxTransport: Gt(Ht),
            ajax: function (e, t) {
              "object" == typeof e && ((t = e), (e = void 0)), (t = t || {});
              var n,
                i,
                a,
                s,
                o,
                l,
                c,
                d,
                u,
                p,
                f = T.ajaxSetup({}, t),
                h = f.context || f,
                m = f.context && (h.nodeType || h.jquery) ? T(h) : T.event,
                g = T.Deferred(),
                v = T.Callbacks("once memory"),
                y = f.statusCode || {},
                w = {},
                x = {},
                C = "canceled",
                E = {
                  readyState: 0,
                  getResponseHeader: function (e) {
                    var t;
                    if (c) {
                      if (!s)
                        for (s = {}; (t = jt.exec(a));)
                          s[t[1].toLowerCase() + " "] = (s[t[1].toLowerCase() + " "] || []).concat(t[2]);
                      t = s[e.toLowerCase() + " "];
                    }
                    return null == t ? null : t.join(", ");
                  },
                  getAllResponseHeaders: function () {
                    return c ? a : null;
                  },
                  setRequestHeader: function (e, t) {
                    return null == c && ((e = x[e.toLowerCase()] = x[e.toLowerCase()] || e), (w[e] = t)), this;
                  },
                  overrideMimeType: function (e) {
                    return null == c && (f.mimeType = e), this;
                  },
                  statusCode: function (e) {
                    var t;
                    if (e)
                      if (c) E.always(e[E.status]);
                      else for (t in e) y[t] = [y[t], e[t]];
                    return this;
                  },
                  abort: function (e) {
                    var t = e || C;
                    return n && n.abort(t), S(0, t), this;
                  },
                };
              if (
                (g.promise(E),
                  (f.url = ((e || f.url || St.href) + "").replace(qt, St.protocol + "//")),
                  (f.type = t.method || t.type || f.method || f.type),
                  (f.dataTypes = (f.dataType || "*").toLowerCase().match(q) || [""]),
                  null == f.crossDomain)
              ) {
                l = b.createElement("a");
                try {
                  (l.href = f.url),
                    (l.href = l.href),
                    (f.crossDomain = Rt.protocol + "//" + Rt.host != l.protocol + "//" + l.host);
                } catch (e) {
                  f.crossDomain = !0;
                }
              }
              if (
                (f.data && f.processData && "string" != typeof f.data && (f.data = T.param(f.data, f.traditional)),
                  Wt(_t, f, t, E),
                  c)
              )
                return E;
              for (u in ((d = T.event && f.global) && 0 == T.active++ && T.event.trigger("ajaxStart"),
                (f.type = f.type.toUpperCase()),
                (f.hasContent = !zt.test(f.type)),
                (i = f.url.replace(Nt, "")),
                f.hasContent
                  ? f.data &&
                  f.processData &&
                  0 === (f.contentType || "").indexOf("application/x-www-form-urlencoded") &&
                  (f.data = f.data.replace(Dt, "+"))
                  : ((p = f.url.slice(i.length)),
                    f.data &&
                    (f.processData || "string" == typeof f.data) &&
                    ((i += (kt.test(i) ? "&" : "?") + f.data), delete f.data),
                    !1 === f.cache &&
                    ((i = i.replace(It, "$1")), (p = (kt.test(i) ? "&" : "?") + "_=" + $t.guid++ + p)),
                    (f.url = i + p)),
                f.ifModified &&
                (T.lastModified[i] && E.setRequestHeader("If-Modified-Since", T.lastModified[i]),
                  T.etag[i] && E.setRequestHeader("If-None-Match", T.etag[i])),
                ((f.data && f.hasContent && !1 !== f.contentType) || t.contentType) &&
                E.setRequestHeader("Content-Type", f.contentType),
                E.setRequestHeader(
                  "Accept",
                  f.dataTypes[0] && f.accepts[f.dataTypes[0]]
                    ? f.accepts[f.dataTypes[0]] + ("*" !== f.dataTypes[0] ? ", " + Bt + "; q=0.01" : "")
                    : f.accepts["*"]
                ),
                f.headers))
                E.setRequestHeader(u, f.headers[u]);
              if (f.beforeSend && (!1 === f.beforeSend.call(h, E, f) || c)) return E.abort();
              if (((C = "abort"), v.add(f.complete), E.done(f.success), E.fail(f.error), (n = Wt(Ht, f, t, E)))) {
                if (((E.readyState = 1), d && m.trigger("ajaxSend", [E, f]), c)) return E;
                f.async &&
                  f.timeout > 0 &&
                  (o = r.setTimeout(function () {
                    E.abort("timeout");
                  }, f.timeout));
                try {
                  (c = !1), n.send(w, S);
                } catch (e) {
                  if (c) throw e;
                  S(-1, e);
                }
              } else S(-1, "No Transport");
              function S(e, t, s, l) {
                var u,
                  p,
                  b,
                  w,
                  x,
                  C = t;
                c ||
                  ((c = !0),
                    o && r.clearTimeout(o),
                    (n = void 0),
                    (a = l || ""),
                    (E.readyState = e > 0 ? 4 : 0),
                    (u = (e >= 200 && e < 300) || 304 === e),
                    s &&
                    (w = (function (e, t, n) {
                      for (var r, i, a, s, o = e.contents, l = e.dataTypes; "*" === l[0];)
                        l.shift(), void 0 === r && (r = e.mimeType || t.getResponseHeader("Content-Type"));
                      if (r)
                        for (i in o)
                          if (o[i] && o[i].test(r)) {
                            l.unshift(i);
                            break;
                          }
                      if (l[0] in n) a = l[0];
                      else {
                        for (i in n) {
                          if (!l[0] || e.converters[i + " " + l[0]]) {
                            a = i;
                            break;
                          }
                          s || (s = i);
                        }
                        a = a || s;
                      }
                      if (a) return a !== l[0] && l.unshift(a), n[a];
                    })(f, E, s)),
                    !u &&
                    T.inArray("script", f.dataTypes) > -1 &&
                    T.inArray("json", f.dataTypes) < 0 &&
                    (f.converters["text script"] = function () { }),
                    (w = (function (e, t, n, r) {
                      var i,
                        a,
                        s,
                        o,
                        l,
                        c = {},
                        d = e.dataTypes.slice();
                      if (d[1]) for (s in e.converters) c[s.toLowerCase()] = e.converters[s];
                      for (a = d.shift(); a;)
                        if (
                          (e.responseFields[a] && (n[e.responseFields[a]] = t),
                            !l && r && e.dataFilter && (t = e.dataFilter(t, e.dataType)),
                            (l = a),
                            (a = d.shift()))
                        )
                          if ("*" === a) a = l;
                          else if ("*" !== l && l !== a) {
                            if (!(s = c[l + " " + a] || c["* " + a]))
                              for (i in c)
                                if ((o = i.split(" "))[1] === a && (s = c[l + " " + o[0]] || c["* " + o[0]])) {
                                  !0 === s ? (s = c[i]) : !0 !== c[i] && ((a = o[0]), d.unshift(o[1]));
                                  break;
                                }
                            if (!0 !== s)
                              if (s && e.throws) t = s(t);
                              else
                                try {
                                  t = s(t);
                                } catch (e) {
                                  return {
                                    state: "parsererror",
                                    error: s ? e : "No conversion from " + l + " to " + a,
                                  };
                                }
                          }
                      return { state: "success", data: t };
                    })(f, w, E, u)),
                    u
                      ? (f.ifModified &&
                        ((x = E.getResponseHeader("Last-Modified")) && (T.lastModified[i] = x),
                          (x = E.getResponseHeader("etag")) && (T.etag[i] = x)),
                        204 === e || "HEAD" === f.type
                          ? (C = "nocontent")
                          : 304 === e
                            ? (C = "notmodified")
                            : ((C = w.state), (p = w.data), (u = !(b = w.error))))
                      : ((b = C), (!e && C) || ((C = "error"), e < 0 && (e = 0))),
                    (E.status = e),
                    (E.statusText = (t || C) + ""),
                    u ? g.resolveWith(h, [p, C, E]) : g.rejectWith(h, [E, C, b]),
                    E.statusCode(y),
                    (y = void 0),
                    d && m.trigger(u ? "ajaxSuccess" : "ajaxError", [E, f, u ? p : b]),
                    v.fireWith(h, [E, C]),
                    d && (m.trigger("ajaxComplete", [E, f]), --T.active || T.event.trigger("ajaxStop")));
              }
              return E;
            },
            getJSON: function (e, t, n) {
              return T.get(e, t, n, "json");
            },
            getScript: function (e, t) {
              return T.get(e, void 0, t, "script");
            },
          }),
          T.each(["get", "post"], function (e, t) {
            T[t] = function (e, n, r, i) {
              return (
                v(n) && ((i = i || r), (r = n), (n = void 0)),
                T.ajax(T.extend({ url: e, type: t, dataType: i, data: n, success: r }, T.isPlainObject(e) && e))
              );
            };
          }),
          T.ajaxPrefilter(function (e) {
            var t;
            for (t in e.headers) "content-type" === t.toLowerCase() && (e.contentType = e.headers[t] || "");
          }),
          (T._evalUrl = function (e, t, n) {
            return T.ajax({
              url: e,
              type: "GET",
              dataType: "script",
              cache: !0,
              async: !1,
              global: !1,
              converters: { "text script": function () { } },
              dataFilter: function (e) {
                T.globalEval(e, t, n);
              },
            });
          }),
          T.fn.extend({
            wrapAll: function (e) {
              var t;
              return (
                this[0] &&
                (v(e) && (e = e.call(this[0])),
                  (t = T(e, this[0].ownerDocument).eq(0).clone(!0)),
                  this[0].parentNode && t.insertBefore(this[0]),
                  t
                    .map(function () {
                      for (var e = this; e.firstElementChild;) e = e.firstElementChild;
                      return e;
                    })
                    .append(this)),
                this
              );
            },
            wrapInner: function (e) {
              return v(e)
                ? this.each(function (t) {
                  T(this).wrapInner(e.call(this, t));
                })
                : this.each(function () {
                  var t = T(this),
                    n = t.contents();
                  n.length ? n.wrapAll(e) : t.append(e);
                });
            },
            wrap: function (e) {
              var t = v(e);
              return this.each(function (n) {
                T(this).wrapAll(t ? e.call(this, n) : e);
              });
            },
            unwrap: function (e) {
              return (
                this.parent(e)
                  .not("body")
                  .each(function () {
                    T(this).replaceWith(this.childNodes);
                  }),
                this
              );
            },
          }),
          (T.expr.pseudos.hidden = function (e) {
            return !T.expr.pseudos.visible(e);
          }),
          (T.expr.pseudos.visible = function (e) {
            return !!(e.offsetWidth || e.offsetHeight || e.getClientRects().length);
          }),
          (T.ajaxSettings.xhr = function () {
            try {
              return new r.XMLHttpRequest();
            } catch (e) { }
          });
        var Xt = { 0: 200, 1223: 204 },
          Yt = T.ajaxSettings.xhr();
        (g.cors = !!Yt && "withCredentials" in Yt),
          (g.ajax = Yt = !!Yt),
          T.ajaxTransport(function (e) {
            var t, n;
            if (g.cors || (Yt && !e.crossDomain))
              return {
                send: function (i, a) {
                  var s,
                    o = e.xhr();
                  if ((o.open(e.type, e.url, e.async, e.username, e.password), e.xhrFields))
                    for (s in e.xhrFields) o[s] = e.xhrFields[s];
                  for (s in (e.mimeType && o.overrideMimeType && o.overrideMimeType(e.mimeType),
                    e.crossDomain || i["X-Requested-With"] || (i["X-Requested-With"] = "XMLHttpRequest"),
                    i))
                    o.setRequestHeader(s, i[s]);
                  (t = function (e) {
                    return function () {
                      t &&
                        ((t = n = o.onload = o.onerror = o.onabort = o.ontimeout = o.onreadystatechange = null),
                          "abort" === e
                            ? o.abort()
                            : "error" === e
                              ? "number" != typeof o.status
                                ? a(0, "error")
                                : a(o.status, o.statusText)
                              : a(
                                Xt[o.status] || o.status,
                                o.statusText,
                                "text" !== (o.responseType || "text") || "string" != typeof o.responseText
                                  ? { binary: o.response }
                                  : { text: o.responseText },
                                o.getAllResponseHeaders()
                              ));
                    };
                  }),
                    (o.onload = t()),
                    (n = o.onerror = o.ontimeout = t("error")),
                    void 0 !== o.onabort
                      ? (o.onabort = n)
                      : (o.onreadystatechange = function () {
                        4 === o.readyState &&
                          r.setTimeout(function () {
                            t && n();
                          });
                      }),
                    (t = t("abort"));
                  try {
                    o.send((e.hasContent && e.data) || null);
                  } catch (e) {
                    if (t) throw e;
                  }
                },
                abort: function () {
                  t && t();
                },
              };
          }),
          T.ajaxPrefilter(function (e) {
            e.crossDomain && (e.contents.script = !1);
          }),
          T.ajaxSetup({
            accepts: {
              script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript",
            },
            contents: { script: /\b(?:java|ecma)script\b/ },
            converters: {
              "text script": function (e) {
                return T.globalEval(e), e;
              },
            },
          }),
          T.ajaxPrefilter("script", function (e) {
            void 0 === e.cache && (e.cache = !1), e.crossDomain && (e.type = "GET");
          }),
          T.ajaxTransport("script", function (e) {
            var t, n;
            if (e.crossDomain || e.scriptAttrs)
              return {
                send: function (r, i) {
                  (t = T("<script>")
                    .attr(e.scriptAttrs || {})
                    .prop({ charset: e.scriptCharset, src: e.url })
                    .on(
                      "load error",
                      (n = function (e) {
                        t.remove(), (n = null), e && i("error" === e.type ? 404 : 200, e.type);
                      })
                    )),
                    b.head.appendChild(t[0]);
                },
                abort: function () {
                  n && n();
                },
              };
          });
        var Vt,
          Ut = [],
          Kt = /(=)\?(?=&|$)|\?\?/;
        T.ajaxSetup({
          jsonp: "callback",
          jsonpCallback: function () {
            var e = Ut.pop() || T.expando + "_" + $t.guid++;
            return (this[e] = !0), e;
          },
        }),
          T.ajaxPrefilter("json jsonp", function (e, t, n) {
            var i,
              a,
              s,
              o =
                !1 !== e.jsonp &&
                (Kt.test(e.url)
                  ? "url"
                  : "string" == typeof e.data &&
                  0 === (e.contentType || "").indexOf("application/x-www-form-urlencoded") &&
                  Kt.test(e.data) &&
                  "data");
            if (o || "jsonp" === e.dataTypes[0])
              return (
                (i = e.jsonpCallback = v(e.jsonpCallback) ? e.jsonpCallback() : e.jsonpCallback),
                o
                  ? (e[o] = e[o].replace(Kt, "$1" + i))
                  : !1 !== e.jsonp && (e.url += (kt.test(e.url) ? "&" : "?") + e.jsonp + "=" + i),
                (e.converters["script json"] = function () {
                  return s || T.error(i + " was not called"), s[0];
                }),
                (e.dataTypes[0] = "json"),
                (a = r[i]),
                (r[i] = function () {
                  s = arguments;
                }),
                n.always(function () {
                  void 0 === a ? T(r).removeProp(i) : (r[i] = a),
                    e[i] && ((e.jsonpCallback = t.jsonpCallback), Ut.push(i)),
                    s && v(a) && a(s[0]),
                    (s = a = void 0);
                }),
                "script"
              );
          }),
          (g.createHTMLDocument =
            (((Vt = b.implementation.createHTMLDocument("").body).innerHTML = "<form></form><form></form>"),
              2 === Vt.childNodes.length)),
          (T.parseHTML = function (e, t, n) {
            return "string" != typeof e
              ? []
              : ("boolean" == typeof t && ((n = t), (t = !1)),
                t ||
                (g.createHTMLDocument
                  ? (((r = (t = b.implementation.createHTMLDocument("")).createElement("base")).href =
                    b.location.href),
                    t.head.appendChild(r))
                  : (t = b)),
                (a = !n && []),
                (i = O.exec(e))
                  ? [t.createElement(i[1])]
                  : ((i = Ee([e], t, a)), a && a.length && T(a).remove(), T.merge([], i.childNodes)));
            var r, i, a;
          }),
          (T.fn.load = function (e, t, n) {
            var r,
              i,
              a,
              s = this,
              o = e.indexOf(" ");
            return (
              o > -1 && ((r = bt(e.slice(o))), (e = e.slice(0, o))),
              v(t) ? ((n = t), (t = void 0)) : t && "object" == typeof t && (i = "POST"),
              s.length > 0 &&
              T.ajax({ url: e, type: i || "GET", dataType: "html", data: t })
                .done(function (e) {
                  (a = arguments), s.html(r ? T("<div>").append(T.parseHTML(e)).find(r) : e);
                })
                .always(
                  n &&
                  function (e, t) {
                    s.each(function () {
                      n.apply(this, a || [e.responseText, t, e]);
                    });
                  }
                ),
              this
            );
          }),
          (T.expr.pseudos.animated = function (e) {
            return T.grep(T.timers, function (t) {
              return e === t.elem;
            }).length;
          }),
          (T.offset = {
            setOffset: function (e, t, n) {
              var r,
                i,
                a,
                s,
                o,
                l,
                c = T.css(e, "position"),
                d = T(e),
                u = {};
              "static" === c && (e.style.position = "relative"),
                (o = d.offset()),
                (a = T.css(e, "top")),
                (l = T.css(e, "left")),
                ("absolute" === c || "fixed" === c) && (a + l).indexOf("auto") > -1
                  ? ((s = (r = d.position()).top), (i = r.left))
                  : ((s = parseFloat(a) || 0), (i = parseFloat(l) || 0)),
                v(t) && (t = t.call(e, n, T.extend({}, o))),
                null != t.top && (u.top = t.top - o.top + s),
                null != t.left && (u.left = t.left - o.left + i),
                "using" in t ? t.using.call(e, u) : d.css(u);
            },
          }),
          T.fn.extend({
            offset: function (e) {
              if (arguments.length)
                return void 0 === e
                  ? this
                  : this.each(function (t) {
                    T.offset.setOffset(this, e, t);
                  });
              var t,
                n,
                r = this[0];
              return r
                ? r.getClientRects().length
                  ? ((t = r.getBoundingClientRect()),
                    (n = r.ownerDocument.defaultView),
                    { top: t.top + n.pageYOffset, left: t.left + n.pageXOffset })
                  : { top: 0, left: 0 }
                : void 0;
            },
            position: function () {
              if (this[0]) {
                var e,
                  t,
                  n,
                  r = this[0],
                  i = { top: 0, left: 0 };
                if ("fixed" === T.css(r, "position")) t = r.getBoundingClientRect();
                else {
                  for (
                    t = this.offset(), n = r.ownerDocument, e = r.offsetParent || n.documentElement;
                    e && (e === n.body || e === n.documentElement) && "static" === T.css(e, "position");

                  )
                    e = e.parentNode;
                  e &&
                    e !== r &&
                    1 === e.nodeType &&
                    (((i = T(e).offset()).top += T.css(e, "borderTopWidth", !0)),
                      (i.left += T.css(e, "borderLeftWidth", !0)));
                }
                return {
                  top: t.top - i.top - T.css(r, "marginTop", !0),
                  left: t.left - i.left - T.css(r, "marginLeft", !0),
                };
              }
            },
            offsetParent: function () {
              return this.map(function () {
                for (var e = this.offsetParent; e && "static" === T.css(e, "position");) e = e.offsetParent;
                return e || se;
              });
            },
          }),
          T.each({ scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function (e, t) {
            var n = "pageYOffset" === t;
            T.fn[e] = function (r) {
              return F(
                this,
                function (e, r, i) {
                  var a;
                  if ((y(e) ? (a = e) : 9 === e.nodeType && (a = e.defaultView), void 0 === i))
                    return a ? a[t] : e[r];
                  a ? a.scrollTo(n ? a.pageXOffset : i, n ? i : a.pageYOffset) : (e[r] = i);
                },
                e,
                r,
                arguments.length
              );
            };
          }),
          T.each(["top", "left"], function (e, t) {
            T.cssHooks[t] = Ve(g.pixelPosition, function (e, n) {
              if (n) return (n = Ye(e, t)), He.test(n) ? T(e).position()[t] + "px" : n;
            });
          }),
          T.each({ Height: "height", Width: "width" }, function (e, t) {
            T.each({ padding: "inner" + e, content: t, "": "outer" + e }, function (n, r) {
              T.fn[r] = function (i, a) {
                var s = arguments.length && (n || "boolean" != typeof i),
                  o = n || (!0 === i || !0 === a ? "margin" : "border");
                return F(
                  this,
                  function (t, n, i) {
                    var a;
                    return y(t)
                      ? 0 === r.indexOf("outer")
                        ? t["inner" + e]
                        : t.document.documentElement["client" + e]
                      : 9 === t.nodeType
                        ? ((a = t.documentElement),
                          Math.max(
                            t.body["scroll" + e],
                            a["scroll" + e],
                            t.body["offset" + e],
                            a["offset" + e],
                            a["client" + e]
                          ))
                        : void 0 === i
                          ? T.css(t, n, o)
                          : T.style(t, n, i, o);
                  },
                  t,
                  s ? i : void 0,
                  s
                );
              };
            });
          }),
          T.each(["ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend"], function (e, t) {
            T.fn[t] = function (e) {
              return this.on(t, e);
            };
          }),
          T.fn.extend({
            bind: function (e, t, n) {
              return this.on(e, null, t, n);
            },
            unbind: function (e, t) {
              return this.off(e, null, t);
            },
            delegate: function (e, t, n, r) {
              return this.on(t, e, n, r);
            },
            undelegate: function (e, t, n) {
              return 1 === arguments.length ? this.off(e, "**") : this.off(t, e || "**", n);
            },
            hover: function (e, t) {
              return this.mouseenter(e).mouseleave(t || e);
            },
          }),
          T.each(
            "blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(
              " "
            ),
            function (e, t) {
              T.fn[t] = function (e, n) {
                return arguments.length > 0 ? this.on(t, null, e, n) : this.trigger(t);
              };
            }
          );
        var Jt = /^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;
        (T.proxy = function (e, t) {
          var n, r, i;
          if (("string" == typeof t && ((n = e[t]), (t = e), (e = n)), v(e)))
            return (
              (r = o.call(arguments, 2)),
              (i = function () {
                return e.apply(t || this, r.concat(o.call(arguments)));
              }),
              (i.guid = e.guid = e.guid || T.guid++),
              i
            );
        }),
          (T.holdReady = function (e) {
            e ? T.readyWait++ : T.ready(!0);
          }),
          (T.isArray = Array.isArray),
          (T.parseJSON = JSON.parse),
          (T.nodeName = L),
          (T.isFunction = v),
          (T.isWindow = y),
          (T.camelCase = U),
          (T.type = C),
          (T.now = Date.now),
          (T.isNumeric = function (e) {
            var t = T.type(e);
            return ("number" === t || "string" === t) && !isNaN(e - parseFloat(e));
          }),
          (T.trim = function (e) {
            return null == e ? "" : (e + "").replace(Jt, "$1");
          }),
          void 0 ===
          (n = function () {
            return T;
          }.apply(t, [])) || (e.exports = n);
        var Qt = r.jQuery,
          Zt = r.$;
        return (
          (T.noConflict = function (e) {
            return r.$ === T && (r.$ = Zt), e && r.jQuery === T && (r.jQuery = Qt), T;
          }),
          void 0 === i && (r.jQuery = r.$ = T),
          T
        );
      });
    },
    61: (e, t, n) => {
      var r = n(698).default;
      function i() {
        "use strict";
        (e.exports = i =
          function () {
            return t;
          }),
          (e.exports.__esModule = !0),
          (e.exports.default = e.exports);
        var t = {},
          n = Object.prototype,
          a = n.hasOwnProperty,
          s =
            Object.defineProperty ||
            function (e, t, n) {
              e[t] = n.value;
            },
          o = "function" == typeof Symbol ? Symbol : {},
          l = o.iterator || "@@iterator",
          c = o.asyncIterator || "@@asyncIterator",
          d = o.toStringTag || "@@toStringTag";
        function u(e, t, n) {
          return Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }), e[t];
        }
        try {
          u({}, "");
        } catch (e) {
          u = function (e, t, n) {
            return (e[t] = n);
          };
        }
        function p(e, t, n, r) {
          var i = t && t.prototype instanceof m ? t : m,
            a = Object.create(i.prototype),
            o = new M(r || []);
          return s(a, "_invoke", { value: T(e, n, o) }), a;
        }
        function f(e, t, n) {
          try {
            return { type: "normal", arg: e.call(t, n) };
          } catch (e) {
            return { type: "throw", arg: e };
          }
        }
        t.wrap = p;
        var h = {};
        function m() { }
        function g() { }
        function v() { }
        var y = {};
        u(y, l, function () {
          return this;
        });
        var b = Object.getPrototypeOf,
          w = b && b(b(P([])));
        w && w !== n && a.call(w, l) && (y = w);
        var x = (v.prototype = m.prototype = Object.create(y));
        function C(e) {
          ["next", "throw", "return"].forEach(function (t) {
            u(e, t, function (e) {
              return this._invoke(t, e);
            });
          });
        }
        function E(e, t) {
          function n(i, s, o, l) {
            var c = f(e[i], e, s);
            if ("throw" !== c.type) {
              var d = c.arg,
                u = d.value;
              return u && "object" == r(u) && a.call(u, "__await")
                ? t.resolve(u.__await).then(
                  function (e) {
                    n("next", e, o, l);
                  },
                  function (e) {
                    n("throw", e, o, l);
                  }
                )
                : t.resolve(u).then(
                  function (e) {
                    (d.value = e), o(d);
                  },
                  function (e) {
                    return n("throw", e, o, l);
                  }
                );
            }
            l(c.arg);
          }
          var i;
          s(this, "_invoke", {
            value: function (e, r) {
              function a() {
                return new t(function (t, i) {
                  n(e, r, t, i);
                });
              }
              return (i = i ? i.then(a, a) : a());
            },
          });
        }
        function T(e, t, n) {
          var r = "suspendedStart";
          return function (i, a) {
            if ("executing" === r) throw new Error("Generator is already running");
            if ("completed" === r) {
              if ("throw" === i) throw a;
              return { value: void 0, done: !0 };
            }
            for (n.method = i, n.arg = a; ;) {
              var s = n.delegate;
              if (s) {
                var o = S(s, n);
                if (o) {
                  if (o === h) continue;
                  return o;
                }
              }
              if ("next" === n.method) n.sent = n._sent = n.arg;
              else if ("throw" === n.method) {
                if ("suspendedStart" === r) throw ((r = "completed"), n.arg);
                n.dispatchException(n.arg);
              } else "return" === n.method && n.abrupt("return", n.arg);
              r = "executing";
              var l = f(e, t, n);
              if ("normal" === l.type) {
                if (((r = n.done ? "completed" : "suspendedYield"), l.arg === h)) continue;
                return { value: l.arg, done: n.done };
              }
              "throw" === l.type && ((r = "completed"), (n.method = "throw"), (n.arg = l.arg));
            }
          };
        }
        function S(e, t) {
          var n = t.method,
            r = e.iterator[n];
          if (void 0 === r)
            return (
              (t.delegate = null),
              ("throw" === n &&
                e.iterator.return &&
                ((t.method = "return"), (t.arg = void 0), S(e, t), "throw" === t.method)) ||
              ("return" !== n &&
                ((t.method = "throw"),
                  (t.arg = new TypeError("The iterator does not provide a '" + n + "' method")))),
              h
            );
          var i = f(r, e.iterator, t.arg);
          if ("throw" === i.type) return (t.method = "throw"), (t.arg = i.arg), (t.delegate = null), h;
          var a = i.arg;
          return a
            ? a.done
              ? ((t[e.resultName] = a.value),
                (t.next = e.nextLoc),
                "return" !== t.method && ((t.method = "next"), (t.arg = void 0)),
                (t.delegate = null),
                h)
              : a
            : ((t.method = "throw"),
              (t.arg = new TypeError("iterator result is not an object")),
              (t.delegate = null),
              h);
        }
        function $(e) {
          var t = { tryLoc: e[0] };
          1 in e && (t.catchLoc = e[1]),
            2 in e && ((t.finallyLoc = e[2]), (t.afterLoc = e[3])),
            this.tryEntries.push(t);
        }
        function k(e) {
          var t = e.completion || {};
          (t.type = "normal"), delete t.arg, (e.completion = t);
        }
        function M(e) {
          (this.tryEntries = [{ tryLoc: "root" }]), e.forEach($, this), this.reset(!0);
        }
        function P(e) {
          if (e) {
            var t = e[l];
            if (t) return t.call(e);
            if ("function" == typeof e.next) return e;
            if (!isNaN(e.length)) {
              var n = -1,
                r = function t() {
                  for (; ++n < e.length;) if (a.call(e, n)) return (t.value = e[n]), (t.done = !1), t;
                  return (t.value = void 0), (t.done = !0), t;
                };
              return (r.next = r);
            }
          }
          return { next: L };
        }
        function L() {
          return { value: void 0, done: !0 };
        }
        return (
          (g.prototype = v),
          s(x, "constructor", { value: v, configurable: !0 }),
          s(v, "constructor", { value: g, configurable: !0 }),
          (g.displayName = u(v, d, "GeneratorFunction")),
          (t.isGeneratorFunction = function (e) {
            var t = "function" == typeof e && e.constructor;
            return !!t && (t === g || "GeneratorFunction" === (t.displayName || t.name));
          }),
          (t.mark = function (e) {
            return (
              Object.setPrototypeOf ? Object.setPrototypeOf(e, v) : ((e.__proto__ = v), u(e, d, "GeneratorFunction")),
              (e.prototype = Object.create(x)),
              e
            );
          }),
          (t.awrap = function (e) {
            return { __await: e };
          }),
          C(E.prototype),
          u(E.prototype, c, function () {
            return this;
          }),
          (t.AsyncIterator = E),
          (t.async = function (e, n, r, i, a) {
            void 0 === a && (a = Promise);
            var s = new E(p(e, n, r, i), a);
            return t.isGeneratorFunction(n)
              ? s
              : s.next().then(function (e) {
                return e.done ? e.value : s.next();
              });
          }),
          C(x),
          u(x, d, "Generator"),
          u(x, l, function () {
            return this;
          }),
          u(x, "toString", function () {
            return "[object Generator]";
          }),
          (t.keys = function (e) {
            var t = Object(e),
              n = [];
            for (var r in t) n.push(r);
            return (
              n.reverse(),
              function e() {
                for (; n.length;) {
                  var r = n.pop();
                  if (r in t) return (e.value = r), (e.done = !1), e;
                }
                return (e.done = !0), e;
              }
            );
          }),
          (t.values = P),
          (M.prototype = {
            constructor: M,
            reset: function (e) {
              if (
                ((this.prev = 0),
                  (this.next = 0),
                  (this.sent = this._sent = void 0),
                  (this.done = !1),
                  (this.delegate = null),
                  (this.method = "next"),
                  (this.arg = void 0),
                  this.tryEntries.forEach(k),
                  !e)
              )
                for (var t in this)
                  "t" === t.charAt(0) && a.call(this, t) && !isNaN(+t.slice(1)) && (this[t] = void 0);
            },
            stop: function () {
              this.done = !0;
              var e = this.tryEntries[0].completion;
              if ("throw" === e.type) throw e.arg;
              return this.rval;
            },
            dispatchException: function (e) {
              if (this.done) throw e;
              var t = this;
              function n(n, r) {
                return (
                  (s.type = "throw"), (s.arg = e), (t.next = n), r && ((t.method = "next"), (t.arg = void 0)), !!r
                );
              }
              for (var r = this.tryEntries.length - 1; r >= 0; --r) {
                var i = this.tryEntries[r],
                  s = i.completion;
                if ("root" === i.tryLoc) return n("end");
                if (i.tryLoc <= this.prev) {
                  var o = a.call(i, "catchLoc"),
                    l = a.call(i, "finallyLoc");
                  if (o && l) {
                    if (this.prev < i.catchLoc) return n(i.catchLoc, !0);
                    if (this.prev < i.finallyLoc) return n(i.finallyLoc);
                  } else if (o) {
                    if (this.prev < i.catchLoc) return n(i.catchLoc, !0);
                  } else {
                    if (!l) throw new Error("try statement without catch or finally");
                    if (this.prev < i.finallyLoc) return n(i.finallyLoc);
                  }
                }
              }
            },
            abrupt: function (e, t) {
              for (var n = this.tryEntries.length - 1; n >= 0; --n) {
                var r = this.tryEntries[n];
                if (r.tryLoc <= this.prev && a.call(r, "finallyLoc") && this.prev < r.finallyLoc) {
                  var i = r;
                  break;
                }
              }
              i && ("break" === e || "continue" === e) && i.tryLoc <= t && t <= i.finallyLoc && (i = null);
              var s = i ? i.completion : {};
              return (
                (s.type = e),
                (s.arg = t),
                i ? ((this.method = "next"), (this.next = i.finallyLoc), h) : this.complete(s)
              );
            },
            complete: function (e, t) {
              if ("throw" === e.type) throw e.arg;
              return (
                "break" === e.type || "continue" === e.type
                  ? (this.next = e.arg)
                  : "return" === e.type
                    ? ((this.rval = this.arg = e.arg), (this.method = "return"), (this.next = "end"))
                    : "normal" === e.type && t && (this.next = t),
                h
              );
            },
            finish: function (e) {
              for (var t = this.tryEntries.length - 1; t >= 0; --t) {
                var n = this.tryEntries[t];
                if (n.finallyLoc === e) return this.complete(n.completion, n.afterLoc), k(n), h;
              }
            },
            catch: function (e) {
              for (var t = this.tryEntries.length - 1; t >= 0; --t) {
                var n = this.tryEntries[t];
                if (n.tryLoc === e) {
                  var r = n.completion;
                  if ("throw" === r.type) {
                    var i = r.arg;
                    k(n);
                  }
                  return i;
                }
              }
              throw new Error("illegal catch attempt");
            },
            delegateYield: function (e, t, n) {
              return (
                (this.delegate = { iterator: P(e), resultName: t, nextLoc: n }),
                "next" === this.method && (this.arg = void 0),
                h
              );
            },
          }),
          t
        );
      }
      (e.exports = i), (e.exports.__esModule = !0), (e.exports.default = e.exports);
    },
    698: (e) => {
      function t(n) {
        return (
          (e.exports = t =
            "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
              ? function (e) {
                return typeof e;
              }
              : function (e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype
                  ? "symbol"
                  : typeof e;
              }),
          (e.exports.__esModule = !0),
          (e.exports.default = e.exports),
          t(n)
        );
      }
      (e.exports = t), (e.exports.__esModule = !0), (e.exports.default = e.exports);
    },
    687: (e, t, n) => {
      var r = n(61)();
      e.exports = r;
      try {
        regeneratorRuntime = r;
      } catch (e) {
        "object" == typeof globalThis
          ? (globalThis.regeneratorRuntime = r)
          : Function("r", "regeneratorRuntime = r")(r);
      }
    },
  },
    t = {};
  function n(r) {
    var i = t[r];
    if (void 0 !== i) return i.exports;
    var a = (t[r] = { exports: {} });
    return e[r].call(a.exports, a, a.exports, n), a.exports;
  }
  (n.n = (e) => {
    var t = e && e.__esModule ? () => e.default : () => e;
    return n.d(t, { a: t }), t;
  }),
    (n.d = (e, t) => {
      for (var r in t) n.o(t, r) && !n.o(e, r) && Object.defineProperty(e, r, { enumerable: !0, get: t[r] });
    }),
    (n.o = (e, t) => Object.prototype.hasOwnProperty.call(e, t)),
    (() => {
      "use strict";
      function e(t) {
        return (
          (e =
            "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
              ? function (e) {
                return typeof e;
              }
              : function (e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype
                  ? "symbol"
                  : typeof e;
              }),
          e(t)
        );
      }
      function t(t, n, r) {
        return (
          (n = (function (t) {
            var n = (function (t, n) {
              if ("object" !== e(t) || null === t) return t;
              var r = t[Symbol.toPrimitive];
              if (void 0 !== r) {
                var i = r.call(t, "string");
                if ("object" !== e(i)) return i;
                throw new TypeError("@@toPrimitive must return a primitive value.");
              }
              return String(t);
            })(t);
            return "symbol" === e(n) ? n : String(n);
          })(n)) in t
            ? Object.defineProperty(t, n, { value: r, enumerable: !0, configurable: !0, writable: !0 })
            : (t[n] = r),
          t
        );
      }
      var r = n(755),
        i = n.n(r);
      function a() {
        var e = window.location.search;
        return "" === e
          ? {}
          : e
            .slice(e.indexOf("?") + 1)
            .split("&")
            .reduce(function (e, n) {
              var r = n.indexOf("=");
              if (r < 0) return Object.assign(e, t({}, n, null));
              var i = n.slice(0, r),
                a = n.slice(r + 1);
              return Object.assign(e, t({}, i, decodeURIComponent(a)));
            }, {});
      }
      function s() {
        var e = new CustomEvent("cart:updated", {});
        document.dispatchEvent(e);
      }
      if (i()(".page-wrap.careers").length > 0)
        for (var o = document.getElementsByClassName("accordion"), l = 0; l < o.length; l++)
          o[l].addEventListener("click", function (e) {
            this.classList.toggle("active");
            var t = this.nextElementSibling;
            "block" === t.style.display
              ? ((t.style.display = "none"), i()(e.target).find(".icon").text("+"))
              : ((t.style.display = "block"), i()(e.target).find(".icon").text("-"));
          });
      function c(e) {
        var t = i()(".form-wrapper .checkout");
        "update" === e
          ? t.attr("name", "update").prop("disabled", !1).removeClass("pla-disable").text("Update Cart")
          : t.attr("name", "checkout").text("Checkout");
      }
      function d(e) {
        var t = i()(e.target),
          n = t.parents(".cart__qty").find("input"),
          r = parseInt(n.val(), 10),
          a = t.hasClass("increment");
        r > 0 ? n.val(a ? r + 1 : r - 1) : n.val(a ? r + 1 : r), c("update");
      }
      function u() {
        c("update");
      }
      function p(e, t) {
        (null == t || t > e.length) && (t = e.length);
        for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
        return r;
      }
      function f(e, t) {
        return (
          (function (e) {
            if (Array.isArray(e)) return e;
          })(e) ||
          (function (e, t) {
            var n = null == e ? null : ("undefined" != typeof Symbol && e[Symbol.iterator]) || e["@@iterator"];
            if (null != n) {
              var r,
                i,
                a,
                s,
                o = [],
                l = !0,
                c = !1;
              try {
                if (((a = (n = n.call(e)).next), 0 === t)) {
                  if (Object(n) !== n) return;
                  l = !1;
                } else for (; !(l = (r = a.call(n)).done) && (o.push(r.value), o.length !== t); l = !0);
              } catch (e) {
                (c = !0), (i = e);
              } finally {
                try {
                  if (!l && null != n.return && ((s = n.return()), Object(s) !== s)) return;
                } finally {
                  if (c) throw i;
                }
              }
              return o;
            }
          })(e, t) ||
          (function (e, t) {
            if (e) {
              if ("string" == typeof e) return p(e, t);
              var n = Object.prototype.toString.call(e).slice(8, -1);
              return (
                "Object" === n && e.constructor && (n = e.constructor.name),
                "Map" === n || "Set" === n
                  ? Array.from(e)
                  : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)
                    ? p(e, t)
                    : void 0
              );
            }
          })(e, t) ||
          (function () {
            throw new TypeError(
              "Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
            );
          })()
        );
      }
      function h(e, t, n, r, i, a, s) {
        try {
          var o = e[a](s),
            l = o.value;
        } catch (e) {
          return void n(e);
        }
        o.done ? t(l) : Promise.resolve(l).then(r, i);
      }
      function m(e) {
        return function () {
          var t = this,
            n = arguments;
          return new Promise(function (r, i) {
            var a = e.apply(t, n);
            function s(e) {
              h(a, r, i, s, o, "next", e);
            }
            function o(e) {
              h(a, r, i, s, o, "throw", e);
            }
            s(void 0);
          });
        };
      }
      i()(function () {
        i()(".page-wrap").hasClass("cart") &&
          (i()(".cart__qty button").on("click", d), i()(".cart__qty input").on("keyup", u));
      });
      var g = n(687),
        v = n.n(g);
      function y() {
        return b.apply(this, arguments);
      }
      function b() {
        return (
          (b = m(
            v().mark(function e() {
              var t,
                n = arguments;
              return v().wrap(function (e) {
                for (; ;)
                  switch ((e.prev = e.next)) {
                    case 0:
                      return (
                        (t = n.length > 0 && void 0 !== n[0] ? n[0] : "json"),
                        e.abrupt("return", i().get("/cart?view=".concat(t)))
                      );
                    case 2:
                    case "end":
                      return e.stop();
                  }
              }, e);
            })
          )),
          b.apply(this, arguments)
        );
      }
      function w(e) {
        return x.apply(this, arguments);
      }
      function x() {
        return (x = m(
          v().mark(function e(t) {
            return v().wrap(function (e) {
              for (; ;)
                switch ((e.prev = e.next)) {
                  case 0:
                    return e.abrupt("return", i().post("/cart/change.js", { id: t, quantity: 0 }));
                  case 1:
                  case "end":
                    return e.stop();
                }
            }, e);
          })
        )).apply(this, arguments);
      }
      function C(e) {
        return E.apply(this, arguments);
      }
      function E() {
        return (E = m(
          v().mark(function e(t) {
            return v().wrap(function (e) {
              for (; ;)
                switch ((e.prev = e.next)) {
                  case 0:
                    return e.abrupt("return", i().post("/cart/update.js", { updates: t }));
                  case 1:
                  case "end":
                    return e.stop();
                }
            }, e);
          })
        )).apply(this, arguments);
      }
      function T(e) {
        console.log("e.deduction_amount: ", e.deduction_amount);
        if (
          window.patient &&
          window.patient.prescription &&
          window.patient.prescription.limits &&
          window.patient.prescription.limits.grams
        ) {
          window.patient.prescription.limits.grams.cart = e.deduction_amount;
          console.log("window.patient: ", window.patient.prescription.limits.grams.cart);
        }
        var t = e.deduction_amount.concat("g");
        i()(".gram-limits .eq-total").html(t);
      }
      function S(e) {
        var t = e.item_count;
        i()(".cart-item-count").html("".concat(t, " items")), i()(".cart-count span").html(t);
      }
      function $(e) {
        i()(".cart-sidebar").html(e);
      }
      function k(e) {
        var t = i()(".cart-sidebar .checkout");
        "update" === e
          ? t.removeClass("pla-disable").prop("disabled", !1).addClass("update-cart").text("Update Cart")
          : "updating" === e
            ? t.addClass("pla-disable").removeClass("update-cart").text("Updating...")
            : t.prop("disabled", !1).removeClass(["pla-disable", "update-cart"]).text("Checkout");
      }
      function M() {
        return P.apply(this, arguments);
      }
      function P() {
        return (P = m(
          v().mark(function e() {
            var t, n, r, i, a;
            return v().wrap(function (e) {
              for (; ;)
                switch ((e.prev = e.next)) {
                  case 0:
                    return (e.next = 2), Promise.all([y("json"), y("sidebar")]);
                  case 2:
                    (t = e.sent), (n = f(t, 2)), (r = n[0]), (i = n[1]), S((a = JSON.parse(r))), T(a), $(i);
                  case 10:
                  case "end":
                    return e.stop();
                }
            }, e);
          })
        )).apply(this, arguments);
      }
      function L() {
        i()(".cart-sidebar").toggleClass("active");
      }
      function O(e) {
        var t = i()(e.target),
          n = t.parents(".quantity-selector").find("input"),
          r = parseInt(n.val(), 10),
          a = t.hasClass("increment");
        r > 0 ? n.val(a ? r + 1 : r - 1) : n.val(a ? r + 1 : r), k("update");
      }
      function A() {
        k("update");
      }
      function D(e) {
        return N.apply(this, arguments);
      }
      function N() {
        return (N = m(
          v().mark(function e(t) {
            var n, r;
            return v().wrap(function (e) {
              for (; ;)
                switch ((e.prev = e.next)) {
                  case 0:
                    if (!i()(t.target).hasClass("update-cart")) {
                      e.next = 10;
                      break;
                    }
                    return (
                      (n = {}),
                      i().each(i()(".cart-sidebar .cart-items"), function (e, t) {
                        var r = i()(t).data("item-id"),
                          a = i()(t).find("input").val();
                        n[r] = a;
                      }),
                      (e.next = 6),
                      C(n)
                    );
                  case 6:
                    s(), k("checkout"), (e.next = 13);
                    break;
                  case 10:
                    (r = i()(".cart-sidebar form"))
                      .find(".checkout")
                      .attr("name", "checkout")
                      .attr("type", "submit"),
                      r.trigger("submit");
                  case 13:
                  case "end":
                    return e.stop();
                }
            }, e);
          })
        )).apply(this, arguments);
      }
      function I(e) {
        return j.apply(this, arguments);
      }
      function j() {
        return (j = m(
          v().mark(function e(t) {
            var n;
            return v().wrap(function (e) {
              for (; ;)
                switch ((e.prev = e.next)) {
                  case 0:
                    return (
                      (n = i()(t.target).parents(".cart-items").data("item-id")), k("updating"), (e.next = 4), w(n)
                    );
                  case 4:
                    s();
                  case 5:
                  case "end":
                    return e.stop();
                }
            }, e);
          })
        )).apply(this, arguments);
      }
      function validatePassword(password) {
        const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#^()_+-])[A-Za-z\d@$!%*?&#^()_+-]{8,}$/;
        return regex.test(password);
      }
      function z(event, $formElements) {
        // Validate required fields
        $formElements.each(function (_, element) {
          const $element = i()(element);
          const $errorField = $element.parent().find(".form-field-error");
          let errorMessage = "";

          if (element.validity.valueMissing || element.value.length === 0) {
            errorMessage = "Field is required";
          } else if (element.validity.typeMismatch || element.validity.patternMismatch) {
            errorMessage = "Must be in the format of example: " + element.dataset.patternExample;
          }

          $element.toggleClass("invalid", errorMessage !== "");
          $errorField.html(errorMessage).toggle(errorMessage !== "");
        });

        // Helper: Validate matching emails
        function validateEmailMatch(selector, message) {
          const $emailFields = i()(selector);
          const emailValues = $emailFields.map((_, el) => i()(el).val().trim());
          const $confirmError = $emailFields.eq(1).next(".form-field-error");
          const confirmInput = $emailFields.eq(1).get(0);

          if (confirmInput && emailValues[0] !== emailValues[1]) {
            confirmInput.setCustomValidity(message);
            $confirmError.text(message).show();
          } else {
            confirmInput?.setCustomValidity("");
            $confirmError.hide();
          }

          $emailFields.on("change", function () {
            if (emailValues[0] === emailValues[1]) {
              $emailFields.eq(1).removeClass("invalid");
              $confirmError.hide();
            }
            z(event, event[0].checkValidity() ? i()() : i()(this));
          });
        }

        validateEmailMatch(
          "input[name='customer[email]'], input[name='customer[note][Confirm Email]']",
          "Email addresses must match"
        );

        validateEmailMatch(
          "input[name='customer[note][Caregiver Email]'], input[name='customer[note][Caregiver Confirm Email]']",
          "Email addresses must match"
        );

        // Check if email already exists
        const emailInput = document.getElementById("email");
        if (emailInput) {
          emailInput.addEventListener("change", function () {
            const emailValue = emailInput.value;
            console.log("email changed: ", emailValue);

            const xhr = new XMLHttpRequest();
            xhr.open("POST", "https://sensimed-customers.vercel.app/check-email-exists");
            xhr.setRequestHeader("Content-Type", "application/json");

            xhr.onload = function () {
              if (xhr.status === 200) {
                const response = JSON.parse(xhr.responseText);
                const $firstEmailInput = i()("input[name='customer[email]']");
                const emailErrorField = $firstEmailInput.next(".form-field-error");
                const errorMsg = "Email address already exists. Please use a different email.";
                const emailEl = $firstEmailInput.get(0);

                if (emailEl && response.exists) {
                  emailEl.setCustomValidity(errorMsg);
                  emailErrorField.text(errorMsg).show();
                } else {
                  emailEl?.setCustomValidity("");
                  emailErrorField.hide();
                }

                console.log("exist: ", response.exists);
              } else {
                console.error("Request failed with status:", xhr.status);
              }
            };

            xhr.send(JSON.stringify({ email: emailValue }));
          });
        }

        // Helper: Validate password and confirmation fields
        function validatePasswordFields(selector) {
          const $passwordFields = i()(selector);
          const values = $passwordFields.map((_, el) => i()(el).val().trim());

          const $passwordError = $passwordFields.eq(0).next(".form-field-error");
          const $confirmError = $passwordFields.eq(1).next(".form-field-error");

          const passwordInput = $passwordFields.eq(0).get(0);
          const confirmInput = $passwordFields.eq(1).get(0);

          const matchMsg = "Password must match";
          const strengthMsg = "Password must be 8 characters, one upper case, one number, and one special character(@$!%*?&#^()_+-).";

          if (passwordInput && !validatePassword(values[0])) {
            passwordInput.setCustomValidity(strengthMsg);
            $passwordError.text(strengthMsg).show();
          } else {
            passwordInput?.setCustomValidity("");
            $passwordError.hide();
          }

          if (confirmInput && values[0] !== values[1]) {
            confirmInput.setCustomValidity(matchMsg);
            $confirmError.text(matchMsg).show();
          } else {
            confirmInput?.setCustomValidity("");
            $confirmError.hide();
          }

          $passwordFields.on("change", function () {
            if (validatePassword(values[0])) {
              $passwordFields.eq(0).removeClass("invalid");
              $passwordError.hide();
            }

            if (values[0] === values[1]) {
              $passwordFields.eq(1).removeClass("invalid");
              $confirmError.hide();
            }

            z(event, event[0].checkValidity() ? i()() : i()(this));
          });
        }

        function validateStatusCardField(selector) {
          const $fileInput = i()(selector);
          const $error = $fileInput.next(".form-field-error").length
            ? $fileInput.next(".form-field-error")
            : i()('<span class="form-field-error"></span>').insertAfter($fileInput);

          const fileInputEl = $fileInput.get(0);
          const MAX_STATUS_FILE_SIZE_MB = 5;
          const MAX_STATUS_FILE_SIZE_BYTES = MAX_STATUS_FILE_SIZE_MB * 1024 * 1024;

          const requiredMsg = "Please upload your Status Card.";
          const sizeMsg = `Status Card must be smaller than ${MAX_STATUS_FILE_SIZE_MB}MB.`;

          // Validation logic
          if (!fileInputEl.files[0]) {
            fileInputEl.setCustomValidity(requiredMsg);
            $error.text(requiredMsg).show();
            return false;
          } else if (fileInputEl.files[0].size > MAX_STATUS_FILE_SIZE_BYTES) {
            fileInputEl.setCustomValidity(sizeMsg);
            $error.text(sizeMsg).show();
            return false;
          } else {
            fileInputEl.setCustomValidity("");
            $error.hide();
            return true;
          }
        }

        // Run password validations
        validatePasswordFields("#register-consent input[name='customer[password]'], #register-consent input[name='customer[password_confirmation]']");
        validatePasswordFields(".reset input[name='customer[password]'], .reset input[name='customer[password_confirmation]']");

        // Validate attachment if first nation is true
        var $firstNations = i()("#first-nations");
        var $statusInput = i()("#status-input");

        if ($firstNations.length && $firstNations.is(':checked')) {
          validateStatusCardField($statusInput);
        }
      }



      function q(e) {
        if ("/account" === e.attr("action")) e.trigger("submit");
        else {
          var t = e.serializeArray().reduce(function (e, t) {
            var n = t.name,
              r = t.value;
            if (n.includes("note")) {
              e.note || (e.note = {});
              var i = n.substring(n.lastIndexOf("[") + 1, n.length - 1);
              e.note[i] = r;
            } else n.includes("customer") ? (e[n.substring(n.indexOf("[") + 1, n.length - 1)] = r) : (e[n] = r);
            return e;
          }, {});
          i()
            .post(e.attr("action"), JSON.stringify(t))
            .done(function () {
              window.location.href = "/pages/address-change-complete";
            });
        }
      }
      function _(e, t) {
        var n = e.find(".accordion-tab-title"),
          r = e.find(".panel"),
          i = e.find(".toggle-icon");
        "open" === t
          ? (n.addClass("active"), i.text("–"), r.slideDown("fast"))
          : "close" === t
            ? (n.removeClass("active"), i.text("+"), r.slideUp("fast"))
            : (n.toggleClass("active"),
              n.hasClass("active") ? (i.text("–"), r.slideDown("fast")) : (i.text("+"), r.slideUp("fast")));
      }
      i()(
        m(
          v().mark(function e() {
            return v().wrap(function (e) {
              for (; ;)
                switch ((e.prev = e.next)) {
                  case 0:
                    return (e.next = 2), M();
                  case 2:
                    document.addEventListener("cart:updated", M),
                      i()(".nav-cart").on("click", L),
                      i()(document).on("click", ".cart-sidebar .close", L),
                      i()(document).on("click", ".cart-sidebar .quantity-selector button", O),
                      i()(document).on("keyup", ".quantity-selector input", A),
                      i()(document).on("click", ".remove-from-cart", I),
                      i()(document).on("click", ".cart-sidebar .checkout", D);
                  case 9:
                  case "end":
                    return e.stop();
                }
            }, e);
          })
        )
      ),
        i()("input").on("blur", function () {
          z(i()(this).closest("form"), i()(this).filter(":invalid"));
        }),
        i()(function () {
          if (
            (i()(".order_row .view_btn_wrap").on("click", function () {
              i()(".order_details_wrap").slideUp();
              var e = i()(this).next(".order_details_wrap");
              e.is(":hidden") && e.slideDown();
            }),
              i()(".toggle-checkbox").on("change", function () {
                var e = i()(this).data("target");
                i()("#".concat(e))[this.checked ? "show" : "hide"]("fast");
              }),
              i()("body").hasClass("template-register"))
          ) {
            // Listen for changes on the patient type dropdown
            i()("#patient_type").on("change", function () {
              // Get the currently selected patient type
              var patientType = i()(this).val();

              // Immediately execute a function to update UI elements based on the selected type
              (function (selectedType) {
                // Mapping logical names to section identifiers
                var sectionIds = {
                  personal: "personal-info",
                  caregiver: "caregiver",
                  additional: "additional-info",
                  address: "home-address",
                  consent: "register-consent",
                };

                // Define which sections should be visible for each patient type
                var visibleSections = {
                  new: [sectionIds.personal, sectionIds.address, sectionIds.additional, sectionIds.consent],
                  address: [sectionIds.personal, sectionIds.address, sectionIds.consent],
                  caregiver: [sectionIds.personal, sectionIds.caregiver, sectionIds.additional, sectionIds.address, sectionIds.consent],
                  caregiverAddress: [sectionIds.personal, sectionIds.caregiver, sectionIds.address, sectionIds.consent],
                };

                // First, hide all sections by adding the "hide" class
                Object.values(sectionIds).forEach(function (section) {
                  i()("#" + section + "-section").addClass("hide");
                });

                // Then, show only the sections that are relevant for the selected patient type
                visibleSections[selectedType].forEach(function (section) {
                  i()("#" + section + "-section").removeClass("hide");
                });

                // Toggle the visibility and required attribute for the password fields
                var passwordWrapper = i()(".password-wrapper");
                if (selectedType === "address" || selectedType === "caregiverAddress") {
                  passwordWrapper.addClass("d-none");
                  passwordWrapper.find("#password-create").removeClass("required");
                  passwordWrapper.find("#password-confirm").removeClass("required");
                } else {
                  passwordWrapper.removeClass("d-none");
                  passwordWrapper.find("#password-create").addClass("required");
                  passwordWrapper.find("#password-confirm").addClass("required");
                }

                // Toggle the authorization (medical document) section
                var authorizationWrapper = i()("#authorization-wrapper");
                if (selectedType === "address" || selectedType === "caregiverAddress") {
                  authorizationWrapper.addClass("d-none");
                  authorizationWrapper.find("#medical_document").removeClass("required");
                } else {
                  authorizationWrapper.removeClass("d-none");
                  authorizationWrapper.find("#medical_document").addClass("required");
                }

                // Toggle the personal email section
                var personalEmailWrapper = i()(".personal-email-wrapper");
                if (selectedType === "address" || selectedType === "caregiverAddress") {
                  personalEmailWrapper.addClass("d-none");
                  personalEmailWrapper.find("#email").removeClass("required");
                  personalEmailWrapper.find("#confirmemail").removeClass("required");
                } else {
                  personalEmailWrapper.removeClass("d-none");
                  personalEmailWrapper.find("#email").addClass("required");
                  personalEmailWrapper.find("#confirmemail").addClass("required");
                }


                if (selectedType == "address" || selectedType == "caregiverAddress") {
                  document.querySelector(".register-container .accepts-marketing").classList.add("hidden")
                } else {
                  document.querySelector(".register-container  .accepts-marketing").classList.remove("hidden")
                }
              })(patientType);

              // Set the form action based on the patient type:
              // If the type is "address" or "caregiverAddress", use a specific URL, otherwise default to "/account"
              var formAction = (patientType === "address" || patientType === "caregiverAddress")
                ? window.zapAddressChangeToFreshdesk
                : "/account";

              // Update the form's action attribute accordingly
              i()("#create_customer").attr("action", formAction);
            });
            var e = window.location.hash.substring(1);
            "" !== e && ["new", "address", "caregiver", "caregiverAddress"].includes(e) && i()("#patient_type").val(e).trigger("change"),
              i()(".next-btn").on("click", function () {
                var e = ".responsive-section-container",
                  t = i()(this).parents(e).nextAll(e).not(".hide").eq(0);
                _(t, "open"), i()(document.documentElement).animate({ scrollTop: i()(t).offset().top - 100 }, 50);
              }),
              i()(".accordion-tab-title").on("click", function () {
                _(i()(this).parent(), "toggle");
              }),
              i()("input").on("input", function () {
                i()(this).removeClass("invalid"), i()(this).parent().find(".form-field-error").html("").hide();
              }),
              // Attach a click event handler to elements with class "submit-btn"
              i()(".submit-btn").on("click", function (e) {
                e.preventDefault();
                // Define some unused variables and get the form element by its ID
                var unused1, unused2, unused3, unused4, unused5,
                  $createCustomerForm = i()("#create_customer");

                // Apologies for the duplicate code but this thing is hard to manage,
                // just note that there are two of this same function on different scopes
                function validateStatusCardField(selector) {
                  const $fileInput = i()(selector);
                  const $error = $fileInput.next(".form-field-error").length
                    ? $fileInput.next(".form-field-error")
                    : i()('<span class="form-field-error"></span>').insertAfter($fileInput);

                  const fileInputEl = $fileInput.get(0);
                  const MAX_STATUS_FILE_SIZE_MB = 5;
                  const MAX_STATUS_FILE_SIZE_BYTES = MAX_STATUS_FILE_SIZE_MB * 1024 * 1024;

                  const requiredMsg = "Please upload your Status Card.";
                  const sizeMsg = `Status Card must be smaller than ${MAX_STATUS_FILE_SIZE_MB}MB.`;

                  // Validation logic
                  if (!fileInputEl.files[0]) {
                    fileInputEl.setCustomValidity(requiredMsg);
                    $error.text(requiredMsg).show();
                    return false;
                  } else if (fileInputEl.files[0].size > MAX_STATUS_FILE_SIZE_BYTES) {
                    fileInputEl.setCustomValidity(sizeMsg);
                    $error.text(sizeMsg).show();
                    return false;
                  } else {
                    fileInputEl.setCustomValidity("");
                    $error.hide();
                    return true;
                  }
                }

                // Validate the form. If the validation function returns false, stop further execution.
                if (
                  (function ($formElement) {
                    // Get the submit button element
                    var $submitButton = i()(".submit-btn");
                    // Disable the submit button and hide any invalid notice messages
                    $submitButton.prop("disabled", true);
                    i()(".invalid-notice").addClass("hide");

                    // Check for invalid required fields within the form
                    var validationResult = (function ($form) {
                      // Find all required fields that are either empty or invalid,
                      // excluding those in a hidden caregiver section or that are hidden.
                      var $invalidRequiredFields = $form.find(".required").filter(function () {
                        return !(
                          i()(this).closest("#caregiver-section").is(":hidden") ||
                          i()(this).is(":hidden") ||
                          (this.value.length !== 0 && this.validity.valid)
                        );
                      });
                      // Return an array: first element is a boolean indicating if all fields are valid,
                      // and second element is the list of invalid fields.
                      return [$invalidRequiredFields.length === 0, $invalidRequiredFields];
                    })($formElement);

                    // Use a helper function "f" to destructure the result array
                    var destructuredResult = f(validationResult, 2),
                    isFormValid = destructuredResult[0],
                    invalidFields = destructuredResult[1];

                    var $firstNations = i()("#first-nations");
                    var $statusInput = i()("#status-input");

                    if ($firstNations.length && $firstNations.is(':checked')) {
                      if (!validateStatusCardField("#status-input")) {
                        isFormValid = false;
                      }
                    }
                    

                    // If the form is valid, return true.
                    // Otherwise, call function "z" to display errors, show the invalid notice,
                    // re-enable the submit button, and return false.
                    return isFormValid || (z($formElement, invalidFields), i()(".invalid-notice").removeClass("hide"), $submitButton.prop("disabled", false), false);
                  })($createCustomerForm)
                ) {
                  // Process form data and dispatch custom event
                  const form = i()("form#create_customer")[0];
                  var patientType = i()("#patient_type").val();


                  // Create and dispatch custom event with form data
                  const submitEvent = new CustomEvent('customerFormSubmit', {
                    detail: {
                      form: form,
                      patientType: patientType,
                    }
                  });
                  document.dispatchEvent(submitEvent);

                  // Handle address change redirects
                  // if ("address" === patientType || "caregiverAddress" === patientType) {
                  //   window.location.href = "/pages/address-change-complete";
                  // }
                }
                // Get the medical document input element, split its value by space,
                // and store the first word in localStorage under the key "medical_document"
                var $medicalDocumentInput = i()("#medical_document");
                var firstWord = $medicalDocumentInput.val().split(" ")[0];
                localStorage.setItem("medical_document", firstWord);
              }),
              i()("#patient_shipping").on("click", function () {
                var e = ["address", "apartment", "city", "province", "postal"];
                i()(this).is(":checked")
                  ? e.forEach(function (e) {
                    return i()("#home_".concat(e))
                      .val(i()("#".concat(e)).val())
                      .trigger("input");
                  })
                  : e.forEach(function (e) {
                    return i()("#home_".concat(e)).val("").trigger("input");
                  });
              }),
              i()("#status-input").on("change", function () {
                var e = i()(this)[0].files[0];
                i()(this).parent().find(".file-name").html(e.name);
                var t = new FileReader();
                t.readAsDataURL(e),
                  (t.onload = function () {
                    var e = t.result.split(","),
                      n = e[0].split(":")[1].split(";")[0],
                      r = e[1];
                    i()("#status-image-type").val(n), i()("#status-image-data").val(r);
                  });
              });
          }
        }),
        i()(".page-wrap").hasClass("faq-container") &&
        (i()(".faq-tab").on("click", function () {
          i()(this).next(".faq-answer").toggleClass("d-none"),
            i()(".faq-answer").not(i()(this).next(".faq-answer")).addClass("d-none"),
            i()(this).find(".faq-icon").toggleClass("faq-icon-reverse");
        }),
          i()(".faq-item").on("click", function () {
            i()(this).addClass("active").siblings().removeClass("active");
            var e = i()(this).data("id");
            i()(".faq-question")
              .hide()
              .filter(function () {
                return i()(this).data("id") === e || "all" === e;
              })
              .show();
          })),
        i()(function () {
          i()(".newsletter-signup-form button").on("click", function () {
            i()(void 0).prop("disabled", !0);
            var e = i()(".newsletter-signup-form"),
              t = e.find(".email-input").val();
            i()
              .post(window.zapSendgridMailingListSignup, { email: t })
              .done(function () {
                e.addClass("d-none"), i()(".signup-success").removeClass("d-none");
              });
          });
        }),
        i()(".page-wrap").hasClass("faq-container") &&
        (i()(".question-tab").on("click", function () {
          i()(this).next(".answer-text").toggleClass("d-none"),
            i()(".answer-text").not(i()(this).next(".answer-text")).addClass("d-none"),
            i()(this).find(".faq-icon").toggleClass("faq-icon-reverse");
        }),
          i()(".faq-item").on("click", function () {
            i()(this).addClass("active").siblings().removeClass("active");
            var e = i()(this).data("id");
            i()(".question-tab")
              .hide()
              .filter(function () {
                return i()(this).data("id") === e || "all" === e;
              })
              .show();
          })),
        i()(".close-note").on("click", function () {
          i()(".nav-note").hide();
        });
      var H = i()(".nav-veil");
      function R() {
        i()(".dropdown-drawer").removeClass("open").addClass("close"), H.removeClass("open").addClass("close");
      }
      function G(e) {
        return null !== e && "object" == typeof e && "constructor" in e && e.constructor === Object;
      }
      function W(e = {}, t = {}) {
        Object.keys(t).forEach((n) => {
          void 0 === e[n] ? (e[n] = t[n]) : G(t[n]) && G(e[n]) && Object.keys(t[n]).length > 0 && W(e[n], t[n]);
        });
      }
      i()(".main-link.basic-dropdown-wrap").mouseenter(function () {
        R();
      }),
        i()(document).on("click", function () {
          i()(".search-button.desktop:not(.closed)") && R(),
            i()(".search-button.mobile:not(.closed)") && i()(".search-button.mobile").addClass("closed");
        }),
        i()(".search-button.mobile").on("click", function (e) {
          var t;
          e.stopPropagation(), (t = i()(e.currentTarget)), i()(t).removeClass("closed");
        }),
        i()(".close-search").on("click", function (e) {
          e.stopPropagation(), R();
        }),
        H.on("click", function () {
          R();
        }),
        i()(".search-input").on("input", function () {
          i()(this).val();
        }),
        i()(".more-results button").on("click", function () {
          var e = i()(".search-input").val(),
            t = "/search?q=".concat(e);
          window.location = window.location.origin + t;
        }),
        i()(".mobile-live-search").on("click", function () {
          i()(".mobile-live-search").addClass("hidden");
        }),
        i()(".mobile-toggler").on("touchstart click", function (e) {
          e.stopPropagation(),
            e.preventDefault(),
            i()(".mobile-dropdown").toggleClass("hidden"),
            i()(".nav-veil-mobile").toggleClass("open");
        }),
        i()(".nav-veil-mobile").on("touchstart click", function (e) {
          e.stopPropagation(),
            e.preventDefault(),
            i()(".mobile-dropdown").toggleClass("hidden"),
            i()(".nav-veil-mobile").toggleClass("open");
        }),
        i()(".page-wrap").hasClass("orders") &&
        (i()("button.view_btn").on("click", function () {
          var e = i()(this).attr("data-order");
          i()(this).hide(),
            i()(".items_table[data-order!='".concat(e, "']")).slideUp(),
            i()(".order_summary[data-order!='".concat(e, "']")).slideUp(),
            i()(".order_details[data-order!='".concat(e, "']")).slideUp(),
            i()(".items_table[data-order='".concat(e, "']")).slideDown("slow"),
            i()(".order_summary[data-order='".concat(e, "']")).slideDown("slow"),
            i()(".order_details[data-order='".concat(e, "']")).slideDown("slow");
        }),
          i()("button.close_btn").on("click", function () {
            i()("button.view_btn").show(),
              i()(".items_table").slideUp("slow"),
              i()(".order_summary").slideUp("slow"),
              i()(".order_details").slideUp("slow");
          })),
        i()(".page-wrap").hasClass("login_form") &&
        document.referrer.includes("recover") &&
        i()(".message").text("Recovery Email Sent");
      const F = {
        body: {},
        addEventListener() { },
        removeEventListener() { },
        activeElement: { blur() { }, nodeName: "" },
        querySelector: () => null,
        querySelectorAll: () => [],
        getElementById: () => null,
        createEvent: () => ({ initEvent() { } }),
        createElement: () => ({
          children: [],
          childNodes: [],
          style: {},
          setAttribute() { },
          getElementsByTagName: () => [],
        }),
        createElementNS: () => ({}),
        importNode: () => null,
        location: { hash: "", host: "", hostname: "", href: "", origin: "", pathname: "", protocol: "", search: "" },
      };
      function X() {
        const e = "undefined" != typeof document ? document : {};
        return W(e, F), e;
      }
      const Y = {
        document: F,
        navigator: { userAgent: "" },
        location: { hash: "", host: "", hostname: "", href: "", origin: "", pathname: "", protocol: "", search: "" },
        history: { replaceState() { }, pushState() { }, go() { }, back() { } },
        CustomEvent: function () {
          return this;
        },
        addEventListener() { },
        removeEventListener() { },
        getComputedStyle: () => ({ getPropertyValue: () => "" }),
        Image() { },
        Date() { },
        screen: {},
        setTimeout() { },
        clearTimeout() { },
        matchMedia: () => ({}),
        requestAnimationFrame: (e) => ("undefined" == typeof setTimeout ? (e(), null) : setTimeout(e, 0)),
        cancelAnimationFrame(e) {
          "undefined" != typeof setTimeout && clearTimeout(e);
        },
      };
      function V() {
        const e = "undefined" != typeof window ? window : {};
        return W(e, Y), e;
      }
      class U extends Array {
        constructor(e) {
          "number" == typeof e
            ? super(e)
            : (super(...(e || [])),
              (function (e) {
                const t = e.__proto__;
                Object.defineProperty(e, "__proto__", {
                  get: () => t,
                  set(e) {
                    t.__proto__ = e;
                  },
                });
              })(this));
        }
      }
      function K(e = []) {
        const t = [];
        return (
          e.forEach((e) => {
            Array.isArray(e) ? t.push(...K(e)) : t.push(e);
          }),
          t
        );
      }
      function J(e, t) {
        return Array.prototype.filter.call(e, t);
      }
      function Q(e, t) {
        const n = V(),
          r = X();
        let i = [];
        if (!t && e instanceof U) return e;
        if (!e) return new U(i);
        if ("string" == typeof e) {
          const n = e.trim();
          if (n.indexOf("<") >= 0 && n.indexOf(">") >= 0) {
            let e = "div";
            0 === n.indexOf("<li") && (e = "ul"),
              0 === n.indexOf("<tr") && (e = "tbody"),
              (0 !== n.indexOf("<td") && 0 !== n.indexOf("<th")) || (e = "tr"),
              0 === n.indexOf("<tbody") && (e = "table"),
              0 === n.indexOf("<option") && (e = "select");
            const t = r.createElement(e);
            t.innerHTML = n;
            for (let e = 0; e < t.childNodes.length; e += 1) i.push(t.childNodes[e]);
          } else
            i = (function (e, t) {
              if ("string" != typeof e) return [e];
              const n = [],
                r = t.querySelectorAll(e);
              for (let e = 0; e < r.length; e += 1) n.push(r[e]);
              return n;
            })(e.trim(), t || r);
        } else if (e.nodeType || e === n || e === r) i.push(e);
        else if (Array.isArray(e)) {
          if (e instanceof U) return e;
          i = e;
        }
        return new U(
          (function (e) {
            const t = [];
            for (let n = 0; n < e.length; n += 1) -1 === t.indexOf(e[n]) && t.push(e[n]);
            return t;
          })(i)
        );
      }
      Q.fn = U.prototype;
      const Z = "resize scroll".split(" ");
      function ee(e) {
        return function (...t) {
          if (void 0 === t[0]) {
            for (let t = 0; t < this.length; t += 1)
              Z.indexOf(e) < 0 && (e in this[t] ? this[t][e]() : Q(this[t]).trigger(e));
            return this;
          }
          return this.on(e, ...t);
        };
      }
      ee("click"),
        ee("blur"),
        ee("focus"),
        ee("focusin"),
        ee("focusout"),
        ee("keyup"),
        ee("keydown"),
        ee("keypress"),
        ee("submit"),
        ee("change"),
        ee("mousedown"),
        ee("mousemove"),
        ee("mouseup"),
        ee("mouseenter"),
        ee("mouseleave"),
        ee("mouseout"),
        ee("mouseover"),
        ee("touchstart"),
        ee("touchend"),
        ee("touchmove"),
        ee("resize"),
        ee("scroll");
      const te = {
        addClass: function (...e) {
          const t = K(e.map((e) => e.split(" ")));
          return (
            this.forEach((e) => {
              e.classList.add(...t);
            }),
            this
          );
        },
        removeClass: function (...e) {
          const t = K(e.map((e) => e.split(" ")));
          return (
            this.forEach((e) => {
              e.classList.remove(...t);
            }),
            this
          );
        },
        hasClass: function (...e) {
          const t = K(e.map((e) => e.split(" ")));
          return J(this, (e) => t.filter((t) => e.classList.contains(t)).length > 0).length > 0;
        },
        toggleClass: function (...e) {
          const t = K(e.map((e) => e.split(" ")));
          this.forEach((e) => {
            t.forEach((t) => {
              e.classList.toggle(t);
            });
          });
        },
        attr: function (e, t) {
          if (1 === arguments.length && "string" == typeof e) return this[0] ? this[0].getAttribute(e) : void 0;
          for (let n = 0; n < this.length; n += 1)
            if (2 === arguments.length) this[n].setAttribute(e, t);
            else for (const t in e) (this[n][t] = e[t]), this[n].setAttribute(t, e[t]);
          return this;
        },
        removeAttr: function (e) {
          for (let t = 0; t < this.length; t += 1) this[t].removeAttribute(e);
          return this;
        },
        transform: function (e) {
          for (let t = 0; t < this.length; t += 1) this[t].style.transform = e;
          return this;
        },
        transition: function (e) {
          for (let t = 0; t < this.length; t += 1)
            this[t].style.transitionDuration = "string" != typeof e ? `${e}ms` : e;
          return this;
        },
        on: function (...e) {
          let [t, n, r, i] = e;
          function a(e) {
            const t = e.target;
            if (!t) return;
            const i = e.target.dom7EventData || [];
            if ((i.indexOf(e) < 0 && i.unshift(e), Q(t).is(n))) r.apply(t, i);
            else {
              const e = Q(t).parents();
              for (let t = 0; t < e.length; t += 1) Q(e[t]).is(n) && r.apply(e[t], i);
            }
          }
          function s(e) {
            const t = (e && e.target && e.target.dom7EventData) || [];
            t.indexOf(e) < 0 && t.unshift(e), r.apply(this, t);
          }
          "function" == typeof e[1] && (([t, r, i] = e), (n = void 0)), i || (i = !1);
          const o = t.split(" ");
          let l;
          for (let e = 0; e < this.length; e += 1) {
            const t = this[e];
            if (n)
              for (l = 0; l < o.length; l += 1) {
                const e = o[l];
                t.dom7LiveListeners || (t.dom7LiveListeners = {}),
                  t.dom7LiveListeners[e] || (t.dom7LiveListeners[e] = []),
                  t.dom7LiveListeners[e].push({ listener: r, proxyListener: a }),
                  t.addEventListener(e, a, i);
              }
            else
              for (l = 0; l < o.length; l += 1) {
                const e = o[l];
                t.dom7Listeners || (t.dom7Listeners = {}),
                  t.dom7Listeners[e] || (t.dom7Listeners[e] = []),
                  t.dom7Listeners[e].push({ listener: r, proxyListener: s }),
                  t.addEventListener(e, s, i);
              }
          }
          return this;
        },
        off: function (...e) {
          let [t, n, r, i] = e;
          "function" == typeof e[1] && (([t, r, i] = e), (n = void 0)), i || (i = !1);
          const a = t.split(" ");
          for (let e = 0; e < a.length; e += 1) {
            const t = a[e];
            for (let e = 0; e < this.length; e += 1) {
              const a = this[e];
              let s;
              if (
                (!n && a.dom7Listeners
                  ? (s = a.dom7Listeners[t])
                  : n && a.dom7LiveListeners && (s = a.dom7LiveListeners[t]),
                  s && s.length)
              )
                for (let e = s.length - 1; e >= 0; e -= 1) {
                  const n = s[e];
                  (r && n.listener === r) || (r && n.listener && n.listener.dom7proxy && n.listener.dom7proxy === r)
                    ? (a.removeEventListener(t, n.proxyListener, i), s.splice(e, 1))
                    : r || (a.removeEventListener(t, n.proxyListener, i), s.splice(e, 1));
                }
            }
          }
          return this;
        },
        trigger: function (...e) {
          const t = V(),
            n = e[0].split(" "),
            r = e[1];
          for (let i = 0; i < n.length; i += 1) {
            const a = n[i];
            for (let n = 0; n < this.length; n += 1) {
              const i = this[n];
              if (t.CustomEvent) {
                const n = new t.CustomEvent(a, { detail: r, bubbles: !0, cancelable: !0 });
                (i.dom7EventData = e.filter((e, t) => t > 0)),
                  i.dispatchEvent(n),
                  (i.dom7EventData = []),
                  delete i.dom7EventData;
              }
            }
          }
          return this;
        },
        transitionEnd: function (e) {
          const t = this;
          return (
            e &&
            t.on("transitionend", function n(r) {
              r.target === this && (e.call(this, r), t.off("transitionend", n));
            }),
            this
          );
        },
        outerWidth: function (e) {
          if (this.length > 0) {
            if (e) {
              const e = this.styles();
              return (
                this[0].offsetWidth +
                parseFloat(e.getPropertyValue("margin-right")) +
                parseFloat(e.getPropertyValue("margin-left"))
              );
            }
            return this[0].offsetWidth;
          }
          return null;
        },
        outerHeight: function (e) {
          if (this.length > 0) {
            if (e) {
              const e = this.styles();
              return (
                this[0].offsetHeight +
                parseFloat(e.getPropertyValue("margin-top")) +
                parseFloat(e.getPropertyValue("margin-bottom"))
              );
            }
            return this[0].offsetHeight;
          }
          return null;
        },
        styles: function () {
          const e = V();
          return this[0] ? e.getComputedStyle(this[0], null) : {};
        },
        offset: function () {
          if (this.length > 0) {
            const e = V(),
              t = X(),
              n = this[0],
              r = n.getBoundingClientRect(),
              i = t.body,
              a = n.clientTop || i.clientTop || 0,
              s = n.clientLeft || i.clientLeft || 0,
              o = n === e ? e.scrollY : n.scrollTop,
              l = n === e ? e.scrollX : n.scrollLeft;
            return { top: r.top + o - a, left: r.left + l - s };
          }
          return null;
        },
        css: function (e, t) {
          const n = V();
          let r;
          if (1 === arguments.length) {
            if ("string" != typeof e) {
              for (r = 0; r < this.length; r += 1) for (const t in e) this[r].style[t] = e[t];
              return this;
            }
            if (this[0]) return n.getComputedStyle(this[0], null).getPropertyValue(e);
          }
          if (2 === arguments.length && "string" == typeof e) {
            for (r = 0; r < this.length; r += 1) this[r].style[e] = t;
            return this;
          }
          return this;
        },
        each: function (e) {
          return e
            ? (this.forEach((t, n) => {
              e.apply(t, [t, n]);
            }),
              this)
            : this;
        },
        html: function (e) {
          if (void 0 === e) return this[0] ? this[0].innerHTML : null;
          for (let t = 0; t < this.length; t += 1) this[t].innerHTML = e;
          return this;
        },
        text: function (e) {
          if (void 0 === e) return this[0] ? this[0].textContent.trim() : null;
          for (let t = 0; t < this.length; t += 1) this[t].textContent = e;
          return this;
        },
        is: function (e) {
          const t = V(),
            n = X(),
            r = this[0];
          let i, a;
          if (!r || void 0 === e) return !1;
          if ("string" == typeof e) {
            if (r.matches) return r.matches(e);
            if (r.webkitMatchesSelector) return r.webkitMatchesSelector(e);
            if (r.msMatchesSelector) return r.msMatchesSelector(e);
            for (i = Q(e), a = 0; a < i.length; a += 1) if (i[a] === r) return !0;
            return !1;
          }
          if (e === n) return r === n;
          if (e === t) return r === t;
          if (e.nodeType || e instanceof U) {
            for (i = e.nodeType ? [e] : e, a = 0; a < i.length; a += 1) if (i[a] === r) return !0;
            return !1;
          }
          return !1;
        },
        index: function () {
          let e,
            t = this[0];
          if (t) {
            for (e = 0; null !== (t = t.previousSibling);) 1 === t.nodeType && (e += 1);
            return e;
          }
        },
        eq: function (e) {
          if (void 0 === e) return this;
          const t = this.length;
          if (e > t - 1) return Q([]);
          if (e < 0) {
            const n = t + e;
            return Q(n < 0 ? [] : [this[n]]);
          }
          return Q([this[e]]);
        },
        append: function (...e) {
          let t;
          const n = X();
          for (let r = 0; r < e.length; r += 1) {
            t = e[r];
            for (let e = 0; e < this.length; e += 1)
              if ("string" == typeof t) {
                const r = n.createElement("div");
                for (r.innerHTML = t; r.firstChild;) this[e].appendChild(r.firstChild);
              } else if (t instanceof U) for (let n = 0; n < t.length; n += 1) this[e].appendChild(t[n]);
              else this[e].appendChild(t);
          }
          return this;
        },
        prepend: function (e) {
          const t = X();
          let n, r;
          for (n = 0; n < this.length; n += 1)
            if ("string" == typeof e) {
              const i = t.createElement("div");
              for (i.innerHTML = e, r = i.childNodes.length - 1; r >= 0; r -= 1)
                this[n].insertBefore(i.childNodes[r], this[n].childNodes[0]);
            } else if (e instanceof U)
              for (r = 0; r < e.length; r += 1) this[n].insertBefore(e[r], this[n].childNodes[0]);
            else this[n].insertBefore(e, this[n].childNodes[0]);
          return this;
        },
        next: function (e) {
          return this.length > 0
            ? e
              ? this[0].nextElementSibling && Q(this[0].nextElementSibling).is(e)
                ? Q([this[0].nextElementSibling])
                : Q([])
              : this[0].nextElementSibling
                ? Q([this[0].nextElementSibling])
                : Q([])
            : Q([]);
        },
        nextAll: function (e) {
          const t = [];
          let n = this[0];
          if (!n) return Q([]);
          for (; n.nextElementSibling;) {
            const r = n.nextElementSibling;
            e ? Q(r).is(e) && t.push(r) : t.push(r), (n = r);
          }
          return Q(t);
        },
        prev: function (e) {
          if (this.length > 0) {
            const t = this[0];
            return e
              ? t.previousElementSibling && Q(t.previousElementSibling).is(e)
                ? Q([t.previousElementSibling])
                : Q([])
              : t.previousElementSibling
                ? Q([t.previousElementSibling])
                : Q([]);
          }
          return Q([]);
        },
        prevAll: function (e) {
          const t = [];
          let n = this[0];
          if (!n) return Q([]);
          for (; n.previousElementSibling;) {
            const r = n.previousElementSibling;
            e ? Q(r).is(e) && t.push(r) : t.push(r), (n = r);
          }
          return Q(t);
        },
        parent: function (e) {
          const t = [];
          for (let n = 0; n < this.length; n += 1)
            null !== this[n].parentNode &&
              (e ? Q(this[n].parentNode).is(e) && t.push(this[n].parentNode) : t.push(this[n].parentNode));
          return Q(t);
        },
        parents: function (e) {
          const t = [];
          for (let n = 0; n < this.length; n += 1) {
            let r = this[n].parentNode;
            for (; r;) e ? Q(r).is(e) && t.push(r) : t.push(r), (r = r.parentNode);
          }
          return Q(t);
        },
        closest: function (e) {
          let t = this;
          return void 0 === e ? Q([]) : (t.is(e) || (t = t.parents(e).eq(0)), t);
        },
        find: function (e) {
          const t = [];
          for (let n = 0; n < this.length; n += 1) {
            const r = this[n].querySelectorAll(e);
            for (let e = 0; e < r.length; e += 1) t.push(r[e]);
          }
          return Q(t);
        },
        children: function (e) {
          const t = [];
          for (let n = 0; n < this.length; n += 1) {
            const r = this[n].children;
            for (let n = 0; n < r.length; n += 1) (e && !Q(r[n]).is(e)) || t.push(r[n]);
          }
          return Q(t);
        },
        filter: function (e) {
          return Q(J(this, e));
        },
        remove: function () {
          for (let e = 0; e < this.length; e += 1) this[e].parentNode && this[e].parentNode.removeChild(this[e]);
          return this;
        },
      };
      Object.keys(te).forEach((e) => {
        Object.defineProperty(Q.fn, e, { value: te[e], writable: !0 });
      });
      const ne = Q;
      function re(e, t = 0) {
        return setTimeout(e, t);
      }
      function ie() {
        return Date.now();
      }
      function ae(e, t = "x") {
        const n = V();
        let r, i, a;
        const s = (function (e) {
          const t = V();
          let n;
          return (
            t.getComputedStyle && (n = t.getComputedStyle(e, null)),
            !n && e.currentStyle && (n = e.currentStyle),
            n || (n = e.style),
            n
          );
        })(e);
        return (
          n.WebKitCSSMatrix
            ? ((i = s.transform || s.webkitTransform),
              i.split(",").length > 6 &&
              (i = i
                .split(", ")
                .map((e) => e.replace(",", "."))
                .join(", ")),
              (a = new n.WebKitCSSMatrix("none" === i ? "" : i)))
            : ((a =
              s.MozTransform ||
              s.OTransform ||
              s.MsTransform ||
              s.msTransform ||
              s.transform ||
              s.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,")),
              (r = a.toString().split(","))),
          "x" === t && (i = n.WebKitCSSMatrix ? a.m41 : 16 === r.length ? parseFloat(r[12]) : parseFloat(r[4])),
          "y" === t && (i = n.WebKitCSSMatrix ? a.m42 : 16 === r.length ? parseFloat(r[13]) : parseFloat(r[5])),
          i || 0
        );
      }
      function se(e) {
        return (
          "object" == typeof e &&
          null !== e &&
          e.constructor &&
          "Object" === Object.prototype.toString.call(e).slice(8, -1)
        );
      }
      function oe(...e) {
        const t = Object(e[0]),
          n = ["__proto__", "constructor", "prototype"];
        for (let i = 1; i < e.length; i += 1) {
          const a = e[i];
          if (
            null != a &&
            ((r = a),
              !("undefined" != typeof window && void 0 !== window.HTMLElement
                ? r instanceof HTMLElement
                : r && (1 === r.nodeType || 11 === r.nodeType)))
          ) {
            const e = Object.keys(Object(a)).filter((e) => n.indexOf(e) < 0);
            for (let n = 0, r = e.length; n < r; n += 1) {
              const r = e[n],
                i = Object.getOwnPropertyDescriptor(a, r);
              void 0 !== i &&
                i.enumerable &&
                (se(t[r]) && se(a[r])
                  ? a[r].__swiper__
                    ? (t[r] = a[r])
                    : oe(t[r], a[r])
                  : !se(t[r]) && se(a[r])
                    ? ((t[r] = {}), a[r].__swiper__ ? (t[r] = a[r]) : oe(t[r], a[r]))
                    : (t[r] = a[r]));
            }
          }
        }
        var r;
        return t;
      }
      function le(e, t, n) {
        e.style.setProperty(t, n);
      }
      function ce({ swiper: e, targetPosition: t, side: n }) {
        const r = V(),
          i = -e.translate;
        let a,
          s = null;
        const o = e.params.speed;
        (e.wrapperEl.style.scrollSnapType = "none"), r.cancelAnimationFrame(e.cssModeFrameID);
        const l = t > i ? "next" : "prev",
          c = (e, t) => ("next" === l && e >= t) || ("prev" === l && e <= t),
          d = () => {
            (a = new Date().getTime()), null === s && (s = a);
            const l = Math.max(Math.min((a - s) / o, 1), 0),
              u = 0.5 - Math.cos(l * Math.PI) / 2;
            let p = i + u * (t - i);
            if ((c(p, t) && (p = t), e.wrapperEl.scrollTo({ [n]: p }), c(p, t)))
              return (
                (e.wrapperEl.style.overflow = "hidden"),
                (e.wrapperEl.style.scrollSnapType = ""),
                setTimeout(() => {
                  (e.wrapperEl.style.overflow = ""), e.wrapperEl.scrollTo({ [n]: p });
                }),
                void r.cancelAnimationFrame(e.cssModeFrameID)
              );
            e.cssModeFrameID = r.requestAnimationFrame(d);
          };
        d();
      }
      let de, ue, pe;
      function fe() {
        return (
          de ||
          (de = (function () {
            const e = V(),
              t = X();
            return {
              smoothScroll: t.documentElement && "scrollBehavior" in t.documentElement.style,
              touch: !!("ontouchstart" in e || (e.DocumentTouch && t instanceof e.DocumentTouch)),
              passiveListener: (function () {
                let t = !1;
                try {
                  const n = Object.defineProperty({}, "passive", {
                    get() {
                      t = !0;
                    },
                  });
                  e.addEventListener("testPassiveListener", null, n);
                } catch (e) { }
                return t;
              })(),
              gestures: "ongesturestart" in e,
            };
          })()),
          de
        );
      }
      const he = {
        on(e, t, n) {
          const r = this;
          if ("function" != typeof t) return r;
          const i = n ? "unshift" : "push";
          return (
            e.split(" ").forEach((e) => {
              r.eventsListeners[e] || (r.eventsListeners[e] = []), r.eventsListeners[e][i](t);
            }),
            r
          );
        },
        once(e, t, n) {
          const r = this;
          if ("function" != typeof t) return r;
          function i(...n) {
            r.off(e, i), i.__emitterProxy && delete i.__emitterProxy, t.apply(r, n);
          }
          return (i.__emitterProxy = t), r.on(e, i, n);
        },
        onAny(e, t) {
          const n = this;
          if ("function" != typeof e) return n;
          const r = t ? "unshift" : "push";
          return n.eventsAnyListeners.indexOf(e) < 0 && n.eventsAnyListeners[r](e), n;
        },
        offAny(e) {
          const t = this;
          if (!t.eventsAnyListeners) return t;
          const n = t.eventsAnyListeners.indexOf(e);
          return n >= 0 && t.eventsAnyListeners.splice(n, 1), t;
        },
        off(e, t) {
          const n = this;
          return n.eventsListeners
            ? (e.split(" ").forEach((e) => {
              void 0 === t
                ? (n.eventsListeners[e] = [])
                : n.eventsListeners[e] &&
                n.eventsListeners[e].forEach((r, i) => {
                  (r === t || (r.__emitterProxy && r.__emitterProxy === t)) && n.eventsListeners[e].splice(i, 1);
                });
            }),
              n)
            : n;
        },
        emit(...e) {
          const t = this;
          if (!t.eventsListeners) return t;
          let n, r, i;
          return (
            "string" == typeof e[0] || Array.isArray(e[0])
              ? ((n = e[0]), (r = e.slice(1, e.length)), (i = t))
              : ((n = e[0].events), (r = e[0].data), (i = e[0].context || t)),
            r.unshift(i),
            (Array.isArray(n) ? n : n.split(" ")).forEach((e) => {
              t.eventsAnyListeners &&
                t.eventsAnyListeners.length &&
                t.eventsAnyListeners.forEach((t) => {
                  t.apply(i, [e, ...r]);
                }),
                t.eventsListeners &&
                t.eventsListeners[e] &&
                t.eventsListeners[e].forEach((e) => {
                  e.apply(i, r);
                });
            }),
            t
          );
        },
      },
        me = {
          updateSize: function () {
            const e = this;
            let t, n;
            const r = e.$el;
            (t = void 0 !== e.params.width && null !== e.params.width ? e.params.width : r[0].clientWidth),
              (n = void 0 !== e.params.height && null !== e.params.height ? e.params.height : r[0].clientHeight),
              (0 === t && e.isHorizontal()) ||
              (0 === n && e.isVertical()) ||
              ((t = t - parseInt(r.css("padding-left") || 0, 10) - parseInt(r.css("padding-right") || 0, 10)),
                (n = n - parseInt(r.css("padding-top") || 0, 10) - parseInt(r.css("padding-bottom") || 0, 10)),
                Number.isNaN(t) && (t = 0),
                Number.isNaN(n) && (n = 0),
                Object.assign(e, { width: t, height: n, size: e.isHorizontal() ? t : n }));
          },
          updateSlides: function () {
            const e = this;
            function t(t) {
              return e.isHorizontal()
                ? t
                : {
                  width: "height",
                  "margin-top": "margin-left",
                  "margin-bottom ": "margin-right",
                  "margin-left": "margin-top",
                  "margin-right": "margin-bottom",
                  "padding-left": "padding-top",
                  "padding-right": "padding-bottom",
                  marginRight: "marginBottom",
                }[t];
            }
            function n(e, n) {
              return parseFloat(e.getPropertyValue(t(n)) || 0);
            }
            const r = e.params,
              { $wrapperEl: i, size: a, rtlTranslate: s, wrongRTL: o } = e,
              l = e.virtual && r.virtual.enabled,
              c = l ? e.virtual.slides.length : e.slides.length,
              d = i.children(`.${e.params.slideClass}`),
              u = l ? e.virtual.slides.length : d.length;
            let p = [];
            const f = [],
              h = [];
            let m = r.slidesOffsetBefore;
            "function" == typeof m && (m = r.slidesOffsetBefore.call(e));
            let g = r.slidesOffsetAfter;
            "function" == typeof g && (g = r.slidesOffsetAfter.call(e));
            const v = e.snapGrid.length,
              y = e.slidesGrid.length;
            let b = r.spaceBetween,
              w = -m,
              x = 0,
              C = 0;
            if (void 0 === a) return;
            "string" == typeof b && b.indexOf("%") >= 0 && (b = (parseFloat(b.replace("%", "")) / 100) * a),
              (e.virtualSize = -b),
              s
                ? d.css({ marginLeft: "", marginBottom: "", marginTop: "" })
                : d.css({ marginRight: "", marginBottom: "", marginTop: "" }),
              r.centeredSlides &&
              r.cssMode &&
              (le(e.wrapperEl, "--swiper-centered-offset-before", ""),
                le(e.wrapperEl, "--swiper-centered-offset-after", ""));
            const E = r.grid && r.grid.rows > 1 && e.grid;
            let T;
            E && e.grid.initSlides(u);
            const S =
              "auto" === r.slidesPerView &&
              r.breakpoints &&
              Object.keys(r.breakpoints).filter((e) => void 0 !== r.breakpoints[e].slidesPerView).length > 0;
            for (let i = 0; i < u; i += 1) {
              T = 0;
              const s = d.eq(i);
              if ((E && e.grid.updateSlide(i, s, u, t), "none" !== s.css("display"))) {
                if ("auto" === r.slidesPerView) {
                  S && (d[i].style[t("width")] = "");
                  const a = getComputedStyle(s[0]),
                    o = s[0].style.transform,
                    l = s[0].style.webkitTransform;
                  if (
                    (o && (s[0].style.transform = "none"), l && (s[0].style.webkitTransform = "none"), r.roundLengths)
                  )
                    T = e.isHorizontal() ? s.outerWidth(!0) : s.outerHeight(!0);
                  else {
                    const e = n(a, "width"),
                      t = n(a, "padding-left"),
                      r = n(a, "padding-right"),
                      i = n(a, "margin-left"),
                      o = n(a, "margin-right"),
                      l = a.getPropertyValue("box-sizing");
                    if (l && "border-box" === l) T = e + i + o;
                    else {
                      const { clientWidth: n, offsetWidth: a } = s[0];
                      T = e + t + r + i + o + (a - n);
                    }
                  }
                  o && (s[0].style.transform = o),
                    l && (s[0].style.webkitTransform = l),
                    r.roundLengths && (T = Math.floor(T));
                } else
                  (T = (a - (r.slidesPerView - 1) * b) / r.slidesPerView),
                    r.roundLengths && (T = Math.floor(T)),
                    d[i] && (d[i].style[t("width")] = `${T}px`);
                d[i] && (d[i].swiperSlideSize = T),
                  h.push(T),
                  r.centeredSlides
                    ? ((w = w + T / 2 + x / 2 + b),
                      0 === x && 0 !== i && (w = w - a / 2 - b),
                      0 === i && (w = w - a / 2 - b),
                      Math.abs(w) < 0.001 && (w = 0),
                      r.roundLengths && (w = Math.floor(w)),
                      C % r.slidesPerGroup == 0 && p.push(w),
                      f.push(w))
                    : (r.roundLengths && (w = Math.floor(w)),
                      (C - Math.min(e.params.slidesPerGroupSkip, C)) % e.params.slidesPerGroup == 0 && p.push(w),
                      f.push(w),
                      (w = w + T + b)),
                  (e.virtualSize += T + b),
                  (x = T),
                  (C += 1);
              }
            }
            if (
              ((e.virtualSize = Math.max(e.virtualSize, a) + g),
                s &&
                o &&
                ("slide" === r.effect || "coverflow" === r.effect) &&
                i.css({ width: `${e.virtualSize + r.spaceBetween}px` }),
                r.setWrapperSize && i.css({ [t("width")]: `${e.virtualSize + r.spaceBetween}px` }),
                E && e.grid.updateWrapperSize(T, p, t),
                !r.centeredSlides)
            ) {
              const t = [];
              for (let n = 0; n < p.length; n += 1) {
                let i = p[n];
                r.roundLengths && (i = Math.floor(i)), p[n] <= e.virtualSize - a && t.push(i);
              }
              (p = t), Math.floor(e.virtualSize - a) - Math.floor(p[p.length - 1]) > 1 && p.push(e.virtualSize - a);
            }
            if ((0 === p.length && (p = [0]), 0 !== r.spaceBetween)) {
              const n = e.isHorizontal() && s ? "marginLeft" : t("marginRight");
              d.filter((e, t) => !r.cssMode || t !== d.length - 1).css({ [n]: `${b}px` });
            }
            if (r.centeredSlides && r.centeredSlidesBounds) {
              let e = 0;
              h.forEach((t) => {
                e += t + (r.spaceBetween ? r.spaceBetween : 0);
              }),
                (e -= r.spaceBetween);
              const t = e - a;
              p = p.map((e) => (e < 0 ? -m : e > t ? t + g : e));
            }
            if (r.centerInsufficientSlides) {
              let e = 0;
              if (
                (h.forEach((t) => {
                  e += t + (r.spaceBetween ? r.spaceBetween : 0);
                }),
                  (e -= r.spaceBetween),
                  e < a)
              ) {
                const t = (a - e) / 2;
                p.forEach((e, n) => {
                  p[n] = e - t;
                }),
                  f.forEach((e, n) => {
                    f[n] = e + t;
                  });
              }
            }
            if (
              (Object.assign(e, { slides: d, snapGrid: p, slidesGrid: f, slidesSizesGrid: h }),
                r.centeredSlides && r.cssMode && !r.centeredSlidesBounds)
            ) {
              le(e.wrapperEl, "--swiper-centered-offset-before", -p[0] + "px"),
                le(e.wrapperEl, "--swiper-centered-offset-after", e.size / 2 - h[h.length - 1] / 2 + "px");
              const t = -e.snapGrid[0],
                n = -e.slidesGrid[0];
              (e.snapGrid = e.snapGrid.map((e) => e + t)), (e.slidesGrid = e.slidesGrid.map((e) => e + n));
            }
            u !== c && e.emit("slidesLengthChange"),
              p.length !== v && (e.params.watchOverflow && e.checkOverflow(), e.emit("snapGridLengthChange")),
              f.length !== y && e.emit("slidesGridLengthChange"),
              r.watchSlidesProgress && e.updateSlidesOffset();
          },
          updateAutoHeight: function (e) {
            const t = this,
              n = [],
              r = t.virtual && t.params.virtual.enabled;
            let i,
              a = 0;
            "number" == typeof e ? t.setTransition(e) : !0 === e && t.setTransition(t.params.speed);
            const s = (e) =>
              r
                ? t.slides.filter((t) => parseInt(t.getAttribute("data-swiper-slide-index"), 10) === e)[0]
                : t.slides.eq(e)[0];
            if ("auto" !== t.params.slidesPerView && t.params.slidesPerView > 1)
              if (t.params.centeredSlides)
                t.visibleSlides.each((e) => {
                  n.push(e);
                });
              else
                for (i = 0; i < Math.ceil(t.params.slidesPerView); i += 1) {
                  const e = t.activeIndex + i;
                  if (e > t.slides.length && !r) break;
                  n.push(s(e));
                }
            else n.push(s(t.activeIndex));
            for (i = 0; i < n.length; i += 1)
              if (void 0 !== n[i]) {
                const e = n[i].offsetHeight;
                a = e > a ? e : a;
              }
            (a || 0 === a) && t.$wrapperEl.css("height", `${a}px`);
          },
          updateSlidesOffset: function () {
            const e = this,
              t = e.slides;
            for (let n = 0; n < t.length; n += 1)
              t[n].swiperSlideOffset = e.isHorizontal() ? t[n].offsetLeft : t[n].offsetTop;
          },
          updateSlidesProgress: function (e = (this && this.translate) || 0) {
            const t = this,
              n = t.params,
              { slides: r, rtlTranslate: i, snapGrid: a } = t;
            if (0 === r.length) return;
            void 0 === r[0].swiperSlideOffset && t.updateSlidesOffset();
            let s = -e;
            i && (s = e), r.removeClass(n.slideVisibleClass), (t.visibleSlidesIndexes = []), (t.visibleSlides = []);
            for (let e = 0; e < r.length; e += 1) {
              const o = r[e];
              let l = o.swiperSlideOffset;
              n.cssMode && n.centeredSlides && (l -= r[0].swiperSlideOffset);
              const c = (s + (n.centeredSlides ? t.minTranslate() : 0) - l) / (o.swiperSlideSize + n.spaceBetween),
                d = (s - a[0] + (n.centeredSlides ? t.minTranslate() : 0) - l) / (o.swiperSlideSize + n.spaceBetween),
                u = -(s - l),
                p = u + t.slidesSizesGrid[e];
              ((u >= 0 && u < t.size - 1) || (p > 1 && p <= t.size) || (u <= 0 && p >= t.size)) &&
                (t.visibleSlides.push(o), t.visibleSlidesIndexes.push(e), r.eq(e).addClass(n.slideVisibleClass)),
                (o.progress = i ? -c : c),
                (o.originalProgress = i ? -d : d);
            }
            t.visibleSlides = ne(t.visibleSlides);
          },
          updateProgress: function (e) {
            const t = this;
            if (void 0 === e) {
              const n = t.rtlTranslate ? -1 : 1;
              e = (t && t.translate && t.translate * n) || 0;
            }
            const n = t.params,
              r = t.maxTranslate() - t.minTranslate();
            let { progress: i, isBeginning: a, isEnd: s } = t;
            const o = a,
              l = s;
            0 === r ? ((i = 0), (a = !0), (s = !0)) : ((i = (e - t.minTranslate()) / r), (a = i <= 0), (s = i >= 1)),
              Object.assign(t, { progress: i, isBeginning: a, isEnd: s }),
              (n.watchSlidesProgress || (n.centeredSlides && n.autoHeight)) && t.updateSlidesProgress(e),
              a && !o && t.emit("reachBeginning toEdge"),
              s && !l && t.emit("reachEnd toEdge"),
              ((o && !a) || (l && !s)) && t.emit("fromEdge"),
              t.emit("progress", i);
          },
          updateSlidesClasses: function () {
            const e = this,
              { slides: t, params: n, $wrapperEl: r, activeIndex: i, realIndex: a } = e,
              s = e.virtual && n.virtual.enabled;
            let o;
            t.removeClass(
              `${n.slideActiveClass} ${n.slideNextClass} ${n.slidePrevClass} ${n.slideDuplicateActiveClass} ${n.slideDuplicateNextClass} ${n.slideDuplicatePrevClass}`
            ),
              (o = s ? e.$wrapperEl.find(`.${n.slideClass}[data-swiper-slide-index="${i}"]`) : t.eq(i)),
              o.addClass(n.slideActiveClass),
              n.loop &&
              (o.hasClass(n.slideDuplicateClass)
                ? r
                  .children(`.${n.slideClass}:not(.${n.slideDuplicateClass})[data-swiper-slide-index="${a}"]`)
                  .addClass(n.slideDuplicateActiveClass)
                : r
                  .children(`.${n.slideClass}.${n.slideDuplicateClass}[data-swiper-slide-index="${a}"]`)
                  .addClass(n.slideDuplicateActiveClass));
            let l = o.nextAll(`.${n.slideClass}`).eq(0).addClass(n.slideNextClass);
            n.loop && 0 === l.length && ((l = t.eq(0)), l.addClass(n.slideNextClass));
            let c = o.prevAll(`.${n.slideClass}`).eq(0).addClass(n.slidePrevClass);
            n.loop && 0 === c.length && ((c = t.eq(-1)), c.addClass(n.slidePrevClass)),
              n.loop &&
              (l.hasClass(n.slideDuplicateClass)
                ? r
                  .children(
                    `.${n.slideClass}:not(.${n.slideDuplicateClass})[data-swiper-slide-index="${l.attr(
                      "data-swiper-slide-index"
                    )}"]`
                  )
                  .addClass(n.slideDuplicateNextClass)
                : r
                  .children(
                    `.${n.slideClass}.${n.slideDuplicateClass}[data-swiper-slide-index="${l.attr(
                      "data-swiper-slide-index"
                    )}"]`
                  )
                  .addClass(n.slideDuplicateNextClass),
                c.hasClass(n.slideDuplicateClass)
                  ? r
                    .children(
                      `.${n.slideClass}:not(.${n.slideDuplicateClass})[data-swiper-slide-index="${c.attr(
                        "data-swiper-slide-index"
                      )}"]`
                    )
                    .addClass(n.slideDuplicatePrevClass)
                  : r
                    .children(
                      `.${n.slideClass}.${n.slideDuplicateClass}[data-swiper-slide-index="${c.attr(
                        "data-swiper-slide-index"
                      )}"]`
                    )
                    .addClass(n.slideDuplicatePrevClass)),
              e.emitSlidesClasses();
          },
          updateActiveIndex: function (e) {
            const t = this,
              n = t.rtlTranslate ? t.translate : -t.translate,
              { slidesGrid: r, snapGrid: i, params: a, activeIndex: s, realIndex: o, snapIndex: l } = t;
            let c,
              d = e;
            if (void 0 === d) {
              for (let e = 0; e < r.length; e += 1)
                void 0 !== r[e + 1]
                  ? n >= r[e] && n < r[e + 1] - (r[e + 1] - r[e]) / 2
                    ? (d = e)
                    : n >= r[e] && n < r[e + 1] && (d = e + 1)
                  : n >= r[e] && (d = e);
              a.normalizeSlideIndex && (d < 0 || void 0 === d) && (d = 0);
            }
            if (i.indexOf(n) >= 0) c = i.indexOf(n);
            else {
              const e = Math.min(a.slidesPerGroupSkip, d);
              c = e + Math.floor((d - e) / a.slidesPerGroup);
            }
            if ((c >= i.length && (c = i.length - 1), d === s))
              return void (c !== l && ((t.snapIndex = c), t.emit("snapIndexChange")));
            const u = parseInt(t.slides.eq(d).attr("data-swiper-slide-index") || d, 10);
            Object.assign(t, { snapIndex: c, realIndex: u, previousIndex: s, activeIndex: d }),
              t.emit("activeIndexChange"),
              t.emit("snapIndexChange"),
              o !== u && t.emit("realIndexChange"),
              (t.initialized || t.params.runCallbacksOnInit) && t.emit("slideChange");
          },
          updateClickedSlide: function (e) {
            const t = this,
              n = t.params,
              r = ne(e).closest(`.${n.slideClass}`)[0];
            let i,
              a = !1;
            if (r)
              for (let e = 0; e < t.slides.length; e += 1)
                if (t.slides[e] === r) {
                  (a = !0), (i = e);
                  break;
                }
            if (!r || !a) return (t.clickedSlide = void 0), void (t.clickedIndex = void 0);
            (t.clickedSlide = r),
              t.virtual && t.params.virtual.enabled
                ? (t.clickedIndex = parseInt(ne(r).attr("data-swiper-slide-index"), 10))
                : (t.clickedIndex = i),
              n.slideToClickedSlide &&
              void 0 !== t.clickedIndex &&
              t.clickedIndex !== t.activeIndex &&
              t.slideToClickedSlide();
          },
        };
      function ge({ swiper: e, runCallbacks: t, direction: n, step: r }) {
        const { activeIndex: i, previousIndex: a } = e;
        let s = n;
        if ((s || (s = i > a ? "next" : i < a ? "prev" : "reset"), e.emit(`transition${r}`), t && i !== a)) {
          if ("reset" === s) return void e.emit(`slideResetTransition${r}`);
          e.emit(`slideChangeTransition${r}`),
            "next" === s ? e.emit(`slideNextTransition${r}`) : e.emit(`slidePrevTransition${r}`);
        }
      }
      const ve = {
        slideTo: function (e = 0, t = this.params.speed, n = !0, r, i) {
          if ("number" != typeof e && "string" != typeof e)
            throw new Error(
              `The 'index' argument cannot have type other than 'number' or 'string'. [${typeof e}] given.`
            );
          if ("string" == typeof e) {
            const t = parseInt(e, 10);
            if (!isFinite(t))
              throw new Error(`The passed-in 'index' (string) couldn't be converted to 'number'. [${e}] given.`);
            e = t;
          }
          const a = this;
          let s = e;
          s < 0 && (s = 0);
          const {
            params: o,
            snapGrid: l,
            slidesGrid: c,
            previousIndex: d,
            activeIndex: u,
            rtlTranslate: p,
            wrapperEl: f,
            enabled: h,
          } = a;
          if ((a.animating && o.preventInteractionOnTransition) || (!h && !r && !i)) return !1;
          const m = Math.min(a.params.slidesPerGroupSkip, s);
          let g = m + Math.floor((s - m) / a.params.slidesPerGroup);
          g >= l.length && (g = l.length - 1),
            (u || o.initialSlide || 0) === (d || 0) && n && a.emit("beforeSlideChangeStart");
          const v = -l[g];
          if ((a.updateProgress(v), o.normalizeSlideIndex))
            for (let e = 0; e < c.length; e += 1) {
              const t = -Math.floor(100 * v),
                n = Math.floor(100 * c[e]),
                r = Math.floor(100 * c[e + 1]);
              void 0 !== c[e + 1]
                ? t >= n && t < r - (r - n) / 2
                  ? (s = e)
                  : t >= n && t < r && (s = e + 1)
                : t >= n && (s = e);
            }
          if (a.initialized && s !== u) {
            if (!a.allowSlideNext && v < a.translate && v < a.minTranslate()) return !1;
            if (!a.allowSlidePrev && v > a.translate && v > a.maxTranslate() && (u || 0) !== s) return !1;
          }
          let y;
          if (
            ((y = s > u ? "next" : s < u ? "prev" : "reset"), (p && -v === a.translate) || (!p && v === a.translate))
          )
            return (
              a.updateActiveIndex(s),
              o.autoHeight && a.updateAutoHeight(),
              a.updateSlidesClasses(),
              "slide" !== o.effect && a.setTranslate(v),
              "reset" !== y && (a.transitionStart(n, y), a.transitionEnd(n, y)),
              !1
            );
          if (o.cssMode) {
            const e = a.isHorizontal(),
              n = p ? v : -v;
            if (0 === t) {
              const t = a.virtual && a.params.virtual.enabled;
              t && ((a.wrapperEl.style.scrollSnapType = "none"), (a._immediateVirtual = !0)),
                (f[e ? "scrollLeft" : "scrollTop"] = n),
                t &&
                requestAnimationFrame(() => {
                  (a.wrapperEl.style.scrollSnapType = ""), (a._swiperImmediateVirtual = !1);
                });
            } else {
              if (!a.support.smoothScroll) return ce({ swiper: a, targetPosition: n, side: e ? "left" : "top" }), !0;
              f.scrollTo({ [e ? "left" : "top"]: n, behavior: "smooth" });
            }
            return !0;
          }
          return (
            a.setTransition(t),
            a.setTranslate(v),
            a.updateActiveIndex(s),
            a.updateSlidesClasses(),
            a.emit("beforeTransitionStart", t, r),
            a.transitionStart(n, y),
            0 === t
              ? a.transitionEnd(n, y)
              : a.animating ||
              ((a.animating = !0),
                a.onSlideToWrapperTransitionEnd ||
                (a.onSlideToWrapperTransitionEnd = function (e) {
                  a &&
                    !a.destroyed &&
                    e.target === this &&
                    (a.$wrapperEl[0].removeEventListener("transitionend", a.onSlideToWrapperTransitionEnd),
                      a.$wrapperEl[0].removeEventListener("webkitTransitionEnd", a.onSlideToWrapperTransitionEnd),
                      (a.onSlideToWrapperTransitionEnd = null),
                      delete a.onSlideToWrapperTransitionEnd,
                      a.transitionEnd(n, y));
                }),
                a.$wrapperEl[0].addEventListener("transitionend", a.onSlideToWrapperTransitionEnd),
                a.$wrapperEl[0].addEventListener("webkitTransitionEnd", a.onSlideToWrapperTransitionEnd)),
            !0
          );
        },
        slideToLoop: function (e = 0, t = this.params.speed, n = !0, r) {
          const i = this;
          let a = e;
          return i.params.loop && (a += i.loopedSlides), i.slideTo(a, t, n, r);
        },
        slideNext: function (e = this.params.speed, t = !0, n) {
          const r = this,
            { animating: i, enabled: a, params: s } = r;
          if (!a) return r;
          let o = s.slidesPerGroup;
          "auto" === s.slidesPerView &&
            1 === s.slidesPerGroup &&
            s.slidesPerGroupAuto &&
            (o = Math.max(r.slidesPerViewDynamic("current", !0), 1));
          const l = r.activeIndex < s.slidesPerGroupSkip ? 1 : o;
          if (s.loop) {
            if (i && s.loopPreventsSlide) return !1;
            r.loopFix(), (r._clientLeft = r.$wrapperEl[0].clientLeft);
          }
          return s.rewind && r.isEnd ? r.slideTo(0, e, t, n) : r.slideTo(r.activeIndex + l, e, t, n);
        },
        slidePrev: function (e = this.params.speed, t = !0, n) {
          const r = this,
            { params: i, animating: a, snapGrid: s, slidesGrid: o, rtlTranslate: l, enabled: c } = r;
          if (!c) return r;
          if (i.loop) {
            if (a && i.loopPreventsSlide) return !1;
            r.loopFix(), (r._clientLeft = r.$wrapperEl[0].clientLeft);
          }
          function d(e) {
            return e < 0 ? -Math.floor(Math.abs(e)) : Math.floor(e);
          }
          const u = d(l ? r.translate : -r.translate),
            p = s.map((e) => d(e));
          let f = s[p.indexOf(u) - 1];
          if (void 0 === f && i.cssMode) {
            let e;
            s.forEach((t, n) => {
              u >= t && (e = n);
            }),
              void 0 !== e && (f = s[e > 0 ? e - 1 : e]);
          }
          let h = 0;
          return (
            void 0 !== f &&
            ((h = o.indexOf(f)),
              h < 0 && (h = r.activeIndex - 1),
              "auto" === i.slidesPerView &&
              1 === i.slidesPerGroup &&
              i.slidesPerGroupAuto &&
              ((h = h - r.slidesPerViewDynamic("previous", !0) + 1), (h = Math.max(h, 0)))),
            i.rewind && r.isBeginning ? r.slideTo(r.slides.length - 1, e, t, n) : r.slideTo(h, e, t, n)
          );
        },
        slideReset: function (e = this.params.speed, t = !0, n) {
          return this.slideTo(this.activeIndex, e, t, n);
        },
        slideToClosest: function (e = this.params.speed, t = !0, n, r = 0.5) {
          const i = this;
          let a = i.activeIndex;
          const s = Math.min(i.params.slidesPerGroupSkip, a),
            o = s + Math.floor((a - s) / i.params.slidesPerGroup),
            l = i.rtlTranslate ? i.translate : -i.translate;
          if (l >= i.snapGrid[o]) {
            const e = i.snapGrid[o];
            l - e > (i.snapGrid[o + 1] - e) * r && (a += i.params.slidesPerGroup);
          } else {
            const e = i.snapGrid[o - 1];
            l - e <= (i.snapGrid[o] - e) * r && (a -= i.params.slidesPerGroup);
          }
          return (a = Math.max(a, 0)), (a = Math.min(a, i.slidesGrid.length - 1)), i.slideTo(a, e, t, n);
        },
        slideToClickedSlide: function () {
          const e = this,
            { params: t, $wrapperEl: n } = e,
            r = "auto" === t.slidesPerView ? e.slidesPerViewDynamic() : t.slidesPerView;
          let i,
            a = e.clickedIndex;
          if (t.loop) {
            if (e.animating) return;
            (i = parseInt(ne(e.clickedSlide).attr("data-swiper-slide-index"), 10)),
              t.centeredSlides
                ? a < e.loopedSlides - r / 2 || a > e.slides.length - e.loopedSlides + r / 2
                  ? (e.loopFix(),
                    (a = n
                      .children(`.${t.slideClass}[data-swiper-slide-index="${i}"]:not(.${t.slideDuplicateClass})`)
                      .eq(0)
                      .index()),
                    re(() => {
                      e.slideTo(a);
                    }))
                  : e.slideTo(a)
                : a > e.slides.length - r
                  ? (e.loopFix(),
                    (a = n
                      .children(`.${t.slideClass}[data-swiper-slide-index="${i}"]:not(.${t.slideDuplicateClass})`)
                      .eq(0)
                      .index()),
                    re(() => {
                      e.slideTo(a);
                    }))
                  : e.slideTo(a);
          } else e.slideTo(a);
        },
      },
        ye = {
          loopCreate: function () {
            const e = this,
              t = X(),
              { params: n, $wrapperEl: r } = e,
              i = r.children().length > 0 ? ne(r.children()[0].parentNode) : r;
            i.children(`.${n.slideClass}.${n.slideDuplicateClass}`).remove();
            let a = i.children(`.${n.slideClass}`);
            if (n.loopFillGroupWithBlank) {
              const e = n.slidesPerGroup - (a.length % n.slidesPerGroup);
              if (e !== n.slidesPerGroup) {
                for (let r = 0; r < e; r += 1) {
                  const e = ne(t.createElement("div")).addClass(`${n.slideClass} ${n.slideBlankClass}`);
                  i.append(e);
                }
                a = i.children(`.${n.slideClass}`);
              }
            }
            "auto" !== n.slidesPerView || n.loopedSlides || (n.loopedSlides = a.length),
              (e.loopedSlides = Math.ceil(parseFloat(n.loopedSlides || n.slidesPerView, 10))),
              (e.loopedSlides += n.loopAdditionalSlides),
              e.loopedSlides > a.length && (e.loopedSlides = a.length);
            const s = [],
              o = [];
            a.each((t, n) => {
              const r = ne(t);
              n < e.loopedSlides && o.push(t),
                n < a.length && n >= a.length - e.loopedSlides && s.push(t),
                r.attr("data-swiper-slide-index", n);
            });
            for (let e = 0; e < o.length; e += 1) i.append(ne(o[e].cloneNode(!0)).addClass(n.slideDuplicateClass));
            for (let e = s.length - 1; e >= 0; e -= 1)
              i.prepend(ne(s[e].cloneNode(!0)).addClass(n.slideDuplicateClass));
          },
          loopFix: function () {
            const e = this;
            e.emit("beforeLoopFix");
            const {
              activeIndex: t,
              slides: n,
              loopedSlides: r,
              allowSlidePrev: i,
              allowSlideNext: a,
              snapGrid: s,
              rtlTranslate: o,
            } = e;
            let l;
            (e.allowSlidePrev = !0), (e.allowSlideNext = !0);
            const c = -s[t] - e.getTranslate();
            t < r
              ? ((l = n.length - 3 * r + t),
                (l += r),
                e.slideTo(l, 0, !1, !0) && 0 !== c && e.setTranslate((o ? -e.translate : e.translate) - c))
              : t >= n.length - r &&
              ((l = -n.length + t + r),
                (l += r),
                e.slideTo(l, 0, !1, !0) && 0 !== c && e.setTranslate((o ? -e.translate : e.translate) - c)),
              (e.allowSlidePrev = i),
              (e.allowSlideNext = a),
              e.emit("loopFix");
          },
          loopDestroy: function () {
            const { $wrapperEl: e, params: t, slides: n } = this;
            e.children(`.${t.slideClass}.${t.slideDuplicateClass},.${t.slideClass}.${t.slideBlankClass}`).remove(),
              n.removeAttr("data-swiper-slide-index");
          },
        };
      function be(e) {
        const t = this,
          n = X(),
          r = V(),
          i = t.touchEventsData,
          { params: a, touches: s, enabled: o } = t;
        if (!o) return;
        if (t.animating && a.preventInteractionOnTransition) return;
        !t.animating && a.cssMode && a.loop && t.loopFix();
        let l = e;
        l.originalEvent && (l = l.originalEvent);
        let c = ne(l.target);
        if ("wrapper" === a.touchEventsTarget && !c.closest(t.wrapperEl).length) return;
        if (((i.isTouchEvent = "touchstart" === l.type), !i.isTouchEvent && "which" in l && 3 === l.which)) return;
        if (!i.isTouchEvent && "button" in l && l.button > 0) return;
        if (i.isTouched && i.isMoved) return;
        a.noSwipingClass &&
          "" !== a.noSwipingClass &&
          l.target &&
          l.target.shadowRoot &&
          e.path &&
          e.path[0] &&
          (c = ne(e.path[0]));
        const d = a.noSwipingSelector ? a.noSwipingSelector : `.${a.noSwipingClass}`,
          u = !(!l.target || !l.target.shadowRoot);
        if (
          a.noSwiping &&
          (u
            ? (function (e, t = this) {
              return (function t(n) {
                return n && n !== X() && n !== V()
                  ? (n.assignedSlot && (n = n.assignedSlot), n.closest(e) || t(n.getRootNode().host))
                  : null;
              })(t);
            })(d, l.target)
            : c.closest(d)[0])
        )
          return void (t.allowClick = !0);
        if (a.swipeHandler && !c.closest(a.swipeHandler)[0]) return;
        (s.currentX = "touchstart" === l.type ? l.targetTouches[0].pageX : l.pageX),
          (s.currentY = "touchstart" === l.type ? l.targetTouches[0].pageY : l.pageY);
        const p = s.currentX,
          f = s.currentY,
          h = a.edgeSwipeDetection || a.iOSEdgeSwipeDetection,
          m = a.edgeSwipeThreshold || a.iOSEdgeSwipeThreshold;
        if (h && (p <= m || p >= r.innerWidth - m)) {
          if ("prevent" !== h) return;
          e.preventDefault();
        }
        if (
          (Object.assign(i, {
            isTouched: !0,
            isMoved: !1,
            allowTouchCallbacks: !0,
            isScrolling: void 0,
            startMoving: void 0,
          }),
            (s.startX = p),
            (s.startY = f),
            (i.touchStartTime = ie()),
            (t.allowClick = !0),
            t.updateSize(),
            (t.swipeDirection = void 0),
            a.threshold > 0 && (i.allowThresholdMove = !1),
            "touchstart" !== l.type)
        ) {
          let e = !0;
          c.is(i.focusableElements) && (e = !1),
            n.activeElement &&
            ne(n.activeElement).is(i.focusableElements) &&
            n.activeElement !== c[0] &&
            n.activeElement.blur();
          const r = e && t.allowTouchMove && a.touchStartPreventDefault;
          (!a.touchStartForcePreventDefault && !r) || c[0].isContentEditable || l.preventDefault();
        }
        t.emit("touchStart", l);
      }
      function we(e) {
        const t = X(),
          n = this,
          r = n.touchEventsData,
          { params: i, touches: a, rtlTranslate: s, enabled: o } = n;
        if (!o) return;
        let l = e;
        if ((l.originalEvent && (l = l.originalEvent), !r.isTouched))
          return void (r.startMoving && r.isScrolling && n.emit("touchMoveOpposite", l));
        if (r.isTouchEvent && "touchmove" !== l.type) return;
        const c = "touchmove" === l.type && l.targetTouches && (l.targetTouches[0] || l.changedTouches[0]),
          d = "touchmove" === l.type ? c.pageX : l.pageX,
          u = "touchmove" === l.type ? c.pageY : l.pageY;
        if (l.preventedByNestedSwiper) return (a.startX = d), void (a.startY = u);
        if (!n.allowTouchMove)
          return (
            (n.allowClick = !1),
            void (
              r.isTouched &&
              (Object.assign(a, { startX: d, startY: u, currentX: d, currentY: u }), (r.touchStartTime = ie()))
            )
          );
        if (r.isTouchEvent && i.touchReleaseOnEdges && !i.loop)
          if (n.isVertical()) {
            if ((u < a.startY && n.translate <= n.maxTranslate()) || (u > a.startY && n.translate >= n.minTranslate()))
              return (r.isTouched = !1), void (r.isMoved = !1);
          } else if (
            (d < a.startX && n.translate <= n.maxTranslate()) ||
            (d > a.startX && n.translate >= n.minTranslate())
          )
            return;
        if (r.isTouchEvent && t.activeElement && l.target === t.activeElement && ne(l.target).is(r.focusableElements))
          return (r.isMoved = !0), void (n.allowClick = !1);
        if ((r.allowTouchCallbacks && n.emit("touchMove", l), l.targetTouches && l.targetTouches.length > 1)) return;
        (a.currentX = d), (a.currentY = u);
        const p = a.currentX - a.startX,
          f = a.currentY - a.startY;
        if (n.params.threshold && Math.sqrt(p ** 2 + f ** 2) < n.params.threshold) return;
        if (void 0 === r.isScrolling) {
          let e;
          (n.isHorizontal() && a.currentY === a.startY) || (n.isVertical() && a.currentX === a.startX)
            ? (r.isScrolling = !1)
            : p * p + f * f >= 25 &&
            ((e = (180 * Math.atan2(Math.abs(f), Math.abs(p))) / Math.PI),
              (r.isScrolling = n.isHorizontal() ? e > i.touchAngle : 90 - e > i.touchAngle));
        }
        if (
          (r.isScrolling && n.emit("touchMoveOpposite", l),
            void 0 === r.startMoving && ((a.currentX === a.startX && a.currentY === a.startY) || (r.startMoving = !0)),
            r.isScrolling)
        )
          return void (r.isTouched = !1);
        if (!r.startMoving) return;
        (n.allowClick = !1),
          !i.cssMode && l.cancelable && l.preventDefault(),
          i.touchMoveStopPropagation && !i.nested && l.stopPropagation(),
          r.isMoved ||
          (i.loop && !i.cssMode && n.loopFix(),
            (r.startTranslate = n.getTranslate()),
            n.setTransition(0),
            n.animating && n.$wrapperEl.trigger("webkitTransitionEnd transitionend"),
            (r.allowMomentumBounce = !1),
            !i.grabCursor || (!0 !== n.allowSlideNext && !0 !== n.allowSlidePrev) || n.setGrabCursor(!0),
            n.emit("sliderFirstMove", l)),
          n.emit("sliderMove", l),
          (r.isMoved = !0);
        let h = n.isHorizontal() ? p : f;
        (a.diff = h),
          (h *= i.touchRatio),
          s && (h = -h),
          (n.swipeDirection = h > 0 ? "prev" : "next"),
          (r.currentTranslate = h + r.startTranslate);
        let m = !0,
          g = i.resistanceRatio;
        if (
          (i.touchReleaseOnEdges && (g = 0),
            h > 0 && r.currentTranslate > n.minTranslate()
              ? ((m = !1),
                i.resistance &&
                (r.currentTranslate = n.minTranslate() - 1 + (-n.minTranslate() + r.startTranslate + h) ** g))
              : h < 0 &&
              r.currentTranslate < n.maxTranslate() &&
              ((m = !1),
                i.resistance &&
                (r.currentTranslate = n.maxTranslate() + 1 - (n.maxTranslate() - r.startTranslate - h) ** g)),
            m && (l.preventedByNestedSwiper = !0),
            !n.allowSlideNext &&
            "next" === n.swipeDirection &&
            r.currentTranslate < r.startTranslate &&
            (r.currentTranslate = r.startTranslate),
            !n.allowSlidePrev &&
            "prev" === n.swipeDirection &&
            r.currentTranslate > r.startTranslate &&
            (r.currentTranslate = r.startTranslate),
            n.allowSlidePrev || n.allowSlideNext || (r.currentTranslate = r.startTranslate),
            i.threshold > 0)
        ) {
          if (!(Math.abs(h) > i.threshold || r.allowThresholdMove)) return void (r.currentTranslate = r.startTranslate);
          if (!r.allowThresholdMove)
            return (
              (r.allowThresholdMove = !0),
              (a.startX = a.currentX),
              (a.startY = a.currentY),
              (r.currentTranslate = r.startTranslate),
              void (a.diff = n.isHorizontal() ? a.currentX - a.startX : a.currentY - a.startY)
            );
        }
        i.followFinger &&
          !i.cssMode &&
          (((i.freeMode && i.freeMode.enabled && n.freeMode) || i.watchSlidesProgress) &&
            (n.updateActiveIndex(), n.updateSlidesClasses()),
            n.params.freeMode && i.freeMode.enabled && n.freeMode && n.freeMode.onTouchMove(),
            n.updateProgress(r.currentTranslate),
            n.setTranslate(r.currentTranslate));
      }
      function xe(e) {
        const t = this,
          n = t.touchEventsData,
          { params: r, touches: i, rtlTranslate: a, slidesGrid: s, enabled: o } = t;
        if (!o) return;
        let l = e;
        if (
          (l.originalEvent && (l = l.originalEvent),
            n.allowTouchCallbacks && t.emit("touchEnd", l),
            (n.allowTouchCallbacks = !1),
            !n.isTouched)
        )
          return n.isMoved && r.grabCursor && t.setGrabCursor(!1), (n.isMoved = !1), void (n.startMoving = !1);
        r.grabCursor &&
          n.isMoved &&
          n.isTouched &&
          (!0 === t.allowSlideNext || !0 === t.allowSlidePrev) &&
          t.setGrabCursor(!1);
        const c = ie(),
          d = c - n.touchStartTime;
        if (t.allowClick) {
          const e = l.path || (l.composedPath && l.composedPath());
          t.updateClickedSlide((e && e[0]) || l.target),
            t.emit("tap click", l),
            d < 300 && c - n.lastClickTime < 300 && t.emit("doubleTap doubleClick", l);
        }
        if (
          ((n.lastClickTime = ie()),
            re(() => {
              t.destroyed || (t.allowClick = !0);
            }),
            !n.isTouched || !n.isMoved || !t.swipeDirection || 0 === i.diff || n.currentTranslate === n.startTranslate)
        )
          return (n.isTouched = !1), (n.isMoved = !1), void (n.startMoving = !1);
        let u;
        if (
          ((n.isTouched = !1),
            (n.isMoved = !1),
            (n.startMoving = !1),
            (u = r.followFinger ? (a ? t.translate : -t.translate) : -n.currentTranslate),
            r.cssMode)
        )
          return;
        if (t.params.freeMode && r.freeMode.enabled) return void t.freeMode.onTouchEnd({ currentPos: u });
        let p = 0,
          f = t.slidesSizesGrid[0];
        for (let e = 0; e < s.length; e += e < r.slidesPerGroupSkip ? 1 : r.slidesPerGroup) {
          const t = e < r.slidesPerGroupSkip - 1 ? 1 : r.slidesPerGroup;
          void 0 !== s[e + t]
            ? u >= s[e] && u < s[e + t] && ((p = e), (f = s[e + t] - s[e]))
            : u >= s[e] && ((p = e), (f = s[s.length - 1] - s[s.length - 2]));
        }
        const h = (u - s[p]) / f,
          m = p < r.slidesPerGroupSkip - 1 ? 1 : r.slidesPerGroup;
        if (d > r.longSwipesMs) {
          if (!r.longSwipes) return void t.slideTo(t.activeIndex);
          "next" === t.swipeDirection && (h >= r.longSwipesRatio ? t.slideTo(p + m) : t.slideTo(p)),
            "prev" === t.swipeDirection && (h > 1 - r.longSwipesRatio ? t.slideTo(p + m) : t.slideTo(p));
        } else {
          if (!r.shortSwipes) return void t.slideTo(t.activeIndex);
          !t.navigation || (l.target !== t.navigation.nextEl && l.target !== t.navigation.prevEl)
            ? ("next" === t.swipeDirection && t.slideTo(p + m), "prev" === t.swipeDirection && t.slideTo(p))
            : l.target === t.navigation.nextEl
              ? t.slideTo(p + m)
              : t.slideTo(p);
        }
      }
      function Ce() {
        const e = this,
          { params: t, el: n } = e;
        if (n && 0 === n.offsetWidth) return;
        t.breakpoints && e.setBreakpoint();
        const { allowSlideNext: r, allowSlidePrev: i, snapGrid: a } = e;
        (e.allowSlideNext = !0),
          (e.allowSlidePrev = !0),
          e.updateSize(),
          e.updateSlides(),
          e.updateSlidesClasses(),
          ("auto" === t.slidesPerView || t.slidesPerView > 1) && e.isEnd && !e.isBeginning && !e.params.centeredSlides
            ? e.slideTo(e.slides.length - 1, 0, !1, !0)
            : e.slideTo(e.activeIndex, 0, !1, !0),
          e.autoplay && e.autoplay.running && e.autoplay.paused && e.autoplay.run(),
          (e.allowSlidePrev = i),
          (e.allowSlideNext = r),
          e.params.watchOverflow && a !== e.snapGrid && e.checkOverflow();
      }
      function Ee(e) {
        const t = this;
        t.enabled &&
          (t.allowClick ||
            (t.params.preventClicks && e.preventDefault(),
              t.params.preventClicksPropagation && t.animating && (e.stopPropagation(), e.stopImmediatePropagation())));
      }
      function Te() {
        const e = this,
          { wrapperEl: t, rtlTranslate: n, enabled: r } = e;
        if (!r) return;
        let i;
        (e.previousTranslate = e.translate),
          e.isHorizontal() ? (e.translate = -t.scrollLeft) : (e.translate = -t.scrollTop),
          -0 === e.translate && (e.translate = 0),
          e.updateActiveIndex(),
          e.updateSlidesClasses();
        const a = e.maxTranslate() - e.minTranslate();
        (i = 0 === a ? 0 : (e.translate - e.minTranslate()) / a),
          i !== e.progress && e.updateProgress(n ? -e.translate : e.translate),
          e.emit("setTranslate", e.translate, !1);
      }
      let Se = !1;
      function $e() { }
      const ke = (e, t) => {
        const n = X(),
          { params: r, touchEvents: i, el: a, wrapperEl: s, device: o, support: l } = e,
          c = !!r.nested,
          d = "on" === t ? "addEventListener" : "removeEventListener",
          u = t;
        if (l.touch) {
          const t = !("touchstart" !== i.start || !l.passiveListener || !r.passiveListeners) && {
            passive: !0,
            capture: !1,
          };
          a[d](i.start, e.onTouchStart, t),
            a[d](i.move, e.onTouchMove, l.passiveListener ? { passive: !1, capture: c } : c),
            a[d](i.end, e.onTouchEnd, t),
            i.cancel && a[d](i.cancel, e.onTouchEnd, t);
        } else a[d](i.start, e.onTouchStart, !1), n[d](i.move, e.onTouchMove, c), n[d](i.end, e.onTouchEnd, !1);
        (r.preventClicks || r.preventClicksPropagation) && a[d]("click", e.onClick, !0),
          r.cssMode && s[d]("scroll", e.onScroll),
          r.updateOnWindowResize
            ? e[u](o.ios || o.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", Ce, !0)
            : e[u]("observerUpdate", Ce, !0);
      },
        Me = {
          attachEvents: function () {
            const e = this,
              t = X(),
              { params: n, support: r } = e;
            (e.onTouchStart = be.bind(e)),
              (e.onTouchMove = we.bind(e)),
              (e.onTouchEnd = xe.bind(e)),
              n.cssMode && (e.onScroll = Te.bind(e)),
              (e.onClick = Ee.bind(e)),
              r.touch && !Se && (t.addEventListener("touchstart", $e), (Se = !0)),
              ke(e, "on");
          },
          detachEvents: function () {
            ke(this, "off");
          },
        },
        Pe = (e, t) => e.grid && t.grid && t.grid.rows > 1,
        Le = {
          setBreakpoint: function () {
            const e = this,
              { activeIndex: t, initialized: n, loopedSlides: r = 0, params: i, $el: a } = e,
              s = i.breakpoints;
            if (!s || (s && 0 === Object.keys(s).length)) return;
            const o = e.getBreakpoint(s, e.params.breakpointsBase, e.el);
            if (!o || e.currentBreakpoint === o) return;
            const l = (o in s ? s[o] : void 0) || e.originalParams,
              c = Pe(e, i),
              d = Pe(e, l),
              u = i.enabled;
            c && !d
              ? (a.removeClass(`${i.containerModifierClass}grid ${i.containerModifierClass}grid-column`),
                e.emitContainerClasses())
              : !c &&
              d &&
              (a.addClass(`${i.containerModifierClass}grid`),
                ((l.grid.fill && "column" === l.grid.fill) || (!l.grid.fill && "column" === i.grid.fill)) &&
                a.addClass(`${i.containerModifierClass}grid-column`),
                e.emitContainerClasses());
            const p = l.direction && l.direction !== i.direction,
              f = i.loop && (l.slidesPerView !== i.slidesPerView || p);
            p && n && e.changeDirection(), oe(e.params, l);
            const h = e.params.enabled;
            Object.assign(e, {
              allowTouchMove: e.params.allowTouchMove,
              allowSlideNext: e.params.allowSlideNext,
              allowSlidePrev: e.params.allowSlidePrev,
            }),
              u && !h ? e.disable() : !u && h && e.enable(),
              (e.currentBreakpoint = o),
              e.emit("_beforeBreakpoint", l),
              f && n && (e.loopDestroy(), e.loopCreate(), e.updateSlides(), e.slideTo(t - r + e.loopedSlides, 0, !1)),
              e.emit("breakpoint", l);
          },
          getBreakpoint: function (e, t = "window", n) {
            if (!e || ("container" === t && !n)) return;
            let r = !1;
            const i = V(),
              a = "window" === t ? i.innerHeight : n.clientHeight,
              s = Object.keys(e).map((e) => {
                if ("string" == typeof e && 0 === e.indexOf("@")) {
                  const t = parseFloat(e.substr(1));
                  return { value: a * t, point: e };
                }
                return { value: e, point: e };
              });
            s.sort((e, t) => parseInt(e.value, 10) - parseInt(t.value, 10));
            for (let e = 0; e < s.length; e += 1) {
              const { point: a, value: o } = s[e];
              "window" === t ? i.matchMedia(`(min-width: ${o}px)`).matches && (r = a) : o <= n.clientWidth && (r = a);
            }
            return r || "max";
          },
        },
        Oe = {
          addClasses: function () {
            const e = this,
              { classNames: t, params: n, rtl: r, $el: i, device: a, support: s } = e,
              o = (function (e, t) {
                const n = [];
                return (
                  e.forEach((e) => {
                    "object" == typeof e
                      ? Object.keys(e).forEach((r) => {
                        e[r] && n.push(t + r);
                      })
                      : "string" == typeof e && n.push(t + e);
                  }),
                  n
                );
              })(
                [
                  "initialized",
                  n.direction,
                  { "pointer-events": !s.touch },
                  { "free-mode": e.params.freeMode && n.freeMode.enabled },
                  { autoheight: n.autoHeight },
                  { rtl: r },
                  { grid: n.grid && n.grid.rows > 1 },
                  { "grid-column": n.grid && n.grid.rows > 1 && "column" === n.grid.fill },
                  { android: a.android },
                  { ios: a.ios },
                  { "css-mode": n.cssMode },
                  { centered: n.cssMode && n.centeredSlides },
                ],
                n.containerModifierClass
              );
            t.push(...o), i.addClass([...t].join(" ")), e.emitContainerClasses();
          },
          removeClasses: function () {
            const { $el: e, classNames: t } = this;
            e.removeClass(t.join(" ")), this.emitContainerClasses();
          },
        },
        Ae = {
          loadImage: function (e, t, n, r, i, a) {
            const s = V();
            let o;
            function l() {
              a && a();
            }
            ne(e).parent("picture")[0] || (e.complete && i)
              ? l()
              : t
                ? ((o = new s.Image()),
                  (o.onload = l),
                  (o.onerror = l),
                  r && (o.sizes = r),
                  n && (o.srcset = n),
                  t && (o.src = t))
                : l();
          },
          preloadImages: function () {
            const e = this;
            function t() {
              null != e &&
                e &&
                !e.destroyed &&
                (void 0 !== e.imagesLoaded && (e.imagesLoaded += 1),
                  e.imagesLoaded === e.imagesToLoad.length &&
                  (e.params.updateOnImagesReady && e.update(), e.emit("imagesReady")));
            }
            e.imagesToLoad = e.$el.find("img");
            for (let n = 0; n < e.imagesToLoad.length; n += 1) {
              const r = e.imagesToLoad[n];
              e.loadImage(
                r,
                r.currentSrc || r.getAttribute("src"),
                r.srcset || r.getAttribute("srcset"),
                r.sizes || r.getAttribute("sizes"),
                !0,
                t
              );
            }
          },
        },
        De = {
          init: !0,
          direction: "horizontal",
          touchEventsTarget: "wrapper",
          initialSlide: 0,
          speed: 300,
          cssMode: !1,
          updateOnWindowResize: !0,
          resizeObserver: !0,
          nested: !1,
          createElements: !1,
          enabled: !0,
          focusableElements: "input, select, option, textarea, button, video, label",
          width: null,
          height: null,
          preventInteractionOnTransition: !1,
          userAgent: null,
          url: null,
          edgeSwipeDetection: !1,
          edgeSwipeThreshold: 20,
          autoHeight: !1,
          setWrapperSize: !1,
          virtualTranslate: !1,
          effect: "slide",
          breakpoints: void 0,
          breakpointsBase: "window",
          spaceBetween: 0,
          slidesPerView: 1,
          slidesPerGroup: 1,
          slidesPerGroupSkip: 0,
          slidesPerGroupAuto: !1,
          centeredSlides: !1,
          centeredSlidesBounds: !1,
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 0,
          normalizeSlideIndex: !0,
          centerInsufficientSlides: !1,
          watchOverflow: !0,
          roundLengths: !1,
          touchRatio: 1,
          touchAngle: 45,
          simulateTouch: !0,
          shortSwipes: !0,
          longSwipes: !0,
          longSwipesRatio: 0.5,
          longSwipesMs: 300,
          followFinger: !0,
          allowTouchMove: !0,
          threshold: 0,
          touchMoveStopPropagation: !1,
          touchStartPreventDefault: !0,
          touchStartForcePreventDefault: !1,
          touchReleaseOnEdges: !1,
          uniqueNavElements: !0,
          resistance: !0,
          resistanceRatio: 0.85,
          watchSlidesProgress: !1,
          grabCursor: !1,
          preventClicks: !0,
          preventClicksPropagation: !0,
          slideToClickedSlide: !1,
          preloadImages: !0,
          updateOnImagesReady: !0,
          loop: !1,
          loopAdditionalSlides: 0,
          loopedSlides: null,
          loopFillGroupWithBlank: !1,
          loopPreventsSlide: !0,
          rewind: !1,
          allowSlidePrev: !0,
          allowSlideNext: !0,
          swipeHandler: null,
          noSwiping: !0,
          noSwipingClass: "swiper-no-swiping",
          noSwipingSelector: null,
          passiveListeners: !0,
          containerModifierClass: "swiper-",
          slideClass: "swiper-slide",
          slideBlankClass: "swiper-slide-invisible-blank",
          slideActiveClass: "swiper-slide-active",
          slideDuplicateActiveClass: "swiper-slide-duplicate-active",
          slideVisibleClass: "swiper-slide-visible",
          slideDuplicateClass: "swiper-slide-duplicate",
          slideNextClass: "swiper-slide-next",
          slideDuplicateNextClass: "swiper-slide-duplicate-next",
          slidePrevClass: "swiper-slide-prev",
          slideDuplicatePrevClass: "swiper-slide-duplicate-prev",
          wrapperClass: "swiper-wrapper",
          runCallbacksOnInit: !0,
          _emitClasses: !1,
        };
      function Ne(e, t) {
        return function (n = {}) {
          const r = Object.keys(n)[0],
            i = n[r];
          "object" == typeof i && null !== i
            ? (["navigation", "pagination", "scrollbar"].indexOf(r) >= 0 && !0 === e[r] && (e[r] = { auto: !0 }),
              r in e && "enabled" in i
                ? (!0 === e[r] && (e[r] = { enabled: !0 }),
                  "object" != typeof e[r] || "enabled" in e[r] || (e[r].enabled = !0),
                  e[r] || (e[r] = { enabled: !1 }),
                  oe(t, n))
                : oe(t, n))
            : oe(t, n);
        };
      }
      const Ie = {
        eventsEmitter: he,
        update: me,
        translate: {
          getTranslate: function (e = this.isHorizontal() ? "x" : "y") {
            const { params: t, rtlTranslate: n, translate: r, $wrapperEl: i } = this;
            if (t.virtualTranslate) return n ? -r : r;
            if (t.cssMode) return r;
            let a = ae(i[0], e);
            return n && (a = -a), a || 0;
          },
          setTranslate: function (e, t) {
            const n = this,
              { rtlTranslate: r, params: i, $wrapperEl: a, wrapperEl: s, progress: o } = n;
            let l,
              c = 0,
              d = 0;
            n.isHorizontal() ? (c = r ? -e : e) : (d = e),
              i.roundLengths && ((c = Math.floor(c)), (d = Math.floor(d))),
              i.cssMode
                ? (s[n.isHorizontal() ? "scrollLeft" : "scrollTop"] = n.isHorizontal() ? -c : -d)
                : i.virtualTranslate || a.transform(`translate3d(${c}px, ${d}px, 0px)`),
              (n.previousTranslate = n.translate),
              (n.translate = n.isHorizontal() ? c : d);
            const u = n.maxTranslate() - n.minTranslate();
            (l = 0 === u ? 0 : (e - n.minTranslate()) / u),
              l !== o && n.updateProgress(e),
              n.emit("setTranslate", n.translate, t);
          },
          minTranslate: function () {
            return -this.snapGrid[0];
          },
          maxTranslate: function () {
            return -this.snapGrid[this.snapGrid.length - 1];
          },
          translateTo: function (e = 0, t = this.params.speed, n = !0, r = !0, i) {
            const a = this,
              { params: s, wrapperEl: o } = a;
            if (a.animating && s.preventInteractionOnTransition) return !1;
            const l = a.minTranslate(),
              c = a.maxTranslate();
            let d;
            if (((d = r && e > l ? l : r && e < c ? c : e), a.updateProgress(d), s.cssMode)) {
              const e = a.isHorizontal();
              if (0 === t) o[e ? "scrollLeft" : "scrollTop"] = -d;
              else {
                if (!a.support.smoothScroll)
                  return ce({ swiper: a, targetPosition: -d, side: e ? "left" : "top" }), !0;
                o.scrollTo({ [e ? "left" : "top"]: -d, behavior: "smooth" });
              }
              return !0;
            }
            return (
              0 === t
                ? (a.setTransition(0),
                  a.setTranslate(d),
                  n && (a.emit("beforeTransitionStart", t, i), a.emit("transitionEnd")))
                : (a.setTransition(t),
                  a.setTranslate(d),
                  n && (a.emit("beforeTransitionStart", t, i), a.emit("transitionStart")),
                  a.animating ||
                  ((a.animating = !0),
                    a.onTranslateToWrapperTransitionEnd ||
                    (a.onTranslateToWrapperTransitionEnd = function (e) {
                      a &&
                        !a.destroyed &&
                        e.target === this &&
                        (a.$wrapperEl[0].removeEventListener("transitionend", a.onTranslateToWrapperTransitionEnd),
                          a.$wrapperEl[0].removeEventListener(
                            "webkitTransitionEnd",
                            a.onTranslateToWrapperTransitionEnd
                          ),
                          (a.onTranslateToWrapperTransitionEnd = null),
                          delete a.onTranslateToWrapperTransitionEnd,
                          n && a.emit("transitionEnd"));
                    }),
                    a.$wrapperEl[0].addEventListener("transitionend", a.onTranslateToWrapperTransitionEnd),
                    a.$wrapperEl[0].addEventListener("webkitTransitionEnd", a.onTranslateToWrapperTransitionEnd))),
              !0
            );
          },
        },
        transition: {
          setTransition: function (e, t) {
            const n = this;
            n.params.cssMode || n.$wrapperEl.transition(e), n.emit("setTransition", e, t);
          },
          transitionStart: function (e = !0, t) {
            const n = this,
              { params: r } = n;
            r.cssMode ||
              (r.autoHeight && n.updateAutoHeight(), ge({ swiper: n, runCallbacks: e, direction: t, step: "Start" }));
          },
          transitionEnd: function (e = !0, t) {
            const n = this,
              { params: r } = n;
            (n.animating = !1),
              r.cssMode || (n.setTransition(0), ge({ swiper: n, runCallbacks: e, direction: t, step: "End" }));
          },
        },
        slide: ve,
        loop: ye,
        grabCursor: {
          setGrabCursor: function (e) {
            const t = this;
            if (
              t.support.touch ||
              !t.params.simulateTouch ||
              (t.params.watchOverflow && t.isLocked) ||
              t.params.cssMode
            )
              return;
            const n = "container" === t.params.touchEventsTarget ? t.el : t.wrapperEl;
            (n.style.cursor = "move"),
              (n.style.cursor = e ? "-webkit-grabbing" : "-webkit-grab"),
              (n.style.cursor = e ? "-moz-grabbin" : "-moz-grab"),
              (n.style.cursor = e ? "grabbing" : "grab");
          },
          unsetGrabCursor: function () {
            const e = this;
            e.support.touch ||
              (e.params.watchOverflow && e.isLocked) ||
              e.params.cssMode ||
              (e["container" === e.params.touchEventsTarget ? "el" : "wrapperEl"].style.cursor = "");
          },
        },
        events: Me,
        breakpoints: Le,
        checkOverflow: {
          checkOverflow: function () {
            const e = this,
              { isLocked: t, params: n } = e,
              { slidesOffsetBefore: r } = n;
            if (r) {
              const t = e.slides.length - 1,
                n = e.slidesGrid[t] + e.slidesSizesGrid[t] + 2 * r;
              e.isLocked = e.size > n;
            } else e.isLocked = 1 === e.snapGrid.length;
            !0 === n.allowSlideNext && (e.allowSlideNext = !e.isLocked),
              !0 === n.allowSlidePrev && (e.allowSlidePrev = !e.isLocked),
              t && t !== e.isLocked && (e.isEnd = !1),
              t !== e.isLocked && e.emit(e.isLocked ? "lock" : "unlock");
          },
        },
        classes: Oe,
        images: Ae,
      },
        je = {};
      class ze {
        constructor(...e) {
          let t, n;
          if (
            (1 === e.length && e[0].constructor && "Object" === Object.prototype.toString.call(e[0]).slice(8, -1)
              ? (n = e[0])
              : ([t, n] = e),
              n || (n = {}),
              (n = oe({}, n)),
              t && !n.el && (n.el = t),
              n.el && ne(n.el).length > 1)
          ) {
            const e = [];
            return (
              ne(n.el).each((t) => {
                const r = oe({}, n, { el: t });
                e.push(new ze(r));
              }),
              e
            );
          }
          const r = this;
          (r.__swiper__ = !0),
            (r.support = fe()),
            (r.device = (function (e = {}) {
              return (
                ue ||
                (ue = (function ({ userAgent: e } = {}) {
                  const t = fe(),
                    n = V(),
                    r = n.navigator.platform,
                    i = e || n.navigator.userAgent,
                    a = { ios: !1, android: !1 },
                    s = n.screen.width,
                    o = n.screen.height,
                    l = i.match(/(Android);?[\s\/]+([\d.]+)?/);
                  let c = i.match(/(iPad).*OS\s([\d_]+)/);
                  const d = i.match(/(iPod)(.*OS\s([\d_]+))?/),
                    u = !c && i.match(/(iPhone\sOS|iOS)\s([\d_]+)/),
                    p = "Win32" === r;
                  let f = "MacIntel" === r;
                  return (
                    !c &&
                    f &&
                    t.touch &&
                    [
                      "1024x1366",
                      "1366x1024",
                      "834x1194",
                      "1194x834",
                      "834x1112",
                      "1112x834",
                      "768x1024",
                      "1024x768",
                      "820x1180",
                      "1180x820",
                      "810x1080",
                      "1080x810",
                    ].indexOf(`${s}x${o}`) >= 0 &&
                    ((c = i.match(/(Version)\/([\d.]+)/)), c || (c = [0, 1, "13_0_0"]), (f = !1)),
                    l && !p && ((a.os = "android"), (a.android = !0)),
                    (c || u || d) && ((a.os = "ios"), (a.ios = !0)),
                    a
                  );
                })(e)),
                ue
              );
            })({ userAgent: n.userAgent })),
            (r.browser =
              (pe ||
                (pe = (function () {
                  const e = V();
                  return {
                    isSafari: (function () {
                      const t = e.navigator.userAgent.toLowerCase();
                      return t.indexOf("safari") >= 0 && t.indexOf("chrome") < 0 && t.indexOf("android") < 0;
                    })(),
                    isWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(e.navigator.userAgent),
                  };
                })()),
                pe)),
            (r.eventsListeners = {}),
            (r.eventsAnyListeners = []),
            (r.modules = [...r.__modules__]),
            n.modules && Array.isArray(n.modules) && r.modules.push(...n.modules);
          const i = {};
          r.modules.forEach((e) => {
            e({
              swiper: r,
              extendParams: Ne(n, i),
              on: r.on.bind(r),
              once: r.once.bind(r),
              off: r.off.bind(r),
              emit: r.emit.bind(r),
            });
          });
          const a = oe({}, De, i);
          return (
            (r.params = oe({}, a, je, n)),
            (r.originalParams = oe({}, r.params)),
            (r.passedParams = oe({}, n)),
            r.params &&
            r.params.on &&
            Object.keys(r.params.on).forEach((e) => {
              r.on(e, r.params.on[e]);
            }),
            r.params && r.params.onAny && r.onAny(r.params.onAny),
            (r.$ = ne),
            Object.assign(r, {
              enabled: r.params.enabled,
              el: t,
              classNames: [],
              slides: ne(),
              slidesGrid: [],
              snapGrid: [],
              slidesSizesGrid: [],
              isHorizontal: () => "horizontal" === r.params.direction,
              isVertical: () => "vertical" === r.params.direction,
              activeIndex: 0,
              realIndex: 0,
              isBeginning: !0,
              isEnd: !1,
              translate: 0,
              previousTranslate: 0,
              progress: 0,
              velocity: 0,
              animating: !1,
              allowSlideNext: r.params.allowSlideNext,
              allowSlidePrev: r.params.allowSlidePrev,
              touchEvents: (function () {
                const e = ["touchstart", "touchmove", "touchend", "touchcancel"],
                  t = ["pointerdown", "pointermove", "pointerup"];
                return (
                  (r.touchEventsTouch = { start: e[0], move: e[1], end: e[2], cancel: e[3] }),
                  (r.touchEventsDesktop = { start: t[0], move: t[1], end: t[2] }),
                  r.support.touch || !r.params.simulateTouch ? r.touchEventsTouch : r.touchEventsDesktop
                );
              })(),
              touchEventsData: {
                isTouched: void 0,
                isMoved: void 0,
                allowTouchCallbacks: void 0,
                touchStartTime: void 0,
                isScrolling: void 0,
                currentTranslate: void 0,
                startTranslate: void 0,
                allowThresholdMove: void 0,
                focusableElements: r.params.focusableElements,
                lastClickTime: ie(),
                clickTimeout: void 0,
                velocities: [],
                allowMomentumBounce: void 0,
                isTouchEvent: void 0,
                startMoving: void 0,
              },
              allowClick: !0,
              allowTouchMove: r.params.allowTouchMove,
              touches: { startX: 0, startY: 0, currentX: 0, currentY: 0, diff: 0 },
              imagesToLoad: [],
              imagesLoaded: 0,
            }),
            r.emit("_swiper"),
            r.params.init && r.init(),
            r
          );
        }
        enable() {
          const e = this;
          e.enabled || ((e.enabled = !0), e.params.grabCursor && e.setGrabCursor(), e.emit("enable"));
        }
        disable() {
          const e = this;
          e.enabled && ((e.enabled = !1), e.params.grabCursor && e.unsetGrabCursor(), e.emit("disable"));
        }
        setProgress(e, t) {
          const n = this;
          e = Math.min(Math.max(e, 0), 1);
          const r = n.minTranslate(),
            i = (n.maxTranslate() - r) * e + r;
          n.translateTo(i, void 0 === t ? 0 : t), n.updateActiveIndex(), n.updateSlidesClasses();
        }
        emitContainerClasses() {
          const e = this;
          if (!e.params._emitClasses || !e.el) return;
          const t = e.el.className
            .split(" ")
            .filter((t) => 0 === t.indexOf("swiper") || 0 === t.indexOf(e.params.containerModifierClass));
          e.emit("_containerClasses", t.join(" "));
        }
        getSlideClasses(e) {
          const t = this;
          return e.className
            .split(" ")
            .filter((e) => 0 === e.indexOf("swiper-slide") || 0 === e.indexOf(t.params.slideClass))
            .join(" ");
        }
        emitSlidesClasses() {
          const e = this;
          if (!e.params._emitClasses || !e.el) return;
          const t = [];
          e.slides.each((n) => {
            const r = e.getSlideClasses(n);
            t.push({ slideEl: n, classNames: r }), e.emit("_slideClass", n, r);
          }),
            e.emit("_slideClasses", t);
        }
        slidesPerViewDynamic(e = "current", t = !1) {
          const { params: n, slides: r, slidesGrid: i, slidesSizesGrid: a, size: s, activeIndex: o } = this;
          let l = 1;
          if (n.centeredSlides) {
            let e,
              t = r[o].swiperSlideSize;
            for (let n = o + 1; n < r.length; n += 1)
              r[n] && !e && ((t += r[n].swiperSlideSize), (l += 1), t > s && (e = !0));
            for (let n = o - 1; n >= 0; n -= 1)
              r[n] && !e && ((t += r[n].swiperSlideSize), (l += 1), t > s && (e = !0));
          } else if ("current" === e)
            for (let e = o + 1; e < r.length; e += 1) (t ? i[e] + a[e] - i[o] < s : i[e] - i[o] < s) && (l += 1);
          else for (let e = o - 1; e >= 0; e -= 1) i[o] - i[e] < s && (l += 1);
          return l;
        }
        update() {
          const e = this;
          if (!e || e.destroyed) return;
          const { snapGrid: t, params: n } = e;
          function r() {
            const t = e.rtlTranslate ? -1 * e.translate : e.translate,
              n = Math.min(Math.max(t, e.maxTranslate()), e.minTranslate());
            e.setTranslate(n), e.updateActiveIndex(), e.updateSlidesClasses();
          }
          let i;
          n.breakpoints && e.setBreakpoint(),
            e.updateSize(),
            e.updateSlides(),
            e.updateProgress(),
            e.updateSlidesClasses(),
            e.params.freeMode && e.params.freeMode.enabled
              ? (r(), e.params.autoHeight && e.updateAutoHeight())
              : ((i =
                ("auto" === e.params.slidesPerView || e.params.slidesPerView > 1) &&
                  e.isEnd &&
                  !e.params.centeredSlides
                  ? e.slideTo(e.slides.length - 1, 0, !1, !0)
                  : e.slideTo(e.activeIndex, 0, !1, !0)),
                i || r()),
            n.watchOverflow && t !== e.snapGrid && e.checkOverflow(),
            e.emit("update");
        }
        changeDirection(e, t = !0) {
          const n = this,
            r = n.params.direction;
          return (
            e || (e = "horizontal" === r ? "vertical" : "horizontal"),
            e === r ||
            ("horizontal" !== e && "vertical" !== e) ||
            (n.$el
              .removeClass(`${n.params.containerModifierClass}${r}`)
              .addClass(`${n.params.containerModifierClass}${e}`),
              n.emitContainerClasses(),
              (n.params.direction = e),
              n.slides.each((t) => {
                "vertical" === e ? (t.style.width = "") : (t.style.height = "");
              }),
              n.emit("changeDirection"),
              t && n.update()),
            n
          );
        }
        mount(e) {
          const t = this;
          if (t.mounted) return !0;
          const n = ne(e || t.params.el);
          if (!(e = n[0])) return !1;
          e.swiper = t;
          const r = () => `.${(t.params.wrapperClass || "").trim().split(" ").join(".")}`;
          let i = (() => {
            if (e && e.shadowRoot && e.shadowRoot.querySelector) {
              const t = ne(e.shadowRoot.querySelector(r()));
              return (t.children = (e) => n.children(e)), t;
            }
            return n.children(r());
          })();
          if (0 === i.length && t.params.createElements) {
            const e = X().createElement("div");
            (i = ne(e)),
              (e.className = t.params.wrapperClass),
              n.append(e),
              n.children(`.${t.params.slideClass}`).each((e) => {
                i.append(e);
              });
          }
          return (
            Object.assign(t, {
              $el: n,
              el: e,
              $wrapperEl: i,
              wrapperEl: i[0],
              mounted: !0,
              rtl: "rtl" === e.dir.toLowerCase() || "rtl" === n.css("direction"),
              rtlTranslate:
                "horizontal" === t.params.direction && ("rtl" === e.dir.toLowerCase() || "rtl" === n.css("direction")),
              wrongRTL: "-webkit-box" === i.css("display"),
            }),
            !0
          );
        }
        init(e) {
          const t = this;
          return (
            t.initialized ||
            !1 === t.mount(e) ||
            (t.emit("beforeInit"),
              t.params.breakpoints && t.setBreakpoint(),
              t.addClasses(),
              t.params.loop && t.loopCreate(),
              t.updateSize(),
              t.updateSlides(),
              t.params.watchOverflow && t.checkOverflow(),
              t.params.grabCursor && t.enabled && t.setGrabCursor(),
              t.params.preloadImages && t.preloadImages(),
              t.params.loop
                ? t.slideTo(t.params.initialSlide + t.loopedSlides, 0, t.params.runCallbacksOnInit, !1, !0)
                : t.slideTo(t.params.initialSlide, 0, t.params.runCallbacksOnInit, !1, !0),
              t.attachEvents(),
              (t.initialized = !0),
              t.emit("init"),
              t.emit("afterInit")),
            t
          );
        }
        destroy(e = !0, t = !0) {
          const n = this,
            { params: r, $el: i, $wrapperEl: a, slides: s } = n;
          return (
            void 0 === n.params ||
            n.destroyed ||
            (n.emit("beforeDestroy"),
              (n.initialized = !1),
              n.detachEvents(),
              r.loop && n.loopDestroy(),
              t &&
              (n.removeClasses(),
                i.removeAttr("style"),
                a.removeAttr("style"),
                s &&
                s.length &&
                s
                  .removeClass(
                    [r.slideVisibleClass, r.slideActiveClass, r.slideNextClass, r.slidePrevClass].join(" ")
                  )
                  .removeAttr("style")
                  .removeAttr("data-swiper-slide-index")),
              n.emit("destroy"),
              Object.keys(n.eventsListeners).forEach((e) => {
                n.off(e);
              }),
              !1 !== e &&
              ((n.$el[0].swiper = null),
                (function (e) {
                  const t = e;
                  Object.keys(t).forEach((e) => {
                    try {
                      t[e] = null;
                    } catch (e) { }
                    try {
                      delete t[e];
                    } catch (e) { }
                  });
                })(n)),
              (n.destroyed = !0)),
            null
          );
        }
        static extendDefaults(e) {
          oe(je, e);
        }
        static get extendedDefaults() {
          return je;
        }
        static get defaults() {
          return De;
        }
        static installModule(e) {
          ze.prototype.__modules__ || (ze.prototype.__modules__ = []);
          const t = ze.prototype.__modules__;
          "function" == typeof e && t.indexOf(e) < 0 && t.push(e);
        }
        static use(e) {
          return Array.isArray(e) ? (e.forEach((e) => ze.installModule(e)), ze) : (ze.installModule(e), ze);
        }
      }
      Object.keys(Ie).forEach((e) => {
        Object.keys(Ie[e]).forEach((t) => {
          ze.prototype[t] = Ie[e][t];
        });
      }),
        ze.use([
          function ({ swiper: e, on: t, emit: n }) {
            const r = V();
            let i = null;
            const a = () => {
              e && !e.destroyed && e.initialized && (n("beforeResize"), n("resize"));
            },
              s = () => {
                e && !e.destroyed && e.initialized && n("orientationchange");
              };
            t("init", () => {
              e.params.resizeObserver && void 0 !== r.ResizeObserver
                ? e &&
                !e.destroyed &&
                e.initialized &&
                ((i = new ResizeObserver((t) => {
                  const { width: n, height: r } = e;
                  let i = n,
                    s = r;
                  t.forEach(({ contentBoxSize: t, contentRect: n, target: r }) => {
                    (r && r !== e.el) ||
                      ((i = n ? n.width : (t[0] || t).inlineSize), (s = n ? n.height : (t[0] || t).blockSize));
                  }),
                    (i === n && s === r) || a();
                })),
                  i.observe(e.el))
                : (r.addEventListener("resize", a), r.addEventListener("orientationchange", s));
            }),
              t("destroy", () => {
                i && i.unobserve && e.el && (i.unobserve(e.el), (i = null)),
                  r.removeEventListener("resize", a),
                  r.removeEventListener("orientationchange", s);
              });
          },
          function ({ swiper: e, extendParams: t, on: n, emit: r }) {
            const i = [],
              a = V(),
              s = (e, t = {}) => {
                const n = new (a.MutationObserver || a.WebkitMutationObserver)((e) => {
                  if (1 === e.length) return void r("observerUpdate", e[0]);
                  const t = function () {
                    r("observerUpdate", e[0]);
                  };
                  a.requestAnimationFrame ? a.requestAnimationFrame(t) : a.setTimeout(t, 0);
                });
                n.observe(e, {
                  attributes: void 0 === t.attributes || t.attributes,
                  childList: void 0 === t.childList || t.childList,
                  characterData: void 0 === t.characterData || t.characterData,
                }),
                  i.push(n);
              };
            t({ observer: !1, observeParents: !1, observeSlideChildren: !1 }),
              n("init", () => {
                if (e.params.observer) {
                  if (e.params.observeParents) {
                    const t = e.$el.parents();
                    for (let e = 0; e < t.length; e += 1) s(t[e]);
                  }
                  s(e.$el[0], { childList: e.params.observeSlideChildren }), s(e.$wrapperEl[0], { attributes: !1 });
                }
              }),
              n("destroy", () => {
                i.forEach((e) => {
                  e.disconnect();
                }),
                  i.splice(0, i.length);
              });
          },
        ]);
      const qe = ze;
      function _e(e, t, n, r) {
        const i = X();
        return (
          e.params.createElements &&
          Object.keys(r).forEach((a) => {
            if (!n[a] && !0 === n.auto) {
              let s = e.$el.children(`.${r[a]}`)[0];
              s || ((s = i.createElement("div")), (s.className = r[a]), e.$el.append(s)), (n[a] = s), (t[a] = s);
            }
          }),
          n
        );
      }
      function He(e = "") {
        return `.${e
          .trim()
          .replace(/([\.:!\/])/g, "\\$1")
          .replace(/ /g, ".")}`;
      }
      function Be(e) {
        const t = this,
          { $wrapperEl: n, params: r } = t;
        if ((r.loop && t.loopDestroy(), "object" == typeof e && "length" in e))
          for (let t = 0; t < e.length; t += 1) e[t] && n.append(e[t]);
        else n.append(e);
        r.loop && t.loopCreate(), r.observer || t.update();
      }
      function Re(e) {
        const t = this,
          { params: n, $wrapperEl: r, activeIndex: i } = t;
        n.loop && t.loopDestroy();
        let a = i + 1;
        if ("object" == typeof e && "length" in e) {
          for (let t = 0; t < e.length; t += 1) e[t] && r.prepend(e[t]);
          a = i + e.length;
        } else r.prepend(e);
        n.loop && t.loopCreate(), n.observer || t.update(), t.slideTo(a, 0, !1);
      }
      function Ge(e, t) {
        const n = this,
          { $wrapperEl: r, params: i, activeIndex: a } = n;
        let s = a;
        i.loop && ((s -= n.loopedSlides), n.loopDestroy(), (n.slides = r.children(`.${i.slideClass}`)));
        const o = n.slides.length;
        if (e <= 0) return void n.prependSlide(t);
        if (e >= o) return void n.appendSlide(t);
        let l = s > e ? s + 1 : s;
        const c = [];
        for (let t = o - 1; t >= e; t -= 1) {
          const e = n.slides.eq(t);
          e.remove(), c.unshift(e);
        }
        if ("object" == typeof t && "length" in t) {
          for (let e = 0; e < t.length; e += 1) t[e] && r.append(t[e]);
          l = s > e ? s + t.length : s;
        } else r.append(t);
        for (let e = 0; e < c.length; e += 1) r.append(c[e]);
        i.loop && n.loopCreate(),
          i.observer || n.update(),
          i.loop ? n.slideTo(l + n.loopedSlides, 0, !1) : n.slideTo(l, 0, !1);
      }
      function We(e) {
        const t = this,
          { params: n, $wrapperEl: r, activeIndex: i } = t;
        let a = i;
        n.loop && ((a -= t.loopedSlides), t.loopDestroy(), (t.slides = r.children(`.${n.slideClass}`)));
        let s,
          o = a;
        if ("object" == typeof e && "length" in e) {
          for (let n = 0; n < e.length; n += 1) (s = e[n]), t.slides[s] && t.slides.eq(s).remove(), s < o && (o -= 1);
          o = Math.max(o, 0);
        } else (s = e), t.slides[s] && t.slides.eq(s).remove(), s < o && (o -= 1), (o = Math.max(o, 0));
        n.loop && t.loopCreate(),
          n.observer || t.update(),
          n.loop ? t.slideTo(o + t.loopedSlides, 0, !1) : t.slideTo(o, 0, !1);
      }
      function Fe() {
        const e = this,
          t = [];
        for (let n = 0; n < e.slides.length; n += 1) t.push(n);
        e.removeSlide(t);
      }
      function Xe(e) {
        const {
          effect: t,
          swiper: n,
          on: r,
          setTranslate: i,
          setTransition: a,
          overwriteParams: s,
          perspective: o,
        } = e;
        r("beforeInit", () => {
          if (n.params.effect !== t) return;
          n.classNames.push(`${n.params.containerModifierClass}${t}`),
            o && o() && n.classNames.push(`${n.params.containerModifierClass}3d`);
          const e = s ? s() : {};
          Object.assign(n.params, e), Object.assign(n.originalParams, e);
        }),
          r("setTranslate", () => {
            n.params.effect === t && i();
          }),
          r("setTransition", (e, r) => {
            n.params.effect === t && a(r);
          });
      }
      function Ye(e, t) {
        return e.transformEl
          ? t.find(e.transformEl).css({ "backface-visibility": "hidden", "-webkit-backface-visibility": "hidden" })
          : t;
      }
      function Ve({ swiper: e, duration: t, transformEl: n, allSlides: r }) {
        const { slides: i, activeIndex: a, $wrapperEl: s } = e;
        if (e.params.virtualTranslate && 0 !== t) {
          let t,
            o = !1;
          (t = r ? (n ? i.find(n) : i) : n ? i.eq(a).find(n) : i.eq(a)),
            t.transitionEnd(() => {
              if (o) return;
              if (!e || e.destroyed) return;
              (o = !0), (e.animating = !1);
              const t = ["webkitTransitionEnd", "transitionend"];
              for (let e = 0; e < t.length; e += 1) s.trigger(t[e]);
            });
        }
      }
      function Ue(e, t, n) {
        const r = "swiper-slide-shadow" + (n ? `-${n}` : ""),
          i = e.transformEl ? t.find(e.transformEl) : t;
        let a = i.children(`.${r}`);
        return a.length || ((a = ne(`<div class="swiper-slide-shadow${n ? `-${n}` : ""}"></div>`)), i.append(a)), a;
      }
      const Ke = [
        function ({ swiper: e, extendParams: t, on: n }) {
          let r;
          function i(t, n) {
            const r = e.params.virtual;
            if (r.cache && e.virtual.cache[n]) return e.virtual.cache[n];
            const i = r.renderSlide
              ? ne(r.renderSlide.call(e, t, n))
              : ne(`<div class="${e.params.slideClass}" data-swiper-slide-index="${n}">${t}</div>`);
            return (
              i.attr("data-swiper-slide-index") || i.attr("data-swiper-slide-index", n),
              r.cache && (e.virtual.cache[n] = i),
              i
            );
          }
          function a(t) {
            const { slidesPerView: n, slidesPerGroup: r, centeredSlides: a } = e.params,
              { addSlidesBefore: s, addSlidesAfter: o } = e.params.virtual,
              { from: l, to: c, slides: d, slidesGrid: u, offset: p } = e.virtual;
            e.params.cssMode || e.updateActiveIndex();
            const f = e.activeIndex || 0;
            let h, m, g;
            (h = e.rtlTranslate ? "right" : e.isHorizontal() ? "left" : "top"),
              a
                ? ((m = Math.floor(n / 2) + r + o), (g = Math.floor(n / 2) + r + s))
                : ((m = n + (r - 1) + o), (g = r + s));
            const v = Math.max((f || 0) - g, 0),
              y = Math.min((f || 0) + m, d.length - 1),
              b = (e.slidesGrid[v] || 0) - (e.slidesGrid[0] || 0);
            function w() {
              e.updateSlides(),
                e.updateProgress(),
                e.updateSlidesClasses(),
                e.lazy && e.params.lazy.enabled && e.lazy.load();
            }
            if (
              (Object.assign(e.virtual, { from: v, to: y, offset: b, slidesGrid: e.slidesGrid }),
                l === v && c === y && !t)
            )
              return e.slidesGrid !== u && b !== p && e.slides.css(h, `${b}px`), void e.updateProgress();
            if (e.params.virtual.renderExternal)
              return (
                e.params.virtual.renderExternal.call(e, {
                  offset: b,
                  from: v,
                  to: y,
                  slides: (function () {
                    const e = [];
                    for (let t = v; t <= y; t += 1) e.push(d[t]);
                    return e;
                  })(),
                }),
                void (e.params.virtual.renderExternalUpdate && w())
              );
            const x = [],
              C = [];
            if (t) e.$wrapperEl.find(`.${e.params.slideClass}`).remove();
            else
              for (let t = l; t <= c; t += 1)
                (t < v || t > y) &&
                  e.$wrapperEl.find(`.${e.params.slideClass}[data-swiper-slide-index="${t}"]`).remove();
            for (let e = 0; e < d.length; e += 1)
              e >= v && e <= y && (void 0 === c || t ? C.push(e) : (e > c && C.push(e), e < l && x.push(e)));
            C.forEach((t) => {
              e.$wrapperEl.append(i(d[t], t));
            }),
              x
                .sort((e, t) => t - e)
                .forEach((t) => {
                  e.$wrapperEl.prepend(i(d[t], t));
                }),
              e.$wrapperEl.children(".swiper-slide").css(h, `${b}px`),
              w();
          }
          t({
            virtual: {
              enabled: !1,
              slides: [],
              cache: !0,
              renderSlide: null,
              renderExternal: null,
              renderExternalUpdate: !0,
              addSlidesBefore: 0,
              addSlidesAfter: 0,
            },
          }),
            (e.virtual = { cache: {}, from: void 0, to: void 0, slides: [], offset: 0, slidesGrid: [] }),
            n("beforeInit", () => {
              e.params.virtual.enabled &&
                ((e.virtual.slides = e.params.virtual.slides),
                  e.classNames.push(`${e.params.containerModifierClass}virtual`),
                  (e.params.watchSlidesProgress = !0),
                  (e.originalParams.watchSlidesProgress = !0),
                  e.params.initialSlide || a());
            }),
            n("setTranslate", () => {
              e.params.virtual.enabled &&
                (e.params.cssMode && !e._immediateVirtual
                  ? (clearTimeout(r),
                    (r = setTimeout(() => {
                      a();
                    }, 100)))
                  : a());
            }),
            n("init update resize", () => {
              e.params.virtual.enabled &&
                e.params.cssMode &&
                le(e.wrapperEl, "--swiper-virtual-size", `${e.virtualSize}px`);
            }),
            Object.assign(e.virtual, {
              appendSlide: function (t) {
                if ("object" == typeof t && "length" in t)
                  for (let n = 0; n < t.length; n += 1) t[n] && e.virtual.slides.push(t[n]);
                else e.virtual.slides.push(t);
                a(!0);
              },
              prependSlide: function (t) {
                const n = e.activeIndex;
                let r = n + 1,
                  i = 1;
                if (Array.isArray(t)) {
                  for (let n = 0; n < t.length; n += 1) t[n] && e.virtual.slides.unshift(t[n]);
                  (r = n + t.length), (i = t.length);
                } else e.virtual.slides.unshift(t);
                if (e.params.virtual.cache) {
                  const t = e.virtual.cache,
                    n = {};
                  Object.keys(t).forEach((e) => {
                    const r = t[e],
                      a = r.attr("data-swiper-slide-index");
                    a && r.attr("data-swiper-slide-index", parseInt(a, 10) + i), (n[parseInt(e, 10) + i] = r);
                  }),
                    (e.virtual.cache = n);
                }
                a(!0), e.slideTo(r, 0);
              },
              removeSlide: function (t) {
                if (null == t) return;
                let n = e.activeIndex;
                if (Array.isArray(t))
                  for (let r = t.length - 1; r >= 0; r -= 1)
                    e.virtual.slides.splice(t[r], 1),
                      e.params.virtual.cache && delete e.virtual.cache[t[r]],
                      t[r] < n && (n -= 1),
                      (n = Math.max(n, 0));
                else
                  e.virtual.slides.splice(t, 1),
                    e.params.virtual.cache && delete e.virtual.cache[t],
                    t < n && (n -= 1),
                    (n = Math.max(n, 0));
                a(!0), e.slideTo(n, 0);
              },
              removeAllSlides: function () {
                (e.virtual.slides = []), e.params.virtual.cache && (e.virtual.cache = {}), a(!0), e.slideTo(0, 0);
              },
              update: a,
            });
        },
        function ({ swiper: e, extendParams: t, on: n, emit: r }) {
          const i = X(),
            a = V();
          function s(t) {
            if (!e.enabled) return;
            const { rtlTranslate: n } = e;
            let s = t;
            s.originalEvent && (s = s.originalEvent);
            const o = s.keyCode || s.charCode,
              l = e.params.keyboard.pageUpDown,
              c = l && 33 === o,
              d = l && 34 === o,
              u = 37 === o,
              p = 39 === o,
              f = 38 === o,
              h = 40 === o;
            if (!e.allowSlideNext && ((e.isHorizontal() && p) || (e.isVertical() && h) || d)) return !1;
            if (!e.allowSlidePrev && ((e.isHorizontal() && u) || (e.isVertical() && f) || c)) return !1;
            if (
              !(
                s.shiftKey ||
                s.altKey ||
                s.ctrlKey ||
                s.metaKey ||
                (i.activeElement &&
                  i.activeElement.nodeName &&
                  ("input" === i.activeElement.nodeName.toLowerCase() ||
                    "textarea" === i.activeElement.nodeName.toLowerCase()))
              )
            ) {
              if (e.params.keyboard.onlyInViewport && (c || d || u || p || f || h)) {
                let t = !1;
                if (
                  e.$el.parents(`.${e.params.slideClass}`).length > 0 &&
                  0 === e.$el.parents(`.${e.params.slideActiveClass}`).length
                )
                  return;
                const r = e.$el,
                  i = r[0].clientWidth,
                  s = r[0].clientHeight,
                  o = a.innerWidth,
                  l = a.innerHeight,
                  c = e.$el.offset();
                n && (c.left -= e.$el[0].scrollLeft);
                const d = [
                  [c.left, c.top],
                  [c.left + i, c.top],
                  [c.left, c.top + s],
                  [c.left + i, c.top + s],
                ];
                for (let e = 0; e < d.length; e += 1) {
                  const n = d[e];
                  if (n[0] >= 0 && n[0] <= o && n[1] >= 0 && n[1] <= l) {
                    if (0 === n[0] && 0 === n[1]) continue;
                    t = !0;
                  }
                }
                if (!t) return;
              }
              e.isHorizontal()
                ? ((c || d || u || p) && (s.preventDefault ? s.preventDefault() : (s.returnValue = !1)),
                  (((d || p) && !n) || ((c || u) && n)) && e.slideNext(),
                  (((c || u) && !n) || ((d || p) && n)) && e.slidePrev())
                : ((c || d || f || h) && (s.preventDefault ? s.preventDefault() : (s.returnValue = !1)),
                  (d || h) && e.slideNext(),
                  (c || f) && e.slidePrev()),
                r("keyPress", o);
            }
          }
          function o() {
            e.keyboard.enabled || (ne(i).on("keydown", s), (e.keyboard.enabled = !0));
          }
          function l() {
            e.keyboard.enabled && (ne(i).off("keydown", s), (e.keyboard.enabled = !1));
          }
          (e.keyboard = { enabled: !1 }),
            t({ keyboard: { enabled: !1, onlyInViewport: !0, pageUpDown: !0 } }),
            n("init", () => {
              e.params.keyboard.enabled && o();
            }),
            n("destroy", () => {
              e.keyboard.enabled && l();
            }),
            Object.assign(e.keyboard, { enable: o, disable: l });
        },
        function ({ swiper: e, extendParams: t, on: n, emit: r }) {
          const i = V();
          let a;
          t({
            mousewheel: {
              enabled: !1,
              releaseOnEdges: !1,
              invert: !1,
              forceToAxis: !1,
              sensitivity: 1,
              eventsTarget: "container",
              thresholdDelta: null,
              thresholdTime: null,
            },
          }),
            (e.mousewheel = { enabled: !1 });
          let s,
            o = ie();
          const l = [];
          function c() {
            e.enabled && (e.mouseEntered = !0);
          }
          function d() {
            e.enabled && (e.mouseEntered = !1);
          }
          function u(t) {
            return !(
              (e.params.mousewheel.thresholdDelta && t.delta < e.params.mousewheel.thresholdDelta) ||
              (e.params.mousewheel.thresholdTime && ie() - o < e.params.mousewheel.thresholdTime) ||
              (!(t.delta >= 6 && ie() - o < 60) &&
                (t.direction < 0
                  ? (e.isEnd && !e.params.loop) || e.animating || (e.slideNext(), r("scroll", t.raw))
                  : (e.isBeginning && !e.params.loop) || e.animating || (e.slidePrev(), r("scroll", t.raw)),
                  (o = new i.Date().getTime()),
                  1))
            );
          }
          function p(t) {
            let n = t,
              i = !0;
            if (!e.enabled) return;
            const o = e.params.mousewheel;
            e.params.cssMode && n.preventDefault();
            let c = e.$el;
            if (
              ("container" !== e.params.mousewheel.eventsTarget && (c = ne(e.params.mousewheel.eventsTarget)),
                !e.mouseEntered && !c[0].contains(n.target) && !o.releaseOnEdges)
            )
              return !0;
            n.originalEvent && (n = n.originalEvent);
            let d = 0;
            const p = e.rtlTranslate ? -1 : 1,
              f = (function (e) {
                let t = 0,
                  n = 0,
                  r = 0,
                  i = 0;
                return (
                  "detail" in e && (n = e.detail),
                  "wheelDelta" in e && (n = -e.wheelDelta / 120),
                  "wheelDeltaY" in e && (n = -e.wheelDeltaY / 120),
                  "wheelDeltaX" in e && (t = -e.wheelDeltaX / 120),
                  "axis" in e && e.axis === e.HORIZONTAL_AXIS && ((t = n), (n = 0)),
                  (r = 10 * t),
                  (i = 10 * n),
                  "deltaY" in e && (i = e.deltaY),
                  "deltaX" in e && (r = e.deltaX),
                  e.shiftKey && !r && ((r = i), (i = 0)),
                  (r || i) && e.deltaMode && (1 === e.deltaMode ? ((r *= 40), (i *= 40)) : ((r *= 800), (i *= 800))),
                  r && !t && (t = r < 1 ? -1 : 1),
                  i && !n && (n = i < 1 ? -1 : 1),
                  { spinX: t, spinY: n, pixelX: r, pixelY: i }
                );
              })(n);
            if (o.forceToAxis)
              if (e.isHorizontal()) {
                if (!(Math.abs(f.pixelX) > Math.abs(f.pixelY))) return !0;
                d = -f.pixelX * p;
              } else {
                if (!(Math.abs(f.pixelY) > Math.abs(f.pixelX))) return !0;
                d = -f.pixelY;
              }
            else d = Math.abs(f.pixelX) > Math.abs(f.pixelY) ? -f.pixelX * p : -f.pixelY;
            if (0 === d) return !0;
            o.invert && (d = -d);
            let h = e.getTranslate() + d * o.sensitivity;
            if (
              (h >= e.minTranslate() && (h = e.minTranslate()),
                h <= e.maxTranslate() && (h = e.maxTranslate()),
                (i = !!e.params.loop || !(h === e.minTranslate() || h === e.maxTranslate())),
                i && e.params.nested && n.stopPropagation(),
                e.params.freeMode && e.params.freeMode.enabled)
            ) {
              const t = { time: ie(), delta: Math.abs(d), direction: Math.sign(d) },
                i = s && t.time < s.time + 500 && t.delta <= s.delta && t.direction === s.direction;
              if (!i) {
                (s = void 0), e.params.loop && e.loopFix();
                let c = e.getTranslate() + d * o.sensitivity;
                const u = e.isBeginning,
                  p = e.isEnd;
                if (
                  (c >= e.minTranslate() && (c = e.minTranslate()),
                    c <= e.maxTranslate() && (c = e.maxTranslate()),
                    e.setTransition(0),
                    e.setTranslate(c),
                    e.updateProgress(),
                    e.updateActiveIndex(),
                    e.updateSlidesClasses(),
                    ((!u && e.isBeginning) || (!p && e.isEnd)) && e.updateSlidesClasses(),
                    e.params.freeMode.sticky)
                ) {
                  clearTimeout(a), (a = void 0), l.length >= 15 && l.shift();
                  const n = l.length ? l[l.length - 1] : void 0,
                    r = l[0];
                  if ((l.push(t), n && (t.delta > n.delta || t.direction !== n.direction))) l.splice(0);
                  else if (l.length >= 15 && t.time - r.time < 500 && r.delta - t.delta >= 1 && t.delta <= 6) {
                    const n = d > 0 ? 0.8 : 0.2;
                    (s = t),
                      l.splice(0),
                      (a = re(() => {
                        e.slideToClosest(e.params.speed, !0, void 0, n);
                      }, 0));
                  }
                  a ||
                    (a = re(() => {
                      (s = t), l.splice(0), e.slideToClosest(e.params.speed, !0, void 0, 0.5);
                    }, 500));
                }
                if (
                  (i || r("scroll", n),
                    e.params.autoplay && e.params.autoplayDisableOnInteraction && e.autoplay.stop(),
                    c === e.minTranslate() || c === e.maxTranslate())
                )
                  return !0;
              }
            } else {
              const n = { time: ie(), delta: Math.abs(d), direction: Math.sign(d), raw: t };
              l.length >= 2 && l.shift();
              const r = l.length ? l[l.length - 1] : void 0;
              if (
                (l.push(n),
                  r ? (n.direction !== r.direction || n.delta > r.delta || n.time > r.time + 150) && u(n) : u(n),
                  (function (t) {
                    const n = e.params.mousewheel;
                    if (t.direction < 0) {
                      if (e.isEnd && !e.params.loop && n.releaseOnEdges) return !0;
                    } else if (e.isBeginning && !e.params.loop && n.releaseOnEdges) return !0;
                    return !1;
                  })(n))
              )
                return !0;
            }
            return n.preventDefault ? n.preventDefault() : (n.returnValue = !1), !1;
          }
          function f(t) {
            let n = e.$el;
            "container" !== e.params.mousewheel.eventsTarget && (n = ne(e.params.mousewheel.eventsTarget)),
              n[t]("mouseenter", c),
              n[t]("mouseleave", d),
              n[t]("wheel", p);
          }
          function h() {
            return e.params.cssMode
              ? (e.wrapperEl.removeEventListener("wheel", p), !0)
              : !e.mousewheel.enabled && (f("on"), (e.mousewheel.enabled = !0), !0);
          }
          function m() {
            return e.params.cssMode
              ? (e.wrapperEl.addEventListener(event, p), !0)
              : !!e.mousewheel.enabled && (f("off"), (e.mousewheel.enabled = !1), !0);
          }
          n("init", () => {
            !e.params.mousewheel.enabled && e.params.cssMode && m(), e.params.mousewheel.enabled && h();
          }),
            n("destroy", () => {
              e.params.cssMode && h(), e.mousewheel.enabled && m();
            }),
            Object.assign(e.mousewheel, { enable: h, disable: m });
        },
        function ({ swiper: e, extendParams: t, on: n, emit: r }) {
          function i(t) {
            let n;
            return (
              t &&
              ((n = ne(t)),
                e.params.uniqueNavElements &&
                "string" == typeof t &&
                n.length > 1 &&
                1 === e.$el.find(t).length &&
                (n = e.$el.find(t))),
              n
            );
          }
          function a(t, n) {
            const r = e.params.navigation;
            t &&
              t.length > 0 &&
              (t[n ? "addClass" : "removeClass"](r.disabledClass),
                t[0] && "BUTTON" === t[0].tagName && (t[0].disabled = n),
                e.params.watchOverflow && e.enabled && t[e.isLocked ? "addClass" : "removeClass"](r.lockClass));
          }
          function s() {
            if (e.params.loop) return;
            const { $nextEl: t, $prevEl: n } = e.navigation;
            a(n, e.isBeginning && !e.params.rewind), a(t, e.isEnd && !e.params.rewind);
          }
          function o(t) {
            t.preventDefault(), (!e.isBeginning || e.params.loop || e.params.rewind) && e.slidePrev();
          }
          function l(t) {
            t.preventDefault(), (!e.isEnd || e.params.loop || e.params.rewind) && e.slideNext();
          }
          function c() {
            const t = e.params.navigation;
            if (
              ((e.params.navigation = _e(e, e.originalParams.navigation, e.params.navigation, {
                nextEl: "swiper-button-next",
                prevEl: "swiper-button-prev",
              })),
                !t.nextEl && !t.prevEl)
            )
              return;
            const n = i(t.nextEl),
              r = i(t.prevEl);
            n && n.length > 0 && n.on("click", l),
              r && r.length > 0 && r.on("click", o),
              Object.assign(e.navigation, { $nextEl: n, nextEl: n && n[0], $prevEl: r, prevEl: r && r[0] }),
              e.enabled || (n && n.addClass(t.lockClass), r && r.addClass(t.lockClass));
          }
          function d() {
            const { $nextEl: t, $prevEl: n } = e.navigation;
            t && t.length && (t.off("click", l), t.removeClass(e.params.navigation.disabledClass)),
              n && n.length && (n.off("click", o), n.removeClass(e.params.navigation.disabledClass));
          }
          t({
            navigation: {
              nextEl: null,
              prevEl: null,
              hideOnClick: !1,
              disabledClass: "swiper-button-disabled",
              hiddenClass: "swiper-button-hidden",
              lockClass: "swiper-button-lock",
            },
          }),
            (e.navigation = { nextEl: null, $nextEl: null, prevEl: null, $prevEl: null }),
            n("init", () => {
              c(), s();
            }),
            n("toEdge fromEdge lock unlock", () => {
              s();
            }),
            n("destroy", () => {
              d();
            }),
            n("enable disable", () => {
              const { $nextEl: t, $prevEl: n } = e.navigation;
              t && t[e.enabled ? "removeClass" : "addClass"](e.params.navigation.lockClass),
                n && n[e.enabled ? "removeClass" : "addClass"](e.params.navigation.lockClass);
            }),
            n("click", (t, n) => {
              const { $nextEl: i, $prevEl: a } = e.navigation,
                s = n.target;
              if (e.params.navigation.hideOnClick && !ne(s).is(a) && !ne(s).is(i)) {
                if (
                  e.pagination &&
                  e.params.pagination &&
                  e.params.pagination.clickable &&
                  (e.pagination.el === s || e.pagination.el.contains(s))
                )
                  return;
                let t;
                i
                  ? (t = i.hasClass(e.params.navigation.hiddenClass))
                  : a && (t = a.hasClass(e.params.navigation.hiddenClass)),
                  r(!0 === t ? "navigationShow" : "navigationHide"),
                  i && i.toggleClass(e.params.navigation.hiddenClass),
                  a && a.toggleClass(e.params.navigation.hiddenClass);
              }
            }),
            Object.assign(e.navigation, { update: s, init: c, destroy: d });
        },
        function ({ swiper: e, extendParams: t, on: n, emit: r }) {
          const i = "swiper-pagination";
          let a;
          t({
            pagination: {
              el: null,
              bulletElement: "span",
              clickable: !1,
              hideOnClick: !1,
              renderBullet: null,
              renderProgressbar: null,
              renderFraction: null,
              renderCustom: null,
              progressbarOpposite: !1,
              type: "bullets",
              dynamicBullets: !1,
              dynamicMainBullets: 1,
              formatFractionCurrent: (e) => e,
              formatFractionTotal: (e) => e,
              bulletClass: `${i}-bullet`,
              bulletActiveClass: `${i}-bullet-active`,
              modifierClass: `${i}-`,
              currentClass: `${i}-current`,
              totalClass: `${i}-total`,
              hiddenClass: `${i}-hidden`,
              progressbarFillClass: `${i}-progressbar-fill`,
              progressbarOppositeClass: `${i}-progressbar-opposite`,
              clickableClass: `${i}-clickable`,
              lockClass: `${i}-lock`,
              horizontalClass: `${i}-horizontal`,
              verticalClass: `${i}-vertical`,
            },
          }),
            (e.pagination = { el: null, $el: null, bullets: [] });
          let s = 0;
          function o() {
            return !e.params.pagination.el || !e.pagination.el || !e.pagination.$el || 0 === e.pagination.$el.length;
          }
          function l(t, n) {
            const { bulletActiveClass: r } = e.params.pagination;
            t[n]().addClass(`${r}-${n}`)[n]().addClass(`${r}-${n}-${n}`);
          }
          function c() {
            const t = e.rtl,
              n = e.params.pagination;
            if (o()) return;
            const i = e.virtual && e.params.virtual.enabled ? e.virtual.slides.length : e.slides.length,
              c = e.pagination.$el;
            let d;
            const u = e.params.loop ? Math.ceil((i - 2 * e.loopedSlides) / e.params.slidesPerGroup) : e.snapGrid.length;
            if (
              (e.params.loop
                ? ((d = Math.ceil((e.activeIndex - e.loopedSlides) / e.params.slidesPerGroup)),
                  d > i - 1 - 2 * e.loopedSlides && (d -= i - 2 * e.loopedSlides),
                  d > u - 1 && (d -= u),
                  d < 0 && "bullets" !== e.params.paginationType && (d = u + d))
                : (d = void 0 !== e.snapIndex ? e.snapIndex : e.activeIndex || 0),
                "bullets" === n.type && e.pagination.bullets && e.pagination.bullets.length > 0)
            ) {
              const r = e.pagination.bullets;
              let i, o, u;
              if (
                (n.dynamicBullets &&
                  ((a = r.eq(0)[e.isHorizontal() ? "outerWidth" : "outerHeight"](!0)),
                    c.css(e.isHorizontal() ? "width" : "height", a * (n.dynamicMainBullets + 4) + "px"),
                    n.dynamicMainBullets > 1 &&
                    void 0 !== e.previousIndex &&
                    ((s += d - (e.previousIndex - e.loopedSlides || 0)),
                      s > n.dynamicMainBullets - 1 ? (s = n.dynamicMainBullets - 1) : s < 0 && (s = 0)),
                    (i = Math.max(d - s, 0)),
                    (o = i + (Math.min(r.length, n.dynamicMainBullets) - 1)),
                    (u = (o + i) / 2)),
                  r.removeClass(
                    ["", "-next", "-next-next", "-prev", "-prev-prev", "-main"]
                      .map((e) => `${n.bulletActiveClass}${e}`)
                      .join(" ")
                  ),
                  c.length > 1)
              )
                r.each((e) => {
                  const t = ne(e),
                    r = t.index();
                  r === d && t.addClass(n.bulletActiveClass),
                    n.dynamicBullets &&
                    (r >= i && r <= o && t.addClass(`${n.bulletActiveClass}-main`),
                      r === i && l(t, "prev"),
                      r === o && l(t, "next"));
                });
              else {
                const t = r.eq(d),
                  a = t.index();
                if ((t.addClass(n.bulletActiveClass), n.dynamicBullets)) {
                  const t = r.eq(i),
                    s = r.eq(o);
                  for (let e = i; e <= o; e += 1) r.eq(e).addClass(`${n.bulletActiveClass}-main`);
                  if (e.params.loop)
                    if (a >= r.length) {
                      for (let e = n.dynamicMainBullets; e >= 0; e -= 1)
                        r.eq(r.length - e).addClass(`${n.bulletActiveClass}-main`);
                      r.eq(r.length - n.dynamicMainBullets - 1).addClass(`${n.bulletActiveClass}-prev`);
                    } else l(t, "prev"), l(s, "next");
                  else l(t, "prev"), l(s, "next");
                }
              }
              if (n.dynamicBullets) {
                const i = Math.min(r.length, n.dynamicMainBullets + 4),
                  s = (a * i - a) / 2 - u * a,
                  o = t ? "right" : "left";
                r.css(e.isHorizontal() ? o : "top", `${s}px`);
              }
            }
            if (
              ("fraction" === n.type &&
                (c.find(He(n.currentClass)).text(n.formatFractionCurrent(d + 1)),
                  c.find(He(n.totalClass)).text(n.formatFractionTotal(u))),
                "progressbar" === n.type)
            ) {
              let t;
              t = n.progressbarOpposite
                ? e.isHorizontal()
                  ? "vertical"
                  : "horizontal"
                : e.isHorizontal()
                  ? "horizontal"
                  : "vertical";
              const r = (d + 1) / u;
              let i = 1,
                a = 1;
              "horizontal" === t ? (i = r) : (a = r),
                c
                  .find(He(n.progressbarFillClass))
                  .transform(`translate3d(0,0,0) scaleX(${i}) scaleY(${a})`)
                  .transition(e.params.speed);
            }
            "custom" === n.type && n.renderCustom
              ? (c.html(n.renderCustom(e, d + 1, u)), r("paginationRender", c[0]))
              : r("paginationUpdate", c[0]),
              e.params.watchOverflow && e.enabled && c[e.isLocked ? "addClass" : "removeClass"](n.lockClass);
          }
          function d() {
            const t = e.params.pagination;
            if (o()) return;
            const n = e.virtual && e.params.virtual.enabled ? e.virtual.slides.length : e.slides.length,
              i = e.pagination.$el;
            let a = "";
            if ("bullets" === t.type) {
              let r = e.params.loop ? Math.ceil((n - 2 * e.loopedSlides) / e.params.slidesPerGroup) : e.snapGrid.length;
              e.params.freeMode && e.params.freeMode.enabled && !e.params.loop && r > n && (r = n);
              for (let n = 0; n < r; n += 1)
                t.renderBullet
                  ? (a += t.renderBullet.call(e, n, t.bulletClass))
                  : (a += `<${t.bulletElement} class="${t.bulletClass}"></${t.bulletElement}>`);
              i.html(a), (e.pagination.bullets = i.find(He(t.bulletClass)));
            }
            "fraction" === t.type &&
              ((a = t.renderFraction
                ? t.renderFraction.call(e, t.currentClass, t.totalClass)
                : `<span class="${t.currentClass}"></span> / <span class="${t.totalClass}"></span>`),
                i.html(a)),
              "progressbar" === t.type &&
              ((a = t.renderProgressbar
                ? t.renderProgressbar.call(e, t.progressbarFillClass)
                : `<span class="${t.progressbarFillClass}"></span>`),
                i.html(a)),
              "custom" !== t.type && r("paginationRender", e.pagination.$el[0]);
          }
          function u() {
            e.params.pagination = _e(e, e.originalParams.pagination, e.params.pagination, { el: "swiper-pagination" });
            const t = e.params.pagination;
            if (!t.el) return;
            let n = ne(t.el);
            0 !== n.length &&
              (e.params.uniqueNavElements &&
                "string" == typeof t.el &&
                n.length > 1 &&
                ((n = e.$el.find(t.el)), n.length > 1 && (n = n.filter((t) => ne(t).parents(".swiper")[0] === e.el))),
                "bullets" === t.type && t.clickable && n.addClass(t.clickableClass),
                n.addClass(t.modifierClass + t.type),
                n.addClass(t.modifierClass + e.params.direction),
                "bullets" === t.type &&
                t.dynamicBullets &&
                (n.addClass(`${t.modifierClass}${t.type}-dynamic`),
                  (s = 0),
                  t.dynamicMainBullets < 1 && (t.dynamicMainBullets = 1)),
                "progressbar" === t.type && t.progressbarOpposite && n.addClass(t.progressbarOppositeClass),
                t.clickable &&
                n.on("click", He(t.bulletClass), function (t) {
                  t.preventDefault();
                  let n = ne(this).index() * e.params.slidesPerGroup;
                  e.params.loop && (n += e.loopedSlides), e.slideTo(n);
                }),
                Object.assign(e.pagination, { $el: n, el: n[0] }),
                e.enabled || n.addClass(t.lockClass));
          }
          function p() {
            const t = e.params.pagination;
            if (o()) return;
            const n = e.pagination.$el;
            n.removeClass(t.hiddenClass),
              n.removeClass(t.modifierClass + t.type),
              n.removeClass(t.modifierClass + e.params.direction),
              e.pagination.bullets &&
              e.pagination.bullets.removeClass &&
              e.pagination.bullets.removeClass(t.bulletActiveClass),
              t.clickable && n.off("click", He(t.bulletClass));
          }
          n("init", () => {
            u(), d(), c();
          }),
            n("activeIndexChange", () => {
              (e.params.loop || void 0 === e.snapIndex) && c();
            }),
            n("snapIndexChange", () => {
              e.params.loop || c();
            }),
            n("slidesLengthChange", () => {
              e.params.loop && (d(), c());
            }),
            n("snapGridLengthChange", () => {
              e.params.loop || (d(), c());
            }),
            n("destroy", () => {
              p();
            }),
            n("enable disable", () => {
              const { $el: t } = e.pagination;
              t && t[e.enabled ? "removeClass" : "addClass"](e.params.pagination.lockClass);
            }),
            n("lock unlock", () => {
              c();
            }),
            n("click", (t, n) => {
              const i = n.target,
                { $el: a } = e.pagination;
              if (
                e.params.pagination.el &&
                e.params.pagination.hideOnClick &&
                a.length > 0 &&
                !ne(i).hasClass(e.params.pagination.bulletClass)
              ) {
                if (
                  e.navigation &&
                  ((e.navigation.nextEl && i === e.navigation.nextEl) ||
                    (e.navigation.prevEl && i === e.navigation.prevEl))
                )
                  return;
                const t = a.hasClass(e.params.pagination.hiddenClass);
                r(!0 === t ? "paginationShow" : "paginationHide"), a.toggleClass(e.params.pagination.hiddenClass);
              }
            }),
            Object.assign(e.pagination, { render: d, update: c, init: u, destroy: p });
        },
        function ({ swiper: e, extendParams: t, on: n, emit: r }) {
          const i = X();
          let a,
            s,
            o,
            l,
            c = !1,
            d = null,
            u = null;
          function p() {
            if (!e.params.scrollbar.el || !e.scrollbar.el) return;
            const { scrollbar: t, rtlTranslate: n, progress: r } = e,
              { $dragEl: i, $el: a } = t,
              l = e.params.scrollbar;
            let c = s,
              u = (o - s) * r;
            n
              ? ((u = -u), u > 0 ? ((c = s - u), (u = 0)) : -u + s > o && (c = o + u))
              : u < 0
                ? ((c = s + u), (u = 0))
                : u + s > o && (c = o - u),
              e.isHorizontal()
                ? (i.transform(`translate3d(${u}px, 0, 0)`), (i[0].style.width = `${c}px`))
                : (i.transform(`translate3d(0px, ${u}px, 0)`), (i[0].style.height = `${c}px`)),
              l.hide &&
              (clearTimeout(d),
                (a[0].style.opacity = 1),
                (d = setTimeout(() => {
                  (a[0].style.opacity = 0), a.transition(400);
                }, 1e3)));
          }
          function f() {
            if (!e.params.scrollbar.el || !e.scrollbar.el) return;
            const { scrollbar: t } = e,
              { $dragEl: n, $el: r } = t;
            (n[0].style.width = ""),
              (n[0].style.height = ""),
              (o = e.isHorizontal() ? r[0].offsetWidth : r[0].offsetHeight),
              (l =
                e.size / (e.virtualSize + e.params.slidesOffsetBefore - (e.params.centeredSlides ? e.snapGrid[0] : 0))),
              (s = "auto" === e.params.scrollbar.dragSize ? o * l : parseInt(e.params.scrollbar.dragSize, 10)),
              e.isHorizontal() ? (n[0].style.width = `${s}px`) : (n[0].style.height = `${s}px`),
              (r[0].style.display = l >= 1 ? "none" : ""),
              e.params.scrollbar.hide && (r[0].style.opacity = 0),
              e.params.watchOverflow &&
              e.enabled &&
              t.$el[e.isLocked ? "addClass" : "removeClass"](e.params.scrollbar.lockClass);
          }
          function h(t) {
            return e.isHorizontal()
              ? "touchstart" === t.type || "touchmove" === t.type
                ? t.targetTouches[0].clientX
                : t.clientX
              : "touchstart" === t.type || "touchmove" === t.type
                ? t.targetTouches[0].clientY
                : t.clientY;
          }
          function m(t) {
            const { scrollbar: n, rtlTranslate: r } = e,
              { $el: i } = n;
            let l;
            (l = (h(t) - i.offset()[e.isHorizontal() ? "left" : "top"] - (null !== a ? a : s / 2)) / (o - s)),
              (l = Math.max(Math.min(l, 1), 0)),
              r && (l = 1 - l);
            const c = e.minTranslate() + (e.maxTranslate() - e.minTranslate()) * l;
            e.updateProgress(c), e.setTranslate(c), e.updateActiveIndex(), e.updateSlidesClasses();
          }
          function g(t) {
            const n = e.params.scrollbar,
              { scrollbar: i, $wrapperEl: s } = e,
              { $el: o, $dragEl: l } = i;
            (c = !0),
              (a =
                t.target === l[0] || t.target === l
                  ? h(t) - t.target.getBoundingClientRect()[e.isHorizontal() ? "left" : "top"]
                  : null),
              t.preventDefault(),
              t.stopPropagation(),
              s.transition(100),
              l.transition(100),
              m(t),
              clearTimeout(u),
              o.transition(0),
              n.hide && o.css("opacity", 1),
              e.params.cssMode && e.$wrapperEl.css("scroll-snap-type", "none"),
              r("scrollbarDragStart", t);
          }
          function v(t) {
            const { scrollbar: n, $wrapperEl: i } = e,
              { $el: a, $dragEl: s } = n;
            c &&
              (t.preventDefault ? t.preventDefault() : (t.returnValue = !1),
                m(t),
                i.transition(0),
                a.transition(0),
                s.transition(0),
                r("scrollbarDragMove", t));
          }
          function y(t) {
            const n = e.params.scrollbar,
              { scrollbar: i, $wrapperEl: a } = e,
              { $el: s } = i;
            c &&
              ((c = !1),
                e.params.cssMode && (e.$wrapperEl.css("scroll-snap-type", ""), a.transition("")),
                n.hide &&
                (clearTimeout(u),
                  (u = re(() => {
                    s.css("opacity", 0), s.transition(400);
                  }, 1e3))),
                r("scrollbarDragEnd", t),
                n.snapOnRelease && e.slideToClosest());
          }
          function b(t) {
            const { scrollbar: n, touchEventsTouch: r, touchEventsDesktop: a, params: s, support: o } = e,
              l = n.$el[0],
              c = !(!o.passiveListener || !s.passiveListeners) && { passive: !1, capture: !1 },
              d = !(!o.passiveListener || !s.passiveListeners) && { passive: !0, capture: !1 };
            if (!l) return;
            const u = "on" === t ? "addEventListener" : "removeEventListener";
            o.touch
              ? (l[u](r.start, g, c), l[u](r.move, v, c), l[u](r.end, y, d))
              : (l[u](a.start, g, c), i[u](a.move, v, c), i[u](a.end, y, d));
          }
          function w() {
            const { scrollbar: t, $el: n } = e;
            e.params.scrollbar = _e(e, e.originalParams.scrollbar, e.params.scrollbar, { el: "swiper-scrollbar" });
            const r = e.params.scrollbar;
            if (!r.el) return;
            let i = ne(r.el);
            e.params.uniqueNavElements &&
              "string" == typeof r.el &&
              i.length > 1 &&
              1 === n.find(r.el).length &&
              (i = n.find(r.el));
            let a = i.find(`.${e.params.scrollbar.dragClass}`);
            0 === a.length && ((a = ne(`<div class="${e.params.scrollbar.dragClass}"></div>`)), i.append(a)),
              Object.assign(t, { $el: i, el: i[0], $dragEl: a, dragEl: a[0] }),
              r.draggable && e.params.scrollbar.el && b("on"),
              i && i[e.enabled ? "removeClass" : "addClass"](e.params.scrollbar.lockClass);
          }
          function x() {
            e.params.scrollbar.el && b("off");
          }
          t({
            scrollbar: {
              el: null,
              dragSize: "auto",
              hide: !1,
              draggable: !1,
              snapOnRelease: !0,
              lockClass: "swiper-scrollbar-lock",
              dragClass: "swiper-scrollbar-drag",
            },
          }),
            (e.scrollbar = { el: null, dragEl: null, $el: null, $dragEl: null }),
            n("init", () => {
              w(), f(), p();
            }),
            n("update resize observerUpdate lock unlock", () => {
              f();
            }),
            n("setTranslate", () => {
              p();
            }),
            n("setTransition", (t, n) => {
              !(function (t) {
                e.params.scrollbar.el && e.scrollbar.el && e.scrollbar.$dragEl.transition(t);
              })(n);
            }),
            n("enable disable", () => {
              const { $el: t } = e.scrollbar;
              t && t[e.enabled ? "removeClass" : "addClass"](e.params.scrollbar.lockClass);
            }),
            n("destroy", () => {
              x();
            }),
            Object.assign(e.scrollbar, { updateSize: f, setTranslate: p, init: w, destroy: x });
        },
        function ({ swiper: e, extendParams: t, on: n }) {
          t({ parallax: { enabled: !1 } });
          const r = (t, n) => {
            const { rtl: r } = e,
              i = ne(t),
              a = r ? -1 : 1,
              s = i.attr("data-swiper-parallax") || "0";
            let o = i.attr("data-swiper-parallax-x"),
              l = i.attr("data-swiper-parallax-y");
            const c = i.attr("data-swiper-parallax-scale"),
              d = i.attr("data-swiper-parallax-opacity");
            if (
              (o || l
                ? ((o = o || "0"), (l = l || "0"))
                : e.isHorizontal()
                  ? ((o = s), (l = "0"))
                  : ((l = s), (o = "0")),
                (o = o.indexOf("%") >= 0 ? parseInt(o, 10) * n * a + "%" : o * n * a + "px"),
                (l = l.indexOf("%") >= 0 ? parseInt(l, 10) * n + "%" : l * n + "px"),
                null != d)
            ) {
              const e = d - (d - 1) * (1 - Math.abs(n));
              i[0].style.opacity = e;
            }
            if (null == c) i.transform(`translate3d(${o}, ${l}, 0px)`);
            else {
              const e = c - (c - 1) * (1 - Math.abs(n));
              i.transform(`translate3d(${o}, ${l}, 0px) scale(${e})`);
            }
          },
            i = () => {
              const { $el: t, slides: n, progress: i, snapGrid: a } = e;
              t
                .children(
                  "[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]"
                )
                .each((e) => {
                  r(e, i);
                }),
                n.each((t, n) => {
                  let s = t.progress;
                  e.params.slidesPerGroup > 1 &&
                    "auto" !== e.params.slidesPerView &&
                    (s += Math.ceil(n / 2) - i * (a.length - 1)),
                    (s = Math.min(Math.max(s, -1), 1)),
                    ne(t)
                      .find(
                        "[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]"
                      )
                      .each((e) => {
                        r(e, s);
                      });
                });
            };
          n("beforeInit", () => {
            e.params.parallax.enabled &&
              ((e.params.watchSlidesProgress = !0), (e.originalParams.watchSlidesProgress = !0));
          }),
            n("init", () => {
              e.params.parallax.enabled && i();
            }),
            n("setTranslate", () => {
              e.params.parallax.enabled && i();
            }),
            n("setTransition", (t, n) => {
              e.params.parallax.enabled &&
                ((t = e.params.speed) => {
                  const { $el: n } = e;
                  n.find(
                    "[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]"
                  ).each((e) => {
                    const n = ne(e);
                    let r = parseInt(n.attr("data-swiper-parallax-duration"), 10) || t;
                    0 === t && (r = 0), n.transition(r);
                  });
                })(n);
            });
        },
        function ({ swiper: e, extendParams: t, on: n, emit: r }) {
          const i = V();
          t({
            zoom: {
              enabled: !1,
              maxRatio: 3,
              minRatio: 1,
              toggle: !0,
              containerClass: "swiper-zoom-container",
              zoomedSlideClass: "swiper-slide-zoomed",
            },
          }),
            (e.zoom = { enabled: !1 });
          let a,
            s,
            o,
            l = 1,
            c = !1;
          const d = {
            $slideEl: void 0,
            slideWidth: void 0,
            slideHeight: void 0,
            $imageEl: void 0,
            $imageWrapEl: void 0,
            maxRatio: 3,
          },
            u = {
              isTouched: void 0,
              isMoved: void 0,
              currentX: void 0,
              currentY: void 0,
              minX: void 0,
              minY: void 0,
              maxX: void 0,
              maxY: void 0,
              width: void 0,
              height: void 0,
              startX: void 0,
              startY: void 0,
              touchesStart: {},
              touchesCurrent: {},
            },
            p = { x: void 0, y: void 0, prevPositionX: void 0, prevPositionY: void 0, prevTime: void 0 };
          let f = 1;
          function h(e) {
            if (e.targetTouches.length < 2) return 1;
            const t = e.targetTouches[0].pageX,
              n = e.targetTouches[0].pageY,
              r = e.targetTouches[1].pageX,
              i = e.targetTouches[1].pageY;
            return Math.sqrt((r - t) ** 2 + (i - n) ** 2);
          }
          function m(t) {
            const n = e.support,
              r = e.params.zoom;
            if (((s = !1), (o = !1), !n.gestures)) {
              if ("touchstart" !== t.type || ("touchstart" === t.type && t.targetTouches.length < 2)) return;
              (s = !0), (d.scaleStart = h(t));
            }
            (d.$slideEl && d.$slideEl.length) ||
              ((d.$slideEl = ne(t.target).closest(`.${e.params.slideClass}`)),
                0 === d.$slideEl.length && (d.$slideEl = e.slides.eq(e.activeIndex)),
                (d.$imageEl = d.$slideEl
                  .find(`.${r.containerClass}`)
                  .eq(0)
                  .find("picture, img, svg, canvas, .swiper-zoom-target")
                  .eq(0)),
                (d.$imageWrapEl = d.$imageEl.parent(`.${r.containerClass}`)),
                (d.maxRatio = d.$imageWrapEl.attr("data-swiper-zoom") || r.maxRatio),
                0 !== d.$imageWrapEl.length)
              ? (d.$imageEl && d.$imageEl.transition(0), (c = !0))
              : (d.$imageEl = void 0);
          }
          function g(t) {
            const n = e.support,
              r = e.params.zoom,
              i = e.zoom;
            if (!n.gestures) {
              if ("touchmove" !== t.type || ("touchmove" === t.type && t.targetTouches.length < 2)) return;
              (o = !0), (d.scaleMove = h(t));
            }
            d.$imageEl && 0 !== d.$imageEl.length
              ? (n.gestures ? (i.scale = t.scale * l) : (i.scale = (d.scaleMove / d.scaleStart) * l),
                i.scale > d.maxRatio && (i.scale = d.maxRatio - 1 + (i.scale - d.maxRatio + 1) ** 0.5),
                i.scale < r.minRatio && (i.scale = r.minRatio + 1 - (r.minRatio - i.scale + 1) ** 0.5),
                d.$imageEl.transform(`translate3d(0,0,0) scale(${i.scale})`))
              : "gesturechange" === t.type && m(t);
          }
          function v(t) {
            const n = e.device,
              r = e.support,
              i = e.params.zoom,
              a = e.zoom;
            if (!r.gestures) {
              if (!s || !o) return;
              if ("touchend" !== t.type || ("touchend" === t.type && t.changedTouches.length < 2 && !n.android)) return;
              (s = !1), (o = !1);
            }
            d.$imageEl &&
              0 !== d.$imageEl.length &&
              ((a.scale = Math.max(Math.min(a.scale, d.maxRatio), i.minRatio)),
                d.$imageEl.transition(e.params.speed).transform(`translate3d(0,0,0) scale(${a.scale})`),
                (l = a.scale),
                (c = !1),
                1 === a.scale && (d.$slideEl = void 0));
          }
          function y(t) {
            const n = e.zoom;
            if (!d.$imageEl || 0 === d.$imageEl.length) return;
            if (((e.allowClick = !1), !u.isTouched || !d.$slideEl)) return;
            u.isMoved ||
              ((u.width = d.$imageEl[0].offsetWidth),
                (u.height = d.$imageEl[0].offsetHeight),
                (u.startX = ae(d.$imageWrapEl[0], "x") || 0),
                (u.startY = ae(d.$imageWrapEl[0], "y") || 0),
                (d.slideWidth = d.$slideEl[0].offsetWidth),
                (d.slideHeight = d.$slideEl[0].offsetHeight),
                d.$imageWrapEl.transition(0));
            const r = u.width * n.scale,
              i = u.height * n.scale;
            if (!(r < d.slideWidth && i < d.slideHeight)) {
              if (
                ((u.minX = Math.min(d.slideWidth / 2 - r / 2, 0)),
                  (u.maxX = -u.minX),
                  (u.minY = Math.min(d.slideHeight / 2 - i / 2, 0)),
                  (u.maxY = -u.minY),
                  (u.touchesCurrent.x = "touchmove" === t.type ? t.targetTouches[0].pageX : t.pageX),
                  (u.touchesCurrent.y = "touchmove" === t.type ? t.targetTouches[0].pageY : t.pageY),
                  !u.isMoved && !c)
              ) {
                if (
                  e.isHorizontal() &&
                  ((Math.floor(u.minX) === Math.floor(u.startX) && u.touchesCurrent.x < u.touchesStart.x) ||
                    (Math.floor(u.maxX) === Math.floor(u.startX) && u.touchesCurrent.x > u.touchesStart.x))
                )
                  return void (u.isTouched = !1);
                if (
                  !e.isHorizontal() &&
                  ((Math.floor(u.minY) === Math.floor(u.startY) && u.touchesCurrent.y < u.touchesStart.y) ||
                    (Math.floor(u.maxY) === Math.floor(u.startY) && u.touchesCurrent.y > u.touchesStart.y))
                )
                  return void (u.isTouched = !1);
              }
              t.cancelable && t.preventDefault(),
                t.stopPropagation(),
                (u.isMoved = !0),
                (u.currentX = u.touchesCurrent.x - u.touchesStart.x + u.startX),
                (u.currentY = u.touchesCurrent.y - u.touchesStart.y + u.startY),
                u.currentX < u.minX && (u.currentX = u.minX + 1 - (u.minX - u.currentX + 1) ** 0.8),
                u.currentX > u.maxX && (u.currentX = u.maxX - 1 + (u.currentX - u.maxX + 1) ** 0.8),
                u.currentY < u.minY && (u.currentY = u.minY + 1 - (u.minY - u.currentY + 1) ** 0.8),
                u.currentY > u.maxY && (u.currentY = u.maxY - 1 + (u.currentY - u.maxY + 1) ** 0.8),
                p.prevPositionX || (p.prevPositionX = u.touchesCurrent.x),
                p.prevPositionY || (p.prevPositionY = u.touchesCurrent.y),
                p.prevTime || (p.prevTime = Date.now()),
                (p.x = (u.touchesCurrent.x - p.prevPositionX) / (Date.now() - p.prevTime) / 2),
                (p.y = (u.touchesCurrent.y - p.prevPositionY) / (Date.now() - p.prevTime) / 2),
                Math.abs(u.touchesCurrent.x - p.prevPositionX) < 2 && (p.x = 0),
                Math.abs(u.touchesCurrent.y - p.prevPositionY) < 2 && (p.y = 0),
                (p.prevPositionX = u.touchesCurrent.x),
                (p.prevPositionY = u.touchesCurrent.y),
                (p.prevTime = Date.now()),
                d.$imageWrapEl.transform(`translate3d(${u.currentX}px, ${u.currentY}px,0)`);
            }
          }
          function b() {
            const t = e.zoom;
            d.$slideEl &&
              e.previousIndex !== e.activeIndex &&
              (d.$imageEl && d.$imageEl.transform("translate3d(0,0,0) scale(1)"),
                d.$imageWrapEl && d.$imageWrapEl.transform("translate3d(0,0,0)"),
                (t.scale = 1),
                (l = 1),
                (d.$slideEl = void 0),
                (d.$imageEl = void 0),
                (d.$imageWrapEl = void 0));
          }
          function w(t) {
            const n = e.zoom,
              r = e.params.zoom;
            if (
              (d.$slideEl ||
                (t && t.target && (d.$slideEl = ne(t.target).closest(`.${e.params.slideClass}`)),
                  d.$slideEl ||
                  (e.params.virtual && e.params.virtual.enabled && e.virtual
                    ? (d.$slideEl = e.$wrapperEl.children(`.${e.params.slideActiveClass}`))
                    : (d.$slideEl = e.slides.eq(e.activeIndex))),
                  (d.$imageEl = d.$slideEl
                    .find(`.${r.containerClass}`)
                    .eq(0)
                    .find("picture, img, svg, canvas, .swiper-zoom-target")
                    .eq(0)),
                  (d.$imageWrapEl = d.$imageEl.parent(`.${r.containerClass}`))),
                !d.$imageEl || 0 === d.$imageEl.length || !d.$imageWrapEl || 0 === d.$imageWrapEl.length)
            )
              return;
            let a, s, o, c, p, f, h, m, g, v, y, b, w, x, C, E, T, S;
            e.params.cssMode && ((e.wrapperEl.style.overflow = "hidden"), (e.wrapperEl.style.touchAction = "none")),
              d.$slideEl.addClass(`${r.zoomedSlideClass}`),
              void 0 === u.touchesStart.x && t
                ? ((a = "touchend" === t.type ? t.changedTouches[0].pageX : t.pageX),
                  (s = "touchend" === t.type ? t.changedTouches[0].pageY : t.pageY))
                : ((a = u.touchesStart.x), (s = u.touchesStart.y)),
              (n.scale = d.$imageWrapEl.attr("data-swiper-zoom") || r.maxRatio),
              (l = d.$imageWrapEl.attr("data-swiper-zoom") || r.maxRatio),
              t
                ? ((T = d.$slideEl[0].offsetWidth),
                  (S = d.$slideEl[0].offsetHeight),
                  (o = d.$slideEl.offset().left + i.scrollX),
                  (c = d.$slideEl.offset().top + i.scrollY),
                  (p = o + T / 2 - a),
                  (f = c + S / 2 - s),
                  (g = d.$imageEl[0].offsetWidth),
                  (v = d.$imageEl[0].offsetHeight),
                  (y = g * n.scale),
                  (b = v * n.scale),
                  (w = Math.min(T / 2 - y / 2, 0)),
                  (x = Math.min(S / 2 - b / 2, 0)),
                  (C = -w),
                  (E = -x),
                  (h = p * n.scale),
                  (m = f * n.scale),
                  h < w && (h = w),
                  h > C && (h = C),
                  m < x && (m = x),
                  m > E && (m = E))
                : ((h = 0), (m = 0)),
              d.$imageWrapEl.transition(300).transform(`translate3d(${h}px, ${m}px,0)`),
              d.$imageEl.transition(300).transform(`translate3d(0,0,0) scale(${n.scale})`);
          }
          function x() {
            const t = e.zoom,
              n = e.params.zoom;
            d.$slideEl ||
              (e.params.virtual && e.params.virtual.enabled && e.virtual
                ? (d.$slideEl = e.$wrapperEl.children(`.${e.params.slideActiveClass}`))
                : (d.$slideEl = e.slides.eq(e.activeIndex)),
                (d.$imageEl = d.$slideEl
                  .find(`.${n.containerClass}`)
                  .eq(0)
                  .find("picture, img, svg, canvas, .swiper-zoom-target")
                  .eq(0)),
                (d.$imageWrapEl = d.$imageEl.parent(`.${n.containerClass}`))),
              d.$imageEl &&
              0 !== d.$imageEl.length &&
              d.$imageWrapEl &&
              0 !== d.$imageWrapEl.length &&
              (e.params.cssMode && ((e.wrapperEl.style.overflow = ""), (e.wrapperEl.style.touchAction = "")),
                (t.scale = 1),
                (l = 1),
                d.$imageWrapEl.transition(300).transform("translate3d(0,0,0)"),
                d.$imageEl.transition(300).transform("translate3d(0,0,0) scale(1)"),
                d.$slideEl.removeClass(`${n.zoomedSlideClass}`),
                (d.$slideEl = void 0));
          }
          function C(t) {
            const n = e.zoom;
            n.scale && 1 !== n.scale ? x() : w(t);
          }
          function E() {
            const t = e.support;
            return {
              passiveListener: !(
                "touchstart" !== e.touchEvents.start ||
                !t.passiveListener ||
                !e.params.passiveListeners
              ) && { passive: !0, capture: !1 },
              activeListenerWithCapture: !t.passiveListener || { passive: !1, capture: !0 },
            };
          }
          function T() {
            return `.${e.params.slideClass}`;
          }
          function S(t) {
            const { passiveListener: n } = E(),
              r = T();
            e.$wrapperEl[t]("gesturestart", r, m, n),
              e.$wrapperEl[t]("gesturechange", r, g, n),
              e.$wrapperEl[t]("gestureend", r, v, n);
          }
          function $() {
            a || ((a = !0), S("on"));
          }
          function k() {
            a && ((a = !1), S("off"));
          }
          function M() {
            const t = e.zoom;
            if (t.enabled) return;
            t.enabled = !0;
            const n = e.support,
              { passiveListener: r, activeListenerWithCapture: i } = E(),
              a = T();
            n.gestures
              ? (e.$wrapperEl.on(e.touchEvents.start, $, r), e.$wrapperEl.on(e.touchEvents.end, k, r))
              : "touchstart" === e.touchEvents.start &&
              (e.$wrapperEl.on(e.touchEvents.start, a, m, r),
                e.$wrapperEl.on(e.touchEvents.move, a, g, i),
                e.$wrapperEl.on(e.touchEvents.end, a, v, r),
                e.touchEvents.cancel && e.$wrapperEl.on(e.touchEvents.cancel, a, v, r)),
              e.$wrapperEl.on(e.touchEvents.move, `.${e.params.zoom.containerClass}`, y, i);
          }
          function P() {
            const t = e.zoom;
            if (!t.enabled) return;
            const n = e.support;
            t.enabled = !1;
            const { passiveListener: r, activeListenerWithCapture: i } = E(),
              a = T();
            n.gestures
              ? (e.$wrapperEl.off(e.touchEvents.start, $, r), e.$wrapperEl.off(e.touchEvents.end, k, r))
              : "touchstart" === e.touchEvents.start &&
              (e.$wrapperEl.off(e.touchEvents.start, a, m, r),
                e.$wrapperEl.off(e.touchEvents.move, a, g, i),
                e.$wrapperEl.off(e.touchEvents.end, a, v, r),
                e.touchEvents.cancel && e.$wrapperEl.off(e.touchEvents.cancel, a, v, r)),
              e.$wrapperEl.off(e.touchEvents.move, `.${e.params.zoom.containerClass}`, y, i);
          }
          Object.defineProperty(e.zoom, "scale", {
            get: () => f,
            set(e) {
              if (f !== e) {
                const t = d.$imageEl ? d.$imageEl[0] : void 0,
                  n = d.$slideEl ? d.$slideEl[0] : void 0;
                r("zoomChange", e, t, n);
              }
              f = e;
            },
          }),
            n("init", () => {
              e.params.zoom.enabled && M();
            }),
            n("destroy", () => {
              P();
            }),
            n("touchStart", (t, n) => {
              e.zoom.enabled &&
                (function (t) {
                  const n = e.device;
                  d.$imageEl &&
                    0 !== d.$imageEl.length &&
                    (u.isTouched ||
                      (n.android && t.cancelable && t.preventDefault(),
                        (u.isTouched = !0),
                        (u.touchesStart.x = "touchstart" === t.type ? t.targetTouches[0].pageX : t.pageX),
                        (u.touchesStart.y = "touchstart" === t.type ? t.targetTouches[0].pageY : t.pageY)));
                })(n);
            }),
            n("touchEnd", (t, n) => {
              e.zoom.enabled &&
                (function () {
                  const t = e.zoom;
                  if (!d.$imageEl || 0 === d.$imageEl.length) return;
                  if (!u.isTouched || !u.isMoved) return (u.isTouched = !1), void (u.isMoved = !1);
                  (u.isTouched = !1), (u.isMoved = !1);
                  let n = 300,
                    r = 300;
                  const i = p.x * n,
                    a = u.currentX + i,
                    s = p.y * r,
                    o = u.currentY + s;
                  0 !== p.x && (n = Math.abs((a - u.currentX) / p.x)),
                    0 !== p.y && (r = Math.abs((o - u.currentY) / p.y));
                  const l = Math.max(n, r);
                  (u.currentX = a), (u.currentY = o);
                  const c = u.width * t.scale,
                    f = u.height * t.scale;
                  (u.minX = Math.min(d.slideWidth / 2 - c / 2, 0)),
                    (u.maxX = -u.minX),
                    (u.minY = Math.min(d.slideHeight / 2 - f / 2, 0)),
                    (u.maxY = -u.minY),
                    (u.currentX = Math.max(Math.min(u.currentX, u.maxX), u.minX)),
                    (u.currentY = Math.max(Math.min(u.currentY, u.maxY), u.minY)),
                    d.$imageWrapEl.transition(l).transform(`translate3d(${u.currentX}px, ${u.currentY}px,0)`);
                })();
            }),
            n("doubleTap", (t, n) => {
              !e.animating && e.params.zoom.enabled && e.zoom.enabled && e.params.zoom.toggle && C(n);
            }),
            n("transitionEnd", () => {
              e.zoom.enabled && e.params.zoom.enabled && b();
            }),
            n("slideChange", () => {
              e.zoom.enabled && e.params.zoom.enabled && e.params.cssMode && b();
            }),
            Object.assign(e.zoom, { enable: M, disable: P, in: w, out: x, toggle: C });
        },
        function ({ swiper: e, extendParams: t, on: n, emit: r }) {
          t({
            lazy: {
              checkInView: !1,
              enabled: !1,
              loadPrevNext: !1,
              loadPrevNextAmount: 1,
              loadOnTransitionStart: !1,
              scrollingElement: "",
              elementClass: "swiper-lazy",
              loadingClass: "swiper-lazy-loading",
              loadedClass: "swiper-lazy-loaded",
              preloaderClass: "swiper-lazy-preloader",
            },
          }),
            (e.lazy = {});
          let i = !1,
            a = !1;
          function s(t, n = !0) {
            const i = e.params.lazy;
            if (void 0 === t) return;
            if (0 === e.slides.length) return;
            const a =
              e.virtual && e.params.virtual.enabled
                ? e.$wrapperEl.children(`.${e.params.slideClass}[data-swiper-slide-index="${t}"]`)
                : e.slides.eq(t),
              o = a.find(`.${i.elementClass}:not(.${i.loadedClass}):not(.${i.loadingClass})`);
            !a.hasClass(i.elementClass) || a.hasClass(i.loadedClass) || a.hasClass(i.loadingClass) || o.push(a[0]),
              0 !== o.length &&
              o.each((t) => {
                const o = ne(t);
                o.addClass(i.loadingClass);
                const l = o.attr("data-background"),
                  c = o.attr("data-src"),
                  d = o.attr("data-srcset"),
                  u = o.attr("data-sizes"),
                  p = o.parent("picture");
                e.loadImage(o[0], c || l, d, u, !1, () => {
                  if (null != e && e && (!e || e.params) && !e.destroyed) {
                    if (
                      (l
                        ? (o.css("background-image", `url("${l}")`), o.removeAttr("data-background"))
                        : (d && (o.attr("srcset", d), o.removeAttr("data-srcset")),
                          u && (o.attr("sizes", u), o.removeAttr("data-sizes")),
                          p.length &&
                          p.children("source").each((e) => {
                            const t = ne(e);
                            t.attr("data-srcset") &&
                              (t.attr("srcset", t.attr("data-srcset")), t.removeAttr("data-srcset"));
                          }),
                          c && (o.attr("src", c), o.removeAttr("data-src"))),
                        o.addClass(i.loadedClass).removeClass(i.loadingClass),
                        a.find(`.${i.preloaderClass}`).remove(),
                        e.params.loop && n)
                    ) {
                      const t = a.attr("data-swiper-slide-index");
                      a.hasClass(e.params.slideDuplicateClass)
                        ? s(
                          e.$wrapperEl
                            .children(`[data-swiper-slide-index="${t}"]:not(.${e.params.slideDuplicateClass})`)
                            .index(),
                          !1
                        )
                        : s(
                          e.$wrapperEl
                            .children(`.${e.params.slideDuplicateClass}[data-swiper-slide-index="${t}"]`)
                            .index(),
                          !1
                        );
                    }
                    r("lazyImageReady", a[0], o[0]), e.params.autoHeight && e.updateAutoHeight();
                  }
                }),
                  r("lazyImageLoad", a[0], o[0]);
              });
          }
          function o() {
            const { $wrapperEl: t, params: n, slides: r, activeIndex: i } = e,
              o = e.virtual && n.virtual.enabled,
              l = n.lazy;
            let c = n.slidesPerView;
            function d(e) {
              if (o) {
                if (t.children(`.${n.slideClass}[data-swiper-slide-index="${e}"]`).length) return !0;
              } else if (r[e]) return !0;
              return !1;
            }
            function u(e) {
              return o ? ne(e).attr("data-swiper-slide-index") : ne(e).index();
            }
            if (("auto" === c && (c = 0), a || (a = !0), e.params.watchSlidesProgress))
              t.children(`.${n.slideVisibleClass}`).each((e) => {
                s(o ? ne(e).attr("data-swiper-slide-index") : ne(e).index());
              });
            else if (c > 1) for (let e = i; e < i + c; e += 1) d(e) && s(e);
            else s(i);
            if (l.loadPrevNext)
              if (c > 1 || (l.loadPrevNextAmount && l.loadPrevNextAmount > 1)) {
                const e = l.loadPrevNextAmount,
                  t = c,
                  n = Math.min(i + t + Math.max(e, t), r.length),
                  a = Math.max(i - Math.max(t, e), 0);
                for (let e = i + c; e < n; e += 1) d(e) && s(e);
                for (let e = a; e < i; e += 1) d(e) && s(e);
              } else {
                const e = t.children(`.${n.slideNextClass}`);
                e.length > 0 && s(u(e));
                const r = t.children(`.${n.slidePrevClass}`);
                r.length > 0 && s(u(r));
              }
          }
          function l() {
            const t = V();
            if (!e || e.destroyed) return;
            const n = e.params.lazy.scrollingElement ? ne(e.params.lazy.scrollingElement) : ne(t),
              r = n[0] === t,
              a = r ? t.innerWidth : n[0].offsetWidth,
              s = r ? t.innerHeight : n[0].offsetHeight,
              c = e.$el.offset(),
              { rtlTranslate: d } = e;
            let u = !1;
            d && (c.left -= e.$el[0].scrollLeft);
            const p = [
              [c.left, c.top],
              [c.left + e.width, c.top],
              [c.left, c.top + e.height],
              [c.left + e.width, c.top + e.height],
            ];
            for (let e = 0; e < p.length; e += 1) {
              const t = p[e];
              if (t[0] >= 0 && t[0] <= a && t[1] >= 0 && t[1] <= s) {
                if (0 === t[0] && 0 === t[1]) continue;
                u = !0;
              }
            }
            const f = !(
              "touchstart" !== e.touchEvents.start ||
              !e.support.passiveListener ||
              !e.params.passiveListeners
            ) && { passive: !0, capture: !1 };
            u ? (o(), n.off("scroll", l, f)) : i || ((i = !0), n.on("scroll", l, f));
          }
          n("beforeInit", () => {
            e.params.lazy.enabled && e.params.preloadImages && (e.params.preloadImages = !1);
          }),
            n("init", () => {
              e.params.lazy.enabled && (e.params.lazy.checkInView ? l() : o());
            }),
            n("scroll", () => {
              e.params.freeMode && e.params.freeMode.enabled && !e.params.freeMode.sticky && o();
            }),
            n("scrollbarDragMove resize _freeModeNoMomentumRelease", () => {
              e.params.lazy.enabled && (e.params.lazy.checkInView ? l() : o());
            }),
            n("transitionStart", () => {
              e.params.lazy.enabled &&
                (e.params.lazy.loadOnTransitionStart || (!e.params.lazy.loadOnTransitionStart && !a)) &&
                (e.params.lazy.checkInView ? l() : o());
            }),
            n("transitionEnd", () => {
              e.params.lazy.enabled && !e.params.lazy.loadOnTransitionStart && (e.params.lazy.checkInView ? l() : o());
            }),
            n("slideChange", () => {
              const {
                lazy: t,
                cssMode: n,
                watchSlidesProgress: r,
                touchReleaseOnEdges: i,
                resistanceRatio: a,
              } = e.params;
              t.enabled && (n || (r && (i || 0 === a))) && o();
            }),
            Object.assign(e.lazy, { load: o, loadInSlide: s });
        },
        function ({ swiper: e, extendParams: t, on: n }) {
          function r(e, t) {
            const n = (function () {
              let e, t, n;
              return (r, i) => {
                for (t = -1, e = r.length; e - t > 1;) (n = (e + t) >> 1), r[n] <= i ? (t = n) : (e = n);
                return e;
              };
            })();
            let r, i;
            return (
              (this.x = e),
              (this.y = t),
              (this.lastIndex = e.length - 1),
              (this.interpolate = function (e) {
                return e
                  ? ((i = n(this.x, e)),
                    (r = i - 1),
                    ((e - this.x[r]) * (this.y[i] - this.y[r])) / (this.x[i] - this.x[r]) + this.y[r])
                  : 0;
              }),
              this
            );
          }
          function i() {
            e.controller.control && e.controller.spline && ((e.controller.spline = void 0), delete e.controller.spline);
          }
          t({ controller: { control: void 0, inverse: !1, by: "slide" } }),
            (e.controller = { control: void 0 }),
            n("beforeInit", () => {
              e.controller.control = e.params.controller.control;
            }),
            n("update", () => {
              i();
            }),
            n("resize", () => {
              i();
            }),
            n("observerUpdate", () => {
              i();
            }),
            n("setTranslate", (t, n, r) => {
              e.controller.control && e.controller.setTranslate(n, r);
            }),
            n("setTransition", (t, n, r) => {
              e.controller.control && e.controller.setTransition(n, r);
            }),
            Object.assign(e.controller, {
              setTranslate: function (t, n) {
                const i = e.controller.control;
                let a, s;
                const o = e.constructor;
                function l(t) {
                  const n = e.rtlTranslate ? -e.translate : e.translate;
                  "slide" === e.params.controller.by &&
                    ((function (t) {
                      e.controller.spline ||
                        (e.controller.spline = e.params.loop
                          ? new r(e.slidesGrid, t.slidesGrid)
                          : new r(e.snapGrid, t.snapGrid));
                    })(t),
                      (s = -e.controller.spline.interpolate(-n))),
                    (s && "container" !== e.params.controller.by) ||
                    ((a = (t.maxTranslate() - t.minTranslate()) / (e.maxTranslate() - e.minTranslate())),
                      (s = (n - e.minTranslate()) * a + t.minTranslate())),
                    e.params.controller.inverse && (s = t.maxTranslate() - s),
                    t.updateProgress(s),
                    t.setTranslate(s, e),
                    t.updateActiveIndex(),
                    t.updateSlidesClasses();
                }
                if (Array.isArray(i)) for (let e = 0; e < i.length; e += 1) i[e] !== n && i[e] instanceof o && l(i[e]);
                else i instanceof o && n !== i && l(i);
              },
              setTransition: function (t, n) {
                const r = e.constructor,
                  i = e.controller.control;
                let a;
                function s(n) {
                  n.setTransition(t, e),
                    0 !== t &&
                    (n.transitionStart(),
                      n.params.autoHeight &&
                      re(() => {
                        n.updateAutoHeight();
                      }),
                      n.$wrapperEl.transitionEnd(() => {
                        i && (n.params.loop && "slide" === e.params.controller.by && n.loopFix(), n.transitionEnd());
                      }));
                }
                if (Array.isArray(i)) for (a = 0; a < i.length; a += 1) i[a] !== n && i[a] instanceof r && s(i[a]);
                else i instanceof r && n !== i && s(i);
              },
            });
        },
        function ({ swiper: e, extendParams: t, on: n }) {
          t({
            a11y: {
              enabled: !0,
              notificationClass: "swiper-notification",
              prevSlideMessage: "Previous slide",
              nextSlideMessage: "Next slide",
              firstSlideMessage: "This is the first slide",
              lastSlideMessage: "This is the last slide",
              paginationBulletMessage: "Go to slide {{index}}",
              slideLabelMessage: "{{index}} / {{slidesLength}}",
              containerMessage: null,
              containerRoleDescriptionMessage: null,
              itemRoleDescriptionMessage: null,
              slideRole: "group",
            },
          });
          let r = null;
          function i(e) {
            const t = r;
            0 !== t.length && (t.html(""), t.html(e));
          }
          function a(e) {
            e.attr("tabIndex", "0");
          }
          function s(e) {
            e.attr("tabIndex", "-1");
          }
          function o(e, t) {
            e.attr("role", t);
          }
          function l(e, t) {
            e.attr("aria-roledescription", t);
          }
          function c(e, t) {
            e.attr("aria-label", t);
          }
          function d(e) {
            e.attr("aria-disabled", !0);
          }
          function u(e) {
            e.attr("aria-disabled", !1);
          }
          function p(t) {
            if (13 !== t.keyCode && 32 !== t.keyCode) return;
            const n = e.params.a11y,
              r = ne(t.target);
            e.navigation &&
              e.navigation.$nextEl &&
              r.is(e.navigation.$nextEl) &&
              ((e.isEnd && !e.params.loop) || e.slideNext(), e.isEnd ? i(n.lastSlideMessage) : i(n.nextSlideMessage)),
              e.navigation &&
              e.navigation.$prevEl &&
              r.is(e.navigation.$prevEl) &&
              ((e.isBeginning && !e.params.loop) || e.slidePrev(),
                e.isBeginning ? i(n.firstSlideMessage) : i(n.prevSlideMessage)),
              e.pagination && r.is(He(e.params.pagination.bulletClass)) && r[0].click();
          }
          function f() {
            if (e.params.loop || e.params.rewind || !e.navigation) return;
            const { $nextEl: t, $prevEl: n } = e.navigation;
            n && n.length > 0 && (e.isBeginning ? (d(n), s(n)) : (u(n), a(n))),
              t && t.length > 0 && (e.isEnd ? (d(t), s(t)) : (u(t), a(t)));
          }
          function h() {
            return e.pagination && e.pagination.bullets && e.pagination.bullets.length;
          }
          function m() {
            return h() && e.params.pagination.clickable;
          }
          const g = (e, t, n) => {
            a(e),
              "BUTTON" !== e[0].tagName && (o(e, "button"), e.on("keydown", p)),
              c(e, n),
              (function (e, t) {
                e.attr("aria-controls", t);
              })(e, t);
          };
          n("beforeInit", () => {
            r = ne(`<span class="${e.params.a11y.notificationClass}" aria-live="assertive" aria-atomic="true"></span>`);
          }),
            n("afterInit", () => {
              e.params.a11y.enabled &&
                ((function () {
                  const t = e.params.a11y;
                  e.$el.append(r);
                  const n = e.$el;
                  t.containerRoleDescriptionMessage && l(n, t.containerRoleDescriptionMessage),
                    t.containerMessage && c(n, t.containerMessage);
                  const i = e.$wrapperEl,
                    a =
                      i.attr("id") ||
                      `swiper-wrapper-${(function (e = 16) {
                        return "x".repeat(e).replace(/x/g, () => Math.round(16 * Math.random()).toString(16));
                      })(16)}`,
                    s = e.params.autoplay && e.params.autoplay.enabled ? "off" : "polite";
                  var d;
                  (d = a),
                    i.attr("id", d),
                    (function (e, t) {
                      e.attr("aria-live", t);
                    })(i, s),
                    t.itemRoleDescriptionMessage && l(ne(e.slides), t.itemRoleDescriptionMessage),
                    o(ne(e.slides), t.slideRole);
                  const u = e.params.loop
                    ? e.slides.filter((t) => !t.classList.contains(e.params.slideDuplicateClass)).length
                    : e.slides.length;
                  let f, h;
                  e.slides.each((n, r) => {
                    const i = ne(n),
                      a = e.params.loop ? parseInt(i.attr("data-swiper-slide-index"), 10) : r;
                    c(i, t.slideLabelMessage.replace(/\{\{index\}\}/, a + 1).replace(/\{\{slidesLength\}\}/, u));
                  }),
                    e.navigation && e.navigation.$nextEl && (f = e.navigation.$nextEl),
                    e.navigation && e.navigation.$prevEl && (h = e.navigation.$prevEl),
                    f && f.length && g(f, a, t.nextSlideMessage),
                    h && h.length && g(h, a, t.prevSlideMessage),
                    m() && e.pagination.$el.on("keydown", He(e.params.pagination.bulletClass), p);
                })(),
                  f());
            }),
            n("toEdge", () => {
              e.params.a11y.enabled && f();
            }),
            n("fromEdge", () => {
              e.params.a11y.enabled && f();
            }),
            n("paginationUpdate", () => {
              e.params.a11y.enabled &&
                (function () {
                  const t = e.params.a11y;
                  h() &&
                    e.pagination.bullets.each((n) => {
                      const r = ne(n);
                      e.params.pagination.clickable &&
                        (a(r),
                          e.params.pagination.renderBullet ||
                          (o(r, "button"), c(r, t.paginationBulletMessage.replace(/\{\{index\}\}/, r.index() + 1)))),
                        r.is(`.${e.params.pagination.bulletActiveClass}`)
                          ? r.attr("aria-current", "true")
                          : r.removeAttr("aria-current");
                    });
                })();
            }),
            n("destroy", () => {
              e.params.a11y.enabled &&
                (function () {
                  let t, n;
                  r && r.length > 0 && r.remove(),
                    e.navigation && e.navigation.$nextEl && (t = e.navigation.$nextEl),
                    e.navigation && e.navigation.$prevEl && (n = e.navigation.$prevEl),
                    t && t.off("keydown", p),
                    n && n.off("keydown", p),
                    m() && e.pagination.$el.off("keydown", He(e.params.pagination.bulletClass), p);
                })();
            });
        },
        function ({ swiper: e, extendParams: t, on: n }) {
          t({ history: { enabled: !1, root: "", replaceState: !1, key: "slides" } });
          let r = !1,
            i = {};
          const a = (e) =>
            e
              .toString()
              .replace(/\s+/g, "-")
              .replace(/[^\w-]+/g, "")
              .replace(/--+/g, "-")
              .replace(/^-+/, "")
              .replace(/-+$/, ""),
            s = (e) => {
              const t = V();
              let n;
              n = e ? new URL(e) : t.location;
              const r = n.pathname
                .slice(1)
                .split("/")
                .filter((e) => "" !== e),
                i = r.length;
              return { key: r[i - 2], value: r[i - 1] };
            },
            o = (t, n) => {
              const i = V();
              if (!r || !e.params.history.enabled) return;
              let s;
              s = e.params.url ? new URL(e.params.url) : i.location;
              const o = e.slides.eq(n);
              let l = a(o.attr("data-history"));
              if (e.params.history.root.length > 0) {
                let n = e.params.history.root;
                "/" === n[n.length - 1] && (n = n.slice(0, n.length - 1)), (l = `${n}/${t}/${l}`);
              } else s.pathname.includes(t) || (l = `${t}/${l}`);
              const c = i.history.state;
              (c && c.value === l) ||
                (e.params.history.replaceState
                  ? i.history.replaceState({ value: l }, null, l)
                  : i.history.pushState({ value: l }, null, l));
            },
            l = (t, n, r) => {
              if (n)
                for (let i = 0, s = e.slides.length; i < s; i += 1) {
                  const s = e.slides.eq(i);
                  if (a(s.attr("data-history")) === n && !s.hasClass(e.params.slideDuplicateClass)) {
                    const n = s.index();
                    e.slideTo(n, t, r);
                  }
                }
              else e.slideTo(0, t, r);
            },
            c = () => {
              (i = s(e.params.url)), l(e.params.speed, e.paths.value, !1);
            };
          n("init", () => {
            e.params.history.enabled &&
              (() => {
                const t = V();
                if (e.params.history) {
                  if (!t.history || !t.history.pushState)
                    return (e.params.history.enabled = !1), void (e.params.hashNavigation.enabled = !0);
                  (r = !0),
                    (i = s(e.params.url)),
                    (i.key || i.value) &&
                    (l(0, i.value, e.params.runCallbacksOnInit),
                      e.params.history.replaceState || t.addEventListener("popstate", c));
                }
              })();
          }),
            n("destroy", () => {
              e.params.history.enabled &&
                (() => {
                  const t = V();
                  e.params.history.replaceState || t.removeEventListener("popstate", c);
                })();
            }),
            n("transitionEnd _freeModeNoMomentumRelease", () => {
              r && o(e.params.history.key, e.activeIndex);
            }),
            n("slideChange", () => {
              r && e.params.cssMode && o(e.params.history.key, e.activeIndex);
            });
        },
        function ({ swiper: e, extendParams: t, emit: n, on: r }) {
          let i = !1;
          const a = X(),
            s = V();
          t({ hashNavigation: { enabled: !1, replaceState: !1, watchState: !1 } });
          const o = () => {
            n("hashChange");
            const t = a.location.hash.replace("#", "");
            if (t !== e.slides.eq(e.activeIndex).attr("data-hash")) {
              const n = e.$wrapperEl.children(`.${e.params.slideClass}[data-hash="${t}"]`).index();
              if (void 0 === n) return;
              e.slideTo(n);
            }
          },
            l = () => {
              if (i && e.params.hashNavigation.enabled)
                if (e.params.hashNavigation.replaceState && s.history && s.history.replaceState)
                  s.history.replaceState(null, null, `#${e.slides.eq(e.activeIndex).attr("data-hash")}` || ""),
                    n("hashSet");
                else {
                  const t = e.slides.eq(e.activeIndex),
                    r = t.attr("data-hash") || t.attr("data-history");
                  (a.location.hash = r || ""), n("hashSet");
                }
            };
          r("init", () => {
            e.params.hashNavigation.enabled &&
              (() => {
                if (!e.params.hashNavigation.enabled || (e.params.history && e.params.history.enabled)) return;
                i = !0;
                const t = a.location.hash.replace("#", "");
                if (t) {
                  const n = 0;
                  for (let r = 0, i = e.slides.length; r < i; r += 1) {
                    const i = e.slides.eq(r);
                    if (
                      (i.attr("data-hash") || i.attr("data-history")) === t &&
                      !i.hasClass(e.params.slideDuplicateClass)
                    ) {
                      const t = i.index();
                      e.slideTo(t, n, e.params.runCallbacksOnInit, !0);
                    }
                  }
                }
                e.params.hashNavigation.watchState && ne(s).on("hashchange", o);
              })();
          }),
            r("destroy", () => {
              e.params.hashNavigation.enabled && e.params.hashNavigation.watchState && ne(s).off("hashchange", o);
            }),
            r("transitionEnd _freeModeNoMomentumRelease", () => {
              i && l();
            }),
            r("slideChange", () => {
              i && e.params.cssMode && l();
            });
        },
        function ({ swiper: e, extendParams: t, on: n, emit: r }) {
          let i;
          function a() {
            const t = e.slides.eq(e.activeIndex);
            let n = e.params.autoplay.delay;
            t.attr("data-swiper-autoplay") && (n = t.attr("data-swiper-autoplay") || e.params.autoplay.delay),
              clearTimeout(i),
              (i = re(() => {
                let t;
                e.params.autoplay.reverseDirection
                  ? e.params.loop
                    ? (e.loopFix(), (t = e.slidePrev(e.params.speed, !0, !0)), r("autoplay"))
                    : e.isBeginning
                      ? e.params.autoplay.stopOnLastSlide
                        ? o()
                        : ((t = e.slideTo(e.slides.length - 1, e.params.speed, !0, !0)), r("autoplay"))
                      : ((t = e.slidePrev(e.params.speed, !0, !0)), r("autoplay"))
                  : e.params.loop
                    ? (e.loopFix(), (t = e.slideNext(e.params.speed, !0, !0)), r("autoplay"))
                    : e.isEnd
                      ? e.params.autoplay.stopOnLastSlide
                        ? o()
                        : ((t = e.slideTo(0, e.params.speed, !0, !0)), r("autoplay"))
                      : ((t = e.slideNext(e.params.speed, !0, !0)), r("autoplay")),
                  ((e.params.cssMode && e.autoplay.running) || !1 === t) && a();
              }, n));
          }
          function s() {
            return void 0 === i && !e.autoplay.running && ((e.autoplay.running = !0), r("autoplayStart"), a(), !0);
          }
          function o() {
            return (
              !!e.autoplay.running &&
              void 0 !== i &&
              (i && (clearTimeout(i), (i = void 0)), (e.autoplay.running = !1), r("autoplayStop"), !0)
            );
          }
          function l(t) {
            e.autoplay.running &&
              (e.autoplay.paused ||
                (i && clearTimeout(i),
                  (e.autoplay.paused = !0),
                  0 !== t && e.params.autoplay.waitForTransition
                    ? ["transitionend", "webkitTransitionEnd"].forEach((t) => {
                      e.$wrapperEl[0].addEventListener(t, d);
                    })
                    : ((e.autoplay.paused = !1), a())));
          }
          function c() {
            const t = X();
            "hidden" === t.visibilityState && e.autoplay.running && l(),
              "visible" === t.visibilityState && e.autoplay.paused && (a(), (e.autoplay.paused = !1));
          }
          function d(t) {
            e &&
              !e.destroyed &&
              e.$wrapperEl &&
              t.target === e.$wrapperEl[0] &&
              (["transitionend", "webkitTransitionEnd"].forEach((t) => {
                e.$wrapperEl[0].removeEventListener(t, d);
              }),
                (e.autoplay.paused = !1),
                e.autoplay.running ? a() : o());
          }
          function u() {
            e.params.autoplay.disableOnInteraction ? o() : l(),
              ["transitionend", "webkitTransitionEnd"].forEach((t) => {
                e.$wrapperEl[0].removeEventListener(t, d);
              });
          }
          function p() {
            e.params.autoplay.disableOnInteraction || ((e.autoplay.paused = !1), a());
          }
          (e.autoplay = { running: !1, paused: !1 }),
            t({
              autoplay: {
                enabled: !1,
                delay: 3e3,
                waitForTransition: !0,
                disableOnInteraction: !0,
                stopOnLastSlide: !1,
                reverseDirection: !1,
                pauseOnMouseEnter: !1,
              },
            }),
            n("init", () => {
              e.params.autoplay.enabled &&
                (s(),
                  X().addEventListener("visibilitychange", c),
                  e.params.autoplay.pauseOnMouseEnter && (e.$el.on("mouseenter", u), e.$el.on("mouseleave", p)));
            }),
            n("beforeTransitionStart", (t, n, r) => {
              e.autoplay.running && (r || !e.params.autoplay.disableOnInteraction ? e.autoplay.pause(n) : o());
            }),
            n("sliderFirstMove", () => {
              e.autoplay.running && (e.params.autoplay.disableOnInteraction ? o() : l());
            }),
            n("touchEnd", () => {
              e.params.cssMode && e.autoplay.paused && !e.params.autoplay.disableOnInteraction && a();
            }),
            n("destroy", () => {
              e.$el.off("mouseenter", u),
                e.$el.off("mouseleave", p),
                e.autoplay.running && o(),
                X().removeEventListener("visibilitychange", c);
            }),
            Object.assign(e.autoplay, { pause: l, run: a, start: s, stop: o });
        },
        function ({ swiper: e, extendParams: t, on: n }) {
          t({
            thumbs: {
              swiper: null,
              multipleActiveThumbs: !0,
              autoScrollOffset: 0,
              slideThumbActiveClass: "swiper-slide-thumb-active",
              thumbsContainerClass: "swiper-thumbs",
            },
          });
          let r = !1,
            i = !1;
          function a() {
            const t = e.thumbs.swiper;
            if (!t) return;
            const n = t.clickedIndex,
              r = t.clickedSlide;
            if (r && ne(r).hasClass(e.params.thumbs.slideThumbActiveClass)) return;
            if (null == n) return;
            let i;
            if (
              ((i = t.params.loop ? parseInt(ne(t.clickedSlide).attr("data-swiper-slide-index"), 10) : n),
                e.params.loop)
            ) {
              let t = e.activeIndex;
              e.slides.eq(t).hasClass(e.params.slideDuplicateClass) &&
                (e.loopFix(), (e._clientLeft = e.$wrapperEl[0].clientLeft), (t = e.activeIndex));
              const n = e.slides.eq(t).prevAll(`[data-swiper-slide-index="${i}"]`).eq(0).index(),
                r = e.slides.eq(t).nextAll(`[data-swiper-slide-index="${i}"]`).eq(0).index();
              i = void 0 === n ? r : void 0 === r ? n : r - t < t - n ? r : n;
            }
            e.slideTo(i);
          }
          function s() {
            const { thumbs: t } = e.params;
            if (r) return !1;
            r = !0;
            const n = e.constructor;
            if (t.swiper instanceof n)
              (e.thumbs.swiper = t.swiper),
                Object.assign(e.thumbs.swiper.originalParams, { watchSlidesProgress: !0, slideToClickedSlide: !1 }),
                Object.assign(e.thumbs.swiper.params, { watchSlidesProgress: !0, slideToClickedSlide: !1 });
            else if (se(t.swiper)) {
              const r = Object.assign({}, t.swiper);
              Object.assign(r, { watchSlidesProgress: !0, slideToClickedSlide: !1 }),
                (e.thumbs.swiper = new n(r)),
                (i = !0);
            }
            return e.thumbs.swiper.$el.addClass(e.params.thumbs.thumbsContainerClass), e.thumbs.swiper.on("tap", a), !0;
          }
          function o(t) {
            const n = e.thumbs.swiper;
            if (!n) return;
            const r = "auto" === n.params.slidesPerView ? n.slidesPerViewDynamic() : n.params.slidesPerView,
              i = e.params.thumbs.autoScrollOffset,
              a = i && !n.params.loop;
            if (e.realIndex !== n.realIndex || a) {
              let s,
                o,
                l = n.activeIndex;
              if (n.params.loop) {
                n.slides.eq(l).hasClass(n.params.slideDuplicateClass) &&
                  (n.loopFix(), (n._clientLeft = n.$wrapperEl[0].clientLeft), (l = n.activeIndex));
                const t = n.slides.eq(l).prevAll(`[data-swiper-slide-index="${e.realIndex}"]`).eq(0).index(),
                  r = n.slides.eq(l).nextAll(`[data-swiper-slide-index="${e.realIndex}"]`).eq(0).index();
                (s =
                  void 0 === t
                    ? r
                    : void 0 === r
                      ? t
                      : r - l == l - t
                        ? n.params.slidesPerGroup > 1
                          ? r
                          : l
                        : r - l < l - t
                          ? r
                          : t),
                  (o = e.activeIndex > e.previousIndex ? "next" : "prev");
              } else (s = e.realIndex), (o = s > e.previousIndex ? "next" : "prev");
              a && (s += "next" === o ? i : -1 * i),
                n.visibleSlidesIndexes &&
                n.visibleSlidesIndexes.indexOf(s) < 0 &&
                (n.params.centeredSlides
                  ? (s = s > l ? s - Math.floor(r / 2) + 1 : s + Math.floor(r / 2) - 1)
                  : s > l && n.params.slidesPerGroup,
                  n.slideTo(s, t ? 0 : void 0));
            }
            let s = 1;
            const o = e.params.thumbs.slideThumbActiveClass;
            if (
              (e.params.slidesPerView > 1 && !e.params.centeredSlides && (s = e.params.slidesPerView),
                e.params.thumbs.multipleActiveThumbs || (s = 1),
                (s = Math.floor(s)),
                n.slides.removeClass(o),
                n.params.loop || (n.params.virtual && n.params.virtual.enabled))
            )
              for (let t = 0; t < s; t += 1)
                n.$wrapperEl.children(`[data-swiper-slide-index="${e.realIndex + t}"]`).addClass(o);
            else for (let t = 0; t < s; t += 1) n.slides.eq(e.realIndex + t).addClass(o);
          }
          (e.thumbs = { swiper: null }),
            n("beforeInit", () => {
              const { thumbs: t } = e.params;
              t && t.swiper && (s(), o(!0));
            }),
            n("slideChange update resize observerUpdate", () => {
              e.thumbs.swiper && o();
            }),
            n("setTransition", (t, n) => {
              const r = e.thumbs.swiper;
              r && r.setTransition(n);
            }),
            n("beforeDestroy", () => {
              const t = e.thumbs.swiper;
              t && i && t && t.destroy();
            }),
            Object.assign(e.thumbs, { init: s, update: o });
        },
        function ({ swiper: e, extendParams: t, emit: n, once: r }) {
          t({
            freeMode: {
              enabled: !1,
              momentum: !0,
              momentumRatio: 1,
              momentumBounce: !0,
              momentumBounceRatio: 1,
              momentumVelocityRatio: 1,
              sticky: !1,
              minimumVelocity: 0.02,
            },
          }),
            Object.assign(e, {
              freeMode: {
                onTouchMove: function () {
                  const { touchEventsData: t, touches: n } = e;
                  0 === t.velocities.length &&
                    t.velocities.push({ position: n[e.isHorizontal() ? "startX" : "startY"], time: t.touchStartTime }),
                    t.velocities.push({ position: n[e.isHorizontal() ? "currentX" : "currentY"], time: ie() });
                },
                onTouchEnd: function ({ currentPos: t }) {
                  const { params: i, $wrapperEl: a, rtlTranslate: s, snapGrid: o, touchEventsData: l } = e,
                    c = ie() - l.touchStartTime;
                  if (t < -e.minTranslate()) e.slideTo(e.activeIndex);
                  else if (t > -e.maxTranslate())
                    e.slides.length < o.length ? e.slideTo(o.length - 1) : e.slideTo(e.slides.length - 1);
                  else {
                    if (i.freeMode.momentum) {
                      if (l.velocities.length > 1) {
                        const t = l.velocities.pop(),
                          n = l.velocities.pop(),
                          r = t.position - n.position,
                          a = t.time - n.time;
                        (e.velocity = r / a),
                          (e.velocity /= 2),
                          Math.abs(e.velocity) < i.freeMode.minimumVelocity && (e.velocity = 0),
                          (a > 150 || ie() - t.time > 300) && (e.velocity = 0);
                      } else e.velocity = 0;
                      (e.velocity *= i.freeMode.momentumVelocityRatio), (l.velocities.length = 0);
                      let t = 1e3 * i.freeMode.momentumRatio;
                      const c = e.velocity * t;
                      let d = e.translate + c;
                      s && (d = -d);
                      let u,
                        p = !1;
                      const f = 20 * Math.abs(e.velocity) * i.freeMode.momentumBounceRatio;
                      let h;
                      if (d < e.maxTranslate())
                        i.freeMode.momentumBounce
                          ? (d + e.maxTranslate() < -f && (d = e.maxTranslate() - f),
                            (u = e.maxTranslate()),
                            (p = !0),
                            (l.allowMomentumBounce = !0))
                          : (d = e.maxTranslate()),
                          i.loop && i.centeredSlides && (h = !0);
                      else if (d > e.minTranslate())
                        i.freeMode.momentumBounce
                          ? (d - e.minTranslate() > f && (d = e.minTranslate() + f),
                            (u = e.minTranslate()),
                            (p = !0),
                            (l.allowMomentumBounce = !0))
                          : (d = e.minTranslate()),
                          i.loop && i.centeredSlides && (h = !0);
                      else if (i.freeMode.sticky) {
                        let t;
                        for (let e = 0; e < o.length; e += 1)
                          if (o[e] > -d) {
                            t = e;
                            break;
                          }
                        (d =
                          Math.abs(o[t] - d) < Math.abs(o[t - 1] - d) || "next" === e.swipeDirection ? o[t] : o[t - 1]),
                          (d = -d);
                      }
                      if (
                        (h &&
                          r("transitionEnd", () => {
                            e.loopFix();
                          }),
                          0 !== e.velocity)
                      ) {
                        if (
                          ((t = s
                            ? Math.abs((-d - e.translate) / e.velocity)
                            : Math.abs((d - e.translate) / e.velocity)),
                            i.freeMode.sticky)
                        ) {
                          const n = Math.abs((s ? -d : d) - e.translate),
                            r = e.slidesSizesGrid[e.activeIndex];
                          t = n < r ? i.speed : n < 2 * r ? 1.5 * i.speed : 2.5 * i.speed;
                        }
                      } else if (i.freeMode.sticky) return void e.slideToClosest();
                      i.freeMode.momentumBounce && p
                        ? (e.updateProgress(u),
                          e.setTransition(t),
                          e.setTranslate(d),
                          e.transitionStart(!0, e.swipeDirection),
                          (e.animating = !0),
                          a.transitionEnd(() => {
                            e &&
                              !e.destroyed &&
                              l.allowMomentumBounce &&
                              (n("momentumBounce"),
                                e.setTransition(i.speed),
                                setTimeout(() => {
                                  e.setTranslate(u),
                                    a.transitionEnd(() => {
                                      e && !e.destroyed && e.transitionEnd();
                                    });
                                }, 0));
                          }))
                        : e.velocity
                          ? (n("_freeModeNoMomentumRelease"),
                            e.updateProgress(d),
                            e.setTransition(t),
                            e.setTranslate(d),
                            e.transitionStart(!0, e.swipeDirection),
                            e.animating ||
                            ((e.animating = !0),
                              a.transitionEnd(() => {
                                e && !e.destroyed && e.transitionEnd();
                              })))
                          : e.updateProgress(d),
                        e.updateActiveIndex(),
                        e.updateSlidesClasses();
                    } else {
                      if (i.freeMode.sticky) return void e.slideToClosest();
                      i.freeMode && n("_freeModeNoMomentumRelease");
                    }
                    (!i.freeMode.momentum || c >= i.longSwipesMs) &&
                      (e.updateProgress(), e.updateActiveIndex(), e.updateSlidesClasses());
                  }
                },
              },
            });
        },
        function ({ swiper: e, extendParams: t }) {
          let n, r, i;
          t({ grid: { rows: 1, fill: "column" } }),
            (e.grid = {
              initSlides: (t) => {
                const { slidesPerView: a } = e.params,
                  { rows: s, fill: o } = e.params.grid;
                (r = n / s),
                  (i = Math.floor(t / s)),
                  (n = Math.floor(t / s) === t / s ? t : Math.ceil(t / s) * s),
                  "auto" !== a && "row" === o && (n = Math.max(n, a * s));
              },
              updateSlide: (t, a, s, o) => {
                const { slidesPerGroup: l, spaceBetween: c } = e.params,
                  { rows: d, fill: u } = e.params.grid;
                let p, f, h;
                if ("row" === u && l > 1) {
                  const e = Math.floor(t / (l * d)),
                    r = t - d * l * e,
                    i = 0 === e ? l : Math.min(Math.ceil((s - e * d * l) / d), l);
                  (h = Math.floor(r / i)),
                    (f = r - h * i + e * l),
                    (p = f + (h * n) / d),
                    a.css({ "-webkit-order": p, order: p });
                } else
                  "column" === u
                    ? ((f = Math.floor(t / d)),
                      (h = t - f * d),
                      (f > i || (f === i && h === d - 1)) && ((h += 1), h >= d && ((h = 0), (f += 1))))
                    : ((h = Math.floor(t / r)), (f = t - h * r));
                a.css(o("margin-top"), 0 !== h ? c && `${c}px` : "");
              },
              updateWrapperSize: (t, r, i) => {
                const { spaceBetween: a, centeredSlides: s, roundLengths: o } = e.params,
                  { rows: l } = e.params.grid;
                if (
                  ((e.virtualSize = (t + a) * n),
                    (e.virtualSize = Math.ceil(e.virtualSize / l) - a),
                    e.$wrapperEl.css({ [i("width")]: `${e.virtualSize + a}px` }),
                    s)
                ) {
                  r.splice(0, r.length);
                  const t = [];
                  for (let n = 0; n < r.length; n += 1) {
                    let i = r[n];
                    o && (i = Math.floor(i)), r[n] < e.virtualSize + r[0] && t.push(i);
                  }
                  r.push(...t);
                }
              },
            });
        },
        function ({ swiper: e }) {
          Object.assign(e, {
            appendSlide: Be.bind(e),
            prependSlide: Re.bind(e),
            addSlide: Ge.bind(e),
            removeSlide: We.bind(e),
            removeAllSlides: Fe.bind(e),
          });
        },
        function ({ swiper: e, extendParams: t, on: n }) {
          t({ fadeEffect: { crossFade: !1, transformEl: null } }),
            Xe({
              effect: "fade",
              swiper: e,
              on: n,
              setTranslate: () => {
                const { slides: t } = e,
                  n = e.params.fadeEffect;
                for (let r = 0; r < t.length; r += 1) {
                  const t = e.slides.eq(r);
                  let i = -t[0].swiperSlideOffset;
                  e.params.virtualTranslate || (i -= e.translate);
                  let a = 0;
                  e.isHorizontal() || ((a = i), (i = 0));
                  const s = e.params.fadeEffect.crossFade
                    ? Math.max(1 - Math.abs(t[0].progress), 0)
                    : 1 + Math.min(Math.max(t[0].progress, -1), 0);
                  Ye(n, t).css({ opacity: s }).transform(`translate3d(${i}px, ${a}px, 0px)`);
                }
              },
              setTransition: (t) => {
                const { transformEl: n } = e.params.fadeEffect;
                (n ? e.slides.find(n) : e.slides).transition(t),
                  Ve({ swiper: e, duration: t, transformEl: n, allSlides: !0 });
              },
              overwriteParams: () => ({
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: !0,
                spaceBetween: 0,
                virtualTranslate: !e.params.cssMode,
              }),
            });
        },
        function ({ swiper: e, extendParams: t, on: n }) {
          t({ cubeEffect: { slideShadows: !0, shadow: !0, shadowOffset: 20, shadowScale: 0.94 } }),
            Xe({
              effect: "cube",
              swiper: e,
              on: n,
              setTranslate: () => {
                const {
                  $el: t,
                  $wrapperEl: n,
                  slides: r,
                  width: i,
                  height: a,
                  rtlTranslate: s,
                  size: o,
                  browser: l,
                } = e,
                  c = e.params.cubeEffect,
                  d = e.isHorizontal(),
                  u = e.virtual && e.params.virtual.enabled;
                let p,
                  f = 0;
                c.shadow &&
                  (d
                    ? ((p = n.find(".swiper-cube-shadow")),
                      0 === p.length && ((p = ne('<div class="swiper-cube-shadow"></div>')), n.append(p)),
                      p.css({ height: `${i}px` }))
                    : ((p = t.find(".swiper-cube-shadow")),
                      0 === p.length && ((p = ne('<div class="swiper-cube-shadow"></div>')), t.append(p))));
                for (let e = 0; e < r.length; e += 1) {
                  const t = r.eq(e);
                  let n = e;
                  u && (n = parseInt(t.attr("data-swiper-slide-index"), 10));
                  let i = 90 * n,
                    a = Math.floor(i / 360);
                  s && ((i = -i), (a = Math.floor(-i / 360)));
                  const l = Math.max(Math.min(t[0].progress, 1), -1);
                  let p = 0,
                    h = 0,
                    m = 0;
                  n % 4 == 0
                    ? ((p = 4 * -a * o), (m = 0))
                    : (n - 1) % 4 == 0
                      ? ((p = 0), (m = 4 * -a * o))
                      : (n - 2) % 4 == 0
                        ? ((p = o + 4 * a * o), (m = o))
                        : (n - 3) % 4 == 0 && ((p = -o), (m = 3 * o + 4 * o * a)),
                    s && (p = -p),
                    d || ((h = p), (p = 0));
                  const g = `rotateX(${d ? 0 : -i}deg) rotateY(${d ? i : 0}deg) translate3d(${p}px, ${h}px, ${m}px)`;
                  if (
                    (l <= 1 && l > -1 && ((f = 90 * n + 90 * l), s && (f = 90 * -n - 90 * l)),
                      t.transform(g),
                      c.slideShadows)
                  ) {
                    let e = d ? t.find(".swiper-slide-shadow-left") : t.find(".swiper-slide-shadow-top"),
                      n = d ? t.find(".swiper-slide-shadow-right") : t.find(".swiper-slide-shadow-bottom");
                    0 === e.length &&
                      ((e = ne(`<div class="swiper-slide-shadow-${d ? "left" : "top"}"></div>`)), t.append(e)),
                      0 === n.length &&
                      ((n = ne(`<div class="swiper-slide-shadow-${d ? "right" : "bottom"}"></div>`)), t.append(n)),
                      e.length && (e[0].style.opacity = Math.max(-l, 0)),
                      n.length && (n[0].style.opacity = Math.max(l, 0));
                  }
                }
                if (
                  (n.css({
                    "-webkit-transform-origin": `50% 50% -${o / 2}px`,
                    "transform-origin": `50% 50% -${o / 2}px`,
                  }),
                    c.shadow)
                )
                  if (d)
                    p.transform(
                      `translate3d(0px, ${i / 2 + c.shadowOffset}px, ${-i / 2}px) rotateX(90deg) rotateZ(0deg) scale(${c.shadowScale
                      })`
                    );
                  else {
                    const e = Math.abs(f) - 90 * Math.floor(Math.abs(f) / 90),
                      t = 1.5 - (Math.sin((2 * e * Math.PI) / 360) / 2 + Math.cos((2 * e * Math.PI) / 360) / 2),
                      n = c.shadowScale,
                      r = c.shadowScale / t,
                      i = c.shadowOffset;
                    p.transform(
                      `scale3d(${n}, 1, ${r}) translate3d(0px, ${a / 2 + i}px, ${-a / 2 / r}px) rotateX(-90deg)`
                    );
                  }
                const h = l.isSafari || l.isWebView ? -o / 2 : 0;
                n.transform(
                  `translate3d(0px,0,${h}px) rotateX(${e.isHorizontal() ? 0 : f}deg) rotateY(${e.isHorizontal() ? -f : 0
                  }deg)`
                );
              },
              setTransition: (t) => {
                const { $el: n, slides: r } = e;
                r
                  .transition(t)
                  .find(
                    ".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left"
                  )
                  .transition(t),
                  e.params.cubeEffect.shadow && !e.isHorizontal() && n.find(".swiper-cube-shadow").transition(t);
              },
              perspective: () => !0,
              overwriteParams: () => ({
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: !0,
                resistanceRatio: 0,
                spaceBetween: 0,
                centeredSlides: !1,
                virtualTranslate: !0,
              }),
            });
        },
        function ({ swiper: e, extendParams: t, on: n }) {
          t({ flipEffect: { slideShadows: !0, limitRotation: !0, transformEl: null } }),
            Xe({
              effect: "flip",
              swiper: e,
              on: n,
              setTranslate: () => {
                const { slides: t, rtlTranslate: n } = e,
                  r = e.params.flipEffect;
                for (let i = 0; i < t.length; i += 1) {
                  const a = t.eq(i);
                  let s = a[0].progress;
                  e.params.flipEffect.limitRotation && (s = Math.max(Math.min(a[0].progress, 1), -1));
                  const o = a[0].swiperSlideOffset;
                  let l = -180 * s,
                    c = 0,
                    d = e.params.cssMode ? -o - e.translate : -o,
                    u = 0;
                  if (
                    (e.isHorizontal() ? n && (l = -l) : ((u = d), (d = 0), (c = -l), (l = 0)),
                      (a[0].style.zIndex = -Math.abs(Math.round(s)) + t.length),
                      r.slideShadows)
                  ) {
                    let t = e.isHorizontal() ? a.find(".swiper-slide-shadow-left") : a.find(".swiper-slide-shadow-top"),
                      n = e.isHorizontal()
                        ? a.find(".swiper-slide-shadow-right")
                        : a.find(".swiper-slide-shadow-bottom");
                    0 === t.length && (t = Ue(r, a, e.isHorizontal() ? "left" : "top")),
                      0 === n.length && (n = Ue(r, a, e.isHorizontal() ? "right" : "bottom")),
                      t.length && (t[0].style.opacity = Math.max(-s, 0)),
                      n.length && (n[0].style.opacity = Math.max(s, 0));
                  }
                  const p = `translate3d(${d}px, ${u}px, 0px) rotateX(${c}deg) rotateY(${l}deg)`;
                  Ye(r, a).transform(p);
                }
              },
              setTransition: (t) => {
                const { transformEl: n } = e.params.flipEffect;
                (n ? e.slides.find(n) : e.slides)
                  .transition(t)
                  .find(
                    ".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left"
                  )
                  .transition(t),
                  Ve({ swiper: e, duration: t, transformEl: n });
              },
              perspective: () => !0,
              overwriteParams: () => ({
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: !0,
                spaceBetween: 0,
                virtualTranslate: !e.params.cssMode,
              }),
            });
        },
        function ({ swiper: e, extendParams: t, on: n }) {
          t({
            coverflowEffect: {
              rotate: 50,
              stretch: 0,
              depth: 100,
              scale: 1,
              modifier: 1,
              slideShadows: !0,
              transformEl: null,
            },
          }),
            Xe({
              effect: "coverflow",
              swiper: e,
              on: n,
              setTranslate: () => {
                const { width: t, height: n, slides: r, slidesSizesGrid: i } = e,
                  a = e.params.coverflowEffect,
                  s = e.isHorizontal(),
                  o = e.translate,
                  l = s ? t / 2 - o : n / 2 - o,
                  c = s ? a.rotate : -a.rotate,
                  d = a.depth;
                for (let e = 0, t = r.length; e < t; e += 1) {
                  const t = r.eq(e),
                    n = i[e],
                    o = ((l - t[0].swiperSlideOffset - n / 2) / n) * a.modifier;
                  let u = s ? c * o : 0,
                    p = s ? 0 : c * o,
                    f = -d * Math.abs(o),
                    h = a.stretch;
                  "string" == typeof h && -1 !== h.indexOf("%") && (h = (parseFloat(a.stretch) / 100) * n);
                  let m = s ? 0 : h * o,
                    g = s ? h * o : 0,
                    v = 1 - (1 - a.scale) * Math.abs(o);
                  Math.abs(g) < 0.001 && (g = 0),
                    Math.abs(m) < 0.001 && (m = 0),
                    Math.abs(f) < 0.001 && (f = 0),
                    Math.abs(u) < 0.001 && (u = 0),
                    Math.abs(p) < 0.001 && (p = 0),
                    Math.abs(v) < 0.001 && (v = 0);
                  const y = `translate3d(${g}px,${m}px,${f}px)  rotateX(${p}deg) rotateY(${u}deg) scale(${v})`;
                  if ((Ye(a, t).transform(y), (t[0].style.zIndex = 1 - Math.abs(Math.round(o))), a.slideShadows)) {
                    let e = s ? t.find(".swiper-slide-shadow-left") : t.find(".swiper-slide-shadow-top"),
                      n = s ? t.find(".swiper-slide-shadow-right") : t.find(".swiper-slide-shadow-bottom");
                    0 === e.length && (e = Ue(a, t, s ? "left" : "top")),
                      0 === n.length && (n = Ue(a, t, s ? "right" : "bottom")),
                      e.length && (e[0].style.opacity = o > 0 ? o : 0),
                      n.length && (n[0].style.opacity = -o > 0 ? -o : 0);
                  }
                }
              },
              setTransition: (t) => {
                const { transformEl: n } = e.params.coverflowEffect;
                (n ? e.slides.find(n) : e.slides)
                  .transition(t)
                  .find(
                    ".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left"
                  )
                  .transition(t);
              },
              perspective: () => !0,
              overwriteParams: () => ({ watchSlidesProgress: !0 }),
            });
        },
        function ({ swiper: e, extendParams: t, on: n }) {
          t({
            creativeEffect: {
              transformEl: null,
              limitProgress: 1,
              shadowPerProgress: !1,
              progressMultiplier: 1,
              perspective: !0,
              prev: { translate: [0, 0, 0], rotate: [0, 0, 0], opacity: 1, scale: 1 },
              next: { translate: [0, 0, 0], rotate: [0, 0, 0], opacity: 1, scale: 1 },
            },
          });
          const r = (e) => ("string" == typeof e ? e : `${e}px`);
          Xe({
            effect: "creative",
            swiper: e,
            on: n,
            setTranslate: () => {
              const { slides: t, $wrapperEl: n, slidesSizesGrid: i } = e,
                a = e.params.creativeEffect,
                { progressMultiplier: s } = a,
                o = e.params.centeredSlides;
              if (o) {
                const t = i[0] / 2 - e.params.slidesOffsetBefore || 0;
                n.transform(`translateX(calc(50% - ${t}px))`);
              }
              for (let n = 0; n < t.length; n += 1) {
                const i = t.eq(n),
                  l = i[0].progress,
                  c = Math.min(Math.max(i[0].progress, -a.limitProgress), a.limitProgress);
                let d = c;
                o || (d = Math.min(Math.max(i[0].originalProgress, -a.limitProgress), a.limitProgress));
                const u = i[0].swiperSlideOffset,
                  p = [e.params.cssMode ? -u - e.translate : -u, 0, 0],
                  f = [0, 0, 0];
                let h = !1;
                e.isHorizontal() || ((p[1] = p[0]), (p[0] = 0));
                let m = { translate: [0, 0, 0], rotate: [0, 0, 0], scale: 1, opacity: 1 };
                c < 0 ? ((m = a.next), (h = !0)) : c > 0 && ((m = a.prev), (h = !0)),
                  p.forEach((e, t) => {
                    p[t] = `calc(${e}px + (${r(m.translate[t])} * ${Math.abs(c * s)}))`;
                  }),
                  f.forEach((e, t) => {
                    f[t] = m.rotate[t] * Math.abs(c * s);
                  }),
                  (i[0].style.zIndex = -Math.abs(Math.round(l)) + t.length);
                const g = p.join(", "),
                  v = `rotateX(${f[0]}deg) rotateY(${f[1]}deg) rotateZ(${f[2]}deg)`,
                  y = d < 0 ? `scale(${1 + (1 - m.scale) * d * s})` : `scale(${1 - (1 - m.scale) * d * s})`,
                  b = d < 0 ? 1 + (1 - m.opacity) * d * s : 1 - (1 - m.opacity) * d * s,
                  w = `translate3d(${g}) ${v} ${y}`;
                if ((h && m.shadow) || !h) {
                  let e = i.children(".swiper-slide-shadow");
                  if ((0 === e.length && m.shadow && (e = Ue(a, i)), e.length)) {
                    const t = a.shadowPerProgress ? c * (1 / a.limitProgress) : c;
                    e[0].style.opacity = Math.min(Math.max(Math.abs(t), 0), 1);
                  }
                }
                const x = Ye(a, i);
                x.transform(w).css({ opacity: b }), m.origin && x.css("transform-origin", m.origin);
              }
            },
            setTransition: (t) => {
              const { transformEl: n } = e.params.creativeEffect;
              (n ? e.slides.find(n) : e.slides).transition(t).find(".swiper-slide-shadow").transition(t),
                Ve({ swiper: e, duration: t, transformEl: n, allSlides: !0 });
            },
            perspective: () => e.params.creativeEffect.perspective,
            overwriteParams: () => ({ watchSlidesProgress: !0, virtualTranslate: !e.params.cssMode }),
          });
        },
        function ({ swiper: e, extendParams: t, on: n }) {
          t({ cardsEffect: { slideShadows: !0, transformEl: null } }),
            Xe({
              effect: "cards",
              swiper: e,
              on: n,
              setTranslate: () => {
                const { slides: t, activeIndex: n } = e,
                  r = e.params.cardsEffect,
                  { startTranslate: i, isTouched: a } = e.touchEventsData,
                  s = e.translate;
                for (let o = 0; o < t.length; o += 1) {
                  const l = t.eq(o),
                    c = l[0].progress,
                    d = Math.min(Math.max(c, -4), 4);
                  let u = l[0].swiperSlideOffset;
                  e.params.centeredSlides &&
                    !e.params.cssMode &&
                    e.$wrapperEl.transform(`translateX(${e.minTranslate()}px)`),
                    e.params.centeredSlides && e.params.cssMode && (u -= t[0].swiperSlideOffset);
                  let p = e.params.cssMode ? -u - e.translate : -u,
                    f = 0;
                  const h = -100 * Math.abs(d);
                  let m = 1,
                    g = -2 * d,
                    v = 8 - 0.75 * Math.abs(d);
                  const y = (o === n || o === n - 1) && d > 0 && d < 1 && (a || e.params.cssMode) && s < i,
                    b = (o === n || o === n + 1) && d < 0 && d > -1 && (a || e.params.cssMode) && s > i;
                  if (y || b) {
                    const e = (1 - Math.abs((Math.abs(d) - 0.5) / 0.5)) ** 0.5;
                    (g += -28 * d * e), (m += -0.5 * e), (v += 96 * e), (f = -25 * e * Math.abs(d) + "%");
                  }
                  if (
                    ((p =
                      d < 0
                        ? `calc(${p}px + (${v * Math.abs(d)}%))`
                        : d > 0
                          ? `calc(${p}px + (-${v * Math.abs(d)}%))`
                          : `${p}px`),
                      !e.isHorizontal())
                  ) {
                    const e = f;
                    (f = p), (p = e);
                  }
                  const w = `\n        translate3d(${p}, ${f}, ${h}px)\n        rotateZ(${g}deg)\n        scale(${d < 0 ? "" + (1 + (1 - m) * d) : "" + (1 - (1 - m) * d)
                    })\n      `;
                  if (r.slideShadows) {
                    let e = l.find(".swiper-slide-shadow");
                    0 === e.length && (e = Ue(r, l)),
                      e.length && (e[0].style.opacity = Math.min(Math.max((Math.abs(d) - 0.5) / 0.5, 0), 1));
                  }
                  (l[0].style.zIndex = -Math.abs(Math.round(c)) + t.length), Ye(r, l).transform(w);
                }
              },
              setTransition: (t) => {
                const { transformEl: n } = e.params.cardsEffect;
                (n ? e.slides.find(n) : e.slides).transition(t).find(".swiper-slide-shadow").transition(t),
                  Ve({ swiper: e, duration: t, transformEl: n });
              },
              perspective: () => !0,
              overwriteParams: () => ({ watchSlidesProgress: !0, virtualTranslate: !e.params.cssMode }),
            });
        },
      ];
      function Je(e, t) {
        "string" == typeof e && (e = e.replace(".", ""));
        let n = "";
        const r = /\{\{\s*(\w+)\s*\}\}/,
          i = t || "${{amount}}";
        function a(e, t = 2, n = ",", r = ".") {
          if (isNaN(e) || null == e) return 0;
          const i = (e = (e / 100).toFixed(t)).split(".");
          return i[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${n}`) + (i[1] ? r + i[1] : "");
        }
        switch (i.match(r)[1]) {
          case "amount":
            n = a(e, 2);
            break;
          case "amount_no_decimals":
            n = a(e, 0);
            break;
          case "amount_with_comma_separator":
            n = a(e, 2, ".", ",");
            break;
          case "amount_no_decimals_with_comma_separator":
            n = a(e, 0, ".", ",");
        }
        return i.replace(r, n);
      }
      function Qe(e, t, n) {
        if (0 !== t) {
          var r = { items: [{ id: "number" == typeof e ? e : e.id, quantity: t }] };
          fetch("/cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(r),
          })
            .then(function (e) {
              n && n(e);
            })
            .catch(function (e) {
              console.error("Error:", e);
            });
        }
      }
      var Ze, et;
      qe.use(Ke), (window.jQuery = i()), (window.$ = i());
      var tt = {
        Availability: "availability",
        Prescription: "prescription",
        Grams: "grams",
        Cycle: "cycle",
        ThcPercent: "thc-percent",
        CbdPercent: "cbd-percent",
      };
      function nt(e, t) {
        return e.variants.find(function (e) {
          return e.id === t;
        });
      }
      function rt(e) {
        return nt(e, i()("#ProductSelect-product-template .selected").data("id"));
      }
      function it(e) {
        return parseInt(e.value, 10);
      }
      function at(e, t, n) {
        var r = [],
          i = window.patient;
        if (!i) return r;
        var a = i.valid,
          s = i.prescription,
          o = s.valid,
          l = s.limits,
          c = l.grams.remaining,
          orderMaximum = l.grams.orderMaximum ? l.grams.orderMaximum : 150,
          cartRemaining = l.grams.cart ? l.grams.cart : 0,
          d = l.thc,
          u = d.min,
          p = d.max,
          h = l.cbd,
          m = h.min,
          g = h.max,
          v = t.metafields,
          y = f(v.thc_range, 2),
          b = y[0],
          w = y[1],
          x = f(v.cbd_range, 2),
          C = x[0],
          E = x[1],
          T = (t.deductions[n.option1] || 999) * e;

        if (t.deductions[n.option1] == undefined) {
          T = 0;
          console.log("undefined");
        }

        var remainingByPrescription = c - cartRemaining,
          remainingByOrder = orderMaximum - cartRemaining,
          currentRemaining = Math.min(remainingByPrescription, remainingByOrder);
        return (
          n.available || r.push(tt.Availability),
          (o && a) || r.push(tt.Prescription),
          T > currentRemaining && r.push(tt.Cycle),
          (b > 0 && u > 0 && b < u) || (w > 0 && p > 0 && w > p)
            ? r.push(tt.ThcPercent)
            : ((C > 0 && m > 0 && C < m) || (E > 0 && g > 0 && E > g)) && r.push(tt.CbdPercent),
          r
        );
      }
      function st(e, t, n) {
        var r = it(e.qty.input),
          i = Array.from(e.variants);
        i.forEach(function (e) {
          return e.classList.remove("selected");
        });
        var a = i.find(function (e) {
          return parseInt(e.dataset.id, 10) === n.id;
        });
        if (a) {
          a.classList.add("selected");
          var s = t.deductions[n.option1];
          s
            ? ((s = (s * r).toFixed(1)),
              e.deduction.classList.remove("d-none"),
              (e.deduction.innerText = "".concat(s, "g")))
            : (e.deduction.classList.add("d-none"), (e.deduction.innerText = "N/A"));
          var o = t.discounting.variants[n.title];
          (e.price.innerText = Je(o.price * r, window.theme.moneyFormat)),
            e.perGram && (e.perGram.innerText = Je(t.per_gram[n.option1]));
        } else console.error("Missing variant");
      }
      function ot(e, t, n) {
        var r = at(it(e.qty.input), t, n);
        var i = e.addToCart.btn;

        if (i) {
          var a = false;
          var s = "";

          if (r.includes(tt.Availability)) {
            s = "Out of Stock";
            a = true;
          }

          if (r.includes(tt.Prescription)) {
            a = true;
            if (window.patient.status == 'call only') {
              s = "Call to order";
            } else {
              s = "Prescription invalid";
            }
          }

          if (r.includes(tt.Grams) || r.includes(tt.CbdPercent) || r.includes(tt.ThcPercent)) {
            a = true;
            s = "Over limit";
            console.log("over limit case 1");
          }

          if (r.includes(tt.Cycle)) {
            a = true;
            s = "Over limit";
            console.log("over limit case 2");
          }

          if (a) {
            i.innerText = s;
            i.classList.add("disabled");
            i.disabled = true;
          } else {
            i.innerText = "Add to Cart";
            i.classList.remove("disabled");
            i.disabled = false;
          }
        }
      }
      function lt(e, n, r) {
        console.log("lt func call: ", e.limits);
        var i,
          a = window.patient,
          s = e.limits,
          o = s.outOfStock,
          l = s.msgLowStock,
          c = s.limitCycle,
          d = s.limitExceeds,
          u =
            (t((i = {}), tt.Availability, [o, l]),
              t(i, tt.Grams, [d]),
              t(i, tt.ThcPercent, [d]),
              t(i, tt.CbdPercent, [d]),
              t(i, tt.Cycle, [c]),
              i);
        [o, c, d].forEach(function (e) {
          e && e.classList.add("d-none");
        }),
          at(parseInt(e.qty.input.value, 10), n, r).forEach(function (t) {
            console.log("at func: ", e.qty.input.value);
            var n = u[t];
            if (
              n &&
              (n.forEach(function (e) {
                e && e.classList.remove("d-none");
              }),
                a &&
                t === tt.Cycle &&
                "approved" !== a.status &&
                n.forEach(function (e) {
                  e && e.classList.add("d-none");
                }),
                a)
            )
              if (t === tt.Cycle) {
                var r = a.prescription,
                  i = r.limits.grams.remaining,
                  m = r.limits.grams.maximum ? r.limits.grams.maximum : 150,
                  g = r.limits.grams.orderMaximum ? r.limits.grams.orderMaximum : 150,
                  v = r.limits.grams.cart ? r.limits.grams.cart : 0,
                  y = i - v,
                  b = g - v,
                  w = Math.max(Math.min(y, b), 0),
                  x = b <= y,
                  s = r.date.expiry,
                  o = e.limits.values;
                o.message && (o.message.innerText = x ? "This product exceeds your current order limit." : "This product exceeds your current prescription."),
                  o.gramsRemainingSummary && (o.gramsRemainingSummary.innerText = w),
                  o.gramsUsedLabel && (o.gramsUsedLabel.innerText = x ? "Grams In Cart:" : "Grams Used:"),
                  o.gramsRemainingLabel && (o.gramsRemainingLabel.innerText = x ? "Available to Order:" : "Prescription Remaining:"),
                  o.gramsUsed && (o.gramsUsed.innerText = x ? v : Math.max(m - i, 0)),
                  o.gramsRemainingDetails && (o.gramsRemainingDetails.innerText = w),
                  o.resetRow &&
                    (x
                      ? (o.resetRow.classList.add("d-none"), o.gramsReset && (o.gramsReset.innerText = ""))
                      : (o.resetRow.classList.remove("d-none"), o.gramsReset && (o.gramsReset.innerText = s)));
              } else
                [tt.ThcPercent, tt.CbdPercent].includes(t) &&
                  (e.limits.values.exceedType.innerText = tt.ThcPercent === t ? "THC" : "CBD");
          });
      }
      function ct(e, t) {
        var n = it(e);
        return (
          (e.value = "increase" === t ? n + 1 : Math.max(n - 1, 0)),
          e.dispatchEvent(new Event("change", { bubbles: !0 })),
          e.value
        );
      }
      function dt(e, t, n) {
        !(function (e) {
          var t = e.id,
            n = window.location.href.split("=")[0],
            r = { variant_change: t },
            i = "".concat(n, "=").concat(t);
          window.location.href.includes("variant")
            ? (window.history.replaceState(r, "", document.referrer), window.history.replaceState(r, "", i))
            : ((i = "".concat(n, "?variant=").concat(t)),
              window.history.replaceState(r, "", document.referrer),
              window.history.replaceState(r, "", i));
        })(n),
          st(e, t, n),
          ot(e, t, n),
          lt(e, t, n),
          (function (e) {
            var t = i()('.product-image.swiper-slide[data-id="'.concat(e.id, '"]'));
            t && Ze.slideTo(t.data("index"));
          })(n);
      }
      function ut() {
        i()(".product-restore-email .email-me-button").trigger("click");
        var e = setInterval(function () {
          var t = i()(".email-frame-content .selected-unavailable-variant > option");
          t.length > 0 &&
            (clearInterval(e),
              t.each(function () {
                i()(this).text().includes("PG") && i()(this).remove();
              }));
        }, 50);
      }
      function pt() {
        var e = function (e) {
          return document.querySelector(e);
        },
          t = {
            addToCart: { btn: e(".product-form__cart-submit"), msg: e(".cart-messages") },
            qty: { incBtn: e(".pdp-increment"), decBtn: e(".pdp-decrement"), input: e("#Quantity") },
            limits: {
              outOfStock: e(".out-of-stock"),
              limitExceeds: e(".limit-exceeds"),
              limitCycle: e(".limit-cycle"),
              msgLowStock: e(".msg__low-stock"),
              pendingApproval: e(".pending-appoval"),
              values: {
                message: e(".limit-message"),
                gramsRemainingSummary: e(".limit-value-grams-remaining-summary"),
                gramsUsed: e(".limit-value-grams-used"),
                gramsUsedLabel: e(".limit-label-grams-used"),
                gramsRemainingLabel: e(".limit-label-grams-remaining"),
                gramsRemainingDetails: e(".limit-value-grams-remaining-details"),
                gramsReset: e(".limit-value-grams-reset"),
                resetRow: e(".limit-detail-row-reset"),
                exceedType: e(".limit-value-exceed-type"),
              },
            },
            price: e(".product-price__price .product-price .price-content"),
            variants: (".product-form__variants .option", document.querySelectorAll(".product-form__variants .option")),
            deduction: e(".deduction-amount"),
            perGram: e(".product-price__gram > span"),
          },
          n = JSON.parse(i()("script#ProductJson").text());
        dt(t, n, rt(n)),
          (function (e, t) {
            e.qty.incBtn.addEventListener("click", function () {
              ct(e.qty.input, "increase");
            }),
              e.qty.decBtn.addEventListener("click", function () {
                ct(e.qty.input, "decrease");
              }),
              e.qty.input.addEventListener("change", function () {
                var n = rt(t);
                st(e, t, n), ot(e, t, n), lt(e, t, n);
              });
          })(t, n),
          (function (e, t) {
            var n = t.variants;
            n &&
              0 !== n.length &&
              n.forEach(function (n) {
                if (n && n.id) {
                  var r = n.id,
                    i = document.querySelector('.option[data-id="'.concat(r, '"]'));
                  i &&
                    i.addEventListener("click", function () {
                      var n = nt(t, r);
                      dt(e, t, n);
                    });
                }
              });
          })(t, n),
          (function (e, t) {
            e.addToCart.btn &&
              e.addToCart.btn.addEventListener("click", function () {
                var n = it(e.qty.input),
                  r = rt(t);
                !(function (e, t, n) {
                  Qe(t, n, function (t) {
                    (e.addToCart.msg.innerHTML = 200 === t.status ? "Successfully added to cart." : "Your order exceeds what we have in stock. More is on the way!"),
                      s();
                  });
                })(e, r, n);
              });
          })(t, n),
          (function (e) {
            e.limits.outOfStock && e.limits.outOfStock.addEventListener("click", ut);
          })(t);
      }
      function ft(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(e);
          t &&
            (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })),
            n.push.apply(n, r);
        }
        return n;
      }
      function ht(e) {
        for (var n = 1; n < arguments.length; n++) {
          var r = null != arguments[n] ? arguments[n] : {};
          n % 2
            ? ft(Object(r), !0).forEach(function (n) {
              t(e, n, r[n]);
            })
            : Object.getOwnPropertyDescriptors
              ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r))
              : ft(Object(r)).forEach(function (t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
              });
        }
        return e;
      }
      i()(function () {
        i()(".page-wrap").hasClass("product") &&
          ((et = new qe(".swiper-thumbs", {
            slidesPerView: 4,
            spaceBetween: 5,
            multipleActiveThumbs: !1,
            slideToClickedSlide: !0,
            autoScrollOffset: 1,
          })),
            ((Ze = new qe(".swiper-main", {
              loop: !0,
              centeredSlides: !0,
              autoHeight: !0,
              zoom: { maxRatio: 4 },
              thumbs: { swiper: et },
              navigation: { nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev" },
              on: {
                init: function () {
                  1 ===
                    i()(
                      ".swiper-wrapper .swiper-slide:not(.swiper-slide-duplicate,.swiper-slide-duplicate-active,.swiper-slide-duplicate-next)"
                    ).length &&
                    (i()(".swiper-wrapper").addClass("disabled"), i()(".swiper-pagination").addClass("disabled"));
                },
              },
            })).controller.control = et),
            pt()),
          i()(".product-thumb").length > 0 &&
          i()(document).on("click", ".product-thumb:not(.no-ajax) .add-to-cart", function () {
            console.log("product card add-to-card clicked");
            var e = this,
              v = i()(this).attr("data-variant-id"),
              n = i()(this).data("text-pre"),
              r = i()(this).data("text-post");
            var t = Number(v)
            console.log("selected variant id: ", t);
            Qe(t, 1, function () {
              s();
              var t = i()(e).find("span");
              t.html(r),
                setTimeout(function () {
                  return t.html(n);
                }, 2e3);
            });
          });
      });
      var mt = document.getElementById("main-carousel"),
        gt = null == mt ? void 0 : mt.dataset.delay,
        vt = gt > 0 ? 1e3 * gt : null,
        yt = { autoplay: { delay: vt } },
        bt = {
          loop: !0,
          scrollbar: !1,
          pagination: { el: ".swiper-pagination", clickable: !0 },
          navigation: { nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev" },
        };
      function wt(e) {
        e[0].classList.contains("active")
          ? e
            .hide()
            .delay(250)
            .queue(function () {
              i()(this).addClass("fade"),
                e[0].classList.remove("active"),
                document.body.classList.remove("modal-open");
            })
            .dequeue()
          : e
            .show()
            .delay(250)
            .queue(function () {
              i()(this).removeClass("fade"), e[0].classList.add("active"), document.body.classList.add("modal-open");
            })
            .dequeue();
      }
      vt && (bt = ht(ht({}, bt), yt)),
        new qe("#main-carousel", bt),
        i()(function () {
          var e = "#products";
          i()(".clear-filter").on("click", function () {
            "" !== window.location.search && (window.location.href = window.location.href.split("?")[0] + e);
          }),
            i()(".block .filter-header").on("click", function () {
              i()(this).siblings(".filter-list").toggleClass("d-none"), i()(this).find("span").toggleClass("rotate");
            }),
            i()(".option-filter:not([type='range'])").on("click", function () {
              window.location.href = i()(this).data("url") + e;
            }),
            i()(".price-range .range").on("change", function () {
              var t = i()(this).val(),
                n = i()(this).data("param-name"),
                r = a();
              (r[n] = t), (window.location.search = decodeURIComponent(i().param(r))), (window.location.hash = e);
            }),
            i()("#sort-by").on("change", function () {
              var e = a();
              (e.sort_by = i()(this).val()), (window.location.search = decodeURIComponent(i().param(e)));
            }),
            i()("#mobile-filter").on("click", function () {
              i()(".sidebar").show();
            }),
            i()(".sidebar .icon-close").on("click", function () {
              i()(".sidebar").hide();
            }),
            i()(".mobile-sort-sidebar .icon-close").on("click", function () {
              i()(".mobile-sort-sidebar").hide();
            }),
            i()("#mobile-sort").on("click", function () {
              if (!i()(".mobile-sort-sidebar .option").length) {
                var e = i()(this).find("#sort-by option");
                i()(e).each(function () {
                  var e = '\n          <div class="option">\n            <input value="'
                    .concat(
                      i()(this).val(),
                      '" type="checkbox" class="option-filter" />\n            <label class="option-label" for="'
                    )
                    .concat(i()(this).val(), '">')
                    .concat(i()(this).html(), "</label>\n          </div>\n        ");
                  i()(".mobile-sort-sidebar").append(e);
                }),
                  i()(".mobile-sort-sidebar .option").on("click", function () {
                    i()(this).find("input").attr("checked")
                      ? (i()(this).attr("checked", !1),
                        i()("#sort-by option:selected").attr("selected", !1),
                        i()("#sort-by option[value='manual']").attr("selected", !0))
                      : (i()("#sort-by option:selected").attr("selected", !1),
                        i()("#sort-by option[value='".concat(i()(this).find("input").val(), "']")).attr(
                          "selected",
                          !0
                        )),
                      i()("#sort-by").trigger("change");
                  });
              }
              i()("\n    .mobile-sort-sidebar input[value='".concat(i()("#sort-by option:selected").val(), "']")).attr(
                "checked",
                !0
              ),
                i()(".mobile-sort-sidebar").show();
            });
        }),
        i()(function () {
          var e = localStorage.getItem("age-verified"),
            t = i()("#age-gate-modal");
          t.length && null === e && wt(t),
            i()("#age-gate-submit span").on("click", function (e) {
              i()("#gate-remember-checkbox").prop("checked"),
                "YES" === i()(e.currentTarget).text()
                  ? (localStorage.setItem("age-verified", !0), wt(t))
                  : window.location.replace("www.google.ca");
            });
        }),
        i()(".page-wrap").hasClass("articles") &&
        i()(".blog-category").on("click", function () {
          i()(this).addClass("active").siblings().removeClass("active");
          var e = i()(this).data("id");
          i()(".blog-card")
            .show()
            .filter(function () {
              return i()(this).data("id").split(" ").join("-").toLowerCase() !== e;
            })
            .hide();
        }),
        i()(function () {
          var e;
          i()(".products-grid").length &&
            (i()(".variant").on("click", function (e) {
              console.log("variant clicked")
              var t,
                n = e.currentTarget;
              i()(n).hasClass("soldout") ||
                ((t = n),
                  i()(t).parents(".variants").find(".variant").removeClass("active"),
                  (function (e) {
                    i()(e).addClass("active");
                  })(n),
                  (function (e) {
                    var t = i()(e).data("variant-id"),
                      n = i()(e).parents(".product-thumb").find(".add-to-cart");
                    i()(n).attr("data-variant-id", t);
                  })(n));
            }),
              (e = i()(".variants")),
              i()(e).each(function () {
                var e = i()(this).find(".arrow");
                i()(this).find(".variant:not(.arrow)").length > 3 && i()(e).show();
              }));
        });
    })();
})();


let inactivityTimeout;

function resetInactivityTimer() {
  clearTimeout(inactivityTimeout);
  inactivityTimeout = setTimeout(logoutUser, 30 * 60 * 1000); // 30 minutes of inactivity
}

function logoutUser() {
  // Perform logout actions here (clear sessions, cookies, etc.)
  window.location.href = '/account/logout'; // Redirect to logout page
}

// Listen for user activity events
document.addEventListener('mousemove', resetInactivityTimer);
document.addEventListener('keydown', resetInactivityTimer);

// js/common/form/price-range.js
var PriceRange = class extends HTMLElement {
  connectedCallback() {
    this._abortController = new AbortController();
    this.rangeLowerBound = this.querySelector('input[type="range"]:first-child');
    this.rangeHigherBound = this.querySelector('input[type="range"]:last-child');
    this.textInputLowerBound = this.querySelector('input[name="filter.v.price.gte"]');
    this.textInputHigherBound = this.querySelector('input[name="filter.v.price.lte"]');
    if (!this.textInputLowerBound && !this.textInputHigherBound) return
    this.textInputLowerBound.addEventListener("focus", () => this.textInputLowerBound.select(), { signal: this._abortController.signal });
    this.textInputHigherBound.addEventListener("focus", () => this.textInputHigherBound.select(), { signal: this._abortController.signal });
    this.textInputLowerBound.addEventListener("change", (event) => {
      event.preventDefault();
      event.target.value = Math.max(Math.min(parseInt(event.target.value), parseInt(this.textInputHigherBound.value || event.target.max) - 1), event.target.min);
      this.rangeLowerBound.value = event.target.value;
      this.rangeLowerBound.parentElement.style.setProperty("--range-min", `${parseInt(this.rangeLowerBound.value) / parseInt(this.rangeLowerBound.max) * 100}%`);
    }, { signal: this._abortController.signal });
    this.textInputHigherBound.addEventListener("change", (event) => {
      event.preventDefault();
      event.target.value = Math.min(Math.max(parseInt(event.target.value), parseInt(this.textInputLowerBound.value || event.target.min) + 1), event.target.max);
      this.rangeHigherBound.value = event.target.value;
      this.rangeHigherBound.parentElement.style.setProperty("--range-max", `${parseInt(this.rangeHigherBound.value) / parseInt(this.rangeHigherBound.max) * 100}%`);
    }, { signal: this._abortController.signal });
    this.rangeLowerBound.addEventListener("change", (event) => {
      event.stopPropagation();
      this.textInputLowerBound.value = event.target.value;
      this.textInputLowerBound.dispatchEvent(new Event("change", { bubbles: true }));
    }, { signal: this._abortController.signal });
    this.rangeHigherBound.addEventListener("change", (event) => {
      event.stopPropagation();
      this.textInputHigherBound.value = event.target.value;
      this.textInputHigherBound.dispatchEvent(new Event("change", { bubbles: true }));
    }, { signal: this._abortController.signal });
    this.rangeLowerBound.addEventListener("input", (event) => {
      event.target.value = Math.min(parseInt(event.target.value), parseInt(this.textInputHigherBound.value || event.target.max) - 1);
      event.target.parentElement.style.setProperty("--range-min", `${parseInt(event.target.value) / parseInt(event.target.max) * 100}%`);
      this.textInputLowerBound.value = event.target.value;
    }, { signal: this._abortController.signal });
    this.rangeHigherBound.addEventListener("input", (event) => {
      event.target.value = Math.max(parseInt(event.target.value), parseInt(this.textInputLowerBound.value || event.target.min) + 1);
      event.target.parentElement.style.setProperty("--range-max", `${parseInt(event.target.value) / parseInt(event.target.max) * 100}%`);
      this.textInputHigherBound.value = event.target.value;
    }, { signal: this._abortController.signal });
  }
  disconnectedCallback() {
    this._abortController.abort();
  }
};
if (!window.customElements.get("price-range")) {
  window.customElements.define("price-range", PriceRange);
}

$(document).on("click", "#feather-icon_search", function () {
  $("#feather-icon_search").hide();
  $(".desktop-nav .main-links").hide();
  $(".nav-search").show();
  $(".nav-search input").focus();
});

$(document).on("click", function (event) {
  let target = $(event.target);
  if (!target.is(".nav-search") && !target.closest(".nav-search").length && !target.is("#feather-icon_search")) {
    $("#feather-icon_search").show();
    $(".desktop-nav .main-links").show();
    $(".nav-search").hide();
  }
});
